// @ts-nocheck
import { DateOnly } from 'src/utils/dates';
import { DateTime } from 'src/utils/dates';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: DateOnly; output: DateOnly; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: DateTime; output: DateTime; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A string value representing either an ID or a name */
  IdOrName: { input: any; output: any; }
};

export type ScheduleTask = CanCollaborate & Commentable & Referencable & Followable & Entity & HasBlueprintUrl & ScheduleEntity & Named & MaybeHasInterval & MaybeHasBaselineInterval & {
  __typename?: 'ScheduleTask';
  kind: Scalars['String']['output'];
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  globalPhase?: Maybe<GlobalPhase>;
  globalSubPhase?: Maybe<GlobalSubPhase>;
  schedulePhase?: Maybe<SchedulePhase>;
  scheduleSubPhase?: Maybe<ScheduleSubPhase>;
  schedule: Schedule;
  parent: ScheduleParent;
  project?: Maybe<Project>;
  name: Scalars['String']['output'];
  status: TaskStatus;
  statusDetail: TaskStatusDetail;
  schedulingStatus: TaskSchedulingStatus;
  homeownerVisible: Scalars['Boolean']['output'];
  homeownerDescription?: Maybe<Scalars['String']['output']>;
  interval: CalendarInterval;
  /** @deprecated baselineInterval is deprecated in favor of baselineInterval2 for better handling of undefined baselines */
  baselineInterval: CalendarInterval;
  baselineInterval2?: Maybe<CalendarInterval2>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  assignee?: Maybe<InternalUser>;
  internalNote?: Maybe<Scalars['String']['output']>;
  slackInDays?: Maybe<Scalars['Int']['output']>;
  aheadOrBehindInDays?: Maybe<Scalars['Int']['output']>;
  isStale: Scalars['Boolean']['output'];
  isCriticalPath: Scalars['Boolean']['output'];
  predecessors: Array<ScheduleTask>;
  successors: Array<ScheduleTask>;
  predecessorDependencies: Array<ScheduleTaskDependency>;
  successorDependencies: Array<ScheduleTaskDependency>;
  homeownerContractDraws: Array<HomeownerContractDraw>;
  blueprintUrl: Url;
  salesforceId?: Maybe<Scalars['String']['output']>;
  tradePartner?: Maybe<TradePartner>;
  canEditStartDate: PotentialOperation2;
  canEditEndDate: PotentialOperation2;
  /**  Convenience operation which is a logical OR of canEditStartDate || canEditEndDate  */
  canEditDuration: PotentialOperation2;
  canComplete: PotentialOperation2;
  canStart: PotentialOperation2;
  canDelete: PotentialOperation2;
  canSetTraderPartner: PotentialOperation2;
  projectCutoffs: Array<ProjectCutoff>;
  projectItems: Array<ProjectItem>;
  deadlineType?: Maybe<TaskDeadlineType>;
  templateProjectRole?: Maybe<ProjectRole>;
  documents: Array<Document>;
  globalTask?: Maybe<GlobalTask>;
  isGlobalMilestoneTask: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  requiredTaskDocuments: Array<RequiredTaskDocument>;
  history: Array<History>;
  scheduleTaskChecklistItems: Array<ScheduleTaskChecklistItem>;
  scheduleFlags: Array<ScheduleFlag>;
  jobLogNotes: Array<JobLogNote>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: Maybe<Scalars['Boolean']['output']>;
  /** Null if there are no checklist items, true if all checklist items are complete, false otherwise */
  checklistComplete?: Maybe<Scalars['Boolean']['output']>;
  hasScheduleFlags: Scalars['Boolean']['output'];
  systemTask?: Maybe<SystemTask>;
  bills: Array<Bill>;
  tradePartners: Array<TradePartner>;
  /** Note: this is the sub-set of tradePartners that are signed */
  committedTradePartners: Array<TradePartner>;
  billLineItems: Array<BillLineItem>;
  defaultedHomeownerDescription: Scalars['String']['output'];
  templateTask?: Maybe<Task>;
  tradePartnerStatus: TradePartnerTaskStatusDetail;
  tradePartnerAvailabilityRequests?: Maybe<Array<TradePartnerAvailabilityRequest>>;
  protoBills: Array<ProtoBill>;
  type: TaskTypeDetail;
  workDays: Array<TaskWorkDay>;
  commitmentDraws: Array<CommitmentDraw>;
};

export type Query = {
  __typename?: 'Query';
  costConfidences: Array<CostConfidenceDetail>;
  approval: Approval;
  approvals?: Maybe<ApprovalPage>;
  /** Returns assets matching the filter. If filter is empty, returns []. */
  assets: Array<Asset>;
  bidContract: BidContract;
  bidContractItems: Array<BidContractPotentialItem>;
  bidContractsPage: BidContractsPage;
  /** @deprecated Use the paginated bidContractLineItemsPaged query. */
  bidContractLineItems: Array<BidContractLineItem>;
  bidContractLineItemsPage: BidContractLineItemsPageResult;
  bidContractRevision: BidContractRevision;
  bidItem: BidItem;
  bidItems: Array<BidItem>;
  bidItemsPage: BidItemsPage;
  potentialBidItems: Array<BidItem>;
  bidItemEstimate: BidItemEstimate;
  bidItemEstimates: BidItemEstimatesPageResult;
  bidPackage: BidPackage;
  potentialBidItemsPage: BidItemsPage;
  overlappingBidPackages: OverlappingBidPackagesResult;
  bidScopeSourceDetail: Array<BidScopeSourceDetail>;
  bidPackageGroup: BidPackageGroup;
  bidPackageGroups: BidPackageGroupsPageResult;
  bidPackageGroupProductOfferingsInfo: BidPackageGroupProductOfferingsResult;
  bidPackageVersion: BidPackageVersion;
  bidPackageVersionScopeLines: Array<BidPackageScopeLine>;
  bill: Bill;
  bills: Array<Bill>;
  billsPage: BillsPage;
  billMetrics?: Maybe<BillMetricsResult>;
  billGmailMessages: Array<BillGmailMessage>;
  billOcr?: Maybe<BillOcr>;
  builder: Builder;
  businessFunction: BusinessFunction;
  businessFunctions: Array<BusinessFunction>;
  projectRolesForBusinessFunctionType: Array<ProjectRoleDetail>;
  changeEvent: ChangeEvent;
  changeEvents: Array<ChangeEvent>;
  changeEventLineItems: Array<ChangeEventLineItem>;
  changeEventBudgetPhases: Array<ChangeEventBudgetPhaseDetail>;
  changeEventReasons: Array<ChangeEventReason>;
  changeRequest: ChangeRequest;
  changeRequests: ChangeRequestsPageResult;
  availableDependencyChangeRequests: Array<ChangeRequest>;
  changeRequestAsset: ChangeRequestAsset;
  changeRequestAssets: ChangeRequestAssetsPageResult;
  changeRequestGroup: ChangeRequestGroup;
  changeRequestGroups: Array<ChangeRequestGroup>;
  checkoutConfig: CheckoutConfig;
  checkoutConfigs: CheckoutConfigsPage;
  checkoutPricingTrace: CheckoutPricingTrace;
  insideMapsSlotAudit: InsideMapsSlotAuditResult;
  insideMapsSlotDiff: InsideMapsSlotDiffResult;
  cohorts: Array<Cohort>;
  cohort: Cohort;
  canCollaborate: CanCollaborate;
  comment: Comment;
  commentStream?: Maybe<CommentStream>;
  /** @deprecated Use the paginated userRelevantCommentStreamsPaged query */
  userRelevantCommentStreams: Array<CommentStream>;
  userRelevantCommentStreamsPaged: UserRelevantCommentStreamsResult;
  commentable: Commentable;
  commitment: Commitment;
  commitments: Array<Commitment>;
  commitmentsPage: CommitmentsPage;
  commitmentStatuses: Array<CommitmentStatusDetail>;
  commitmentTypes: Array<CommitmentTypeDetail>;
  commitmentChangeOrder: CommitmentChangeOrder;
  community: Community;
  communities: CommunitiesPageResult;
  costCodes: Array<CostCode>;
  costDivisions: Array<CostDivision>;
  costTypes: Array<CostTypeDetail>;
  customers: Array<Customer>;
  customerOwnerEntities: Array<CustomerOwnerEntity>;
  cutoffs: Array<Cutoff>;
  designPackage: DesignPackage;
  designPackages: DesignPackagesPageResult;
  designPackageFinishSchedule: DesignPackageFinishSchedulePageResult;
  /**
   * Determines what the target combinations for each product card will be based on the placeholder and a product card
   * that we're currently adding/editing. This is useful for the FE to know which combinations will be stolen or dropped
   * from sibling product cards without making excessive requests to the BE.
   *
   * Example: Stolen Combination
   * - Given the following product cards:
   *   - `tli:1` - `targetCombinations: [[Essential]]`
   *   - `tli:2` - `targetCombinations: [[Deluxe], [Premium]]`
   * - When we edit the first product card to have combinations `[[Essential], [Deluxe]]`
   * - Then the second product card will lose the `[Deluxe]` combination
   *   - `tli:1` - `targetCombinations: [[Essential], [Deluxe]]`
   *   - `tli:2` - `targetCombinations: [[Premium]]`
   */
  placeholderCombinations: Array<PlaceholderCombinationsResult>;
  developments: Array<Development>;
  development: Development;
  developmentLotSummaryCharts?: Maybe<DevelopmentLotSummaryChartsResult>;
  developmentCommitment: DevelopmentCommitment;
  developmentCommitments: Array<DevelopmentCommitment>;
  developmentCommitmentsPage: DevelopmentCommitmentsPage;
  /** @deprecated Replaced by developmentCommitmentPotentialLineItems */
  protoDevelopmentCommitmentSummary: DevelopmentCommitmentSummary;
  /**
   * When creating or updating a dev commitment, provides a list of project items, grouped by cost code+type, for the user to include.
   *
   * If creating a dev commitment, then stage+projectIds are required.
   *
   * If updating a dev commitment, then just developmentCommitmentId is required.
   */
  developmentCommitmentPotentialLineItems: Array<DevelopmentCommitmentPotentialLineItem>;
  /** Ability to only include/exclude system-controlled document types */
  documentTypes: Array<DocumentTypeDetail>;
  /** @deprecated replaced by documentsPage */
  documents: Array<Document>;
  documentsPage: DocumentsPageResult;
  document: Document;
  documentCategories: Array<DocumentCategoryDetail>;
  userProjectDocuments: Array<Document>;
  drops: Array<Drop>;
  entity: Entity;
  enumDetails: AllEnumDetails;
  identifyProjectAccrualAdjustments: Array<IdentifyProjectAccrualAdjustmentsResult>;
  projectEstimate: Estimate;
  projectEstimates: Array<Estimate>;
  expenses: Array<Expense>;
  expensesPage: ExpensesPage;
  expense: Expense;
  featureFlag: FeatureFlag;
  featureFlags: Array<FeatureFlag>;
  availableFeatureFlagTypes: Array<FeatureFlagTypeDetail>;
  userFeatureFlags: Array<FeatureFlag>;
  followable: Followable;
  globalOptions: Array<GlobalOption>;
  globalOption: GlobalOption;
  globalOptionGroups: Array<GlobalOptionGroup>;
  globalOptionTags: Array<GlobalOptionTag>;
  globalOptionTypes: Array<GlobalOptionType>;
  globalPhases: Array<GlobalPhase>;
  globalPhase: GlobalPhase;
  globalPlanConstraintItems: Array<GlobalPlanConstraintItem>;
  globalPlanMilestone: GlobalPlanMilestone;
  globalPlanMilestones: GlobalPlanMilestonesPageResult;
  globalPlanMilestoneGroups: Array<GlobalPlanMilestoneGroup>;
  globalPlanStage: GlobalPlanStage;
  globalPlanStages: Array<GlobalPlanStage>;
  globalPlanTag: GlobalPlanTag;
  globalPlanTags: Array<GlobalPlanTag>;
  globalPlanTask: GlobalPlanTask;
  globalPlanTasks: GlobalPlanTasksPageResult;
  globalSearch: Array<GlobalSearchResult>;
  globalSubPhases: Array<GlobalSubPhase>;
  globalTasks: Array<GlobalTask>;
  homeowners: HomeownersPage;
  homeownerContract: HomeownerContract;
  homeownerContracts: Array<HomeownerContract>;
  homeownerContractChangeOrder: HomeownerContractChangeOrder;
  homeownerContractChangeOrders: Array<HomeownerContractChangeOrder>;
  homeownerNotes: Array<HomeownerNote>;
  homeownerNote: HomeownerNote;
  homeownerSelection: HomeownerSelection;
  homeownerSelectionOption: HomeownerSelectionOptionLike;
  currentInternalUser?: Maybe<InternalUser>;
  internalUsers: Array<InternalUser>;
  invoice: Invoice;
  invoices: Array<Invoice>;
  invoicesPage: InvoicesPage;
  invoiceScheduleTemplate: InvoiceScheduleTemplate;
  invoiceScheduleTemplates: Array<InvoiceScheduleTemplate>;
  items: Array<Item>;
  itemStatuses: Array<ItemStatusDetail>;
  itemPlanTaskMappingPage: ItemPlanTaskMappingPage;
  itemTemplates: Array<ItemTemplate>;
  itemTemplate: ItemTemplate;
  itemTemplateItem: ItemTemplateItem;
  itemTemplateItemVersion: ItemTemplateItemVersion;
  itemTemplateItemVersions: Array<ItemTemplateItemVersion>;
  itemTemplateItemVersionsPage: ItemTemplateItemVersionsPage;
  itemTemplateItemVersionGroupTotals: Array<ItemTemplateItemVersionGroupTotal>;
  jobLog: JobLog;
  /** @deprecated Use jobLogsPage instead */
  jobLogs: Array<JobLog>;
  jobLogsPage: JobLogsPageResult;
  jobLogImages: Array<JobLogImage>;
  jobLogNote: JobLogNote;
  lienWaiver: LienWaiver;
  lienWaivers: Array<LienWaiver>;
  lienWaiversPage: LienWaiversPage;
  locations: Array<Location>;
  location: Location;
  lot: Lot;
  lotRatings: Array<LotRating>;
  market: Market;
  markets: Array<Market>;
  materialAttributeDimensions: Array<MaterialAttributeDimension>;
  materialBrands: Array<MaterialBrand>;
  materialTypes: Array<MaterialTypeDetail>;
  materialListings: MaterialListingsPage;
  materialVariant: MaterialVariant;
  materialVariantCostSources: MaterialVariantCostSourcesPage;
  materialVariants: MaterialVariantsPage;
  materialVariantsForPlaceholderTli: Array<MaterialVariant>;
  materialVariantTags: Array<MaterialVariantTag>;
  mermaid: MermaidResult;
  mobileSyncUpdates: MobileSyncUpdatesPageResult;
  pandaDoc: PandaDoc;
  pandaDocs: Array<PandaDoc>;
  paymentTerms: Array<PaymentTerm>;
  paymentTermDueFromDetails: Array<PaymentTermDueFromDetail>;
  planMilestone: PlanMilestone;
  planMilestones: PlanMilestonesResult;
  planPackage: PlanPackage;
  planPackages: PlanPackagesPageResult;
  draftPlanSchedule: DraftScheduleResult;
  /** Query for planTask & planMilestone historical date snapshots. Default `asOfDate` is `PlanSchedule.currentBaselineDate` */
  planScheduleSnapshots: PlanScheduleSnapshotsResult;
  planSchedule: PlanSchedule;
  planTask: PlanTask;
  planTasks: PlanTasksResult;
  preconContractTypes: Array<PreconContractType>;
  products: Array<Product>;
  productsPage: ProductsPage;
  attributes: Array<ProductAttribute>;
  attributeTypes: Array<ProductAttributeTypeDetail>;
  dimensionTypes: Array<ProductDimensionTypeDetail>;
  productStatuses: Array<ProductStatusDetail>;
  promotionStatuses: Array<PromotionStatusDetail>;
  productOffering: ProductOffering;
  productOfferings: ProductOfferingsPageResult;
  potentialOptions: Array<ReadyPlanOption>;
  /** Computes the cost and price details for a product offering, including the selected and unselected options. */
  computeProductOfferingCostsAndPrices: ComputeProductOfferingCostsAndPricesResponse;
  /** Calculates the default options for a product offering based on the current configuration. */
  calculateDefaultOfferingOptions: Array<ReadyPlanOption>;
  /**  Calculates the scope difference (added and removed TLIVs) between two product offering configurations.  */
  calculateScopeChange: CalculateScopeChangeResult;
  productOfferingConfig: ProductOfferingConfig;
  productOfferingConfigs: ProductOfferingConfigsPage;
  computeProductOfferingConfigCosts: ComputeProductOfferingConfigCostsResult;
  productTypes: Array<ProductType>;
  computeProgramData: NewProgramData;
  /**
   * note: `id` is deprecated, use `filter` instead
   * @deprecated Use the paginated projectsPage query
   */
  projects: Array<Project>;
  projectsPage: ProjectsPageResult;
  project: Project;
  projectFeatures: Array<ProjectFeatureDetail>;
  homeownerProject: Project;
  homeownerProjects: Array<Project>;
  myTeamMemberProjects: Array<Project>;
  projectRoleDetails: Array<ProjectRoleDetail>;
  projectsToUpdateByTemplates: ProjectsToUpdateByTemplatesResult;
  projectOptionCutoffs: Array<OptionWithCutoffDate>;
  /** note: this is a top level resolver due to the expense of calling it */
  projectCompletedTaskBudgetReview: Array<ProjectCompletedTaskBudgetReview>;
  projectDirectMarginGraph: ProjectDirectMarginGraph;
  projectChangeEventGraphs: ProjectChangeEventGraphsResult;
  projectCostCodes: ProjectCostCodesPageResult;
  projectItem: ProjectItem;
  projectItems: Array<ProjectItem>;
  projectItemsPage: ProjectItemsPage;
  projectLotDetail: ProjectLotDetail;
  projectLotDetails: Array<ProjectLotDetail>;
  projectReadyPlanConfig: ProjectReadyPlanConfig;
  projectReadyPlanConfigs: Array<ProjectReadyPlanConfig>;
  projectStage: ProjectStage;
  projectStatusChangeReasons: Array<ProjectStatusChangeReason>;
  punchlistItemTodos: Array<PunchlistItemTodo>;
  readyPlan: ReadyPlan;
  readyPlans: Array<ReadyPlan>;
  readyPlanStatuses: Array<ReadyPlanStatusDetail>;
  computeReadyPlanCost: ComputeReadyPlanCostResult;
  /** @deprecated Use readyPlanLike2 instead */
  readyPlanLike: Array<ReadyPlanLike>;
  /**  Replacement for readyPlanLike which has the initially desired error when ID doesn't exist and returns a singular entity.  */
  readyPlanLike2: ReadyPlanLike;
  readyPlanAggregateVersions: Array<ReadyPlanAggregateVersion>;
  readyPlanAggregateVersionsPage: ReadyPlanAggregateVersionsPageResult;
  readyPlanAggregateVersion: ReadyPlanAggregateVersion;
  readyPlanConfigLike: ReadyPlanConfigLike;
  readyPlanOption: ReadyPlanOption;
  readyPlanOptions: Array<ReadyPlanOption>;
  referencable: Referencable;
  region: Region;
  regions: Array<Region>;
  requiredTaskDocument: RequiredTaskDocument;
  roomTypes: Array<RoomType>;
  testQuery: Scalars['Int']['output'];
  schedules: Array<Schedule>;
  schedule: Schedule;
  scheduleFlags: Array<ScheduleFlag>;
  scheduleFlagReasons: Array<ScheduleFlagReason>;
  schedulePhases: Array<SchedulePhase>;
  schedulePhase: SchedulePhase;
  latestActivePhase?: Maybe<SchedulePhase>;
  scheduleSubPhases: Array<ScheduleSubPhase>;
  scheduleSubPhase: ScheduleSubPhase;
  scheduleTask: ScheduleTask;
  scheduleTasks: Array<ScheduleTask>;
  milestoneTasksForTemplates: Array<ScheduleTask>;
  scheduleTemplates: Array<ScheduleTemplate>;
  scheduleTemplate: ScheduleTemplate;
  scopeChangeReasons: Array<ScopeChangeReason>;
  siteSpecificInfos: Array<SiteSpecificInfo>;
  stages: Array<StageDetail>;
  structure: Structure;
  structures: StructuresPageResult;
  subdivision: Subdivision;
  submarkets: Array<Submarket>;
  takeoffLineItem: TakeoffLineItem;
  takeoffLineItemsPage: TakeoffLineItemsPage;
  testGroupDependenciesLineItems: Array<TakeoffLineItem>;
  task: Task;
  tasks: Array<Task>;
  /**  By default returns a max of 100 tasks. We purposefully don't support paging due to cross-db/TS filtering.  */
  tasks2: TaskPage;
  tasksPage: TaskPage;
  taskStatuses: Array<TaskStatusDetail>;
  toDoStatuses: Array<ToDoStatusDetail>;
  toDoTypes?: Maybe<Array<ToDoTypeDetail>>;
  toDos: Array<ToDo>;
  trackedJob: TrackedJob;
  trackedJobs: Array<TrackedJob>;
  tradeCategories: Array<TradeCategory>;
  tradeCategory: TradeCategory;
  tradeCategoryLeadTimes: Array<TradeCategoryLeadTimeLike>;
  tradePartners: Array<TradePartner>;
  tradePartnersPage: TradePartnersPage;
  tradePartner: TradePartner;
  tradePartnerContactsWithRoles: Array<MarketContactWithRoles>;
  tradePartnerMailingLists: Array<TradePartnerMailingList>;
  tradePartnerMarketRoles: Array<TradePartnerMarketRoleDetail>;
  tradePartnerRequirement: TradePartnerRequirement;
  tradePartnerRequirements: Array<TradePartnerRequirement>;
  tradePartnerRequirementTypes: Array<TradePartnerRequirementTypeDetail>;
  tradePartnerRequirementStatuses: Array<TradePartnerRequirementStatusDetail>;
  unit: Unit;
  unitsOfMeasure: Array<UnitOfMeasure>;
  currentUser?: Maybe<User>;
  communicationChannels: Array<CommunicationChannelDetail>;
  userCommunicationPreferences?: Maybe<UserCommunicationPreference>;
  userEvents: Array<UserEvent>;
  userEventParentTypes: Array<UserEventParentType>;
  userGroup?: Maybe<UserGroup>;
  userGroups: Array<UserGroup>;
  warrantyTicket: WarrantyTicket;
  warrantyTickets: Array<WarrantyTicket>;
  warrantyTicketsPage: WarrantyTicketsPage;
  warrantyTicketItemTypesDetail: Array<WarrantyTicketItemTypeDetail>;
  warrantyTicketItemStatusesDetail: Array<WarrantyTicketItemStatusDetail>;
  warrantyTicketTypesDetail: Array<WarrantyTicketTypeDetail>;
  warrantyTicketStatusesDetail: Array<WarrantyTicketStatusDetail>;
  workAuthorization: WorkAuthorization;
  workAuthorizations: Array<WorkAuthorization>;
};


export type QueryApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApprovalsArgs = {
  filter: ApprovalFilter;
};


export type QueryAssetsArgs = {
  filter: AssetsFilter;
};


export type QueryBidContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBidContractItemsArgs = {
  filter?: InputMaybe<BidContractItemsFilter>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  developmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryBidContractsPageArgs = {
  filter?: InputMaybe<BidContractsFilter>;
  page?: InputMaybe<PageFilter>;
  order?: InputMaybe<BidContractOrder>;
};


export type QueryBidContractLineItemsArgs = {
  filter?: InputMaybe<BidContractLineItemFilter>;
};


export type QueryBidContractLineItemsPageArgs = {
  filter?: InputMaybe<BidContractLineItemFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBidContractRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBidItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBidItemsArgs = {
  filter?: InputMaybe<BidItemFilter>;
  order?: InputMaybe<BidItemOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBidItemsPageArgs = {
  filter?: InputMaybe<BidItemFilter>;
  order?: InputMaybe<BidItemOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPotentialBidItemsArgs = {
  filter?: InputMaybe<PotentialBidItemFilter>;
};


export type QueryBidItemEstimateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBidItemEstimatesArgs = {
  filter?: InputMaybe<BidItemEstimateFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBidPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPotentialBidItemsPageArgs = {
  filter: PotentialBidItemsPageFilter;
  order?: InputMaybe<BidItemOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOverlappingBidPackagesArgs = {
  costCodes: Array<Scalars['ID']['input']>;
  costType: CostType;
  projects: Array<Scalars['ID']['input']>;
  scopeSource: BidScopeSource;
};


export type QueryBidPackageGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBidPackageGroupsArgs = {
  filter?: InputMaybe<BidPackageGroupsFilter>;
  orderBy?: InputMaybe<BidPackageGroupOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBidPackageGroupProductOfferingsInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBidPackageVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBidPackageVersionScopeLinesArgs = {
  id: Scalars['ID']['input'];
  filter: BpvScopeLinesFilter;
};


export type QueryBillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillsArgs = {
  filter?: InputMaybe<BillFilter>;
  order?: InputMaybe<BillOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBillsPageArgs = {
  filter?: InputMaybe<BillFilter>;
  order?: InputMaybe<BillOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryBillMetricsArgs = {
  filter?: InputMaybe<BillFilter>;
};


export type QueryBillGmailMessagesArgs = {
  filter: BillGmailMessageFilter;
  page?: InputMaybe<PageFilter>;
  orderBy?: InputMaybe<BillGmailMessageOrderBy>;
};


export type QueryBillOcrArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBuilderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBusinessFunctionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectRolesForBusinessFunctionTypeArgs = {
  businessFunctionType: BusinessFunctionType;
};


export type QueryChangeEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChangeEventsArgs = {
  filter?: InputMaybe<ChangeEventFilter>;
};


export type QueryChangeEventLineItemsArgs = {
  filter?: InputMaybe<ChangeEventLineItemFilter>;
};


export type QueryChangeRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChangeRequestsArgs = {
  filter?: InputMaybe<ChangeRequestsFilter>;
  orderBy?: InputMaybe<ChangeRequestOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryAvailableDependencyChangeRequestsArgs = {
  id: Scalars['ID']['input'];
  kind: ChangeRequestDependency;
};


export type QueryChangeRequestAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChangeRequestAssetsArgs = {
  filter?: InputMaybe<ChangeRequestAssetFilter>;
  orderBy?: InputMaybe<ChangeRequestAssetOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryChangeRequestGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCheckoutConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCheckoutConfigsArgs = {
  filter?: InputMaybe<CheckoutConfigsFilter>;
  order?: InputMaybe<CheckoutConfigsOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryCheckoutPricingTraceArgs = {
  input: CheckoutPricingTraceInput;
};


export type QueryInsideMapsSlotAuditArgs = {
  input: InsideMapsSlotAuditInput;
};


export type QueryInsideMapsSlotDiffArgs = {
  input: InsideMapsSlotDiffInput;
};


export type QueryCohortsArgs = {
  filter?: InputMaybe<CohortFilter>;
};


export type QueryCohortArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCanCollaborateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommentStreamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserRelevantCommentStreamsArgs = {
  filter: UserRelevantCommentStreamsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserRelevantCommentStreamsPagedArgs = {
  filter: UserRelevantCommentStreamsFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryCommentableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommitmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommitmentsArgs = {
  filter?: InputMaybe<CommitmentsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommitmentOrder>;
};


export type QueryCommitmentsPageArgs = {
  filter?: InputMaybe<CommitmentsFilter>;
  page?: InputMaybe<PageFilter>;
  orderBy?: InputMaybe<CommitmentOrder>;
};


export type QueryCommitmentChangeOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunitiesArgs = {
  filter?: InputMaybe<ProjectFilter>;
  orderBy?: InputMaybe<ProjectOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryCostCodesArgs = {
  filter?: InputMaybe<CostCodeFilter>;
};


export type QueryCostDivisionsArgs = {
  filter?: InputMaybe<CostDivisionFilter>;
};


export type QueryCustomerOwnerEntitiesArgs = {
  filter: CustomerOwnerEntityFilter;
};


export type QueryDesignPackageArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDesignPackagesArgs = {
  filter?: InputMaybe<DesignPackageFilter>;
  orderBy?: InputMaybe<DesignPackageOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryDesignPackageFinishScheduleArgs = {
  filter: DesignPackageFinishScheduleFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryPlaceholderCombinationsArgs = {
  input: PlaceholderCombinationsInput;
};


export type QueryDevelopmentsArgs = {
  filter?: InputMaybe<DevelopmentFilter>;
};


export type QueryDevelopmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDevelopmentLotSummaryChartsArgs = {
  id: Scalars['ID']['input'];
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryDevelopmentCommitmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDevelopmentCommitmentsArgs = {
  filter: DevelopmentCommitmentFilter;
};


export type QueryDevelopmentCommitmentsPageArgs = {
  filter: DevelopmentCommitmentFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryProtoDevelopmentCommitmentSummaryArgs = {
  projectIds: Array<Scalars['ID']['input']>;
  tradeCategoryIds: Array<Scalars['ID']['input']>;
  stage?: InputMaybe<Stage>;
  type?: InputMaybe<DevelopmentCommitmentType>;
  costTypes?: InputMaybe<Array<CostType>>;
};


export type QueryDevelopmentCommitmentPotentialLineItemsArgs = {
  developmentCommitmentId?: InputMaybe<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  stage?: InputMaybe<Stage>;
};


export type QueryDocumentTypesArgs = {
  systemControlled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DocumentsOrder>;
};


export type QueryDocumentsPageArgs = {
  filter: DocumentsFilter;
  page: PageFilter;
  order?: InputMaybe<DocumentsOrder>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserProjectDocumentsArgs = {
  project: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDropsArgs = {
  filter?: InputMaybe<DropsFilter>;
};


export type QueryEntityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIdentifyProjectAccrualAdjustmentsArgs = {
  input: IdentifyProjectAccrualAdjustmentsInput;
};


export type QueryProjectEstimateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectEstimatesArgs = {
  filter: EstimateFilter;
};


export type QueryExpensesArgs = {
  filter?: InputMaybe<ExpenseFilter>;
};


export type QueryExpensesPageArgs = {
  filter?: InputMaybe<ExpenseFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeatureFlagArgs = {
  type: FeatureFlagType;
};


export type QueryFeatureFlagsArgs = {
  filter: FeatureFlagFilter;
};


export type QueryAvailableFeatureFlagTypesArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFollowableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalOptionsArgs = {
  filter?: InputMaybe<GlobalOptionsFilter>;
};


export type QueryGlobalOptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalOptionGroupsArgs = {
  filter?: InputMaybe<GlobalOptionGroupFilter>;
};


export type QueryGlobalOptionTagsArgs = {
  filter?: InputMaybe<GlobalOptionTagsFilter>;
};


export type QueryGlobalOptionTypesArgs = {
  filter?: InputMaybe<GlobalOptionTypesFilter>;
};


export type QueryGlobalPhasesArgs = {
  filter?: InputMaybe<GlobalPhaseFilter>;
};


export type QueryGlobalPhaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalPlanMilestoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalPlanMilestonesArgs = {
  filter?: InputMaybe<GlobalPlanMilestoneFilter>;
  page?: InputMaybe<PageFilter>;
  orderBy?: InputMaybe<GlobalPlanMilestoneOrder>;
};


export type QueryGlobalPlanStageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalPlanTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalPlanTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalPlanTasksArgs = {
  filter?: InputMaybe<GlobalPlanTaskFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryGlobalSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryGlobalSubPhasesArgs = {
  filter?: InputMaybe<GlobalSubPhasesFilter>;
};


export type QueryGlobalTasksArgs = {
  filter?: InputMaybe<GlobalTasksFilter>;
};


export type QueryHomeownersArgs = {
  filter?: InputMaybe<HomeownersFilter>;
  order?: InputMaybe<HomeownersOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryHomeownerContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeownerContractsArgs = {
  filter: HomeownerContractFilter;
};


export type QueryHomeownerContractChangeOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeownerContractChangeOrdersArgs = {
  filter: HomeownerContractChangeOrderFilter;
};


export type QueryHomeownerNotesArgs = {
  filter?: InputMaybe<HomeownerNoteFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHomeownerNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeownerSelectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeownerSelectionOptionArgs = {
  id: Scalars['ID']['input'];
  homeownerSelectionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInternalUsersArgs = {
  filter?: InputMaybe<InternalUserFilter>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  order?: InputMaybe<InvoiceOrder>;
};


export type QueryInvoicesPageArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  order?: InputMaybe<InvoiceOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryInvoiceScheduleTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryItemsArgs = {
  filter?: InputMaybe<ItemFilter>;
};


export type QueryItemPlanTaskMappingPageArgs = {
  page?: InputMaybe<PageFilter>;
};


export type QueryItemTemplatesArgs = {
  filter?: InputMaybe<ItemTemplateFilter>;
  order?: InputMaybe<ItemTemplateOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryItemTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryItemTemplateItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryItemTemplateItemVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryItemTemplateItemVersionsArgs = {
  filter?: InputMaybe<ItemTemplateItemVersionFilter>;
};


export type QueryItemTemplateItemVersionsPageArgs = {
  filter?: InputMaybe<ItemTemplateItemVersionFilter>;
  subFilter?: InputMaybe<ItemTemplateItemVersionFilter>;
  order?: InputMaybe<Array<ItemTemplateItemVersionOrder>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryItemTemplateItemVersionGroupTotalsArgs = {
  input: GroupTotalsInput;
};


export type QueryJobLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobLogsArgs = {
  filter: JobLogFilter;
};


export type QueryJobLogsPageArgs = {
  filter: JobLogFilter;
  orderBy?: InputMaybe<JobLogOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryJobLogImagesArgs = {
  filter: JobLogImageFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<JobLogImageOrder>;
};


export type QueryJobLogNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLienWaiverArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLienWaiversArgs = {
  filter: LienWaiverFilter;
};


export type QueryLienWaiversPageArgs = {
  filter?: InputMaybe<LienWaiverFilter>;
  order?: InputMaybe<LienWaiverOrder>;
  page: PageFilter;
};


export type QueryLocationsArgs = {
  filter?: InputMaybe<LocationsFilter>;
  orderBy?: InputMaybe<LocationOrderBy>;
  effectiveLocations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLotArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMarketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaterialAttributeDimensionsArgs = {
  filter?: InputMaybe<MaterialAttributeDimensionFilter>;
};


export type QueryMaterialBrandsArgs = {
  filter: MaterialBrandFilter;
};


export type QueryMaterialListingsArgs = {
  filter: MaterialListingsFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryMaterialVariantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaterialVariantCostSourcesArgs = {
  materialVariantId: Scalars['ID']['input'];
  orderBy?: InputMaybe<MaterialCostSourceOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryMaterialVariantsArgs = {
  filter: MaterialVariantsFilter;
  orderBy?: InputMaybe<MaterialVariantOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryMaterialVariantsForPlaceholderTliArgs = {
  filter: MaterialVariantsForPlaceholderTliFilter;
  orderBy?: InputMaybe<MaterialVariantOrderBy>;
};


export type QueryMermaidArgs = {
  input: MermaidInput;
};


export type QueryMobileSyncUpdatesArgs = {
  input: MobileSyncUpdatesInput;
  page?: InputMaybe<PageFilter>;
};


export type QueryPandaDocArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPandaDocsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<PandaDocFilter>;
};


export type QueryPaymentTermsArgs = {
  filter?: InputMaybe<PaymentTermFilter>;
};


export type QueryPlanMilestoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanMilestonesArgs = {
  filter?: InputMaybe<PlanMilestoneFilter>;
  orderBy?: InputMaybe<PlanMilestoneOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryPlanPackageArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlanPackagesArgs = {
  filter?: InputMaybe<PlanPackageFilter>;
  orderBy?: InputMaybe<PlanPackageOrderBy>;
  page?: InputMaybe<PageFilter>;
};


export type QueryDraftPlanScheduleArgs = {
  input: DraftScheduleInput;
};


export type QueryPlanScheduleSnapshotsArgs = {
  input: PlanScheduleSnapshotsInput;
};


export type QueryPlanScheduleArgs = {
  idOrScheduleParentId: Scalars['ID']['input'];
};


export type QueryPlanTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanTasksArgs = {
  filter?: InputMaybe<PlanTasksFilter>;
  order?: InputMaybe<PlanTasksOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  order?: InputMaybe<ProductOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsPageArgs = {
  filter?: InputMaybe<ProductFilter>;
  order?: InputMaybe<ProductOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAttributesArgs = {
  filter?: InputMaybe<ProductAttributeFilter>;
};


export type QueryProductOfferingArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductOfferingsArgs = {
  filter?: InputMaybe<ProductOfferingsFilter>;
  orderBy?: InputMaybe<ProductOfferingOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryPotentialOptionsArgs = {
  input: PotentialOptionsInput;
};


export type QueryComputeProductOfferingCostsAndPricesArgs = {
  input: ComputeProductOfferingCostsAndPricesInput;
};


export type QueryCalculateDefaultOfferingOptionsArgs = {
  input: CalculateDefaultOfferingOptionsInput;
};


export type QueryCalculateScopeChangeArgs = {
  input: CalculateScopeChangeInput;
};


export type QueryProductOfferingConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductOfferingConfigsArgs = {
  filter?: InputMaybe<ProductOfferingConfigsFilter>;
  order?: InputMaybe<ProductOfferingConfigOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryComputeProductOfferingConfigCostsArgs = {
  input: ProductOfferingConfigCostsInput;
};


export type QueryComputeProgramDataArgs = {
  input: ComputeProgramDataInput;
};


export type QueryProjectsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ProjectFilter>;
};


export type QueryProjectsPageArgs = {
  filter?: InputMaybe<ProjectFilter>;
  orderBy?: InputMaybe<ProjectOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeownerProjectArgs = {
  by: SearchBy;
  id: Scalars['ID']['input'];
};


export type QueryProjectsToUpdateByTemplatesArgs = {
  input: ProjectsToUpdateByTemplatesInput;
};


export type QueryProjectOptionCutoffsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectCompletedTaskBudgetReviewArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectDirectMarginGraphArgs = {
  projectId: Scalars['ID']['input'];
  filter?: InputMaybe<ProjectDirectMarginGraphFilter>;
};


export type QueryProjectChangeEventGraphsArgs = {
  projectId: Scalars['ID']['input'];
  filter?: InputMaybe<ProjectChangeEventGraphsFilter>;
};


export type QueryProjectCostCodesArgs = {
  filter?: InputMaybe<ProjectCostCodeFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryProjectItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectItemsArgs = {
  filter: ProjectItemFilter;
};


export type QueryProjectItemsPageArgs = {
  filter: ProjectItemFilter;
  page?: InputMaybe<PageFilter>;
};


export type QueryProjectLotDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectLotDetailsArgs = {
  filter: ProjectLotDetailFilter;
};


export type QueryProjectReadyPlanConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectReadyPlanConfigsArgs = {
  filter?: InputMaybe<ProjectReadyPlanConfigFilter>;
};


export type QueryProjectStageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectStatusChangeReasonsArgs = {
  filter?: InputMaybe<ProjectStatusChangeReasonsFilter>;
};


export type QueryPunchlistItemTodosArgs = {
  filter?: InputMaybe<PunchlistItemFilter>;
};


export type QueryReadyPlanArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReadyPlansArgs = {
  filter?: InputMaybe<ReadyPlanFilter>;
};


export type QueryComputeReadyPlanCostArgs = {
  input: ComputeReadyPlanCostInput;
};


export type QueryReadyPlanLikeArgs = {
  filter?: InputMaybe<ReadyPlanFilter>;
};


export type QueryReadyPlanLike2Args = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReadyPlanAggregateVersionsArgs = {
  filter: ReadyPlanAggregateVersionsFilter;
};


export type QueryReadyPlanAggregateVersionsPageArgs = {
  filter: ReadyPlanAggregateVersionsFilter;
  page: PageFilter;
};


export type QueryReadyPlanAggregateVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReadyPlanConfigLikeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReadyPlanOptionArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReadyPlanOptionsArgs = {
  filter?: InputMaybe<ReadyPlanOptionsFilter>;
};


export type QueryReferencableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRegionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequiredTaskDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTestQueryArgs = {
  error?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySchedulesArgs = {
  filter: SchedulesFilter;
};


export type QueryScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScheduleFlagsArgs = {
  filter?: InputMaybe<ScheduleFlagFilter>;
};


export type QueryScheduleFlagReasonsArgs = {
  filter: ScheduleFlagReasonsFilter;
};


export type QuerySchedulePhasesArgs = {
  filter?: InputMaybe<SchedulePhasesFilter>;
};


export type QuerySchedulePhaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLatestActivePhaseArgs = {
  parent: Scalars['ID']['input'];
  stage: Stage;
};


export type QueryScheduleSubPhasesArgs = {
  filter?: InputMaybe<ScheduleSubPhasesFilter>;
};


export type QueryScheduleSubPhaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScheduleTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScheduleTasksArgs = {
  filter?: InputMaybe<ScheduleTaskFilter>;
  order?: InputMaybe<ScheduleTaskOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMilestoneTasksForTemplatesArgs = {
  input: MilestoneTasksForTemplatesInput;
};


export type QueryScheduleTemplatesArgs = {
  filter?: InputMaybe<ScheduleTemplatesFilter>;
};


export type QueryScheduleTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStructureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStructuresArgs = {
  filter?: InputMaybe<ProjectFilter>;
  orderBy?: InputMaybe<ProjectOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QuerySubdivisionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTakeoffLineItemArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTakeoffLineItemsPageArgs = {
  filter?: InputMaybe<TakeoffLineItemFilter>;
  subFilter?: InputMaybe<TakeoffLineItemFilter>;
  order?: InputMaybe<Array<TakeoffLineItemOrder>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTestGroupDependenciesLineItemsArgs = {
  input: TestGroupDependenciesLineItemsInput;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
  filter?: InputMaybe<TaskFilter>;
  order?: InputMaybe<TaskOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTasks2Args = {
  filter?: InputMaybe<TaskFilter>;
  order?: InputMaybe<TaskOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTasksPageArgs = {
  filter?: InputMaybe<TaskFilter>;
  orderBy?: InputMaybe<TaskOrder>;
  page?: InputMaybe<PageFilter>;
};


export type QueryToDosArgs = {
  filter: ToDoFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTrackedJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrackedJobsArgs = {
  filter?: InputMaybe<TrackedJobFilter>;
};


export type QueryTradeCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTradeCategoryLeadTimesArgs = {
  filter: TradeCategoryLeadTimeFilter;
};


export type QueryTradePartnersArgs = {
  filter?: InputMaybe<TradePartnerFilter>;
};


export type QueryTradePartnersPageArgs = {
  filter: TradePartnerFilter;
  page: PageFilter;
};


export type QueryTradePartnerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTradePartnerContactsWithRolesArgs = {
  tradePartnerId: Scalars['ID']['input'];
  scopeId: Scalars['ID']['input'];
  marketRoles: Array<TradePartnerMarketRole>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTradePartnerRequirementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTradePartnerRequirementsArgs = {
  filter?: InputMaybe<TradePartnerRequirementFilter>;
};


export type QueryUnitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserCommunicationPreferencesArgs = {
  user: Scalars['ID']['input'];
};


export type QueryUserEventsArgs = {
  filter: UserEventFilter;
  order?: InputMaybe<UserEventOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserGroupsArgs = {
  filter?: InputMaybe<UserGroupFilter>;
};


export type QueryWarrantyTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWarrantyTicketsArgs = {
  filter?: InputMaybe<WarrantyTicketFilter>;
};


export type QueryWarrantyTicketsPageArgs = {
  filter?: InputMaybe<WarrantyTicketFilter>;
  page?: InputMaybe<PageFilter>;
};


export type QueryWorkAuthorizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkAuthorizationsArgs = {
  filter?: InputMaybe<WorkAuthorizationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  saveHomeownerContractLineItems: Array<HomeownerContractLineItem>;
  saveApproval: SaveApprovalResult;
  saveApprovals: SaveApprovalsResult;
  saveApprover: SaveApproverResult;
  saveApprovers: SaveApproversResult;
  /**  Creates an asset upload url with the following  key structure `assets/${UUID}`.  */
  createAssetUploadUrl: CreateAssetUploadUrlResult;
  createAsset: CreateAssetResult;
  /**
   * Creates presigned URLs for multipart upload of large files.
   * Returns URLs for each part that the client should upload to.
   * Use the returned s3Key and uploadId in AssetInput when creating/attaching the asset.
   */
  createAssetMultipartUploadUrl: CreateAssetMultipartUploadUrlResult;
  /**
   * Aborts an in-progress multipart upload and cleans up uploaded parts.
   * Call this if the client cancels the upload or encounters errors.
   */
  abortAssetMultipartUpload: AbortAssetMultipartUploadResult;
  saveAttachment: SaveAttachmentResult;
  deleteAttachment: DeleteAttachmentResult;
  deleteAuditEvents: DeleteAuditEventsResult;
  saveBidContract: SaveBidContractResult;
  saveBidContractLineItem: SaveBidContractLineItemResult;
  saveBidContractLineItems: SaveBidContractLineItemsResult;
  deleteBidContractLineItems: DeleteBidContractLineItemResult;
  saveBidContractRevision: SaveBidContractRevisionResult;
  deleteBidContractRevision: EmptyResult;
  internallySignBidContractRevision: BidContractRevision;
  saveBidContractTradeLineItems: SaveBidContractTradeLineItemsResult;
  saveBidItem: SaveBidItemResult;
  saveBidItemEstimate: SaveBidItemEstimateResult;
  saveBidPackage: SaveBidPackageResult;
  saveBidPackages: SaveBidPackagesResult;
  acceptBidPackageIncomingUpdates: BidPackage;
  deleteBidPackage: EmptyResult;
  /**
   * Creates a new BidPackageVersion on an already-awarded BidPackage, along with new draft BCRs, so costs
   * can be revised without re-running the full bidding workflow.
   */
  reviseBidPackageCosts: ReviseBidPackageCostsResult;
  saveBidPackageAwards: SaveBidPackageAwardsResult;
  saveBidPackageRequest: SaveBidPackageRequestResult;
  saveBill: SaveBillResult;
  saveBills: SaveBillsResult;
  deleteBill: EmptyResult;
  syncBillToIntacct: EmptyResult;
  handleBillEmailNotification: EmptyResult;
  handleBillParserResult: EmptyResult;
  runBillParser: RunBillParserResult;
  deletePreConBudgetLineItem: DeletePreConBudgetLineItemResult;
  savePreConBudgetLineItem: SavePreConBudgetLineItemResult;
  approvePreConBudget: ApprovePreConBudgetLineItemResult;
  saveBuilder: SaveBuilderResult;
  saveBusinessFunction: SaveBusinessFunctionResult;
  deleteChangeEvent: EmptyResult;
  saveChangeEvent: SaveChangeEventResult;
  saveChangeEvents: SaveChangeEventsResult;
  createChangeEventLineItemsFromCommitted: SaveChangeEventResult;
  saveChangeEventLineItems: SaveChangeEventLineItemsResult;
  deleteChangeEventLineItems: EmptyResult;
  saveChangeEventReason: SaveChangeEventReasonResult;
  saveChangeRequest: SaveChangeRequestResult;
  saveChangeRequests: SaveChangeRequestsResult;
  saveChangeRequestAssets: SaveChangeRequestAssetsResult;
  saveChangeRequestGroup: SaveChangeRequestGroupResult;
  saveChangeRequestGroups: SaveChangeRequestGroupsResult;
  deleteChangeRequestGroup: EmptyResult;
  saveCheckoutConfig: SaveCheckoutConfigResult;
  /**
   * Provides an escape hatch for moving an already reserved checkout config back to draft status.
   * This includes clearing the reserved prices and cutoff dates
   *
   * If `preserveExpiresAt` is true, the expiresAt date will not be cleared.
   */
  unreserveCheckoutConfig: SaveCheckoutConfigResult;
  syncCheckoutConfigToVersion: SaveCheckoutConfigResult;
  runCheckoutPricingReport: RunCheckoutPricingReportResult;
  createCredentialsForExistingClient: EmptyResult;
  updateClientEmail: EmptyResult;
  saveCohorts: SaveCohortsResult;
  deleteCohort: EmptyResult;
  saveComment: SaveCommentResult;
  deleteComment: DeleteCommentResult;
  markCommentStreamAsRead?: Maybe<CommentStream>;
  saveCommitment: SaveCommitmentResult;
  saveCommitments: SaveCommitmentsResult;
  deleteCommitmentLineItems: EmptyResult;
  deleteCommitment: EmptyResult;
  /**  Marks commitments (or change orders) created from bid contracts for release (signed) to trade partners.  */
  releaseBidCommitments: Array<CommitmentLike>;
  /**  Creates/updates commitments based on Bid Contracts.  */
  saveBidToCommitments: SaveCommitmentsResult;
  moveCommitmentsToNewTradePartner: Scalars['String']['output'];
  assignWorkToBidContract: Array<ChangeEvent>;
  unassignWorkFromBidContract: EmptyResult;
  createCommitmentFromBill: CreateCommitmentFromBillResult;
  saveCommitmentChangeOrder: SaveCommitmentChangeOrderResult;
  deleteCommitmentChangeOrder: EmptyResult;
  saveCommunity: SaveCommunityResult;
  saveCostCodes: SaveCostCodesResult;
  deleteCostCode: EmptyResult;
  saveCostDivisions: SaveCostDivisionsResult;
  deleteCostDivision: EmptyResult;
  saveCustomer: SaveCustomerResult;
  saveCustomerItemConfig: SaveCustomerItemConfigResult;
  saveCustomerOwnerEntity: SaveCustomerOwnerEntityResult;
  saveCutoff: SaveCutoffResult;
  sendTestDailyLotSummaryDigest?: Maybe<EmptyResult>;
  deleteDataCacheEntry: EmptyResult;
  clearDataCache: EmptyResult;
  saveDesignPackage: SaveDesignPackageResult;
  createDesignPackagePlaceholderTli: CreateDesignPackagePlaceholderTliResult;
  acceptDesignPackageUpdates: SaveDesignPackageUpdatesResult;
  copyDesignPackage: SaveDesignPackageResult;
  copyDesignPackageCards: CopyDesignPackageCardsResult;
  savePersonalizationOptionGroup: SavePersonalizationOptionGroupResult;
  /**  Copies selections from one option to another (e.g., make SchemeA exactly match SchemeB).  */
  copyDesignPackageSelections: CopyDesignPackageSelectionsResult;
  /**  Auto-assigns package option materials to the POF RPOs that are linked to the DP Package Personalization RPOGs.  */
  autoAssignPackageOptionMaterials: EmptyResult;
  saveDevelopments: SaveDevelopmentsResult;
  deleteDevelopments: EmptyResult;
  /**  A temporary mutation to bulk write primary bid costs into templates.  */
  pushBidCostsIntoTemplates: EmptyResult;
  saveDevelopmentCommitment: SaveDevelopmentCommitmentResult;
  deleteDevelopmentCommitment: EmptyResult;
  deleteDevelopmentCommitmentProjectsAndCommitments: DeleteDevelopmentCommitmentProjectsAndCommitmentsResult;
  saveDevelopmentOptions: SaveDevelopmentOptionsResult;
  saveDevelopmentTeamMember: EmptyResult;
  /** @deprecated Use `createAssetUploadUrl` to upload a document Asset, then use `saveDocuments` to create the Document and Asset. */
  createDocumentPendingUpload: CreateDocumentPendingUploadResult;
  /** @deprecated Use `createAssetUploadUrl` to upload a document Asset, then use `saveDocuments` to create the Document and Asset. */
  markDocumentAsUploaded: MarkDocumentAsUploadedResult;
  toggleDocumentAsFavorited: ToggleDocumentAsFavoritedResult;
  saveDocuments: SaveDocumentsResult;
  deleteDocuments: DeleteDocumentsResult;
  saveDrop: SaveDropResult;
  deleteDrop: EmptyResult;
  erpRevenueInitialBalance: EmptyResult;
  saveEstimate: SaveEstimateResult;
  saveExpenses: SaveExpensesResult;
  deleteExpenses: EmptyResult;
  convertExpenseToBill: ConvertExpenseToBillResult;
  saveExpenseAllocations: SaveExpenseAllocationsResult;
  saveFeatureFlag: SaveFeatureFlagResult;
  saveFeatureFlagTarget: SaveFeatureFlagTargetResult;
  followSequenceSheet: FollowSequenceSheetResult;
  saveFollowers: SaveFollowersResult;
  saveGlobalOptions: SaveGlobalOptionsResult;
  migrateGlobalOption?: Maybe<EmptyResult>;
  migrateGlobalOptions?: Maybe<EmptyResult>;
  backfillGlobalOptionNames: BackfillGlobalOptionNamesResult;
  saveGlobalOptionGroup: SaveGlobalOptionGroupResult;
  saveGlobalOptionTags: SaveGlobalOptionTagsResult;
  saveGlobalOptionTypes: SaveGlobalOptionTypesResult;
  /**  Used to create and update GlobalPhases  */
  saveGlobalPhases: SaveGlobalPhasesResult;
  saveGlobalPlanConstraintItem: SaveGlobalPlanConstraintItemResult;
  saveGlobalPlanConstraintItems: SaveGlobalPlanConstraintItemsResult;
  deleteGlobalPlanConstraintItem: EmptyResult;
  saveGlobalPlanMilestone: SaveGlobalPlanMilestoneResult;
  saveGlobalPlanMilestones: SaveGlobalPlanMilestonesResult;
  saveGlobalPlanMilestoneGroup: SaveGlobalPlanMilestoneGroupResult;
  saveGlobalPlanStage: SaveGlobalPlanStageResult;
  saveGlobalPlanStageVariants: SaveGlobalPlanStageVariantsResult;
  saveGlobalPlanTag: SaveGlobalPlanTagResult;
  bulkSaveGlobalPlanTags: BulkSaveGlobalPlanTagsResult;
  saveGlobalPlanTask: SaveGlobalPlanTaskResult;
  saveGlobalPlanTasks: SaveGlobalPlanTasksResult;
  saveGlobalRequiredTaskDocument: SaveGlobalRequiredTaskDocumentResult;
  /**  Used to create and update globalSubPhases  */
  saveGlobalSubPhases: SaveGlobalSubPhasesResult;
  /**  Replaces one GlobalSubPhase with another on ALL Projects  */
  replaceGlobalSubPhase?: Maybe<ReplaceGlobalSubPhaseResult>;
  saveGlobalTasks: SaveGlobalTasksResult;
  saveHomeboundHoliday: SaveHomeboundHolidayResult;
  saveHomeowner: SaveHomeownerResult;
  /** Public mutation for signing up new homeowners */
  signUpHomeowner: EmptyResult;
  saveHomeownerContract: SaveHomeownerContractResult;
  saveHomeownerContractChangeOrder: SaveHomeownerContractChangeOrderResult;
  deleteHomeownerContract?: Maybe<EmptyResult>;
  deleteHomeownerContractChangeOrder?: Maybe<EmptyResult>;
  reverseEngineerInsuranceAndContingency?: Maybe<EmptyResult>;
  saveHomeownerNote: SaveHomeownerNoteResult;
  deleteHomeownerNote?: Maybe<EmptyResult>;
  saveHomeownerSelection: SaveHomeownerSelectionResult;
  makeHomeownerSelection: MakeHomeownerSelectionResult;
  saveHomeownerSelectionOption: SaveHomeownerSelectionOptionResult;
  syncCostsForHomeownerSelectionOptions: SyncCostsForHomeownerSelectionOptionsResult;
  saveInternalUser: SaveInternalUserResult;
  reassignTeamMembers?: Maybe<EmptyResult>;
  saveInvoice: SaveInvoiceResult;
  saveInvoices: SaveInvoicesResult;
  deleteInvoice: EmptyResult;
  syncInvoiceToIntacct: EmptyResult;
  saveInvoiceDocument: SaveInvoiceDocumentResult;
  deleteInvoiceSchedule: DeleteInvoiceScheduleResult;
  saveInvoiceScheduleTemplate: SaveInvoiceScheduleTemplateResult;
  saveItems: Array<Item>;
  deleteItem: EmptyResult;
  saveItemPlanTaskMapping: SaveItemPlanTaskMappingResult;
  deleteItemPlanTaskMapping: EmptyResult;
  saveItemSlot: SaveItemSlotResult;
  saveItemTemplate: SaveItemTemplateResult;
  saveItemTemplates: SaveItemTemplatesResult;
  applyItemTemplate: ApplyItemTemplateResult;
  applyItemTemplateToChangeEvent: ApplyItemTemplateToChangeEventResult;
  cloneItemTemplate: CloneItemTemplateResult;
  copyItemTemplateItems: CopyItemTemplateItemsResult;
  createNewItemTemplateVersions: CreateNewItemTemplateVersionsResult;
  activateItemTemplateVersions: ActivateItemTemplateVersionsResult;
  recalcItemTemplateHashes: EmptyResult;
  archiveItemTemplateVersions: EmptyResult;
  deleteItemTemplates: EmptyResult;
  saveItemTemplateItemVersions: SaveItemTemplateItemVersionsResult;
  dedupeReadyPlanItemTemplateItemVersions: DedupeReadyPlanItemTemplateItemVersionsResult;
  addJob: EmptyResult;
  addJobs: EmptyResult;
  saveJobLog: SaveJobLogResult;
  duplicateJobLogs: DuplicateJobLogsResult;
  saveJobLogImage: SaveJobLogImageResult;
  deleteJobLogImage: DeleteJobLogImageResult;
  saveJobLogNote: SaveJobLogNoteResult;
  deleteJobLogNote: DeleteJobLogNoteResult;
  saveLienWaiver: SaveLienWaiverResult;
  saveLocations: SaveLocationsResult;
  deleteLocation: EmptyResult;
  /** Only returns locations that match the path received in the input */
  createLocationsFromPaths: SaveLocationsResult;
  saveLot: SaveLotResult;
  saveLotRating: SaveLotRatingResult;
  saveMarket: SaveMarketResult;
  saveMaterialAssemblyComponent: SaveMaterialAssemblyComponentResult;
  saveMaterialAttributeValue: SaveMaterialAttributeValueResult;
  backfillMavsNumericValues: BackfillResponse;
  saveMaterialBrand: SaveMaterialBrandResult;
  saveMaterialLeadTimeConfig: SaveMaterialLeadTimeConfigResult;
  mergeMaterialListings: MergeMaterialListingsResult;
  migrateMaterialListingItem: MigrateMaterialListingItemResult;
  saveMaterialListing: MaterialListing;
  saveMaterialVariant: SaveMaterialVariantResult;
  uploadMaterialVariants: UploadMaterialVariantsResult;
  saveMaterialVariantTag: SaveMaterialVariantTagResult;
  saveOptionPricingConfigs: SaveOptionPricingConfigsResult;
  deleteOptionPricingConfig: EmptyResult;
  savePandaDoc: SavePandaDocResult;
  deletePandaDoc: DeletePandaDocResult;
  uploadPandaDoc: UploadPandaDocResult;
  handlePandaDocWebhook: EmptyResult;
  createPandaDocSession: PandaDocSession;
  savePaymentTerm: SavePaymentTermResult;
  savePlanPackage: SavePlanPackageResult;
  copyPlanPackage: SavePlanPackageResult;
  backfillPlanPackageOptionGroupLocations: Array<ReadyPlanOptionGroup>;
  deletePlanPackageIncomingSlots: EmptyResult;
  savePlanSchedule: SavePlanScheduleResult;
  saveDraftSchedule: DraftScheduleResult;
  resetPlanScheduleDates: SavePlanScheduleResult;
  savePlanTask: SavePlanTaskResult;
  savePlanTaskChecklistItem: SavePlanTaskChecklistItemResult;
  deletePlanTaskChecklistItem: EmptyResult;
  savePreconContractType: SavePreconContractTypeResult;
  /**
   * ProductAttributes can be added/created/removed via this
   * one mutation. Similarly product images can also be added/removed.
   */
  saveProducts: SaveProductsResult;
  deleteProduct: EmptyResult;
  /**
   * These mutations are meant for product attribute maintenance,
   * like correcting tag values and eliminating duplicates
   * However the UI could choose to make attributes this way and then
   * associate them to a product.
   */
  saveProductAttributes: SaveProductAttributesResult;
  deleteProductAttribute: EmptyResult;
  saveProductOffering: SaveProductOfferingResult;
  acceptProductOfferingUpdates: ProductOffering;
  promoteToCheckout: EmptyResult;
  saveProductOfferingConfig: SaveProductOfferingConfigResult;
  saveProductType: SaveProductTypeResult;
  toggleProjectFeature: SaveProjectResult;
  deleteProject: EmptyResult;
  saveProject: SaveProjectResult;
  recalcProjectDates: EmptyResult;
  /**
   * Call the google maps api to populate projects with geocoding info based on build address.
   * We are currently calling this manually as a part of hack day. In the future we will also do this as a part of project creation
   */
  geocodeProjects: EmptyResult;
  resyncProjectFinancials: EmptyResult;
  cloneProjectCostAllocations: CloneProjectCostAllocationsResult;
  exportProjectBills: ExportProjectBillsResult;
  /** @deprecated Field no longer supported */
  createProjectFromReadyPlanConfig: SaveProjectResult;
  createProjectFromReadyPlan: SaveProjectResult;
  applyInvoiceScheduleToProject: ApplyInvoiceScheduleResult;
  saveProjectAllocationRule: SaveProjectAllocationRuleResult;
  saveProjectCollaborator: EmptyResult;
  sendInviteEmail: SendInviteEmailResult;
  deleteProjectCollaborator: EmptyResult;
  saveProjectContact: SaveProjectContactResult;
  saveProjectCutoff: SaveProjectCutoffResult;
  saveProjectInvoiceSetting: SaveProjectInvoiceSettingResult;
  saveProjectItems: SaveProjectItemsResult;
  duplicateProjectItems: DuplicateProjectItemsResult;
  deleteProjectItem: EmptyResult;
  deleteProjectItems: EmptyResult;
  saveProjectLotDetails: SaveProjectLotDetailsResult;
  saveProjectReadyPlanConfigs: SaveProjectReadyPlanConfigsResult;
  applyProjectReadyPlanConfigs: ApplyProjectReadyPlanConfigsResult;
  /**  Used to update the price of ProjectReadyPlanConfigOptions.  */
  saveProjectReadyPlanConfigOptions: SaveProjectReadyPlanConfigOptionsResult;
  syncSalesforcePrpc: EmptyResult;
  saveProjectSiteCondition: SaveProjectSiteConditionResult;
  sendProjectSiteConditionsNotification: EmptyResult;
  saveProjectSiteSpecificInfo: SaveProjectSiteSpecificInfoResult;
  /**  Admin.  */
  saveProjectStage: EmptyResult;
  /**
   *  Schedule.
   * @deprecated Use `saveProjectStage`.
   */
  completeStage: EmptyResult;
  saveProjectStatusChangeReasons: SaveProjectStatusChangeReasonsResult;
  updateProjectRole: UpdateProjectRoleResult;
  bulkUpdateProjectRole: Array<BulkUpdateProjectRoleResult>;
  sendProjectUpdate?: Maybe<EmptyResult>;
  savePunchlistItemTodos: SavePunchlistItemTodosResult;
  /**
   * Sends an email to the trade partner associated with punchlist items.
   *
   * If additional emails or contacts are provided, then a single TradePartner must be associated with all items.
   * A project must be associated with all items, but multiple projects are allowed.
   */
  sendTradePartnerPunchlistEmail: SendTradePartnerPunchlistEmailResults;
  /** Export a CSV of punchlist items and send it via email. */
  sendPunchlistExportEmail: SendPunchlistExportEmailResults;
  registerPushNotificationToken: RegisterPushNotificationTokenResult;
  unregisterPushNotificationToken: EmptyResult;
  saveReadyPlan: SaveReadyPlanResult;
  saveReadyPlans: SaveReadyPlansResult;
  deleteReadyPlans: EmptyResult;
  /**
   * Scopes GOGs to RPs via the GOG.readyPlan relation. Ensures global options are moved/copied accordingly.
   * Currently only supports scoping Interior/Exterior Scheme and Package Personalization GOGs to DPs.
   *
   * Example 1: Scoping Interior Scheme
   * Given an Interior Scheme GOG (gog:1) and the following DPs that use the GOG: rp:1, rp:2, rp:3,
   * When we scope the GOG to the DPs,
   * Then 3 new GOGs should be created:
   * - gog:2, readyPlan: rp:1
   * - gog:3, readyPlan: rp:2
   * - gog:4, readyPlan: rp:3
   * And the original GOG should be deleted
   */
  scopeGlobalOptionGroupsToReadyPlans: ScopeGlobalOptionGroupsToReadyPlansResult;
  saveReadyPlanAggregateVersion: SaveReadyPlanAggregateVersionResult;
  /**  Deletes a ReadyPlanAggregateVersion, and all related changes.  */
  deleteReadyPlanAggregateVersion: DeleteReadyPlanAggregateVersionResult;
  saveReadyPlanDesignNote: SaveReadyPlanDesignNoteResult;
  saveReadyPlanLocations: SaveReadyPlanLocationBulkResult;
  createDesignPackageAlternateLocation: CreateDesignPackageAlternateLocationResult;
  saveDesignPackageLocationPlanMappings: SaveDesignPackageLocationPlanMappingsResult;
  deleteDesignPackageAlternateLocation: SaveDesignPackageLocationPlanMappingsResult;
  saveReadyPlanOptions: SaveReadyPlanOptionsResult;
  mergeReadyPlanOptions: MergeReadyPlanOptionsResult;
  saveReadyPlanOptionGroup: SaveReadyPlanOptionGroupResult;
  saveReadyPlanOptionGroups: SaveReadyPlanOptionGroupsResult;
  saveReadyPlanOptionProgramDataModifications: SaveReadyPlanOptionProgramDataModificationsResult;
  deleteReadyPlanOptionProgramDataModifications: Array<DeleteReadyPlanOptionProgramDataModificationsResult>;
  saveReadyPlanRequiredOptions: SaveReadyPlanRequiredOptionsResult;
  saveReferences: SaveReferencesResult;
  deleteReferences: EmptyResult;
  saveRegion: SaveRegionResult;
  saveRequiredTaskDocument: SaveRequiredTaskDocumentResult;
  deleteRequireTaskDocument: DeleteRequiredTaskDocumentResult;
  saveRoomType: SaveRoomTypeResult;
  testMutation: TestMutationResult;
  syncSalesforceEntity: EmptyResult;
  saveSchedule: SaveScheduleResult;
  /** @deprecated This mutation is no longer supported, please use the `resetScheduleBaselines` job via `addJobForSchedules` mutation instead. */
  resetScheduleBaselines: ResetScheduleBaselinesResult;
  scheduleSoftDeleteSubPhasesWithEmptyTasks?: Maybe<EmptyResult>;
  addJobForSchedules: EmptyResult;
  saveScheduleFlag: SaveScheduleFlagResult;
  deleteScheduleFlag: DeleteScheduleFlagResult;
  saveScheduleFlagReasons: SaveScheduleFlagReasonsResult;
  /**  Used to Create and Update SchedulePhases  */
  saveSchedulePhases: SaveSchedulePhasesResult;
  deleteSchedulePhases: DeleteSchedulePhasesResult;
  recalculateSchedulePhaseStatus: EmptyResult;
  saveScheduleSettings: SaveScheduleSettingsResult;
  /** Create or update one or more ScheduleSubPhases */
  saveScheduleSubPhases: SaveScheduleSubPhasesResult;
  /** Delete a ScheduleSubPhase and all associated ScheduleTasks */
  deleteScheduleSubPhases: DeleteScheduleSubPhasesResult;
  /** Move a list of ScheduleSubPhases to different GlobalPhase -> SchedulePhase parent */
  moveScheduleSubPhases: MoveScheduleSubPhasesResult;
  /** Recalculate the task status rollup on ScheduleSubPhases via a job */
  recalculateScheduleSubPhaseStatus: EmptyResult;
  saveScheduleTasks: SaveScheduleTasksResult;
  saveScheduleTaskChecklistItem: SaveScheduleTaskChecklistItemResult;
  deleteScheduleTaskChecklistItem: EmptyResult;
  applyTemplateChecklistItems?: Maybe<EmptyResult>;
  saveScheduleTemplates: SaveScheduleTemplatesResult;
  duplicateScheduleTemplate: DuplicateScheduleTemplateResult;
  applyScheduleTemplates: ApplyScheduleTemplatesResult;
  saveScheduleTemplateItemMappings: SaveScheduleTemplateItemMappingsResult;
  saveScopeChangeReason: SaveScopeChangeReasonResult;
  setupData: EmptyResult;
  saveSiteSpecificInfo: SaveSiteSpecificInfoResult;
  saveStructure: SaveStructureResult;
  saveSubdivision: SaveSubdivisionResult;
  saveSubmarket: SaveSubmarketResult;
  saveTakeoffLineItems: SaveTakeoffLineItemResult;
  copyTakeoffLineItems: CopyTakeoffLineItemsResult;
  /** @deprecated Use `saveScheduleTasks` with `delete: true` instead */
  deleteTask: EmptyResult;
  saveTaskWorkDay: SaveTaskWorkDayResult;
  saveToDos: SaveToDosResult;
  deleteToDo: EmptyResult;
  saveToDoChecklistItem: SaveToDoChecklistItemResult;
  saveTradeCategory: SaveTradeCategoryResult;
  saveTradeCategoryLeadTimes: SaveTradeCategoryLeadTimesResult;
  /** @deprecated Use `saveTradePartners`. */
  saveTradePartner: SaveTradePartnerResult;
  saveTradePartners: SaveTradePartnersResult;
  deleteTradePartner: EmptyResult;
  saveTradePartnerAgreement: SaveTradePartnerAgreementResult;
  deleteTradePartnerAgreement: DeleteTradePartnerAgreementResult;
  saveTradePartnerAvailabilityRequest: SaveTradePartnerAvailabilityRequestResult;
  saveTradePartnerAvailabilityRequests: SaveTradePartnerAvailabilityRequestsResult;
  /**  keeping this input separate for permissioning with the trade portal.  */
  updateTradePartnerAvailabilityRequestStatus: EmptyResult;
  approveTradePartnerAvailabilityRequest: EmptyResult;
  saveTradePartnerContact: SaveTradePartnerContactResult;
  deleteTradePartnerContact: DeleteTradePartnerContactResult;
  saveTradePartnerMarketContact: SaveTradePartnerMarketContactResult;
  deleteTradePartnerMarketContact: DeleteTradePartnerMarketContactResult;
  saveTradePartnerRequirement: SaveTradePartnerRequirementResult;
  saveTradePartnerReview: SaveTradePartnerReviewResult;
  saveUnit: SaveUnitResult;
  saveUnitsOfMeasure: SaveUnitsOfMeasureResult;
  deleteUnitOfMeasure: EmptyResult;
  saveUser: SaveUserResult;
  activateUser: ActivateUserResult;
  deactivateUser: DeactivateUserResult;
  activateUsers: ActivateUsersResult;
  deactivateUsers: DeactivateUsersResult;
  saveUserCommunicationPreference: SaveUserCommunicationPreferenceResult;
  saveUserGroup: SaveUserGroupResult;
  removeUserGroup: EmptyResult;
  deleteWarrantyTicket: EmptyResult;
  saveWarrantyTicket: SaveWarrantyTicketResult;
  saveWarrantyTicketItem: SaveWarrantyTicketItemResult;
  deleteWarrantyTicketItem: EmptyResult;
  saveWarrantyTicketItems: SaveWarrantyTicketItemsResult;
  saveWorkAuthorization: SaveWorkAuthorizationResult;
  deleteWorkAuthorization: EmptyResult;
};


export type MutationSaveHomeownerContractLineItemsArgs = {
  input: SaveHomeownerContractLineItemsInput;
};


export type MutationSaveApprovalArgs = {
  input: SaveApprovalInput;
};


export type MutationSaveApprovalsArgs = {
  input: Array<SaveApprovalInput>;
};


export type MutationSaveApproverArgs = {
  input: SaveApproverInput;
};


export type MutationSaveApproversArgs = {
  inputs: Array<SaveApproverInput>;
};


export type MutationCreateAssetUploadUrlArgs = {
  input: CreateAssetUploadUrlInput;
};


export type MutationCreateAssetArgs = {
  input: AssetInput;
};


export type MutationCreateAssetMultipartUploadUrlArgs = {
  input: CreateAssetMultipartUploadUrlInput;
};


export type MutationAbortAssetMultipartUploadArgs = {
  input: AbortAssetMultipartUploadInput;
};


export type MutationSaveAttachmentArgs = {
  input: SaveAttachmentInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteAuditEventsArgs = {
  input: DeleteAuditEventsInput;
};


export type MutationSaveBidContractArgs = {
  input: SaveBidContractInput;
};


export type MutationSaveBidContractLineItemArgs = {
  input: SaveBidContractLineItemInput;
};


export type MutationSaveBidContractLineItemsArgs = {
  bidContractRevisionId: Scalars['ID']['input'];
  lineItems: Array<SaveBidContractLineItemInput>;
};


export type MutationDeleteBidContractLineItemsArgs = {
  bidContractRevisionId: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']>;
};


export type MutationSaveBidContractRevisionArgs = {
  input: SaveBidContractRevisionInput;
};


export type MutationDeleteBidContractRevisionArgs = {
  input: DeleteBidContractRevisionInput;
};


export type MutationInternallySignBidContractRevisionArgs = {
  input: InternallySignBidContractRevisionInput;
};


export type MutationSaveBidContractTradeLineItemsArgs = {
  input: SaveBidContractTradeLineItemsInput;
};


export type MutationSaveBidItemArgs = {
  input: SaveBidItemInput;
};


export type MutationSaveBidItemEstimateArgs = {
  input: SaveBidItemEstimateInput;
};


export type MutationSaveBidPackageArgs = {
  input: SaveBidPackageInput;
};


export type MutationSaveBidPackagesArgs = {
  input: Array<SaveBidPackageInput>;
};


export type MutationAcceptBidPackageIncomingUpdatesArgs = {
  input: AcceptBidPackageIncomingUpdatesInput;
};


export type MutationDeleteBidPackageArgs = {
  input: DeleteEntityInput;
};


export type MutationReviseBidPackageCostsArgs = {
  input: ReviseBidPackageCostsInput;
};


export type MutationSaveBidPackageAwardsArgs = {
  input: SaveBidPackageAwardsInput;
};


export type MutationSaveBidPackageRequestArgs = {
  input: SaveBidPackageRequestInput;
};


export type MutationSaveBillArgs = {
  input: SaveBillInput;
};


export type MutationSaveBillsArgs = {
  input: SaveBillsInput;
};


export type MutationDeleteBillArgs = {
  input: DeleteBillInput;
};


export type MutationSyncBillToIntacctArgs = {
  input: SyncBillToIntacctInput;
};


export type MutationHandleBillEmailNotificationArgs = {
  input: HandleBillEmailNotificationInput;
};


export type MutationHandleBillParserResultArgs = {
  input: HandleBillParserResultInput;
};


export type MutationRunBillParserArgs = {
  input: RunBillParserInput;
};


export type MutationDeletePreConBudgetLineItemArgs = {
  input: DeletePreConBudgetLineItemInput;
};


export type MutationSavePreConBudgetLineItemArgs = {
  input: SavePreConBudgetLineItemInput;
};


export type MutationApprovePreConBudgetArgs = {
  input: ApprovePreConBudgetLineItemInput;
};


export type MutationSaveBuilderArgs = {
  input: SaveBuilderInput;
};


export type MutationSaveBusinessFunctionArgs = {
  input: SaveBusinessFunctionInput;
};


export type MutationDeleteChangeEventArgs = {
  input: DeleteChangeEventInput;
};


export type MutationSaveChangeEventArgs = {
  input: SaveChangeEventInput;
};


export type MutationSaveChangeEventsArgs = {
  input: Array<SaveChangeEventsInput>;
};


export type MutationCreateChangeEventLineItemsFromCommittedArgs = {
  changeEventId: Scalars['ID']['input'];
  includeDraftCommitments?: InputMaybe<Scalars['Boolean']['input']>;
  includeZeroCommitted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSaveChangeEventLineItemsArgs = {
  input: SaveChangeEventLineItemsInput;
};


export type MutationDeleteChangeEventLineItemsArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveChangeEventReasonArgs = {
  input: SaveChangeEventReasonInput;
};


export type MutationSaveChangeRequestArgs = {
  input: SaveChangeRequestInput;
};


export type MutationSaveChangeRequestsArgs = {
  input: SaveChangeRequestsInput;
};


export type MutationSaveChangeRequestAssetsArgs = {
  input: SaveChangeRequestAssetsInput;
};


export type MutationSaveChangeRequestGroupArgs = {
  input: SaveChangeRequestGroupInput;
};


export type MutationSaveChangeRequestGroupsArgs = {
  input: Array<SaveChangeRequestGroupInput>;
};


export type MutationDeleteChangeRequestGroupArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveCheckoutConfigArgs = {
  input: SaveCheckoutConfigInput;
};


export type MutationUnreserveCheckoutConfigArgs = {
  input: UnreserveCheckoutConfigInput;
};


export type MutationSyncCheckoutConfigToVersionArgs = {
  input: SyncCheckoutConfigToVersionInput;
};


export type MutationRunCheckoutPricingReportArgs = {
  input: RunCheckoutPricingReportInput;
};


export type MutationCreateCredentialsForExistingClientArgs = {
  input: CreateCredentialsForExistingClientInput;
};


export type MutationUpdateClientEmailArgs = {
  input: UpdateClientEmailInput;
};


export type MutationSaveCohortsArgs = {
  input: SaveCohortsInput;
};


export type MutationDeleteCohortArgs = {
  input: DeleteCohortInput;
};


export type MutationSaveCommentArgs = {
  input: SaveCommentInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationMarkCommentStreamAsReadArgs = {
  input: MarkCommentStreamAsReadInput;
};


export type MutationSaveCommitmentArgs = {
  input: SaveCommitmentInput;
};


export type MutationSaveCommitmentsArgs = {
  input: Array<SaveCommitmentInput>;
};


export type MutationDeleteCommitmentLineItemsArgs = {
  input: DeleteCommitmentLineItemsInput;
};


export type MutationDeleteCommitmentArgs = {
  input: DeleteCommitmentInput;
};


export type MutationReleaseBidCommitmentsArgs = {
  commitmentLikeIds: Array<Scalars['ID']['input']>;
};


export type MutationSaveBidToCommitmentsArgs = {
  inputs: Array<SaveBidToCommitmentsInput>;
};


export type MutationMoveCommitmentsToNewTradePartnerArgs = {
  input: MoveCommitmentsToNewTradePartnerInput;
};


export type MutationAssignWorkToBidContractArgs = {
  input: Array<AssignWorkToBidContractInput>;
};


export type MutationUnassignWorkFromBidContractArgs = {
  input: UnassignWorkFromBidContractInput;
};


export type MutationCreateCommitmentFromBillArgs = {
  input: CreateCommitmentFromBillInput;
};


export type MutationSaveCommitmentChangeOrderArgs = {
  input: SaveCommitmentChangeOrderInput;
};


export type MutationDeleteCommitmentChangeOrderArgs = {
  input: DeleteCommitmentChangeOrderInput;
};


export type MutationSaveCommunityArgs = {
  input: SaveCommunityInput;
};


export type MutationSaveCostCodesArgs = {
  input: SaveCostCodesInput;
};


export type MutationDeleteCostCodeArgs = {
  input: DeleteCostCodeInput;
};


export type MutationSaveCostDivisionsArgs = {
  input: SaveCostDivisionsInput;
};


export type MutationDeleteCostDivisionArgs = {
  input: DeleteCostDivisionInput;
};


export type MutationSaveCustomerArgs = {
  input: SaveCustomerInput;
};


export type MutationSaveCustomerItemConfigArgs = {
  input: SaveCustomerItemConfigInput;
};


export type MutationSaveCustomerOwnerEntityArgs = {
  input: SaveCustomerOwnerEntityInput;
};


export type MutationSaveCutoffArgs = {
  input: SaveCutoffInput;
};


export type MutationSendTestDailyLotSummaryDigestArgs = {
  input: SendTestDailyLotSummaryDigestInput;
};


export type MutationDeleteDataCacheEntryArgs = {
  input: DeleteDataCacheEntryInput;
};


export type MutationClearDataCacheArgs = {
  input: ClearDataCacheInput;
};


export type MutationSaveDesignPackageArgs = {
  input: SaveDesignPackageInput;
};


export type MutationCreateDesignPackagePlaceholderTliArgs = {
  input: CreateDesignPackagePlaceholderTliInput;
};


export type MutationAcceptDesignPackageUpdatesArgs = {
  input: AcceptDesignPackageUpdatesInput;
};


export type MutationCopyDesignPackageArgs = {
  input: CopyDesignPackageInput;
};


export type MutationCopyDesignPackageCardsArgs = {
  input: CopyDesignPackageCardsInput;
};


export type MutationSavePersonalizationOptionGroupArgs = {
  input: SavePersonalizationOptionGroupInput;
};


export type MutationCopyDesignPackageSelectionsArgs = {
  input: CopyDesignPackageSelectionsInput;
};


export type MutationAutoAssignPackageOptionMaterialsArgs = {
  input: AutoAssignPackageOptionMaterialsInput;
};


export type MutationSaveDevelopmentsArgs = {
  input: SaveDevelopmentsInput;
};


export type MutationDeleteDevelopmentsArgs = {
  input: DeleteEntitiesInput;
};


export type MutationPushBidCostsIntoTemplatesArgs = {
  developmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSaveDevelopmentCommitmentArgs = {
  input: SaveDevelopmentCommitmentInput;
};


export type MutationDeleteDevelopmentCommitmentArgs = {
  input: DeleteDevelopmentCommitmentInput;
};


export type MutationDeleteDevelopmentCommitmentProjectsAndCommitmentsArgs = {
  input: DeleteDevelopmentCommitmentProjectsAndCommitmentsInput;
};


export type MutationSaveDevelopmentOptionsArgs = {
  input: SaveDevelopmentOptionsInput;
};


export type MutationSaveDevelopmentTeamMemberArgs = {
  input: SaveDevelopmentTeamMemberInput;
};


export type MutationCreateDocumentPendingUploadArgs = {
  input: CreateDocumentPendingUploadInput;
};


export type MutationMarkDocumentAsUploadedArgs = {
  input: MarkDocumentAsUploadedInput;
};


export type MutationToggleDocumentAsFavoritedArgs = {
  input: ToggleDocumentAsFavoritedInput;
};


export type MutationSaveDocumentsArgs = {
  input: SaveDocumentsInput;
};


export type MutationDeleteDocumentsArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveDropArgs = {
  input: SaveDropInput;
};


export type MutationDeleteDropArgs = {
  input: DeleteDropInput;
};


export type MutationErpRevenueInitialBalanceArgs = {
  input: ErpRevenueInitialBalanceInput;
};


export type MutationSaveEstimateArgs = {
  input: SaveEstimateInput;
};


export type MutationSaveExpensesArgs = {
  input: SaveExpensesInput;
};


export type MutationDeleteExpensesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationConvertExpenseToBillArgs = {
  input: ConvertExpenseToBillInput;
};


export type MutationSaveExpenseAllocationsArgs = {
  input: SaveExpenseAllocationsInput;
};


export type MutationSaveFeatureFlagArgs = {
  input: SaveFeatureFlagInput;
};


export type MutationSaveFeatureFlagTargetArgs = {
  input: SaveFeatureFlagTargetInput;
};


export type MutationFollowSequenceSheetArgs = {
  input: FollowSequenceSheetInput;
};


export type MutationSaveFollowersArgs = {
  input: SaveFollowersInput;
};


export type MutationSaveGlobalOptionsArgs = {
  input: SaveGlobalOptionsInput;
};


export type MutationMigrateGlobalOptionArgs = {
  input: MigrateGlobalOptionInput;
};


export type MutationMigrateGlobalOptionsArgs = {
  input: MigrateGlobalOptionsInput;
};


export type MutationBackfillGlobalOptionNamesArgs = {
  input: BackfillGlobalOptionNamesInput;
};


export type MutationSaveGlobalOptionGroupArgs = {
  input: SaveGlobalOptionGroupInput;
};


export type MutationSaveGlobalOptionTagsArgs = {
  input: SaveGlobalOptionTagsInput;
};


export type MutationSaveGlobalOptionTypesArgs = {
  input: SaveGlobalOptionTypesInput;
};


export type MutationSaveGlobalPhasesArgs = {
  input: SaveGlobalPhasesInput;
};


export type MutationSaveGlobalPlanConstraintItemArgs = {
  input: SaveGlobalPlanConstraintItemInput;
};


export type MutationSaveGlobalPlanConstraintItemsArgs = {
  input: Array<SaveGlobalPlanConstraintItemInput>;
};


export type MutationDeleteGlobalPlanConstraintItemArgs = {
  input: DeleteGlobalPlanConstraintItemInput;
};


export type MutationSaveGlobalPlanMilestoneArgs = {
  input: SaveGlobalPlanMilestoneInput;
};


export type MutationSaveGlobalPlanMilestonesArgs = {
  input: SaveGlobalPlanMilestonesInput;
};


export type MutationSaveGlobalPlanMilestoneGroupArgs = {
  input: SaveGlobalMilestoneGroupInput;
};


export type MutationSaveGlobalPlanStageArgs = {
  input: SaveGlobalPlanStageInput;
};


export type MutationSaveGlobalPlanStageVariantsArgs = {
  input: SaveGlobalPlanStageVariantsInput;
};


export type MutationSaveGlobalPlanTagArgs = {
  input: SaveGlobalPlanTagInput;
};


export type MutationBulkSaveGlobalPlanTagsArgs = {
  input: Array<SaveGlobalPlanTagInput>;
};


export type MutationSaveGlobalPlanTaskArgs = {
  input: SaveGlobalPlanTaskInput;
};


export type MutationSaveGlobalPlanTasksArgs = {
  input: Array<SaveGlobalPlanTaskInput>;
};


export type MutationSaveGlobalRequiredTaskDocumentArgs = {
  input: SaveGlobalRequiredTaskDocumentInput;
};


export type MutationSaveGlobalSubPhasesArgs = {
  input: SaveGlobalSubPhasesInput;
};


export type MutationReplaceGlobalSubPhaseArgs = {
  input: ReplaceGlobalSubPhaseInput;
};


export type MutationSaveGlobalTasksArgs = {
  input: SaveGlobalTasksInput;
};


export type MutationSaveHomeboundHolidayArgs = {
  input: SaveHomeboundHolidayInput;
};


export type MutationSaveHomeownerArgs = {
  input: SaveHomeownerInput;
};


export type MutationSignUpHomeownerArgs = {
  input: SignUpHomeownerInput;
};


export type MutationSaveHomeownerContractArgs = {
  input: SaveHomeownerContractInput;
};


export type MutationSaveHomeownerContractChangeOrderArgs = {
  input: SaveHomeownerContractChangeOrderInput;
};


export type MutationDeleteHomeownerContractArgs = {
  input: DeleteEntityInput;
};


export type MutationDeleteHomeownerContractChangeOrderArgs = {
  input: DeleteHomeownerContractChangeOrderInput;
};


export type MutationReverseEngineerInsuranceAndContingencyArgs = {
  homeownerContractId: Scalars['ID']['input'];
  newMarkupInBasisPoints: Scalars['Int']['input'];
  insuranceItemId: Scalars['ID']['input'];
  insurancePriceInCents: Scalars['Int']['input'];
  contingencyItemId: Scalars['ID']['input'];
};


export type MutationSaveHomeownerNoteArgs = {
  input: SaveHomeownerNoteInput;
};


export type MutationDeleteHomeownerNoteArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveHomeownerSelectionArgs = {
  input: HomeownerSelectionInput;
};


export type MutationMakeHomeownerSelectionArgs = {
  input: MakeHomeownerSelectionInput;
};


export type MutationSaveHomeownerSelectionOptionArgs = {
  input: HomeownerSelectionOptionInput;
};


export type MutationSyncCostsForHomeownerSelectionOptionsArgs = {
  input: SyncCostsForHomeownerSelectionOptionsInput;
};


export type MutationSaveInternalUserArgs = {
  input: SaveInternalUserInput;
};


export type MutationReassignTeamMembersArgs = {
  input: ReassignTeamMembersInput;
};


export type MutationSaveInvoiceArgs = {
  input: SaveInvoiceInput;
};


export type MutationSaveInvoicesArgs = {
  input: SaveInvoicesInput;
};


export type MutationDeleteInvoiceArgs = {
  input: DeleteInvoiceInput;
};


export type MutationSyncInvoiceToIntacctArgs = {
  input: SyncInvoiceToIntacctInput;
};


export type MutationSaveInvoiceDocumentArgs = {
  input: SaveInvoiceDocumentInput;
};


export type MutationDeleteInvoiceScheduleArgs = {
  input: DeleteInvoiceScheduleInput;
};


export type MutationSaveInvoiceScheduleTemplateArgs = {
  input: SaveInvoiceScheduleTemplateInput;
};


export type MutationSaveItemsArgs = {
  input: SaveItemsInput;
};


export type MutationDeleteItemArgs = {
  input: DeleteItemInput;
};


export type MutationSaveItemPlanTaskMappingArgs = {
  input: SaveItemPlanTaskMappingInput;
};


export type MutationDeleteItemPlanTaskMappingArgs = {
  input: DeleteItemPlanTaskMappingInput;
};


export type MutationSaveItemSlotArgs = {
  input: SaveItemSlotInput;
};


export type MutationSaveItemTemplateArgs = {
  input: SaveItemTemplateInput;
};


export type MutationSaveItemTemplatesArgs = {
  input: SaveItemTemplatesInput;
};


export type MutationApplyItemTemplateArgs = {
  input: ApplyItemTemplateInput;
};


export type MutationApplyItemTemplateToChangeEventArgs = {
  input: ApplyItemTemplateToChangeEventInput;
};


export type MutationCloneItemTemplateArgs = {
  input: CloneItemTemplateInput;
};


export type MutationCopyItemTemplateItemsArgs = {
  input: CopyItemTemplateItemsInput;
};


export type MutationCreateNewItemTemplateVersionsArgs = {
  input: CreateNewItemTemplateVersionsInput;
};


export type MutationActivateItemTemplateVersionsArgs = {
  input: ActivateItemTemplateVersionsInput;
};


export type MutationRecalcItemTemplateHashesArgs = {
  input?: InputMaybe<ItemTemplateFilter>;
};


export type MutationArchiveItemTemplateVersionsArgs = {
  input: ArchiveItemTemplateVersionsInput;
};


export type MutationDeleteItemTemplatesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveItemTemplateItemVersionsArgs = {
  input: SaveItemTemplateItemVersionsInput;
  groupTotalsInput?: InputMaybe<GroupTotalsInput>;
};


export type MutationDedupeReadyPlanItemTemplateItemVersionsArgs = {
  input: DedupeReadyPlanItemTemplateItemVersionsInput;
};


export type MutationAddJobArgs = {
  input: AddJobInput;
};


export type MutationAddJobsArgs = {
  input: AddJobsInput;
};


export type MutationSaveJobLogArgs = {
  input: SaveJobLogInput;
};


export type MutationDuplicateJobLogsArgs = {
  input: DuplicateJobLogsInput;
};


export type MutationSaveJobLogImageArgs = {
  input: SaveJobLogImageInput;
};


export type MutationDeleteJobLogImageArgs = {
  input: DeleteJobLogImageInput;
};


export type MutationSaveJobLogNoteArgs = {
  input: SaveJobLogNoteInput;
};


export type MutationDeleteJobLogNoteArgs = {
  input: DeleteJobLogNoteInput;
};


export type MutationSaveLienWaiverArgs = {
  input: SaveLienWaiverInput;
};


export type MutationSaveLocationsArgs = {
  input: SaveLocationsInput;
};


export type MutationDeleteLocationArgs = {
  input: DeleteLocationInput;
};


export type MutationCreateLocationsFromPathsArgs = {
  input: CreateLocationsFromPathsInput;
};


export type MutationSaveLotArgs = {
  input: SaveLotInput;
};


export type MutationSaveLotRatingArgs = {
  input: SaveLotRatingInput;
};


export type MutationSaveMarketArgs = {
  input: SaveMarketInput;
};


export type MutationSaveMaterialAssemblyComponentArgs = {
  input: SaveMaterialAssemblyComponentInput;
};


export type MutationSaveMaterialAttributeValueArgs = {
  input: SaveMaterialAttributeValueInput;
};


export type MutationSaveMaterialBrandArgs = {
  input: SaveMaterialBrandInput;
};


export type MutationSaveMaterialLeadTimeConfigArgs = {
  input: SaveMaterialLeadTimeConfigInput;
};


export type MutationMergeMaterialListingsArgs = {
  input: MergeMaterialListingsInput;
};


export type MutationMigrateMaterialListingItemArgs = {
  input: MigrateMaterialListingItemInput;
};


export type MutationSaveMaterialListingArgs = {
  input: SaveMaterialListingInput;
};


export type MutationSaveMaterialVariantArgs = {
  input: SaveMaterialVariantInput;
};


export type MutationUploadMaterialVariantsArgs = {
  input: UploadMaterialVariantsInput;
};


export type MutationSaveMaterialVariantTagArgs = {
  input: SaveMaterialVariantTagInput;
};


export type MutationSaveOptionPricingConfigsArgs = {
  input: SaveOptionPricingConfigsInput;
};


export type MutationDeleteOptionPricingConfigArgs = {
  input: DeleteOptionPricingConfigInput;
};


export type MutationSavePandaDocArgs = {
  input: SavePandaDocInput;
};


export type MutationDeletePandaDocArgs = {
  input: DeletePandaDocInput;
};


export type MutationUploadPandaDocArgs = {
  input: UploadPandaDocInput;
};


export type MutationHandlePandaDocWebhookArgs = {
  input: HandlePandaDocWebhookInput;
};


export type MutationCreatePandaDocSessionArgs = {
  input: CreatePandaDocSessionInput;
};


export type MutationSavePaymentTermArgs = {
  input: SavePaymentTermInput;
};


export type MutationSavePlanPackageArgs = {
  input: SavePlanPackageInput;
};


export type MutationCopyPlanPackageArgs = {
  input: CopyPlanPackageInput;
};


export type MutationBackfillPlanPackageOptionGroupLocationsArgs = {
  input: BackfillPlanPackageOptionGroupLocationsInput;
};


export type MutationDeletePlanPackageIncomingSlotsArgs = {
  input: DeletePlanPackageIncomingSlotsInput;
};


export type MutationSavePlanScheduleArgs = {
  input: SavePlanScheduleInput;
};


export type MutationSaveDraftScheduleArgs = {
  input: DraftScheduleInput;
};


export type MutationResetPlanScheduleDatesArgs = {
  input: ResetPlanScheduleDatesInput;
};


export type MutationSavePlanTaskArgs = {
  input: SavePlanTaskInput;
};


export type MutationSavePlanTaskChecklistItemArgs = {
  input: SavePlanTaskChecklistItemInput;
};


export type MutationDeletePlanTaskChecklistItemArgs = {
  input: DeletePlanTaskChecklistItemInput;
};


export type MutationSavePreconContractTypeArgs = {
  input: SavePreconContractTypeInput;
};


export type MutationSaveProductsArgs = {
  input: SaveProductsInput;
};


export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};


export type MutationSaveProductAttributesArgs = {
  input: SaveProductAttributesInput;
};


export type MutationDeleteProductAttributeArgs = {
  input: DeleteProductAttributeInput;
};


export type MutationSaveProductOfferingArgs = {
  input: SaveProductOfferingInput;
};


export type MutationAcceptProductOfferingUpdatesArgs = {
  input: AcceptProductOfferingUpdatesInput;
};


export type MutationPromoteToCheckoutArgs = {
  input: PromoteToCheckoutInput;
};


export type MutationSaveProductOfferingConfigArgs = {
  input: SaveProductOfferingConfigInput;
};


export type MutationSaveProductTypeArgs = {
  input: SaveProductTypeInput;
};


export type MutationToggleProjectFeatureArgs = {
  input: ToggleProjectFeatureInput;
};


export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


export type MutationSaveProjectArgs = {
  input: ProjectInput;
};


export type MutationRecalcProjectDatesArgs = {
  input: RecalcProjectDatesInput;
};


export type MutationGeocodeProjectsArgs = {
  input: GeocodeProjectsInput;
};


export type MutationResyncProjectFinancialsArgs = {
  input?: InputMaybe<ResyncProjectFinancialsInput>;
};


export type MutationCloneProjectCostAllocationsArgs = {
  input: CloneProjectCostAllocationsInput;
};


export type MutationExportProjectBillsArgs = {
  input: ExportProjectBillsInput;
};


export type MutationCreateProjectFromReadyPlanConfigArgs = {
  input: CreateProjectFromReadyPlanConfigInput;
};


export type MutationCreateProjectFromReadyPlanArgs = {
  input: CreateProjectFromReadyPlanInput;
};


export type MutationApplyInvoiceScheduleToProjectArgs = {
  input: ApplyInvoiceScheduleInput;
};


export type MutationSaveProjectAllocationRuleArgs = {
  input: SaveProjectAllocationRuleInput;
};


export type MutationSaveProjectCollaboratorArgs = {
  input: SaveProjectCollaboratorInput;
};


export type MutationSendInviteEmailArgs = {
  input: SendInviteEmailInput;
};


export type MutationDeleteProjectCollaboratorArgs = {
  input: DeleteProjectCollaboratorInput;
};


export type MutationSaveProjectContactArgs = {
  input: SaveProjectContactInput;
};


export type MutationSaveProjectCutoffArgs = {
  input: SaveProjectCutoffInput;
};


export type MutationSaveProjectInvoiceSettingArgs = {
  input: SaveProjectInvoiceSettingInput;
};


export type MutationSaveProjectItemsArgs = {
  input: ProjectItemsInput;
};


export type MutationDuplicateProjectItemsArgs = {
  input: DuplicateProjectItemsInput;
};


export type MutationDeleteProjectItemArgs = {
  input: DeleteProjectItemInput;
};


export type MutationDeleteProjectItemsArgs = {
  input: DeleteProjectItemsInput;
};


export type MutationSaveProjectLotDetailsArgs = {
  input: SaveProjectLotDetailsInput;
};


export type MutationSaveProjectReadyPlanConfigsArgs = {
  input: SaveProjectReadyPlanConfigsInput;
};


export type MutationApplyProjectReadyPlanConfigsArgs = {
  input: ApplyProjectReadyPlanConfigsInput;
};


export type MutationSaveProjectReadyPlanConfigOptionsArgs = {
  input: Array<SaveProjectReadyPlanConfigOptionInput>;
};


export type MutationSyncSalesforcePrpcArgs = {
  input: SyncSalesforcePrpcInput;
};


export type MutationSaveProjectSiteConditionArgs = {
  input: SaveProjectSiteConditionInput;
};


export type MutationSendProjectSiteConditionsNotificationArgs = {
  input: SendProjectSiteConditionsNotificationInput;
};


export type MutationSaveProjectSiteSpecificInfoArgs = {
  input: SaveProjectSiteSpecificInfoInput;
};


export type MutationSaveProjectStageArgs = {
  input: SaveProjectStageInput;
};


export type MutationCompleteStageArgs = {
  input: CompleteStageInput;
};


export type MutationSaveProjectStatusChangeReasonsArgs = {
  input: SaveProjectStatusChangeReasonsInput;
};


export type MutationUpdateProjectRoleArgs = {
  input: UpdateProjectRoleInput;
};


export type MutationBulkUpdateProjectRoleArgs = {
  input: BulkUpdateProjectRolesInput;
};


export type MutationSendProjectUpdateArgs = {
  input: ProjectUpdateInput;
};


export type MutationSavePunchlistItemTodosArgs = {
  input: SavePunchlistItemTodosInput;
};


export type MutationSendTradePartnerPunchlistEmailArgs = {
  input: SendTradePartnerPunchlistEmailInput;
};


export type MutationSendPunchlistExportEmailArgs = {
  input: SendPunchlistExportEmailInput;
};


export type MutationRegisterPushNotificationTokenArgs = {
  input: RegisterPushNotificationTokenInput;
};


export type MutationUnregisterPushNotificationTokenArgs = {
  input: UnregisterPushNotificationTokenInput;
};


export type MutationSaveReadyPlanArgs = {
  input: SaveReadyPlanInput;
};


export type MutationSaveReadyPlansArgs = {
  input: SaveReadyPlansInput;
};


export type MutationDeleteReadyPlansArgs = {
  input: DeleteReadyPlansInput;
};


export type MutationScopeGlobalOptionGroupsToReadyPlansArgs = {
  input: ScopeGlobalOptionGroupsToReadyPlansInput;
};


export type MutationSaveReadyPlanAggregateVersionArgs = {
  input: SaveReadyPlanAggregateVersionInput;
};


export type MutationDeleteReadyPlanAggregateVersionArgs = {
  input: DeleteReadyPlanAggregateVersionInput;
};


export type MutationSaveReadyPlanDesignNoteArgs = {
  input: SaveReadyPlanDesignNoteInput;
};


export type MutationSaveReadyPlanLocationsArgs = {
  inputs: Array<SaveReadyPlanLocationInput>;
};


export type MutationCreateDesignPackageAlternateLocationArgs = {
  input: CreateDesignPackageAlternateLocationInput;
};


export type MutationSaveDesignPackageLocationPlanMappingsArgs = {
  input: Array<SaveDesignPackageLocationPlanMappingInput>;
};


export type MutationDeleteDesignPackageAlternateLocationArgs = {
  altRplId: Scalars['ID']['input'];
};


export type MutationSaveReadyPlanOptionsArgs = {
  input: SaveReadyPlanOptionsInput;
};


export type MutationMergeReadyPlanOptionsArgs = {
  input: MergeReadyPlanOptionsInput;
};


export type MutationSaveReadyPlanOptionGroupArgs = {
  input: SaveReadyPlanOptionGroupInput;
};


export type MutationSaveReadyPlanOptionGroupsArgs = {
  inputs: Array<SaveReadyPlanOptionGroupInput>;
};


export type MutationSaveReadyPlanOptionProgramDataModificationsArgs = {
  input: Array<SaveReadyPlanOptionProgramDataModificationInput>;
};


export type MutationDeleteReadyPlanOptionProgramDataModificationsArgs = {
  input: DeleteReadyPlanOptionProgramDataModificationsInput;
};


export type MutationSaveReadyPlanRequiredOptionsArgs = {
  input: Array<SaveReadyPlanRequiredOptionInput>;
};


export type MutationSaveReferencesArgs = {
  input: SaveReferencesInput;
};


export type MutationDeleteReferencesArgs = {
  input: DeleteReferencesInput;
};


export type MutationSaveRegionArgs = {
  input: SaveRegionInput;
};


export type MutationSaveRequiredTaskDocumentArgs = {
  input: SaveRequiredTaskDocumentInput;
};


export type MutationDeleteRequireTaskDocumentArgs = {
  input: DeleteRequireTaskDocumentInput;
};


export type MutationSaveRoomTypeArgs = {
  input: SaveRoomTypeInput;
};


export type MutationTestMutationArgs = {
  input: TestMutationInput;
};


export type MutationSyncSalesforceEntityArgs = {
  input: SyncSalesforceEntityInput;
};


export type MutationSaveScheduleArgs = {
  input: SaveScheduleInput;
};


export type MutationResetScheduleBaselinesArgs = {
  input: ResetScheduleBaselinesInput;
};


export type MutationScheduleSoftDeleteSubPhasesWithEmptyTasksArgs = {
  scheduleId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddJobForSchedulesArgs = {
  input: AddJobsForSchedulesInput;
};


export type MutationSaveScheduleFlagArgs = {
  input: SaveScheduleFlagInput;
};


export type MutationDeleteScheduleFlagArgs = {
  input: DeleteScheduleFlagInput;
};


export type MutationSaveScheduleFlagReasonsArgs = {
  input: SaveScheduleFlagReasonsInput;
};


export type MutationSaveSchedulePhasesArgs = {
  input: SaveSchedulePhasesInput;
};


export type MutationDeleteSchedulePhasesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveScheduleSettingsArgs = {
  input: SaveScheduleSettingsInput;
};


export type MutationSaveScheduleSubPhasesArgs = {
  input: SaveScheduleSubPhasesInput;
};


export type MutationDeleteScheduleSubPhasesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationMoveScheduleSubPhasesArgs = {
  input: MoveScheduleSubPhasesInput;
};


export type MutationSaveScheduleTasksArgs = {
  input: SaveScheduleTasksInput;
};


export type MutationSaveScheduleTaskChecklistItemArgs = {
  input: SaveScheduleTaskChecklistItemInput;
};


export type MutationDeleteScheduleTaskChecklistItemArgs = {
  input: DeleteScheduleTaskChecklistItemInput;
};


export type MutationApplyTemplateChecklistItemsArgs = {
  input: ApplyTemplateChecklistItems;
};


export type MutationSaveScheduleTemplatesArgs = {
  input: SaveScheduleTemplatesInput;
};


export type MutationDuplicateScheduleTemplateArgs = {
  input: DuplicateScheduleTemplateInput;
};


export type MutationApplyScheduleTemplatesArgs = {
  input: ApplyScheduleTemplatesInput;
};


export type MutationSaveScheduleTemplateItemMappingsArgs = {
  input: SaveScheduleTemplateItemMappingsInput;
};


export type MutationSaveScopeChangeReasonArgs = {
  input: SaveScopeChangeReasonInput;
};


export type MutationSetupDataArgs = {
  input: SetupDataInput;
};


export type MutationSaveSiteSpecificInfoArgs = {
  input: SaveSiteSpecificInfoInput;
};


export type MutationSaveStructureArgs = {
  input: SaveStructureInput;
};


export type MutationSaveSubdivisionArgs = {
  input: SaveSubdivisionInput;
};


export type MutationSaveSubmarketArgs = {
  input: SaveSubmarketInput;
};


export type MutationSaveTakeoffLineItemsArgs = {
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  input: Array<SaveTakeoffLineItemInput>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  groupTotalsInput?: InputMaybe<TliGroupTotalsInput>;
};


export type MutationCopyTakeoffLineItemsArgs = {
  input: CopyTakeoffLineItemsInput;
};


export type MutationDeleteTaskArgs = {
  input: DeleteTaskInput;
};


export type MutationSaveTaskWorkDayArgs = {
  input: SaveTaskWorkDayInput;
};


export type MutationSaveToDosArgs = {
  input: SaveToDosInput;
};


export type MutationDeleteToDoArgs = {
  input: DeleteToDoInput;
};


export type MutationSaveToDoChecklistItemArgs = {
  input: SaveToDoChecklistItemInput;
};


export type MutationSaveTradeCategoryArgs = {
  input: SaveTradeCategoryInput;
};


export type MutationSaveTradeCategoryLeadTimesArgs = {
  input: SaveTradeCategoryLeadTimesInput;
};


export type MutationSaveTradePartnerArgs = {
  input: SaveTradePartnerInput;
};


export type MutationSaveTradePartnersArgs = {
  input: SaveTradePartnersInput;
};


export type MutationDeleteTradePartnerArgs = {
  input: DeleteTradePartnerInput;
};


export type MutationSaveTradePartnerAgreementArgs = {
  input: SaveTradePartnerAgreementInput;
};


export type MutationDeleteTradePartnerAgreementArgs = {
  input: DeleteTradePartnerAgreementInput;
};


export type MutationSaveTradePartnerAvailabilityRequestArgs = {
  input: SaveTradePartnerAvailabilityRequestInput;
};


export type MutationSaveTradePartnerAvailabilityRequestsArgs = {
  input: Array<SaveTradePartnerAvailabilityRequestInput>;
};


export type MutationUpdateTradePartnerAvailabilityRequestStatusArgs = {
  input: UpdateTradePartnerAvailabilityRequestStatusInput;
};


export type MutationApproveTradePartnerAvailabilityRequestArgs = {
  confirmationToken: Scalars['String']['input'];
};


export type MutationSaveTradePartnerContactArgs = {
  input: SaveTradePartnerContactInput;
};


export type MutationDeleteTradePartnerContactArgs = {
  input: DeleteTradePartnerContactInput;
};


export type MutationSaveTradePartnerMarketContactArgs = {
  input: SaveTradePartnerMarketContactInput;
};


export type MutationDeleteTradePartnerMarketContactArgs = {
  input: DeleteTradePartnerMarketContactInput;
};


export type MutationSaveTradePartnerRequirementArgs = {
  input: SaveTradePartnerRequirementInput;
};


export type MutationSaveTradePartnerReviewArgs = {
  input: SaveTradePartnerReviewInput;
};


export type MutationSaveUnitArgs = {
  input: SaveUnitInput;
};


export type MutationSaveUnitsOfMeasureArgs = {
  input: SaveUnitsOfMeasureInput;
};


export type MutationDeleteUnitOfMeasureArgs = {
  input: DeleteUnitOfMeasureInput;
};


export type MutationSaveUserArgs = {
  input: SaveUserInput;
};


export type MutationActivateUserArgs = {
  input: ActivateUserInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};


export type MutationActivateUsersArgs = {
  input: ActivateUsersInput;
};


export type MutationDeactivateUsersArgs = {
  input: DeactivateUsersInput;
};


export type MutationSaveUserCommunicationPreferenceArgs = {
  input: SaveUserCommunicationPreferenceInput;
};


export type MutationSaveUserGroupArgs = {
  input: SaveUserGroupInput;
};


export type MutationRemoveUserGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWarrantyTicketArgs = {
  input: DeleteWarrantyTicketInput;
};


export type MutationSaveWarrantyTicketArgs = {
  input: SaveWarrantyTicketInput;
};


export type MutationSaveWarrantyTicketItemArgs = {
  input: SaveWarrantyTicketItemInput;
};


export type MutationDeleteWarrantyTicketItemArgs = {
  input: DeleteWarrantyTicketItemInput;
};


export type MutationSaveWarrantyTicketItemsArgs = {
  input: SaveWarrantyTicketItemsInput;
};


export type MutationSaveWorkAuthorizationArgs = {
  input: SaveWorkAuthorizationInput;
};


export type MutationDeleteWorkAuthorizationArgs = {
  input: DeleteEntityInput;
};

export type SaveHomeownerContractLineItemsInput = {
  lineItems: Array<SaveHomeownerContractLineItemInput>;
};

export type HomeownerContractLineItem = {
  __typename?: 'HomeownerContractLineItem';
  id: Scalars['ID']['output'];
  priceChangeInCents?: Maybe<Scalars['Int']['output']>;
  budgetChangeInCents?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  costCode: CostCode;
  internalNote?: Maybe<Scalars['String']['output']>;
  invoiceLineItems: Array<InvoiceLineItem>;
  projectItem: ProjectItem;
  /** @deprecated use `owner` because it's consistent with naming across the app */
  parent: HomeownerContractLike;
  owner: HomeownerContractLike;
  amountPaidInCents?: Maybe<Scalars['Int']['output']>;
  invoicedAmountInCents: Scalars['Int']['output'];
  changeEventLineItem?: Maybe<ChangeEventLineItem>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  specifications?: Maybe<Scalars['String']['output']>;
  bidItem?: Maybe<BidItem>;
  allocations: Array<HomeownerContractLineItemAllocation>;
};

export type SaveHomeownerContractLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  priceChangeInCents?: InputMaybe<Scalars['Int']['input']>;
  budgetChangeInCents?: InputMaybe<Scalars['Int']['input']>;
  costCodeId?: InputMaybe<Scalars['ID']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  changeEventLineItemId?: InputMaybe<Scalars['ID']['input']>;
  isAllowance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Address = {
  __typename?: 'Address';
  id: Scalars['ID']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  country: Scalars['String']['output'];
};

export type AddressInput = {
  /**  We don't include id b/c addresses are logically owned by their parent entities.  */
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
};

export type Approval = HasBlueprintUrl & Named & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'Approval';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  dueOn?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: ApprovalStatusDetail;
  requestedBy?: Maybe<User>;
  rootProject?: Maybe<Project>;
  approvers: Array<Approver>;
  source?: Maybe<ApprovalSource>;
  subject: ApprovalSubject;
  blueprintUrl: Url;
  isFinalized: Scalars['Boolean']['output'];
  userEvents: Array<UserEvent>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type ApprovalPage = {
  __typename?: 'ApprovalPage';
  approvals: Array<Approval>;
  pageInfo: PageInfo;
};

export type ApprovalFilter = {
  /**  These all actually exist on Approvals  */
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestedAt?: InputMaybe<DateFilter2>;
  dueOn?: InputMaybe<DateFilter2>;
  createdAt?: InputMaybe<DateFilter2>;
  status?: InputMaybe<Array<ApprovalStatus>>;
  /**  InternalUserId | TradePartnerUserId | HomeownerId | UserId  */
  requestedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootProject?: InputMaybe<Array<Scalars['ID']['input']>>;
  source?: InputMaybe<Array<Scalars['ID']['input']>>;
  subject?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvers?: InputMaybe<ApproverFilter>;
  subjectType?: InputMaybe<Array<ApprovalSubjectType>>;
  /**
   * Special Case: Returns approvals "relevant to" a given `InternalUserId` | `TradePartnerUserId` | `HomeownerId`
   * (based on internal logic)
   */
  relevantTo?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveApprovalInput = {
  /** Nullable to create a new Approval, otherwise required if one already exists for subjectId */
  id?: InputMaybe<Scalars['ID']['input']>;
  dueOn?: InputMaybe<Scalars['Date']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  /** An ergonomic way to move an Approval from Changes Needed back to Requested */
  reopen?: InputMaybe<Scalars['Boolean']['input']>;
  retract?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveApprovalResult = {
  __typename?: 'SaveApprovalResult';
  approval: Approval;
};

export type SaveApprovalsResult = {
  __typename?: 'SaveApprovalsResult';
  approvals: Array<Approval>;
};

export type ApprovalSource = BidContractRevision | ItemTemplate | ReadyPlanAggregateVersion;

export type ApprovalSubject = Bill | ChangeEvent | ChangeRequest | Invoice;

export enum ApprovalSubjectType {
  ChangeEvent = 'CHANGE_EVENT',
  Bill = 'BILL',
  Invoice = 'INVOICE',
  ChangeRequest = 'CHANGE_REQUEST'
}

export type Approver = {
  __typename?: 'Approver';
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: ApproverStatusDetail;
  nextApprover?: Maybe<Approver>;
  approval: Approval;
  user: ApproverUser;
  wasAutoApproved: Scalars['Boolean']['output'];
  subjectData?: Maybe<ApproverSubjectData>;
  requireSignature: Scalars['Boolean']['output'];
  pandaDocRecipient?: Maybe<PandaDocRecipient>;
};

export type ApproverFilter = {
  status?: InputMaybe<Array<ApproverStatus>>;
  /**  InternalUserId | TradePartnerUserId | HomeownerId  */
  user?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveApproverInput = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<ApproverStatus>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** this will add a comment to the underlying approval */
  comment?: InputMaybe<SaveCommentInput>;
  requireSignature?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveApproverResult = {
  __typename?: 'SaveApproverResult';
  approver: Approver;
};

export type SaveApproversResult = {
  __typename?: 'SaveApproversResult';
  approvers: Array<Approver>;
};

export type ApproverSource = DevelopmentTeamMember | ProjectCollaborator | ProjectTeamMember | TradePartnerMarketContact;

export type ApproverSubjectData = ChangeRequestApproverSubjectData;

export type ApproverUser = Client | InternalUser | TradePartnerUser;

export type AssetsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateAssetUploadUrlInput = {
  contentType: Scalars['String']['input'];
  previewResizing?: InputMaybe<AssetResizing>;
};

export type CreateAssetUploadUrlResult = {
  __typename?: 'CreateAssetUploadUrlResult';
  s3Key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
  /** After the asset is uploaded, it can be viewed at this URL. */
  downloadUrl: Scalars['String']['output'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String']['output'];
  /**
   * Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Only generated if previewResizing is provided as mutation input
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateAssetMultipartUploadUrlInput = {
  /** MIME type of the file (e.g., "video/mp4") */
  contentType: Scalars['String']['input'];
  /** Original filename for tracking/debugging */
  fileName: Scalars['String']['input'];
  /** Total file size in bytes */
  sizeInBytes: Scalars['Int']['input'];
  /**
   * Number of parts for the upload. Client should calculate:
   * Math.ceil(sizeInBytes / partSize) where partSize >= 5MB
   * Server validates: partCount <= 10000 (S3 limit)
   */
  partCount: Scalars['Int']['input'];
};

export type CreateAssetMultipartUploadUrlResult = {
  __typename?: 'CreateAssetMultipartUploadUrlResult';
  /** Unique identifier for this multipart upload session */
  uploadId: Scalars['String']['output'];
  /** S3 key where file will be stored: assets/${UUID}.${ext} */
  s3Key: Scalars['String']['output'];
  /** Total number of parts to upload */
  totalParts: Scalars['Int']['output'];
  /** Presigned URLs for uploading each part via HTTP PUT */
  partUploadUrls: Array<MultipartPartUploadUrl>;
  /** When presigned URLs expire */
  expiresAt: Scalars['DateTime']['output'];
};

export type MultipartPartUploadUrl = {
  __typename?: 'MultipartPartUploadUrl';
  /** Part number (1-indexed). Upload in any order. */
  partNumber: Scalars['Int']['output'];
  /** Presigned URL for HTTP PUT of this part's file chunk */
  uploadUrl: Scalars['String']['output'];
};

export type MultipartPartInput = {
  /** Part number (1-indexed, matching partNumber from MultipartPartUploadUrl) */
  partNumber: Scalars['Int']['input'];
  /**
   * ETag header returned by S3 after uploading this part.
   * Required for S3 to verify and assemble the parts.
   * Format: quoted string like "abc123def456"
   */
  etag: Scalars['String']['input'];
};

export type AbortAssetMultipartUploadInput = {
  /** Upload ID from createAssetMultipartUploadUrl */
  uploadId: Scalars['String']['input'];
  /** S3 key from createAssetMultipartUploadUrl */
  s3Key: Scalars['String']['input'];
  /** Optional reason for aborting (for logging) */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AbortAssetMultipartUploadResult = {
  __typename?: 'AbortAssetMultipartUploadResult';
  /** The aborted upload ID */
  uploadId: Scalars['String']['output'];
  /** The abandoned S3 key */
  s3Key: Scalars['String']['output'];
};

export type Asset = Entity & {
  __typename?: 'Asset';
  id: Scalars['ID']['output'];
  contentType: Scalars['String']['output'];
  /**
   * After the asset is uploaded, it can be downloaded from this URL.
   *
   * This is an S3 signed url, which means the user has already been authed when
   * creating the returned URL, and so can directly access this URL without any extra auth.
   * However, that also means this URL is unique per request (it has timestamps in it)
   * and so won't be cached.
   *
   * It expires after 1 week.
   */
  downloadUrl: Scalars['String']['output'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String']['output'];
  /**
   * Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Similar to downloadUrl, but is a consistent path like `/asset?id=assetId` so
   * that caching works.
   *
   * Note that auth will be done on access to `/asset` and so currently this only
   * works for internal users.
   */
  url: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  sizeInBytes?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
  /**
   * The S3 key where the asset is stored.  This is generally not needed for the applications,
   * but we need it when we need to do something like copy the asset to another bucket (PropCo App)
   */
  s3Key: Scalars['String']['output'];
};


export type AssetPreviewUrlArgs = {
  resizing: AssetResizing;
};

export type AssetResizing = {
  width?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<AssetResizingRegion>;
  /** Optional output image format, e.g. "jpg", "png", defaults to original asset format. */
  format?: InputMaybe<AssetResizingFormat>;
};

export enum AssetResizingFormat {
  Jpg = 'jpg',
  Png = 'png'
}

export enum AssetResizingRegion {
  Square = 'SQUARE',
  Full = 'FULL',
  Auto = 'AUTO'
}

export type AssetInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** This field is only accepted for Asset creation */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** This field is accepted for Asset creation and update */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** This field is only accepted for Asset creation */
  s3Key?: InputMaybe<Scalars['String']['input']>;
  /** This field is only accepted for Asset creation */
  sizeInBytes?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Upload ID from createAssetMultipartUploadUrl.
   * When provided with multipartParts, the multipart upload will be completed automatically.
   */
  multipartUploadId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Array of uploaded parts with ETags from S3 PUT responses.
   * Required when multipartUploadId is provided.
   */
  multipartParts?: InputMaybe<Array<MultipartPartInput>>;
};

export type CreateAssetResult = {
  __typename?: 'CreateAssetResult';
  asset: Asset;
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  asset: Asset;
  parent: AttachmentParent;
};

export type SaveAttachmentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  asset: AssetInput;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteAttachmentInput = {
  id: Scalars['ID']['input'];
};

export type SaveAttachmentResult = {
  __typename?: 'SaveAttachmentResult';
  attachment: Attachment;
};

export type DeleteAttachmentResult = {
  __typename?: 'DeleteAttachmentResult';
  parent?: Maybe<AttachmentParent>;
};

export type AttachmentParent = ChangeRequest | Comment | GlobalOption | Product | ProjectSiteCondition | ScheduleFlag | ToDo | TradePartnerAvailabilityRequestEmail | TradePartnerRequirement | WarrantyTicket | WarrantyTicketItem;

export type DeleteAuditEventsInput = {
  table: Scalars['String']['input'];
  columns: Array<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAuditEventsResult = {
  __typename?: 'DeleteAuditEventsResult';
  results: Array<DeleteAuditEventResult>;
};

export type DeleteAuditEventResult = {
  __typename?: 'DeleteAuditEventResult';
  table: Scalars['String']['output'];
  column: Scalars['String']['output'];
  deletedCount: Scalars['Int']['output'];
};

/**
 * Implemented by ItemTemplate and ReadyPlanLike so that they can be used interchangeably in the UI,
 * which typically ony cares about the display name.
 */
export type BaseItemParent = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

/**
 * Implemented by ItemTemplate and ReadyPlanAggregateVersion so that they can be used interchangeably in the UI,
 * which typically ony cares about the display name/version.
 */
export type BaseItemParentVersion = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayVersion: Scalars['String']['output'];
};

export type BaseItemLike = {
  id: Scalars['ID']['output'];
  /**  Either the original ITI ID or the TLI ID.  */
  identityId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /**  TBD - Should this reach through to the RP even for OG RPs?  */
  parent: BaseItemParent;
  /**  The first version this line item was added.  */
  first: BaseItemParentVersion;
  readyPlan?: Maybe<ReadyPlanLike>;
  specifications?: Maybe<Scalars['String']['output']>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  slot: ItemSlot;
  item: Item;
  quantity?: Maybe<Scalars['Int']['output']>;
  totalCostInCents: Scalars['Int']['output'];
  unitCostInCents: Scalars['Int']['output'];
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  options: Array<ReadyPlanOption>;
  materialVariant?: Maybe<MaterialVariant>;
  /** @deprecated Old product catalog is deprecated */
  baseProduct?: Maybe<Product>;
  task?: Maybe<GlobalPlanTask>;
  bidItemTemplateItem?: Maybe<BaseItemLike>;
  blueprintUrl: Url;
  development?: Maybe<Development>;
  customPlaceholderName?: Maybe<Scalars['String']['output']>;
  /**  Helper for the FE multi-select dropdown  */
  elevationIds: Array<Scalars['ID']['output']>;
  /**  Helper for the FE multi-select dropdown  */
  specOptionIds: Array<Scalars['ID']['output']>;
  /**  Helper for the FE multi-select dropdown  */
  otherOptionIds: Array<Scalars['ID']['output']>;
  laborLine?: Maybe<BaseItemLike>;
  costEstimate: CostEstimate;
};

export type BidContract = HasBlueprintUrl & Named & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'BidContract';
  id: Scalars['ID']['output'];
  /**  Returns the trade partner name or `Homebound internal estimate` and the development name prefixed.  */
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  /**  Returns the trade partner name or `Homebound internal estimate`  */
  displayName: Scalars['String']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  tradePartner?: Maybe<TradePartner>;
  revisions: Array<BidContractRevision>;
  /**  The current version, which will be draft if there is no signed revision yet or the latest signed revision. */
  currentRevision: BidContractRevision;
  latestSignedRevision?: Maybe<BidContractRevision>;
  /**  The current draft/pending/sent version, or unset if there is none.  */
  unsignedRevision?: Maybe<BidContractRevision>;
  /**  The latest revision with the highest version number */
  latestRevision: BidContractRevision;
  isInternalEstimate: Scalars['Boolean']['output'];
  developments: Array<Development>;
  bidRequest?: Maybe<BidPackageRequest>;
  type?: Maybe<BidContractTypeDetail>;
  projects: Array<Project>;
  relevantMarket: Market;
  scopeSource?: Maybe<BidScopeSourceDetail>;
  isProjectLevelBidding: Scalars['Boolean']['output'];
  internalEstimateBidPackage?: Maybe<BidPackage>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type SaveBidContractInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  isInternalEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  developmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  internalEstimateBidPackageId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<BidContractType>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  scopeSource?: InputMaybe<BidScopeSource>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveBidContractResult = {
  __typename?: 'SaveBidContractResult';
  bidContract: BidContract;
};

export type BidContractItemsFilter = {
  itemTemplateStatus?: InputMaybe<Array<ItemTemplateStatus>>;
  itemTemplateItemId?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeItemTemplateItemId?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlanId?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlanOptionId?: InputMaybe<Array<Scalars['ID']['input']>>;
  costCodeId?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemId?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BidContractPotentialItem = {
  __typename?: 'BidContractPotentialItem';
  item: Item;
  /**
   * If BidContractItemsFilter.updatedOnly is true, then only ITIs which need to be updated are included.
   * Otherwise, all of the latest ITIs for the associated Item are included
   */
  templateItemIds: Array<Scalars['ID']['output']>;
  needsBid: Scalars['Boolean']['output'];
};

export type BidContractsFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  scopeSource?: InputMaybe<Array<BidScopeSource>>;
  /** @deprecated use includeRelatedProjectBids instead */
  includeChildProjectBids?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedProjectBids?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BidContractOrder = {
  id?: InputMaybe<Order>;
};

export type BidContractsPage = {
  __typename?: 'BidContractsPage';
  entities: Array<BidContract>;
  pageInfo: PageInfo;
};

export type BidContractLineItem = Named & {
  __typename?: 'BidContractLineItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalCostInCents: Scalars['Int']['output'];
  unitCostInCents: Scalars['Int']['output'];
  unitCostInMills: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  itemTemplateItem?: Maybe<BaseItemLike>;
  revision: BidContractRevision;
  previousLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  scopeUpdated: Scalars['Boolean']['output'];
  ofIti: Scalars['Boolean']['output'];
  ofBi: Scalars['Boolean']['output'];
  preferredByItemTemplateItems: Array<BaseItemLike>;
  potentialUsages: Array<BaseItemLike>;
  isTaxExempt: Scalars['Boolean']['output'];
  tradeLineItem?: Maybe<BidContractTradeLineItem>;
};

export type SaveBidContractLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  totalCostInCents?: InputMaybe<Scalars['Int']['input']>;
  itemTemplateItemId?: InputMaybe<Scalars['ID']['input']>;
  revisionId?: InputMaybe<Scalars['ID']['input']>;
  bidItemId?: InputMaybe<Scalars['ID']['input']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveBidContractLineItemResult = {
  __typename?: 'SaveBidContractLineItemResult';
  bidContractLineItem: BidContractLineItem;
};

export type SaveBidContractLineItemsResult = {
  __typename?: 'SaveBidContractLineItemsResult';
  bidContractRevision: BidContractRevision;
};

export type DeleteBidContractLineItemResult = {
  __typename?: 'DeleteBidContractLineItemResult';
  bidContractRevision: BidContractRevision;
};

export type BidContractLineItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  bidItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemTemplateItemId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<BidContractRevisionStatus>>;
};

export type BidContractLineItemsPageResult = {
  __typename?: 'BidContractLineItemsPageResult';
  entities: Array<BidContractLineItem>;
  pageInfo: PageInfo;
};

export type BidContractRevision = HasBlueprintUrl & HasPandaDoc & {
  __typename?: 'BidContractRevision';
  id: Scalars['ID']['output'];
  /**  Returns `Trade Name (Revision x) - Plan/Item Based`.  */
  displayName: Scalars['String']['output'];
  version: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: BidContractRevisionStatusDetail;
  bidContract: BidContract;
  lineItems: Array<BidContractLineItem>;
  canEdit: PotentialOperation2;
  costCodes: Array<CostCode>;
  costCodeAwards: Array<CostCodeAward>;
  pandaDocRecipients: Array<PandaDocIntendedRecipient>;
  pandaDoc?: Maybe<PandaDoc>;
  document?: Maybe<Document>;
  canCreatePandaDoc: PotentialOperation2;
  canDelete: PotentialOperation2;
  startDate: Scalars['Date']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  isEffective: Scalars['Boolean']['output'];
  commitments: Array<Commitment>;
  /**  When projectId is provided, it will search for the BCR corresponding to that project or within its hierarchy. */
  blueprintUrl: Url;
  hasOutdatedScope: Scalars['Boolean']['output'];
  sourceForApprovals: Array<Approval>;
  tradeSignatory?: Maybe<TradePartnerContact>;
  potentialProjectItems: Array<PotentialProjectItem>;
  itemTemplateCostUpdates: Array<ItemTemplateCostUpdate>;
  signedOn?: Maybe<Scalars['Date']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  tradeLineItems: Array<BidContractTradeLineItem>;
  hasValidTradeCosts: Scalars['Boolean']['output'];
  draws: Array<BidContractRevisionDraw>;
  canAddDraws: PotentialOperation2;
  primaryRevisionBidPackageAwards: Array<BidPackageAward>;
  bidPackageVersion?: Maybe<BidPackageVersion>;
  hasValidDrawTasks: Scalars['Boolean']['output'];
  hasAwardedBidPackageVersion: Scalars['Boolean']['output'];
};


export type BidContractRevisionBlueprintUrlArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveBidContractRevisionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  bidContractId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  draws?: InputMaybe<Array<SaveBidContractRevisionDrawInput>>;
  bidPackageVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveBidContractRevisionResult = {
  __typename?: 'SaveBidContractRevisionResult';
  bidContractRevision: BidContractRevision;
};

export type PandaDocIntendedRecipient = {
  __typename?: 'PandaDocIntendedRecipient';
  name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  role: PandaDocRole;
  tradePartnerContact?: Maybe<TradePartnerContact>;
  user?: Maybe<User>;
  signingOrder?: Maybe<Scalars['Int']['output']>;
};

export type DeleteBidContractRevisionInput = {
  id: Scalars['ID']['input'];
};

export type InternallySignBidContractRevisionInput = {
  id: Scalars['ID']['input'];
};

/**  All project items whose scope of work could be fulfilled by this BCR.  */
export type PotentialProjectItem = {
  __typename?: 'PotentialProjectItem';
  projectItem: ProjectItem;
  /**  The cost for this Trade Partner to do the work  */
  totalCostInCents: Scalars['Int']['output'];
};

export type CostCodeAward = {
  __typename?: 'CostCodeAward';
  costCode: CostCode;
  isPrimary: Scalars['Boolean']['output'];
  isSecondary: Scalars['Boolean']['output'];
};

export type BidContractRevisionDraw = {
  __typename?: 'BidContractRevisionDraw';
  id: Scalars['ID']['output'];
  amountInBasisPoints: Scalars['Int']['output'];
  isDeposit: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  bidContractRevision: BidContractRevision;
  globalPlanTask?: Maybe<GlobalPlanTask>;
  canEdit: PotentialOperation2;
};

export type SaveBidContractRevisionDrawInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  amountInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  isDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  bidContractRevisionId?: InputMaybe<Scalars['ID']['input']>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']['input']>;
};

export type BidContractTradeLineItem = {
  __typename?: 'BidContractTradeLineItem';
  id: Scalars['ID']['output'];
  totalCostInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  revision: BidContractRevision;
  productOffering: ProductOffering;
  options: Array<ReadyPlanOption>;
  hasValidCost: Scalars['Boolean']['output'];
  lineItems: Array<BidContractLineItem>;
};

export type SaveBidContractTradeLineItemsInput = {
  bidContractTradeLineItems: Array<SaveBidContractTradeLineItemInput>;
};

export type SaveBidContractTradeLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  totalCostInCents?: InputMaybe<Scalars['Int']['input']>;
  revisionId?: InputMaybe<Scalars['ID']['input']>;
  productOfferingId?: InputMaybe<Scalars['ID']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** This input is still used, but creates line items instead of prorations */
  prorations?: InputMaybe<Array<SaveBidContractTradeLineItemProrationInput>>;
};

export type SaveBidContractTradeLineItemProrationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  itemTemplateItemId?: InputMaybe<Scalars['ID']['input']>;
  costInCents?: InputMaybe<Scalars['Int']['input']>;
  userEntered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveBidContractTradeLineItemsResult = {
  __typename?: 'SaveBidContractTradeLineItemsResult';
  bidContractTradeLineItems: Array<BidContractTradeLineItem>;
};

export type BidItem = Named & HasBlueprintUrl & HasDisplayName & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'BidItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costType: CostTypeDetail;
  unitOfMeasure: UnitOfMeasure;
  items: Array<Item>;
  /** @deprecated product->bidItem link has been deleted */
  products: Array<Product>;
  bidContractLineItems: Array<BidContractLineItem>;
  blueprintUrl: Url;
  parentMaterialVariant?: Maybe<MaterialVariant>;
  parentTask?: Maybe<GlobalPlanTask>;
  estimates: Array<BidItemEstimate>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type BidItemsPage = {
  __typename?: 'BidItemsPage';
  bidItems: Array<BidItem>;
  pageInfo: PageInfo;
};

export type SaveBidItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  costType?: InputMaybe<CostType>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveBidItemResult = {
  __typename?: 'SaveBidItemResult';
  bidItem: BidItem;
};

export type BidItemOrder = {
  id?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
};

export type BidItemFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<Scalars['ID']['input']>>;
  unitOfMeasure?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  costType?: InputMaybe<Array<CostType>>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  materialType?: InputMaybe<Array<MaterialType>>;
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  materialVariantTags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PotentialBidItemFilter = {
  projectItemId?: InputMaybe<Scalars['ID']['input']>;
  itemTemplateItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type BidItemEstimate = {
  __typename?: 'BidItemEstimate';
  id: Scalars['ID']['output'];
  costInMills: Scalars['Int']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  bidItem: BidItem;
  createdBy: User;
  markets: Array<Market>;
};

export type SaveBidItemEstimateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  costInMills?: InputMaybe<Scalars['Int']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  materialVariantId?: InputMaybe<Scalars['ID']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveBidItemEstimateResult = {
  __typename?: 'SaveBidItemEstimateResult';
  bidItemEstimate: BidItemEstimate;
};

export type BidItemEstimateFilter = {
  parent?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BidItemEstimatesPageResult = {
  __typename?: 'BidItemEstimatesPageResult';
  entities: Array<BidItemEstimate>;
  pageInfo: PageInfo;
};

export type BidPackage = Named & {
  __typename?: 'BidPackage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  costCodesName: Scalars['String']['output'];
  planRoomLink?: Maybe<Scalars['String']['output']>;
  invitationText?: Maybe<Scalars['String']['output']>;
  bidInstructionsText?: Maybe<Scalars['String']['output']>;
  existingInvitationText?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  estimatedAwardDate?: Maybe<Scalars['Date']['output']>;
  estimatedConstructionDate?: Maybe<Scalars['Date']['output']>;
  sendReminderDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  productOfferings: Array<ProductOffering>;
  status: BidPackageStatusDetail;
  lineItems: Array<BidPackageLineItem>;
  requests: Array<BidPackageRequest>;
  potentialBidPackageLineItems: Array<BidItem>;
  bidPackageGroup?: Maybe<BidPackageGroup>;
  scopeLines: Array<BidPackageScopeLine>;
  awards: Array<BidPackageAward>;
  isHistoricalBid: Scalars['Boolean']['output'];
  costCodes: Array<CostCode>;
  costType: CostTypeDetail;
  basePlanGlobalPlanTasks: Array<GlobalPlanTask>;
  isUnitBased: Scalars['Boolean']['output'];
  versions: Array<BidPackageVersion>;
  latestVersion: BidPackageVersion;
  canComplete: PotentialOperation2;
  versionNotes?: Maybe<Scalars['String']['output']>;
  availableUpdates: Array<BidPackageIncomingUpdate>;
  activeRequests: Array<BidPackageRequest>;
  scopeHasChanged: Scalars['Boolean']['output'];
  canDelete: PotentialOperation2;
  canReviseCosts: PotentialOperation2;
  projects: Array<Project>;
  relevantMarket: Market;
  primaryHomeboundUser?: Maybe<User>;
  secondaryHomeboundUsers: Array<User>;
  overlappingBidPackages: Array<BidPackage>;
  latestAwards: Array<BidPackageAward>;
  scopeSource: BidScopeSourceDetail;
  isProjectLevelBidding: Scalars['Boolean']['output'];
  isInternalEstimate: Scalars['Boolean']['output'];
  internalEstimateBidContract?: Maybe<BidContract>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BidPackageScopeLine = {
  __typename?: 'BidPackageScopeLine';
  takeoffLineItemVersion: TakeoffLineItemVersion;
  changeType?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<TakeoffLineItemVersion>;
};

export type BidPackageOrderBy = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
};

export type SaveBidPackageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  invitationText?: InputMaybe<Scalars['String']['input']>;
  bidInstructionsText?: InputMaybe<Scalars['String']['input']>;
  existingInvitationText?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  estimatedAwardDate?: InputMaybe<Scalars['Date']['input']>;
  estimatedConstructionDate?: InputMaybe<Scalars['Date']['input']>;
  sendReminderDate?: InputMaybe<Scalars['Date']['input']>;
  productOfferings?: InputMaybe<Array<Scalars['ID']['input']>>;
  costCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  requests?: InputMaybe<Array<SaveBidPackageRequestInput>>;
  status?: InputMaybe<BidPackageStatus>;
  lineItems?: InputMaybe<Array<SaveBidPackageLineItemInput>>;
  bidPackageGroupId?: InputMaybe<Scalars['ID']['input']>;
  isHistoricalBid?: InputMaybe<Scalars['Boolean']['input']>;
  costType?: InputMaybe<CostType>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  isUnitBased?: InputMaybe<Scalars['Boolean']['input']>;
  versionNotes?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  scopeSource?: InputMaybe<BidScopeSource>;
  isInternalEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  internalEstimateBidContractId?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PotentialBidItemsPageFilter = {
  bidPackageId: Scalars['ID']['input'];
  isUsedUpstream?: InputMaybe<Scalars['Boolean']['input']>;
  bidItemsFilter?: InputMaybe<BidItemFilter>;
};

export type AcceptBidPackageIncomingUpdatesInput = {
  bidPackageId: Scalars['ID']['input'];
  bidPackageIncomingUpdateIds: Array<Scalars['ID']['input']>;
};

export type SaveBidPackageResult = {
  __typename?: 'SaveBidPackageResult';
  bidPackage: BidPackage;
};

export type SaveBidPackagesResult = {
  __typename?: 'SaveBidPackagesResult';
  bidPackages: Array<BidPackage>;
};

export type OverlappingBidPackagesResult = {
  __typename?: 'OverlappingBidPackagesResult';
  bidPackages: Array<BidPackage>;
};

export type ReviseBidPackageCostsInput = {
  bidPackageId: Scalars['ID']['input'];
};

export type ReviseBidPackageCostsResult = {
  __typename?: 'ReviseBidPackageCostsResult';
  bidPackage: BidPackage;
};

export type BidPackageAward = {
  __typename?: 'BidPackageAward';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  primaryRevision: BidContractRevision;
  secondaryRevision?: Maybe<BidContractRevision>;
  costCode: CostCode;
  bidPackageVersion?: Maybe<BidPackageVersion>;
};

export type SaveBidPackageAwardsInput = {
  bidPackageAwards: Array<SaveBidPackageAwardInput>;
};

export type SaveBidPackageAwardInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  primaryRevisionId?: InputMaybe<Scalars['ID']['input']>;
  secondaryRevisionId?: InputMaybe<Scalars['ID']['input']>;
  costCodeId?: InputMaybe<Scalars['ID']['input']>;
  bidPackageVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveBidPackageAwardsResult = {
  __typename?: 'SaveBidPackageAwardsResult';
  bidPackageAwards: Array<BidPackageAward>;
};

export type BidPackageGroup = {
  __typename?: 'BidPackageGroup';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  bidPackages: Array<BidPackage>;
  displayName: Scalars['String']['output'];
  productOfferings: Array<ProductOffering>;
  projects: Array<Project>;
  status: BidPackageStatusDetail;
};


export type BidPackageGroupBidPackagesArgs = {
  costCode?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<BidPackageOrderBy>;
};

export type BidPackageGroupsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  costCode?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  scopeSource?: InputMaybe<Array<BidScopeSource>>;
  /** @deprecated use includeRelatedProjectBids instead */
  includeChildProjectBids?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedProjectBids?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BidPackageGroupOrderBy = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
};

export type BidPackageGroupProductOfferingsResult = {
  __typename?: 'BidPackageGroupProductOfferingsResult';
  productOfferingInfos: Array<ProductOfferingInfo>;
};

export type ProductOfferingInfo = {
  __typename?: 'ProductOfferingInfo';
  productOffering: ProductOffering;
  bidPackage: BidPackage;
  numberOfLineItems: Scalars['Int']['output'];
  relevantOptions: Array<ReadyPlanOption>;
};

export type BidPackageGroupsPageResult = {
  __typename?: 'BidPackageGroupsPageResult';
  entities: Array<BidPackageGroup>;
  pageInfo: PageInfo;
};

export type BidPackageIncomingUpdate = {
  __typename?: 'BidPackageIncomingUpdate';
  id: Scalars['ID']['output'];
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  bidPackage: BidPackage;
  source: ReadyPlanAggregateVersion;
  updateStats: BidPackageIncomingUpdateStats;
};

export type BidPackageIncomingUpdateStats = {
  __typename?: 'BidPackageIncomingUpdateStats';
  tlivs: IncomingChanges;
  rplvs: IncomingChanges;
};

export type IncomingChanges = {
  __typename?: 'IncomingChanges';
  added: Scalars['Int']['output'];
  removed: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type BidPackageLineItem = {
  __typename?: 'BidPackageLineItem';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  bidItem: BidItem;
  bidPackageVersion?: Maybe<BidPackageVersion>;
};

export type SaveBidPackageLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  bidItemId?: InputMaybe<Scalars['ID']['input']>;
  bidPackageVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type BidPackageRequest = Named & HasBlueprintUrl & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'BidPackageRequest';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  bidPackage: BidPackage;
  tradePartner: TradePartner;
  primaryContact?: Maybe<TradePartnerContact>;
  secondaryContact?: Maybe<TradePartnerContact>;
  bidContract?: Maybe<BidContract>;
  sentDate?: Maybe<Scalars['Date']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  lastVersion?: Maybe<BidPackageVersion>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type SaveBidPackageRequestInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  primaryContactId?: InputMaybe<Scalars['ID']['input']>;
  secondaryContactId?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveBidPackageRequestResult = {
  __typename?: 'SaveBidPackageRequestResult';
  bidPackageRequest: BidPackageRequest;
};

export type BpvScopeLinesFilter = {
  readyPlan?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BidPackageVersion = {
  __typename?: 'BidPackageVersion';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  displayVersion: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  status: BidPackageStatusDetail;
  dueDate?: Maybe<Scalars['Date']['output']>;
  estimatedConstructionDate?: Maybe<Scalars['Date']['output']>;
  readyPlanAggregateVersions: Array<ReadyPlanAggregateVersion>;
  previous?: Maybe<BidPackageVersion>;
  lineItems: Array<BidPackageLineItem>;
  latestBidContractRevisions: Array<BidContractRevision>;
  relevantTakeoffLineItemVersions: Array<TakeoffLineItemVersion>;
  scopeLines: Array<BidPackageScopeLine>;
  basePlanGlobalPlanTasks: Array<GlobalPlanTask>;
  awards: Array<BidPackageAward>;
  bidPackage: BidPackage;
  canComplete: PotentialOperation2;
};

export type BillMetricsResult = {
  __typename?: 'BillMetricsResult';
  openPayables: Array<BillMetric>;
  totalOpenPayables: Scalars['Int']['output'];
  agingOfPayables: Array<BillMetric>;
  totalAgingOfPayables: Scalars['Int']['output'];
  awaitingApprovals: Array<BillMetric>;
  totalAwaitingApprovals: Scalars['Int']['output'];
};

export type BillMetric = {
  __typename?: 'BillMetric';
  label: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
  totalAmount?: Maybe<Scalars['BigInt']['output']>;
};

export type TradePartner = Entity & Named & {
  __typename?: 'TradePartner';
  bills: Array<Bill>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  commitments: Array<Commitment>;
  quickbooksId?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
  markets: Array<Market>;
  users: Array<TradePartnerUser>;
  contacts: Array<TradePartnerContact>;
  doesMaterials: Scalars['Boolean']['output'];
  doesLabor: Scalars['Boolean']['output'];
  isSweetheart: Scalars['Boolean']['output'];
  sourceNote?: Maybe<Scalars['String']['output']>;
  source?: Maybe<InternalUser>;
  website?: Maybe<Scalars['String']['output']>;
  agreements: Array<TradePartnerAgreement>;
  reviews: Array<TradePartnerReview>;
  reviewCount: Scalars['Int']['output'];
  /** @deprecated Use `onboardingStatus`. */
  doNotUse: Scalars['Boolean']['output'];
  intacctId?: Maybe<Scalars['String']['output']>;
  developmentCommitments: Array<DevelopmentCommitment>;
  costCodes: Array<CostCode>;
  tradeCategories: Array<TradeCategory>;
  requirements: Array<TradePartnerRequirement>;
  meetsRequirements: Scalars['Boolean']['output'];
  /** @deprecated renamed to meetsRequirementsExpiresOn */
  meetsRequirementsExpiresAt?: Maybe<Scalars['Date']['output']>;
  meetsRequirementsExpiresOn?: Maybe<Scalars['Date']['output']>;
  averageScore: Scalars['Float']['output'];
  homeboundAccountNumber?: Maybe<Scalars['String']['output']>;
  bidContracts: Array<BidContract>;
  createdAt: Scalars['DateTime']['output'];
  onboardingStatus: TradePartnerOnboardingStatusDetail;
  /** returns contacts ordered by the specified roles.  roles that correspond to no contact will be null in the returned array */
  contactsForDevelopmentAndRoles: Array<Maybe<TradePartnerContact>>;
  /** returns contacts ordered by the specified roles.  roles that correspond to no contact will be null in the returned array */
  contactsForProjectAndRoles: Array<Maybe<TradePartnerContact>>;
  /**
   * projectDevelopmentMarketId: ProjectId | DevelopmentId | MarketId
   * returns all contacts within the associated market
   */
  contactsForMarket: Array<Maybe<TradePartnerContact>>;
  billDueDateFor: Scalars['Date']['output'];
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  primaryForMarket?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  signatoryForMarket?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  primaryForDevelopment?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  signatoryForDevelopment?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForDevelopmentAndRoles instead */
  billApproverForDevelopment?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForProjectAndRoles instead */
  primaryForProject?: Maybe<TradePartnerContact>;
  /** @deprecated Use contactsForProjectAndRoles instead */
  signatoryForProject?: Maybe<TradePartnerContact>;
  /** @deprecated Use `contactsForProjectAndRoles` or `contactsForMarket` */
  billApproverForProject?: Maybe<TradePartnerContact>;
  marketContacts: Array<TradePartnerMarketContact>;
  pendingChangeEventsToCreateCommitments: Array<ChangeEvent>;
  leadTimeInDays: Scalars['Int']['output'];
  canLoginToPortal: Scalars['Boolean']['output'];
  paymentTerm: PaymentTerm;
  lienWaivers: Array<LienWaiver>;
  enableClickToPay: Scalars['Boolean']['output'];
  isLienWaiverReceiver: Scalars['Boolean']['output'];
  activeTasksCount: Scalars['Int']['output'];
  activeProjectsCount: Scalars['Int']['output'];
  activeContractsCount: Scalars['Int']['output'];
  totalBilledInCents: Scalars['Int']['output'];
  totalPaidInCents: Scalars['Int']['output'];
  totalCommittedInCents: Scalars['Int']['output'];
  commitmentCountThisWeek: Scalars['Int']['output'];
  commitmentCountLastWeek: Scalars['Int']['output'];
  bidPackageRequests: Array<BidPackageRequest>;
};


export type TradePartnerContactsArgs = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TradePartnerContactsForDevelopmentAndRolesArgs = {
  developmentId: Scalars['ID']['input'];
  roles: Array<TradePartnerMarketRole>;
};


export type TradePartnerContactsForProjectAndRolesArgs = {
  projectId: Scalars['ID']['input'];
  roles: Array<TradePartnerMarketRole>;
};


export type TradePartnerContactsForMarketArgs = {
  projectDevelopmentMarketId: Scalars['ID']['input'];
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TradePartnerBillDueDateForArgs = {
  billDate: Scalars['Date']['input'];
};


export type TradePartnerPrimaryForMarketArgs = {
  developmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type TradePartnerSignatoryForMarketArgs = {
  developmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type TradePartnerPrimaryForDevelopmentArgs = {
  developmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type TradePartnerSignatoryForDevelopmentArgs = {
  developmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type TradePartnerBillApproverForDevelopmentArgs = {
  developmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type TradePartnerPrimaryForProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type TradePartnerSignatoryForProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type TradePartnerBillApproverForProjectArgs = {
  projectId: Scalars['ID']['input'];
};

export type Bill = Entity & HasBlueprintUrl & Named & MaybeHasProject & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'Bill';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tradePartnerNumber: Scalars['String']['output'];
  tradePartner: TradePartner;
  projectStage: ProjectStage;
  /** Returns all commitments/change orders via bill.lineItems.commitmentLineItem.owner. */
  parents: Array<CommitmentLike>;
  document?: Maybe<Document>;
  internalNote?: Maybe<Scalars['String']['output']>;
  billDate: Scalars['Date']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  billedInCents: Scalars['Int']['output'];
  paidInCents: Scalars['Int']['output'];
  balanceInCents: Scalars['Int']['output'];
  lineItems: Array<BillLineItem>;
  quickbooksId?: Maybe<Scalars['String']['output']>;
  history: Array<History>;
  quickbooksPullOnly: Scalars['Boolean']['output'];
  isTradePartnerCredit: Scalars['Boolean']['output'];
  blueprintUrl: Url;
  project: Project;
  quickbooksAmountPaidInCents: Scalars['Int']['output'];
  intacctAmountPaidInCents: Scalars['Int']['output'];
  intacctSyncError?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  intacctId?: Maybe<Scalars['String']['output']>;
  paidDate?: Maybe<Scalars['Date']['output']>;
  documents: Array<Document>;
  postedDate?: Maybe<Scalars['Date']['output']>;
  shouldSyncToIntacct: Scalars['Boolean']['output'];
  predictedApprovers: Array<ApproverUser>;
  type: BillTypeDetail;
  status: BillStatusDetail;
  approval?: Maybe<Approval>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  sentDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use canEdit instead. */
  isEditable: Scalars['Boolean']['output'];
  isPendingOrBilled: Scalars['Boolean']['output'];
  isProcessingReversal: Scalars['Boolean']['output'];
  canSubmitForApproval: PotentialOperation2;
  canDelete: PotentialOperation2;
  canReverse: PotentialOperation2;
  updatedAt: Scalars['DateTime']['output'];
  canEdit: PotentialOperation2;
  lienWaivers: Array<LienWaiver>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  reversalIntacctId?: Maybe<Scalars['String']['output']>;
  canCancel: PotentialOperation2;
  skipCostAccountDerivation?: Maybe<Scalars['Boolean']['output']>;
  pendingReview: Scalars['Boolean']['output'];
  reviewReason?: Maybe<BillReviewReason>;
  reviewReasonDetail?: Maybe<BillReviewReasonDetail>;
  isHeadless: Scalars['Boolean']['output'];
  syncedToIntacctAt?: Maybe<Scalars['DateTime']['output']>;
  isBilled: Scalars['Boolean']['output'];
  proposedAmountInCents: Scalars['Int']['output'];
  amountInCents: Scalars['Int']['output'];
  changeEvents: Array<ChangeEvent>;
  source: BillSourceDetail;
  ocrs: Array<BillOcr>;
  isDeferred: Scalars['Boolean']['output'];
  reviewers: Array<InternalUser>;
  erpAccountLines: Array<ErpAccountBillLineItem>;
  billOcr?: Maybe<BillOcr>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type SaveBillInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Replaced by documents. */
  documentId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerNumber?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  billDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  lineItems?: InputMaybe<Array<SaveBillLineItemInput>>;
  quickbooksAmountPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  quickbooksId?: InputMaybe<Scalars['String']['input']>;
  quickbooksPullOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isTradePartnerCredit?: InputMaybe<Scalars['Boolean']['input']>;
  intacctAmountPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  intacctSyncError?: InputMaybe<Scalars['String']['input']>;
  intacctId?: InputMaybe<Scalars['String']['input']>;
  paidDate?: InputMaybe<Scalars['Date']['input']>;
  documents?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
  postedDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<BillType>;
  status?: InputMaybe<BillStatus>;
  /** The source of the update (e.g intacct). Used to determine if the bill should be synced to Intacct. */
  updateSource?: InputMaybe<UpdateBillSource>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  balanceInCents?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<SaveCommentInput>;
  /**
   * Used to create Repair & Maintenance or Warranty bills, this will create a single BLI with the specified amount.
   * Other bill types will ignore this input.
   */
  billedInCents?: InputMaybe<Scalars['Int']['input']>;
  reversalIntacctId?: InputMaybe<Scalars['String']['input']>;
  pendingReview?: InputMaybe<Scalars['Boolean']['input']>;
  reviewReason?: InputMaybe<BillReviewReason>;
  proposedAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<BillSource>;
  isDeferred?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveBillResult = {
  __typename?: 'SaveBillResult';
  bill?: Maybe<Bill>;
};

export type SaveBillsInput = {
  bills: Array<SaveBillInput>;
};

export type SaveBillsResult = {
  __typename?: 'SaveBillsResult';
  bills: Array<Bill>;
};

export type DeleteBillInput = {
  id: Scalars['ID']['input'];
};

export type ReverseBillInput = {
  id: Scalars['ID']['input'];
};

export type SyncBillToIntacctInput = {
  id: Scalars['ID']['input'];
};

export type BillFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  quickbooksId?: InputMaybe<Array<Scalars['String']['input']>>;
  dueDate?: InputMaybe<DateFilter2>;
  marketId?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Array<Scalars['ID']['input']>>;
  requesterId?: InputMaybe<Array<Scalars['ID']['input']>>;
  intacctId?: InputMaybe<Array<Scalars['String']['input']>>;
  tradePartnerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<BillType>>;
  status?: InputMaybe<Array<BillStatus>>;
  search?: InputMaybe<Scalars['String']['input']>;
  billDate?: InputMaybe<DateFilter2>;
  hasBalanceDue?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated renamed to reviewer to move logic into backend */
  assignees?: InputMaybe<Array<BillAssigneeFilter>>;
  pendingReview?: InputMaybe<Scalars['Boolean']['input']>;
  reviewReason?: InputMaybe<Array<BillReviewReason>>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerOwnerEntityId?: InputMaybe<Array<Scalars['ID']['input']>>;
  source?: InputMaybe<Array<BillSource>>;
  approver?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDeferred?: InputMaybe<Scalars['Boolean']['input']>;
  reviewer?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BillOrder = {
  id?: InputMaybe<Order>;
  project?: InputMaybe<Order>;
  commitment?: InputMaybe<Order>;
  billDate?: InputMaybe<Order>;
  dueDate?: InputMaybe<Order>;
  billedInCents?: InputMaybe<Order>;
  paidInCents?: InputMaybe<Order>;
  balanceInCents?: InputMaybe<Order>;
  tradePartner?: InputMaybe<Order>;
  paidDate?: InputMaybe<Order>;
};

export enum UpdateBillSource {
  Intacct = 'INTACCT'
}

export type BillsPage = {
  __typename?: 'BillsPage';
  entities: Array<Bill>;
  pageInfo: PageInfo;
};

export type BillAssigneeFilter = {
  users: Array<Scalars['ID']['input']>;
  roles: Array<ProjectRole>;
  reviewReasons: Array<BillReviewReason>;
};

/**
 * This type is returned by the protoBills field on Task, PlanTask, and Schedule Task. It is used by the frontend to
 * generate click to pay bills upon task completion.
 */
export type ProtoBill = {
  __typename?: 'ProtoBill';
  id: Scalars['ID']['output'];
  existingBills: Array<Bill>;
  /** @deprecated use lineItems instead */
  commitmentLineItems: Array<CommitmentLineItem>;
  tradePartner: TradePartner;
  lineItems: Array<ProtoBillLineItem>;
};

export type HandleBillEmailNotificationInput = {
  items: Array<HandleBillEmailNotificationItem>;
};

export type HandleBillEmailNotificationItem = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ErpAccountBillLineItemErpSource = CommitmentDraw | CommitmentLineItem | ProjectItem | CostCode | Commitment;

export type ErpAccountBillLineItem = {
  __typename?: 'ErpAccountBillLineItem';
  amountInCents: Scalars['Int']['output'];
  sourceLine: ErpAccrualLineItemSourceLine;
  erpSource: ErpAccountBillLineItemErpSource;
  costCode: CostCode;
  task?: Maybe<Task>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
};

export type BillGmailAttachment = {
  __typename?: 'BillGmailAttachment';
  id: Scalars['ID']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  sizeInBytes?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  results: Array<BillGmailAttachmentResult>;
  message: BillGmailMessage;
  gmailPartId: Scalars['String']['output'];
  gmailAttachmentId?: Maybe<Scalars['String']['output']>;
  billOcrs: Array<BillOcr>;
  asset?: Maybe<Asset>;
};

export type BillGmailMessage = {
  __typename?: 'BillGmailMessage';
  id: Scalars['ID']['output'];
  gmailMessageId: Scalars['String']['output'];
  gmailUserId: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  result: BillGmailMessageResultDetail;
  attachments: Array<BillGmailAttachment>;
};

export type BillGmailMessageFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  gmailMessageId?: InputMaybe<Array<Scalars['String']['input']>>;
  gmailUserId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BillGmailMessageOrderBy = {
  id?: InputMaybe<Order>;
  receivedAt?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
};

export type BillLineItem = {
  __typename?: 'BillLineItem';
  id: Scalars['ID']['output'];
  bill: Bill;
  amountInCents: Scalars['Int']['output'];
  commitmentLineItem?: Maybe<CommitmentLineItem>;
  paidInCents: Scalars['Int']['output'];
  historicBillAmountInvoiced?: Maybe<Scalars['Int']['output']>;
  /** @deprecated replaced by task */
  scheduleTask?: Maybe<Task>;
  projectItem: ProjectItem;
  commitmentDraw?: Maybe<CommitmentDraw>;
  task?: Maybe<Task>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  isTaxExempt: Scalars['Boolean']['output'];
  taxableAmountInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  allocations: Array<BillLineItemAllocation>;
};

export type SaveBillLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  costCode?: InputMaybe<Scalars['ID']['input']>;
  commitmentLineItemId?: InputMaybe<Scalars['ID']['input']>;
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  historicBillAmountInvoiced?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated replaced by taskId */
  scheduleTaskId?: InputMaybe<Scalars['ID']['input']>;
  projectItemId?: InputMaybe<Scalars['ID']['input']>;
  commitmentDrawId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  taxableAmountInCents?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * This type is returned by the protoBills field on Task, PlanTask, and Schedule Task. It is used by the frontend to
 * generate click to pay bills upon task completion.
 */
export type ProtoBillLineItem = {
  __typename?: 'ProtoBillLineItem';
  commitmentLineItem: CommitmentLineItem;
  commitmentDraw?: Maybe<CommitmentDraw>;
  amountInCents: Scalars['Int']['output'];
};

export type BillLineItemAllocation = {
  __typename?: 'BillLineItemAllocation';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costInCents: Scalars['Int']['output'];
  paidCostInCents: Scalars['Int']['output'];
  commitmentLineItemAllocation?: Maybe<CommitmentLineItemAllocation>;
  projectItemAllocation: ProjectItemAllocation;
};

export type BillOcr = {
  __typename?: 'BillOcr';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  asset: Asset;
  bill?: Maybe<Bill>;
  tradePartner?: Maybe<TradePartner>;
  project?: Maybe<Project>;
  commitmentLikes: Array<CommitmentLike>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  billDate?: Maybe<Scalars['Date']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  totalInCents?: Maybe<Scalars['Int']['output']>;
  type: BillTypeDetail;
  gmailAttachment?: Maybe<BillGmailAttachment>;
  billOcrBill?: Maybe<Bill>;
  trackedJobs: Array<TrackedJob>;
};

export type HandleBillParserResultInput = {
  workflowRunId: Scalars['String']['input'];
};

export type RunBillParserInput = {
  assetId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type RunBillParserResult = {
  __typename?: 'RunBillParserResult';
  trackedJob: TrackedJob;
};

/** I.e. "0100 Site Engineering Reports". */
export type PreConBudgetCostDivisionLineItem = {
  __typename?: 'PreConBudgetCostDivisionLineItem';
  costDivision: CostDivision;
  lines: Array<PreConBudgetCostCodeLineItem>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  budgetInCents?: Maybe<Scalars['Int']['output']>;
};

/** I.e. "0120 GeoTech report". */
export type PreConBudgetCostCodeLineItem = {
  __typename?: 'PreConBudgetCostCodeLineItem';
  costCode: CostCode;
  internalNote?: Maybe<Scalars['String']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  budgetInCents?: Maybe<Scalars['Int']['output']>;
};

export type SavePreConBudgetLineItemInput = {
  projectId: Scalars['ID']['input'];
  costCodeId: Scalars['ID']['input'];
  /**
   *  `0` == keep the line item, but we don't have a budget for it? This doesn't really make sense.
   * `null` == delete the line item
   */
  budgetInCents?: InputMaybe<Scalars['Int']['input']>;
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
};

export type SavePreConBudgetLineItemResult = {
  __typename?: 'SavePreConBudgetLineItemResult';
  lineItem: PreConBudgetCostCodeLineItem;
};

export type DeletePreConBudgetLineItemInput = {
  projectId: Scalars['ID']['input'];
  costCodeId: Scalars['ID']['input'];
};

export type DeletePreConBudgetLineItemResult = {
  __typename?: 'DeletePreConBudgetLineItemResult';
  emptyResult?: Maybe<EmptyResult>;
};

export type ApprovePreConBudgetLineItemInput = {
  projectId: Scalars['ID']['input'];
  contractDocumentId: Scalars['ID']['input'];
  executionDate: Scalars['Date']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<ContractType>;
  costPlusMarkupBasisPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type ApprovePreConBudgetLineItemResult = {
  __typename?: 'ApprovePreConBudgetLineItemResult';
  contract: HomeownerContract;
};

export type Builder = {
  __typename?: 'Builder';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SaveBuilderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaveBuilderResult = {
  __typename?: 'SaveBuilderResult';
  builder: Builder;
};

export type BusinessFunction = Named & HasBlueprintUrl & {
  __typename?: 'BusinessFunction';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  autoApprovalAmountInCents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  impactReviewer?: Maybe<ProjectRoleDetail>;
  initialReviewer?: Maybe<ProjectRoleDetail>;
  businessFunctionType: BusinessFunctionTypeDetail;
  blueprintUrl: Url;
  approverProjectRole?: Maybe<ProjectRoleDetail>;
  applicableChangeTypes: Array<ChangeTypeDetail>;
};

export type SaveBusinessFunctionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  autoApprovalAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  impactReviewer?: InputMaybe<ProjectRole>;
  initialReviewer?: InputMaybe<ProjectRole>;
  businessFunctionType?: InputMaybe<BusinessFunctionType>;
  approverProjectRole?: InputMaybe<ProjectRole>;
};

export type SaveBusinessFunctionResult = {
  __typename?: 'SaveBusinessFunctionResult';
  businessFunction: BusinessFunction;
};

export type CalendarInterval = {
  __typename?: 'CalendarInterval';
  startDate: Scalars['Date']['output'];
  endDate: Scalars['Date']['output'];
  durationInDays: Scalars['Int']['output'];
  calendarProgress: Scalars['Int']['output'];
};

export type CalendarInterval2 = {
  __typename?: 'CalendarInterval2';
  startDate?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  durationInDays?: Maybe<Scalars['Int']['output']>;
};

export type ChangeEvent = HasBlueprintUrl & Named & MaybeHasProject & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'ChangeEvent';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  commitments: Array<CommitmentLike>;
  internalNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: ChangeEventStatus;
  statusDetail: ChangeEventStatusDetail;
  projectStage: ProjectStage;
  project: Project;
  lineItems: Array<ChangeEventLineItem>;
  homeownerContractChangeOrder?: Maybe<HomeownerContractChangeOrder>;
  blueprintUrl: Url;
  name: Scalars['String']['output'];
  history: Array<History>;
  estimates: Array<Estimate>;
  canCreateFinalEstimate: Scalars['Boolean']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  originalTotalCostInCents: Scalars['Int']['output'];
  originalTotalPriceInCents: Scalars['Int']['output'];
  proposedTotalCostInCents: Scalars['Int']['output'];
  proposedTotalPriceInCents: Scalars['Int']['output'];
  budgetImpactInCents: Scalars['Int']['output'];
  revisedBudgetInCents: Scalars['Int']['output'];
  /** @deprecated replaced by type */
  isHomeownerChangeEvent: Scalars['Boolean']['output'];
  isReadyHomeManaged: Scalars['Boolean']['output'];
  canEditLineItems: PotentialOperation2;
  internalImpactInDays?: Maybe<Scalars['Int']['output']>;
  homeownerImpactInDays?: Maybe<Scalars['Int']['output']>;
  reasonDetails?: Maybe<Scalars['String']['output']>;
  reason: ChangeEventReason;
  identifier: Scalars['Int']['output'];
  appliedTemplates: Array<ItemTemplate>;
  templateConfigs: Array<ChangeEventTemplateConfig>;
  projectCutoff?: Maybe<ProjectCutoff>;
  budgetPhase: ChangeEventBudgetPhaseDetail;
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  approval?: Maybe<Approval>;
  impactedCommitments: Array<CommitmentLike>;
  predictedApprovers: Array<ApproverUser>;
  type: ChangeEventTypeDetail;
  canBeLocked: PotentialOperation2;
  canSubmitForApproval: PotentialOperation2;
  tradesToDraftCommitmentsFor: Array<TradePartner>;
  impactedTrades: Array<TradePartner>;
  pandaDoc?: Maybe<PandaDoc>;
  requireSignature: Scalars['Boolean']['output'];
  createdBy?: Maybe<ChangeEventCreatedBy>;
  readyPlan?: Maybe<ReadyPlanLike>;
  originalReadyPlan?: Maybe<ReadyPlanLike>;
  originalReadyPlanOptions: Array<ChangeEventOriginalOption>;
  proposedReadyPlanOptions: Array<ChangeEventProposedOption>;
  isContractAddendum: Scalars['Boolean']['output'];
  removedReadyPlanOptions: Array<ChangeEventOriginalOption>;
  addedReadyPlanOptions: Array<ChangeEventProposedOption>;
  checkoutConfig?: Maybe<CheckoutConfig>;
  proposedOrientation?: Maybe<ProjectReadyPlanConfigOrientationDetail>;
  hasPreSignedContract: Scalars['Boolean']['output'];
  document?: Maybe<Document>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type SaveChangeEventInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChangeEventStatus>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  projectCutoffId?: InputMaybe<Scalars['ID']['input']>;
  internalImpactInDays?: InputMaybe<Scalars['Int']['input']>;
  homeownerImpactInDays?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated replaced by type */
  isHomeownerChangeEvent?: InputMaybe<Scalars['Boolean']['input']>;
  reasonDetails?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  lineItems?: InputMaybe<Array<SaveChangeEventLineItemInput>>;
  budgetPhase?: InputMaybe<ChangeEventBudgetPhase>;
  type?: InputMaybe<ChangeEventType>;
  tradesToDraftCommitmentsFor?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  originalReadyPlanId?: InputMaybe<Scalars['ID']['input']>;
  isContractAddendum?: InputMaybe<Scalars['Boolean']['input']>;
  originalReadyPlanOptions?: InputMaybe<Array<ChangeEventReadyPlanOptionInput>>;
  proposedReadyPlanOptions?: InputMaybe<Array<ChangeEventReadyPlanOptionInput>>;
  checkoutConfigId?: InputMaybe<Scalars['ID']['input']>;
  proposedOrientation?: InputMaybe<ProjectReadyPlanConfigOrientation>;
  hasPreSignedContract?: InputMaybe<Scalars['Boolean']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
};

/**  Input used for bulk updating change events as it only requires a subset of fields from SaveChangeEventInput.  */
export type SaveChangeEventsInput = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChangeEventStatus>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChangeEventReadyPlanOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  readyPlanOptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveChangeEventResult = {
  __typename?: 'SaveChangeEventResult';
  changeEvent: ChangeEvent;
};

export type SaveChangeEventsResult = {
  __typename?: 'SaveChangeEventsResult';
  changeEvents: Array<ChangeEvent>;
};

export type ChangeEventFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ChangeEventStatus>>;
  /** @deprecated replaced by type */
  isHomeownerChangeEvent?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Array<ChangeEventType>>;
  stage?: InputMaybe<Array<Stage>>;
};

export type ChangeEventLineItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteChangeEventInput = {
  id: Scalars['ID']['input'];
  maybeVoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangeEventCreatedBy = Bill | Expense;

export type ChangeEventLineItem = Named & HasDisplayName & {
  __typename?: 'ChangeEventLineItem';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  changeEvent: ChangeEvent;
  projectItem: ProjectItem;
  /**  The change in quantity.  */
  quantity?: Maybe<Scalars['Int']['output']>;
  /**  The change in total price.  */
  totalPriceInCents: Scalars['Int']['output'];
  /**  The change in cost price.  */
  totalCostInCents: Scalars['Int']['output'];
  /** @deprecated Unit cost on a delta doesn't make sense. */
  unitCostInCents: Scalars['Int']['output'];
  originalQuantity?: Maybe<Scalars['Int']['output']>;
  originalTotalCostInCents: Scalars['Int']['output'];
  originalTotalPriceInCents: Scalars['Int']['output'];
  proposedTotalCostInCents: Scalars['Int']['output'];
  /**  The original/current selection that cannot be changed.  */
  originalSelection?: Maybe<HomeownerSelection>;
  /**  The new/proposed selection that can be changed.  */
  proposedSelection?: Maybe<HomeownerSelection>;
  item: Item;
  /** name used to override projectItem name when CE merged */
  name: Scalars['String']['output'];
  costType: CostType;
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  /** @deprecated Use originalSelection or proposedSelection */
  homeownerSelection?: Maybe<HomeownerSelection>;
  displayName: Scalars['String']['output'];
  /** @deprecated Use costConfidenceDetail instead. */
  costConfidence: CostConfidence;
  costConfidenceDetail: CostConfidenceDetail;
  type: ChangeEventLineItemType;
  typeDetail: ChangeEventLineItemTypeDetail;
  specifications?: Maybe<Scalars['String']['output']>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  canEditName: PotentialOperation2;
  canEditCost: PotentialOperation2;
  itemTemplateItem?: Maybe<BaseItemLike>;
  modifyingTemplateItems: Array<BaseItemLike>;
  tradePartner?: Maybe<TradePartner>;
  originalTradePartner?: Maybe<TradePartner>;
  internalNote?: Maybe<Scalars['String']['output']>;
  originalBidItem?: Maybe<BidItem>;
  proposedBidItem?: Maybe<BidItem>;
  originalBidContractLineItem?: Maybe<BidContractLineItem>;
  proposedBidContractLineItem?: Maybe<BidContractLineItem>;
  proposedProduct?: Maybe<Product>;
  originalProduct?: Maybe<Product>;
  originalTask?: Maybe<GlobalPlanTask>;
  proposedTask?: Maybe<GlobalPlanTask>;
  originalMaterialVariant?: Maybe<MaterialVariant>;
  proposedMaterialVariant?: Maybe<MaterialVariant>;
  allocations: Array<ChangeEventLineItemAllocation>;
  originalPackageDesignNotes?: Maybe<Scalars['String']['output']>;
  proposedPackageDesignNotes?: Maybe<Scalars['String']['output']>;
};

export type SaveChangeEventLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  changeEventId?: InputMaybe<Scalars['ID']['input']>;
  totalPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  totalCostInCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  projectItemId and itemId are mutually exclusive, and only used for initial creation (if using an existing project item or not)  */
  projectItemId?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  /**  the fields below here all belong to the project item object itself, not to the celi, so they are passed through to update when available */
  costType?: InputMaybe<CostType>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  costConfidence?: InputMaybe<CostConfidence>;
  specifications?: InputMaybe<Scalars['String']['input']>;
  tradePartnerNote?: InputMaybe<Scalars['String']['input']>;
  /**  Can be deprecated once CEv2 is released.  */
  homeownerSelection?: InputMaybe<HomeownerSelectionInput>;
  type?: InputMaybe<ChangeEventLineItemType>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  proposedQuantity?: InputMaybe<Scalars['Int']['input']>;
  proposedTotalCostInCents?: InputMaybe<Scalars['Int']['input']>;
  proposedTotalPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  matchExisting?: InputMaybe<Scalars['Boolean']['input']>;
  proposedBidItemId?: InputMaybe<Scalars['ID']['input']>;
  proposedBidContractLineItemId?: InputMaybe<Scalars['ID']['input']>;
  proposedProductId?: InputMaybe<Scalars['ID']['input']>;
  proposedTaskId?: InputMaybe<Scalars['ID']['input']>;
  proposedMaterialVariantId?: InputMaybe<Scalars['ID']['input']>;
  proposedPackageDesignNotes?: InputMaybe<Scalars['String']['input']>;
};

export type SaveChangeEventLineItemsInput = {
  changeEventLineItems: Array<SaveChangeEventLineItemInput>;
  /**  flag indicating a celi should not be created for any matched project items with signed commitments from a file upload */
  ignoreContracted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveChangeEventLineItemsResult = {
  __typename?: 'SaveChangeEventLineItemsResult';
  changeEventLineItems: Array<ChangeEventLineItem>;
  /**  Any CELIs which were auto-added to the CE due to the addition of a new material which requires labor.  */
  autoAddedLaborLines: Array<ChangeEventLineItem>;
};

export type ChangeEventLineItemAllocation = {
  __typename?: 'ChangeEventLineItemAllocation';
  id: Scalars['ID']['output'];
  costInCents: Scalars['Int']['output'];
  priceInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  changeEventLineItem: ChangeEventLineItem;
  projectItemAllocation: ProjectItemAllocation;
};

export type ChangeEventOriginalOption = {
  __typename?: 'ChangeEventOriginalOption';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  priceInCents: Scalars['Int']['output'];
  changeEvent: ChangeEvent;
  readyPlanOption: ReadyPlanOption;
};

export type ChangeEventProposedOption = {
  __typename?: 'ChangeEventProposedOption';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  priceInCents: Scalars['Int']['output'];
  changeEvent: ChangeEvent;
  readyPlanOption: ReadyPlanOption;
};

export type ChangeEventReason = Named & {
  __typename?: 'ChangeEventReason';
  id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  changeEvents: Array<ChangeEvent>;
  isEpo: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  isIncludedInVariance?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveChangeEventReasonInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  isEpo?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  isIncludedInVariance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveChangeEventReasonResult = {
  __typename?: 'SaveChangeEventReasonResult';
  changeEventReason: ChangeEventReason;
};

export type ChangeEventTemplateConfig = ProjectStageTemplateConfigLike & Named & {
  __typename?: 'ChangeEventTemplateConfig';
  id: Scalars['ID']['output'];
  onlyChangedInVersion?: Maybe<Scalars['Boolean']['output']>;
  projectStage: ProjectStage;
  changeEvent: ChangeEvent;
  /** @deprecated Use the parent instead */
  itemTemplate: ItemTemplate;
  parent: BaseItemParentVersion;
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
};

export type ChangeRequest = Named & HasBlueprintUrl & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'ChangeRequest';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  /** Resolves the `title` field */
  name: Scalars['String']['output'];
  rationale: Scalars['String']['output'];
  estimateBudgetImpactInCents?: Maybe<Scalars['Int']['output']>;
  /** Falls back to 0 if a change request has no budget impact */
  estimateBudgetImpactInCentsFallback: Scalars['Int']['output'];
  estimateScheduleImpactInDays?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  priority: ChangeRequestPriorityDetail;
  source: ChangeRequestSourceDetail;
  status: ChangeRequestStatusDetail;
  createdBy: User;
  blueprintUrl: Url;
  scopes: Array<ChangeRequestScope>;
  attachments: Array<Attachment>;
  blocking: Array<ChangeRequest>;
  blockers: Array<ChangeRequest>;
  changeRequestAssets: Array<ChangeRequestAsset>;
  toDos: Array<ChangeRequestToDo>;
  history: Array<History>;
  changeTypes: Array<ChangeType>;
  approval?: Maybe<Approval>;
  predictedApprovers: Array<ApproverUser>;
  estimateRevenueImpactInCents?: Maybe<Scalars['Int']['output']>;
  estimateMarginImpactBasisPoints?: Maybe<Scalars['Int']['output']>;
  linkedTo: Array<ChangeRequest>;
  groups: Array<ChangeRequestGroup>;
  isStandardOffering?: Maybe<Scalars['Boolean']['output']>;
  salesforceOpportunityUrl?: Maybe<Scalars['String']['output']>;
  isUnderContract?: Maybe<Scalars['Boolean']['output']>;
  productSelection?: Maybe<Scalars['String']['output']>;
  markupBasisPoints?: Maybe<Scalars['Int']['output']>;
  estimatedBuyerOutOfPocketInCents?: Maybe<Scalars['Int']['output']>;
  estimatedRetailPriceInCents?: Maybe<Scalars['Int']['output']>;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type ChangeRequestsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ChangeRequestStatus>>;
  changeTypes?: InputMaybe<Array<ChangeType>>;
  source?: InputMaybe<Array<ChangeRequestSource>>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Non-tagged ids will be considered InternalUserIds */
  createdByUser?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectWithDevelopment?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** BusinessFunctionType Filter for BusinessFunctions that have ChangeRequestAssets associated to the ChangeRequest */
  businessFunction?: InputMaybe<Array<BusinessFunctionType>>;
  /**  InternalUser filter includes ChangeRequest.createdBy, any ToDo assignee and any Approver  */
  internalUser?: InputMaybe<Array<Scalars['ID']['input']>>;
  group?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeRequestOrder = {
  id?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  title?: InputMaybe<Order>;
  rationale?: InputMaybe<Order>;
  source?: InputMaybe<Order>;
  estimateBudgetImpactInCents?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
  estimateRevenueImpactInCents?: InputMaybe<Order>;
  estimateMarginImpactBasisPoints?: InputMaybe<Order>;
};

export type ChangeRequestsPageResult = {
  __typename?: 'ChangeRequestsPageResult';
  entities: Array<ChangeRequest>;
  pageInfo: PageInfo;
};

export type SaveChangeRequestInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  estimateBudgetImpactInCents?: InputMaybe<Scalars['Int']['input']>;
  estimateScheduleImpactInDays?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<ChangeRequestPriority>;
  source?: InputMaybe<ChangeRequestSource>;
  status?: InputMaybe<ChangeRequestStatus>;
  scopes?: InputMaybe<Array<SaveChangeRequestScopeInput>>;
  attachments?: InputMaybe<Array<SaveChangeRequestAttachmentInput>>;
  blocking?: InputMaybe<Array<SaveChangeRequestDependencyInput>>;
  blockers?: InputMaybe<Array<SaveChangeRequestDependencyInput>>;
  linkedTo?: InputMaybe<Array<SaveChangeRequestLinkInput>>;
  changeTypes?: InputMaybe<Array<ChangeType>>;
  changeRequestAssets?: InputMaybe<Array<SaveChangeRequestAsset>>;
  estimateRevenueImpactInCents?: InputMaybe<Scalars['Int']['input']>;
  estimateMarginImpactBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<SaveChangeRequestGroupsInput>>;
  isStandardOffering?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceOpportunityUrl?: InputMaybe<Scalars['String']['input']>;
  isUnderContract?: InputMaybe<Scalars['Boolean']['input']>;
  productSelection?: InputMaybe<Scalars['String']['input']>;
  markup?: InputMaybe<Scalars['Int']['input']>;
  estimatedBuyerOutOfPocketInCents?: InputMaybe<Scalars['Int']['input']>;
  estimatedRetailPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  markupBasisPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveChangeRequestsInput = {
  changeRequests: Array<SaveChangeRequestInput>;
};

export type SaveChangeRequestResult = {
  __typename?: 'SaveChangeRequestResult';
  changeRequest: ChangeRequest;
};

export type SaveChangeRequestsResult = {
  __typename?: 'SaveChangeRequestsResult';
  changeRequests: Array<ChangeRequest>;
};

export type ChangeRequestApproverSubjectData = {
  __typename?: 'ChangeRequestApproverSubjectData';
  businessFunction: Scalars['String']['output'];
  autoApprovalAmountInCents?: Maybe<Scalars['Int']['output']>;
};

export type SaveChangeRequestScopeInput = {
  /** The ID of the RequestScope record (only used for deletes) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The (tagged) ID of the Project or Development record */
  targetId?: InputMaybe<Scalars['ID']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveChangeRequestAttachmentInput = {
  /** The ID of the Attachment record (only used for deletes) */
  id?: InputMaybe<Scalars['ID']['input']>;
  asset: AssetInput;
};

export type SaveChangeRequestDependencyInput = {
  id: Scalars['ID']['input'];
  op: IncrementalCollectionOp;
};

export type SaveChangeRequestLinkInput = {
  id: Scalars['ID']['input'];
  op: IncrementalCollectionOp;
};

export type SaveChangeRequestGroupsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveChangeRequestAsset = {
  id: Scalars['ID']['input'];
  op: IncrementalCollectionOp;
};

export enum ChangeRequestDependency {
  Block = 'BLOCK',
  Dependent = 'DEPENDENT',
  Link = 'LINK'
}

export type ChangeRequestAsset = Named & {
  __typename?: 'ChangeRequestAsset';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  functionType: BusinessFunctionTypeDetail;
  platform: ChangeRequestAssetPlatformDetail;
  implementationReviewer?: Maybe<ProjectRoleDetail>;
  changeRequests: Array<ChangeRequest>;
  scopes: Array<ChangeRequestAssetScope>;
  implementer: ProjectRoleDetail;
  requiredForChangeRequestSource: Array<ChangeRequestSource>;
  systemChangeRequestAsset?: Maybe<SystemChangeRequestAssetDetail>;
};

export type SaveChangeRequestAssetInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  functionType?: InputMaybe<BusinessFunctionType>;
  platform?: InputMaybe<ChangeRequestAssetPlatform>;
  implementationReviewer?: InputMaybe<ProjectRole>;
  implementer?: InputMaybe<ProjectRole>;
  scopes?: InputMaybe<Array<ChangeRequestAssetScope>>;
  requiredForChangeRequestSource?: InputMaybe<Array<ChangeRequestSource>>;
  systemChangeRequestAsset?: InputMaybe<SystemChangeRequestAsset>;
};

export type SaveChangeRequestAssetsInput = {
  changeRequestAssets: Array<SaveChangeRequestAssetInput>;
};

export type SaveChangeRequestAssetsResult = {
  __typename?: 'SaveChangeRequestAssetsResult';
  changeRequestAssets: Array<ChangeRequestAsset>;
};

export type ChangeRequestAssetFilter = {
  functionType: BusinessFunctionType;
};

export type ChangeRequestAssetOrder = {
  id?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  scopes?: InputMaybe<Order>;
  implementer?: InputMaybe<Order>;
  implementationReviewer?: InputMaybe<Order>;
  platform?: InputMaybe<Order>;
  functionType?: InputMaybe<Order>;
};

export type ChangeRequestAssetsPageResult = {
  __typename?: 'ChangeRequestAssetsPageResult';
  entities: Array<ChangeRequestAsset>;
  pageInfo: PageInfo;
};

export type ChangeRequestGroup = {
  __typename?: 'ChangeRequestGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  changeRequests: Array<ChangeRequest>;
  salesforceOpportunityLink?: Maybe<Scalars['String']['output']>;
  underContract?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveChangeRequestGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  changeRequests?: InputMaybe<Array<SaveChangeRequestGroupChangeRequestInput>>;
  salesforceOpportunityLink?: InputMaybe<Scalars['String']['input']>;
  underContract?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveChangeRequestGroupResult = {
  __typename?: 'SaveChangeRequestGroupResult';
  changeRequestGroup: ChangeRequestGroup;
};

export type SaveChangeRequestGroupsResult = {
  __typename?: 'SaveChangeRequestGroupsResult';
  changeRequestGroups: Array<ChangeRequestGroup>;
};

export type SaveChangeRequestGroupChangeRequestInput = {
  id: Scalars['ID']['input'];
  op: IncrementalCollectionOp;
};

export type ChangeRequestScope = {
  __typename?: 'ChangeRequestScope';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  changeRequest: ChangeRequest;
  target: ChangeRequestScopeTarget;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChangeRequestScopeTarget = StandaloneProject | Region | Development | Market | Community | Subdivision | Lot | Structure | Unit;

export type ChangeRequestToDo = Named & HasBlueprintUrl & CanCollaborate & Commentable & Referencable & Followable & {
  __typename?: 'ChangeRequestToDo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  order: Scalars['String']['output'];
  urgent: Scalars['Boolean']['output'];
  status: ToDoStatusDetail;
  type: ToDoTypeDetail;
  createdBy: User;
  attachments: Array<Attachment>;
  checklistItems: Array<ToDoChecklistItem>;
  assignees: Array<User>;
  parent?: Maybe<ToDoParent>;
  priorityGroup: Scalars['Int']['output'];
  changeRequestToDoType: ChangeRequestToDoTypeDetail;
  businessFunction: BusinessFunction;
  changeRequest: ChangeRequest;
  changeRequestAsset?: Maybe<ChangeRequestAsset>;
  originalAssignee: User;
  blueprintUrl: Url;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type CheckoutConfig = HasCheckoutUrl & ReadyPlanConfigLike & {
  __typename?: 'CheckoutConfig';
  id: Scalars['ID']['output'];
  /**  Should default the POF name, but then can be customized by homeowner.  */
  name?: Maybe<Scalars['String']['output']>;
  reservedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  status: CheckoutConfigStatus;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFirstName?: Maybe<Scalars['String']['output']>;
  customerLastName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  structure: Structure;
  community: Community;
  productOffering?: Maybe<ProductOffering>;
  readyPlan?: Maybe<ReadyPlanLike>;
  readyPlanOptions: Array<ReadyPlanOption>;
  isReversed: Scalars['Boolean']['output'];
  /** @deprecated Use optionGroups instead. */
  options: Array<ReadyPlanOption>;
  /**  All of the RPOGs, both selected and not selected, with contextual cutoffs/prices for this config.  */
  optionGroups: Array<CheckoutConfigOptionGroup>;
  /**  The MH starting sales price (structure-specific if available, otherwise base config price).  */
  mhSalesPriceInCents: Scalars['Int']['output'];
  /**  The ADU starting sales price. 0 if no ADU product offering is set.  */
  aduSalesPriceInCents: Scalars['Int']['output'];
  /**  Combined sales price (mhSalesPriceInCents + aduSalesPriceInCents). Returns reserved price if config is reserved | expired.  */
  salesPriceInCents: Scalars['Int']['output'];
  /**  MH total price including all selected MH options.  */
  mhTotalPriceInCents: Scalars['Int']['output'];
  /**  ADU total price including all selected ADU options. 0 if no ADU product offering is set.  */
  aduTotalPriceInCents: Scalars['Int']['output'];
  /**  Combined total price (mhTotalPriceInCents + aduTotalPriceInCents). Returns reserved price if config is reserved | expired.  */
  totalPriceInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  checkoutUrl: Url;
  /**  Only internal tech team users will have access to this */
  pricingTraceUrl?: Maybe<Url>;
  canChangeProductOffering: PotentialOperation2;
  canEdit: PotentialOperation2;
  programData?: Maybe<ProgramData>;
  aduProgramData?: Maybe<ProgramData>;
  rendering?: Maybe<Asset>;
  /**  Static interior rendering images for the checkout config, filtered by the selected config.  */
  interiorRenderings: Array<InteriorRoomRendering>;
  /** Returns renderings matched by selected RPO IDs. Parses filenames with format '{Type}-ids={id1}_{id2}.ext' and returns the best match per type. */
  renderings: Array<RenderingAsset>;
  /**  Stored price that calculates once. Used for listing endpoints (i.e Product Offering page)  */
  storedPriceInCents?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<User>;
  /**  Will always return package selection and whole house as the first two steps.  */
  interiorSubSteps: Array<CheckoutConfigInteriorSubStep>;
  /** Pre-computed texture swaps and camera data for InsideMaps rendering */
  insideMapsTextureSwaps?: Maybe<InsideMapsTextureSwaps>;
  insideMapsRoomRenderings: Array<InsideMapsRoomRendering>;
  homeowners: Array<Homeowner>;
  aggregateVersion?: Maybe<ReadyPlanAggregateVersion>;
  changeEvents: Array<ChangeEvent>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  useStackedPricing: Scalars['Boolean']['output'];
  /** Main house estimated invoice schedule that distributes the MH total price pro-rata across cost code invoice categories based on the underlying cost breakdown. If additionalSitePriceInCents is provided, it is added after proration: 80% to Foundation and 20% to Exterior. */
  mhEstimatedInvoiceSchedule: Array<EstimatedInvoiceScheduleItem>;
  /** ADU estimated invoice schedule. Only construction phases prorated from ADU total price. */
  aduEstimatedInvoiceSchedule: Array<EstimatedInvoiceScheduleItem>;
  /** @deprecated Use mhEstimatedInvoiceSchedule and aduEstimatedInvoiceSchedule instead */
  estimatedInvoiceSchedule: Array<EstimatedInvoiceScheduleItem>;
  buildablePlans: Array<ProductOffering>;
  buildableAduPlans: Array<ProductOffering>;
  aduProductOffering?: Maybe<ProductOffering>;
  aduAggregateVersion?: Maybe<ReadyPlanAggregateVersion>;
  /**  All ADU ProductOfferings in the community that have showInCheckout enabled.  */
  potentialAdus: Array<ProductOffering>;
};


export type CheckoutConfigOptionGroupsArgs = {
  filter?: InputMaybe<CheckoutConfigOptionGroupFilter>;
  shallow?: InputMaybe<Scalars['Boolean']['input']>;
  disablePackageOptions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CheckoutConfigRenderingsArgs = {
  type: Array<ReadyPlanAssetType>;
};


export type CheckoutConfigInsideMapsTextureSwapsArgs = {
  debugParts?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CheckoutConfigMhEstimatedInvoiceScheduleArgs = {
  additionalSitePriceInCents?: InputMaybe<Scalars['Int']['input']>;
};


export type CheckoutConfigEstimatedInvoiceScheduleArgs = {
  additionalSitePriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type EstimatedInvoiceScheduleItem = {
  __typename?: 'EstimatedInvoiceScheduleItem';
  costCodeInvoiceCategory: CostCodeInvoiceCategory;
  invoiceAmountInCents: Scalars['Int']['output'];
};

export type CheckoutConfigOptionGroupFilter = {
  rpogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasDynamicProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  Maps each CheckoutConfigOptionGroup to a specific step in checkout.  */
export enum CheckoutConfigOptionGroupStep {
  /**  I.e. Elevation and Exterior Design Package (exterior scheme/style)  */
  ExteriorElevation = 'EXTERIOR_ELEVATION',
  ExteriorDesignPackage = 'EXTERIOR_DESIGN_PACKAGE',
  /**  I.e. Add Bedroom, Add Bathroom, Add Garage, etc (permit changes).  */
  OptionsStructural = 'OPTIONS_STRUCTURAL',
  /**  I.e. Add Wet Bar, Add Washer & Dryer (non-permit takeoff changes).  */
  OptionsAddon = 'OPTIONS_ADDON',
  /**  I.e. Interior Design Package (interior scheme/spec level)  */
  InteriorDesignPackage = 'INTERIOR_DESIGN_PACKAGE',
  /**  I.e. Package Option & Product Option product swaps.  */
  InteriorPersonalization = 'INTERIOR_PERSONALIZATION',
  /**  I.e. All options specific to ADU locations are assigned here */
  Adu = 'ADU'
}

export type CheckoutConfigOptionGroup = {
  __typename?: 'CheckoutConfigOptionGroup';
  id: Scalars['ID']['output'];
  step: CheckoutConfigOptionGroupStep;
  subStepNumber?: Maybe<Scalars['Int']['output']>;
  group: ReadyPlanOptionGroup;
  options: Array<CheckoutConfigPotentialOption>;
  selectedOption?: Maybe<CheckoutConfigPotentialOption>;
  cutoffDate?: Maybe<Scalars['Date']['output']>;
  /**  This option group is allowed to be selected if it has all necessary prerequisites met.  */
  isEnabled: Scalars['Boolean']['output'];
  parentGroup?: Maybe<ReadyPlanOptionGroup>;
  childGroup?: Maybe<ReadyPlanOptionGroup>;
};

export type CheckoutConfigPotentialOption = {
  __typename?: 'CheckoutConfigPotentialOption';
  id: Scalars['ID']['output'];
  option: ReadyPlanOption;
  /**  Whether this option is selected in the current checkout config.  */
  isSelected: Scalars['Boolean']['output'];
  /**
   *  Whether this option should be shown to the user, based on the config-so-far.
   *
   * I.e. we disable options like SpecLevel=Premium based on earlier Interior/Exterior Scheme selections,
   * or InteriorScheme=Farmhouse based on earlier Elevation choices.
   */
  isEnabled: Scalars['Boolean']['output'];
  /**
   *  Whether this option can be selected, or if it would 'fundamentally' conflict with a currently-selected option.
   * @deprecated Use option.isEnabled instead.
   */
  canBeSelected: PotentialOperation2;
  /**
   * Whether this option should be shown on the summary.
   *
   * Normally this is true only for selected options, but optional base-config options that the
   * user has opted-opt of (i.e. they don't want Add Bedroom, so we need to reduce the price)
   * also need to be included, for the `base price +/- deltas = total price` math to work.
   */
  showOnSummary: Scalars['Boolean']['output'];
  /**
   * The incremental price to add/remove this option.
   * When the CheckoutConfig is reserved (or expired), this price will be locked at the time of reservation.
   */
  totalPriceInCents: Scalars['Int']['output'];
  /**  If this is a package option, e.g. Samsung Appliances, returns the unique products in slot order.  */
  packageOptionMaterials: Array<MaterialVariant>;
  primaryProduct?: Maybe<MaterialVariant>;
  displayProducts: Array<MaterialVariant>;
  includedBy?: Maybe<CheckoutConfigPotentialOption>;
  /**  if Spec 2 -> AddBedroom -> ConvertBath -> THIS, then returns spec 2 */
  includedByRoot?: Maybe<CheckoutConfigPotentialOption>;
};

export type CheckoutConfigPackageOptionSlot = {
  __typename?: 'CheckoutConfigPackageOptionSlot';
  /**  An opaque slot ID, i.e. for groupByFeature might be `Kitchen~Island~Range` or just `Kitchen~Range`.  */
  id: Scalars['ID']['output'];
  /**  e.g., Whole House / Level 1 / Kitchen 101  */
  location: Location;
  /**  e.g., type=placeholder generic 36in fridge.  */
  materialVariant: MaterialVariant;
};

/**
 * One of the products in a package option, e.g., the Samsung Fridge SKU123 in the Samsung Appliances package option.
 *
 * Note that "the same product" might show up multiple times in a package option, i.e. if a Modern Tile package option
 * uses the same Blue tile SKU123 in multiple rooms/locations (slots).
 */
export type CheckoutConfigPackageOptionProduct = {
  __typename?: 'CheckoutConfigPackageOptionProduct';
  /**  The opaque ID of the 'cell' of slot/column x option/row.  */
  id: Scalars['ID']['output'];
  /**
   * The slot/column id for this cell.
   *
   * Note this `slotId` should be the primary mechanism of mapping the "product SKU123 -> column/slot 36in Fridge
   * placeholder" because the mapping depends on per-RPOG flags like `groupByFeature` that mean seemingly-correct
   * "just compare by placeholder/location" heuristics may not work.
   */
  slotId: Scalars['ID']['output'];
  /**  e.g., the type=placeholder generic 36in fridge.  */
  placeholder: MaterialVariant;
  /**  e.g., the location=Flex Room -> Interior Appliances.  */
  location: Location;
  /**  e.g., the type=product Fridge SKU1.  */
  product: MaterialVariant;
  /**  Whether this product should be displayed as a single product in checkout instead of separate package options  */
  displayPackageOptionsAsSingleProduct: Scalars['Boolean']['output'];
};

export type SaveCheckoutConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /**  Can only be set on create, then immutable.  */
  structureId?: InputMaybe<Scalars['ID']['input']>;
  /**  Allow swapping plans (before structural cutoffs).  */
  productOfferingId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CheckoutConfigStatus>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  isReversed?: InputMaybe<Scalars['Boolean']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** `expiresAt` is expected to be provided by the client when moving `status` to `Reserved` otherwise it will be set to 7 days from `reservedAt`. */
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  customerFirstName?: InputMaybe<Scalars['String']['input']>;
  customerLastName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  homeownerId?: InputMaybe<Scalars['ID']['input']>;
  /**  If true, return existing Draft config for homeowner + structure instead of creating a new one (used for QR code flow).  */
  reuseExistingConfig?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Set to true to archive, false to unarchive.  */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  useStackedPricing?: InputMaybe<Scalars['Boolean']['input']>;
  aduProductOfferingId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveCheckoutConfigResult = {
  __typename?: 'SaveCheckoutConfigResult';
  checkoutConfig: CheckoutConfig;
};

export type UnreserveCheckoutConfigInput = {
  id: Scalars['ID']['input'];
  /**  If true, preserves the expiresAt date instead of clearing it. Defaults to false.  */
  preserveExpiresAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SyncCheckoutConfigToVersionInput = {
  id: Scalars['ID']['input'];
  rpavId: Scalars['ID']['input'];
};

export type CheckoutConfigsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  structure?: InputMaybe<Array<Scalars['ID']['input']>>;
  productOffering?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<CheckoutConfigStatus>>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  When false, excludes configs created by users in the 'Checkout Team Testers' user group  */
  isTechTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /**  When true, includes archived configs in the results. Defaults to false.  */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckoutConfigsOrder = {
  id?: InputMaybe<Order>;
  expiresAt?: InputMaybe<Order>;
  reservedAt?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
  structureAddress?: InputMaybe<Order>;
  customerFirstName?: InputMaybe<Order>;
};

export type CheckoutConfigsPage = {
  __typename?: 'CheckoutConfigsPage';
  entities: Array<CheckoutConfig>;
  pageInfo: PageInfo;
};

export type CheckoutPricingTraceInput = {
  /**  The ccfg to debug; we use this for the 'included' and 'selected' prices / drift calculation.  */
  checkoutConfigId: Scalars['ID']['input'];
};

export type CheckoutPricingTrace = {
  __typename?: 'CheckoutPricingTrace';
  /**  The ccfg that drove this trace; optional b/c we might eventually support non-CCFG driven price tracing, i.e. with POCs.  */
  checkoutConfig?: Maybe<CheckoutConfig>;
  baseHousePriceInCents: Scalars['Int']['output'];
  includedPriceInCents: Scalars['Int']['output'];
  selectedPriceInCents: Scalars['Int']['output'];
  optionGroups: Array<CheckoutPricingTraceOptionGroup>;
};

export type CheckoutPricingTraceOptionGroup = {
  __typename?: 'CheckoutPricingTraceOptionGroup';
  group: ReadyPlanOptionGroup;
  /**  Which option, if any, was included for this group.  */
  included?: Maybe<CheckoutPricingTraceOption>;
  /**  Which option, if any, was selected for this group.  */
  selected?: Maybe<CheckoutPricingTraceOption>;
  /**  The UW/base credit, i.e. the UW ElevationA caused $200k increase, so they can spend $200k.  */
  availableCreditInCents: Scalars['Int']['output'];
  /**  The actual delta above their credit.  */
  priceChangeInCents: Scalars['Int']['output'];
};

export type CheckoutPricingTraceOption = {
  __typename?: 'CheckoutPricingTraceOption';
  option?: Maybe<ReadyPlanOption>;
  /**  Full-home price with this option added.  */
  totalPriceInCents: Scalars['Int']['output'];
  /**
   * The per-option pricing breakdown of what changed at this option group.
   *
   * For the first RPOG, this includes all groups. For subsequent RPOGs, only the current group and
   * any transitively-dirtied downstream groups whose selection or pricing changed appear here.
   *
   * Empty for groups like "Add Bedroom" that may not have a selection.
   */
  changed: Array<CheckoutPricingTraceOptionChange>;
};

export type CheckoutPricingTraceOptionChange = {
  __typename?: 'CheckoutPricingTraceOptionChange';
  group: ReadyPlanOptionGroup;
  /**  The new option (or null if the option was removed) that caused the price change at this group.  */
  option?: Maybe<ReadyPlanOption>;
  /**  The previous option (or null if an option wasn't selected).  */
  previousOption?: Maybe<ReadyPlanOption>;
  /**  The price change caused by this option.  */
  priceInCents: Scalars['Int']['output'];
  /**  The cost change caused by this option.  */
  costInCents: Scalars['Int']['output'];
  /**  The selection fee change caused by this option.  */
  selectionFeeInCents: Scalars['Int']['output'];
  /**  The min price fee change caused by this option.  */
  minimumPriceInCents: Scalars['Int']['output'];
};

export type CheckoutConfigInteriorSubStep = {
  __typename?: 'CheckoutConfigInteriorSubStep';
  id: Scalars['ID']['output'];
  /**
   * Empty for the up-front Package, Whole House, and trailing Additional substeps, otherwise the room
   * like Great Room, Kitchen etc.
   */
  location?: Maybe<ReadyPlanLocation>;
  /**  'Interior Package', 'Whole House', or 'Great Room' etc.  */
  displayName: Scalars['String']['output'];
  stepNumber: Scalars['Int']['output'];
};

/**
 * Pre-computed texture swaps and camera data for InsideMaps rendering.
 * Replaces the need for frontend to process raw config + slot assignments.
 */
export type InsideMapsTextureSwaps = {
  __typename?: 'InsideMapsTextureSwaps';
  /** All cameras with their display info and relationships */
  cameras: Array<InsideMapsCamera>;
  /** Texture swaps grouped by camera name */
  textureSwapsByCamera: Array<InsideMapsCameraTextureSwaps>;
  /** The InsideMaps project ID needed for iframe URL */
  projectId?: Maybe<Scalars['String']['output']>;
  /**
   * Optional debug information about slot assignments and texture changes.
   * Only populated when debug mode is enabled. Array of debug entries that can be logged.
   */
  debugSlots?: Maybe<Array<InsideMapsDebugSlot>>;
};

export type InsideMapsCamera = {
  __typename?: 'InsideMapsCamera';
  cameraName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  /** Whether this is the default camera to use when no location is specified. */
  isDefault: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  /** If this is an alternate view, the primary camera name it belongs to */
  alternateViewFor?: Maybe<Scalars['String']['output']>;
  /** Alternate cameras for this primary camera (empty for alternate cameras) */
  alternateCameras: Array<InsideMapsCamera>;
};

export type InsideMapsCameraTextureSwaps = {
  __typename?: 'InsideMapsCameraTextureSwaps';
  cameraName: Scalars['String']['output'];
  textureSwaps: Array<InsideMapsTextureSwap>;
};

export type InsideMapsTextureSwap = {
  __typename?: 'InsideMapsTextureSwap';
  part: Scalars['String']['output'];
  texture: Scalars['String']['output'];
};

/**
 * Formatted debug message string that can be logged directly to the console.
 *  Having this be an object rather than just debugSlots: [String!]! so we can add more details without breaking changes in the future (say we want to debug by camera view, etc)
 */
export type InsideMapsDebugSlot = {
  __typename?: 'InsideMapsDebugSlot';
  message: Scalars['String']['output'];
};

export type InsideMapsSlotAuditInput = {
  productOfferingId: Scalars['ID']['input'];
  rpavId?: InputMaybe<Scalars['ID']['input']>;
};

export type InsideMapsSlotAuditResult = {
  __typename?: 'InsideMapsSlotAuditResult';
  /** Output a string with rows containing ${camera}.${part}.${texture} ${combo} ==> ${textureName} */
  audit: Array<Scalars['String']['output']>;
};

export type InsideMapsSlotDiffInput = {
  productOfferingId: Scalars['ID']['input'];
  rpavId1: Scalars['ID']['input'];
  rpavId2: Scalars['ID']['input'];
};

export type InsideMapsSlotDiffResult = {
  __typename?: 'InsideMapsSlotDiffResult';
  /** Get the slot audit for each version, then output only the keys that have changed/are different from rpavId1 / rpavId2 */
  diffs: Array<Scalars['String']['output']>;
};

export type RunCheckoutPricingReportInput = {
  pofId: Scalars['String']['input'];
  rpavId?: InputMaybe<Scalars['String']['input']>;
  compareToRpavId?: InputMaybe<Scalars['String']['input']>;
  onlyDeltas?: InputMaybe<Scalars['Boolean']['input']>;
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RunCheckoutPricingReportResult = {
  __typename?: 'RunCheckoutPricingReportResult';
  report: TrackedJob;
};

export type CheckoutConfigOption = {
  __typename?: 'CheckoutConfigOption';
  id: Scalars['ID']['output'];
  readyPlanOption: ReadyPlanOption;
  checkoutConfig: CheckoutConfig;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  reservedPriceInCents?: Maybe<Scalars['Int']['output']>;
  isIncluded: Scalars['Boolean']['output'];
  showOnSummary: Scalars['Boolean']['output'];
  reservedCutoffDate?: Maybe<Scalars['Date']['output']>;
  includedByCheckoutConfigOption?: Maybe<CheckoutConfigOption>;
  /**  if Spec 2 -> AddBedroom -> ConvertBath -> THIS, then returns spec 2 */
  includedByRoot?: Maybe<CheckoutConfigOption>;
};

/**
 * Note that `Homeowner` is the entity name on the backend, but it's still Client in GraphQL
 * because that would have been a large breaking API change.
 */
export type Client = Named & {
  __typename?: 'Client';
  id: Scalars['ID']['output'];
  /**  alias of fullName for approvals and Named  */
  name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /**  Just last name. (I think `shortName` is from an original `displayName`-ish convention.)  */
  shortName: Scalars['String']['output'];
  /**  First and last, if both are set.  */
  fullName: Scalars['String']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated use lastActiveAt instead */
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  address?: Maybe<Address>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ClientInput = {
  /**  We don't include id because we use email as the primary identifier.  */
  email: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCredentialsForExistingClientInput = {
  email: Scalars['String']['input'];
};

export type UpdateClientEmailInput = {
  id: Scalars['ID']['input'];
  newEmail: Scalars['String']['input'];
};

export type Cohort = Named & {
  __typename?: 'Cohort';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  market: Market;
  projects: Array<Project>;
  developer?: Maybe<InternalUser>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  development?: Maybe<Development>;
  scopeMode: ScopeModeDetail;
  isBoolDefaultForDevelopment?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveCohortsResult = {
  __typename?: 'SaveCohortsResult';
  cohorts: Array<Cohort>;
};

export type CohortFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  developer?: InputMaybe<Array<Scalars['ID']['input']>>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveCohortsInput = {
  cohorts: Array<SaveCohortInput>;
};

export type SaveCohortInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  developerId?: InputMaybe<Scalars['ID']['input']>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  isBoolDefaultForDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteCohortInput = {
  id: Scalars['ID']['input'];
};

/** Helper interface which implements all collaboration features */
export type CanCollaborate = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type SchedulePhase = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & ScheduleEntity & Named & MaybeHasInterval & MaybeHasBaselineInterval & {
  __typename?: 'SchedulePhase';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent: ScheduleParent;
  project?: Maybe<Project>;
  schedule: Schedule;
  interval?: Maybe<CalendarInterval>;
  baselineInterval?: Maybe<CalendarInterval>;
  blueprintUrl: Url;
  progress: SchedulePhaseProgress;
  cmsId?: Maybe<Scalars['String']['output']>;
  scheduleSubPhases: Array<ScheduleSubPhase>;
  globalPhase: GlobalPhase;
  taskStatusRollup?: Maybe<TaskStatus>;
};


export type SchedulePhaseProgressArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchedulePhaseScheduleSubPhasesArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScheduleSubPhase = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & ScheduleEntity & Named & MaybeHasInterval & MaybeHasBaselineInterval & {
  __typename?: 'ScheduleSubPhase';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent: ScheduleParent;
  project?: Maybe<Project>;
  schedule: Schedule;
  schedulePhase: SchedulePhase;
  scheduleTasks: Array<ScheduleTask>;
  globalSubPhase: GlobalSubPhase;
  blueprintUrl: Url;
  interval?: Maybe<CalendarInterval>;
  baselineInterval?: Maybe<CalendarInterval>;
  progress: ScheduleSubPhaseProgress;
  cmsId?: Maybe<Scalars['String']['output']>;
};


export type ScheduleSubPhaseScheduleTasksArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScheduleSubPhaseProgressArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Task = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & MaybeHasProject & MaybeHasInterval & {
  __typename?: 'Task';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  stage: ProjectStage;
  project?: Maybe<Project>;
  name: Scalars['String']['output'];
  /** @deprecated All tasks now behave as user created. */
  userCreated: Scalars['Boolean']['output'];
  status: TaskStatusDetail;
  homeownerVisible: Scalars['Boolean']['output'];
  homeownerDescription?: Maybe<Scalars['String']['output']>;
  interval: CalendarInterval;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  baselineInterval: CalendarInterval;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  baselineInterval2?: Maybe<CalendarInterval2>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  assignee?: Maybe<InternalUser>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  internalNote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  cmsId: Scalars['String']['output'];
  slackInDays?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  aheadOrBehindInDays?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  isStale: Scalars['Boolean']['output'];
  isCriticalPath: Scalars['Boolean']['output'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  predecessors: Array<Task>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  successors: Array<Task>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  predecessorDependencies: Array<TaskDependency>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  successorDependencies: Array<TaskDependency>;
  homeownerContractDraws: Array<HomeownerContractDraw>;
  isManuallyScheduled: Scalars['Boolean']['output'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  isBaselineManuallyScheduled?: Maybe<Scalars['Boolean']['output']>;
  blueprintUrl: Url;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  isMilestone: Scalars['Boolean']['output'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  salesforceId?: Maybe<Scalars['String']['output']>;
  tradePartner?: Maybe<TradePartner>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  canEditStartDate: PotentialOperation2;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  canEditEndDate: PotentialOperation2;
  /**
   *  Convenience operation which is a logical OR of canEditStartDate || canEditEndDate
   * @deprecated Legacy attribute, will only be available on ScheduleTask going forward.
   */
  canEditDuration: PotentialOperation2;
  canComplete: PotentialOperation2;
  canStart: PotentialOperation2;
  canDelete: PotentialOperation2;
  canSetTraderPartner: PotentialOperation2;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  projectCutoffs: Array<ProjectCutoff>;
  projectItems: Array<ProjectItem>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  deadlineType?: Maybe<TaskDeadlineType>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  deadlineTypeDetail?: Maybe<TaskDeadlineTypeDetail>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  templateProjectRole?: Maybe<ProjectRole>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  templateProjectRoleDetail?: Maybe<ProjectRoleDetail>;
  documents: Array<Document>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  globalTask?: Maybe<GlobalTask>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  isGlobalMilestoneTask: Scalars['Boolean']['output'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  scheduleTemplateItemMappings: Array<ScheduleTemplateItemMapping>;
  requiredTaskDocuments: Array<RequiredTaskDocument>;
  scheduleTaskChecklistItems: Array<ScheduleTaskChecklistItem>;
  scheduleFlags: Array<ScheduleFlag>;
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  jobLogNotes: Array<JobLogNote>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: Maybe<Scalars['Boolean']['output']>;
  hasScheduleFlags: Scalars['Boolean']['output'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  systemTask?: Maybe<SystemTask>;
  tradePartners: Array<TradePartner>;
  committedTradePartners: Array<TradePartner>;
  billLineItems: Array<BillLineItem>;
  defaultedHomeownerDescription: Scalars['String']['output'];
  /** @deprecated Legacy attribute, will only be available on ScheduleTask going forward. */
  templateTask?: Maybe<Task>;
  tradePartnerStatus: TradePartnerTaskStatusDetail;
  tradePartnerAvailabilityRequests?: Maybe<Array<TradePartnerAvailabilityRequest>>;
  depositCommitments: Array<Commitment>;
  type: TaskTypeDetail;
  workDays: Array<TaskWorkDay>;
  commitmentDraws: Array<CommitmentDraw>;
  protoBills: Array<ProtoBill>;
  checklistComplete?: Maybe<Scalars['Boolean']['output']>;
  schedule: ScheduleLike;
};

export type PlanTask = CanCollaborate & Commentable & Referencable & Followable & Entity & HasBlueprintUrl & Named & {
  __typename?: 'PlanTask';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  durationInDays: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
  endDate: Scalars['Date']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  slackInDays?: Maybe<Scalars['Int']['output']>;
  /** NOTE: `PlanTask` critical path is expanded to be `slackInDays <= 3` compared to `Task` critical path of `slackInDays === 0` */
  isCriticalPath: Scalars['Boolean']['output'];
  homeownerVisible?: Maybe<Scalars['Boolean']['output']>;
  status: TaskStatusDetail;
  type: TaskTypeDetail;
  sortOrder: Scalars['Int']['output'];
  internalUser?: Maybe<InternalUser>;
  blueprintUrl: Url;
  schedule: PlanSchedule;
  globalPlanTask: GlobalPlanTask;
  /** A filtered subset of `globalPlanTask.checklistItems` that are required for this based on its completion date. */
  globalChecklistItems: Array<GlobalPlanTaskChecklistItem>;
  checklistItems: Array<PlanTaskChecklistItem>;
  requiredTaskDocuments: Array<RequiredTaskDocument>;
  documents: Array<Document>;
  history: Array<History>;
  earliestStartDate?: Maybe<Scalars['Date']['output']>;
  knownDurationInDays?: Maybe<Scalars['Int']['output']>;
  isManuallyScheduled?: Maybe<Scalars['Boolean']['output']>;
  canStart: PotentialOperation2;
  canComplete: PotentialOperation2;
  canDeleteWithWarning: PotentialOperation2;
  canDelete: PotentialOperation2;
  canSetTraderPartner: PotentialOperation2;
  /**
   * Lists `GlobalPlanConstraintItems` that constrain this task.
   * Prefer this attribute vs. `globalTask.constraints` as this PlanTask may have market-specific overrides
   */
  constraintItems: Array<GlobalPlanConstraintItem>;
  /**
   * Lists `GlobalPlanConstraintItems` that allow this task.
   * Prefer this attribute vs. `globalTask.allowances` as this PlanTask may have market-specific overrides
   */
  allowanceItems: Array<GlobalPlanConstraintItem>;
  tradePartner?: Maybe<TradePartner>;
  tradePartners: Array<TradePartner>;
  /** Note: this is the sub-set of tradePartners that are signed */
  committedTradePartners: Array<TradePartner>;
  billLineItems: Array<BillLineItem>;
  tradePartnerStatus: TradePartnerTaskStatusDetail;
  tradePartnerAvailabilityRequests?: Maybe<Array<TradePartnerAvailabilityRequest>>;
  simulationProbability: SimulationProbability;
  scheduleFlags: Array<ScheduleFlag>;
  ignoredConstraintsOnTaskEnd: Array<GlobalPlanConstraintItem>;
  ignoredConstraintsOnTaskStart: Array<GlobalPlanConstraintItem>;
  workDays: Array<TaskWorkDay>;
  workingDaysProgress: Scalars['Int']['output'];
  projectItems: Array<ProjectItem>;
  isStale: Scalars['Boolean']['output'];
  stage?: Maybe<GlobalPlanStage>;
  commitmentDraws: Array<CommitmentDraw>;
  protoBills: Array<ProtoBill>;
  /** Defaults to Monday - Friday even if `customWorkableDaysOfWeek` is not set */
  customWorkableDays: Array<DayOfWeek>;
  /** PlanMilestones that this task contributes to via its 'allowances' */
  allowsPlanMilestones: Array<PlanMilestone>;
  knownSchedulingContacts: Array<TradePartnerContact>;
};

export type ToDo = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & {
  __typename?: 'ToDo';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  description?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  order: Scalars['String']['output'];
  status: ToDoStatusDetail;
  type: ToDoTypeDetail;
  parent?: Maybe<ToDoParent>;
  createdBy: User;
  /** @deprecated Use assignees instead */
  assignee?: Maybe<User>;
  assignees: Array<User>;
  attachments: Array<Attachment>;
  urgent: Scalars['Boolean']['output'];
  checklistItems: Array<ToDoChecklistItem>;
  checklistProgress: ToDoChecklistProgress;
  changeRequest?: Maybe<ChangeRequest>;
};

export type Invoice = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & MaybeHasProject & {
  __typename?: 'Invoice';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  invoiceDate: Scalars['Date']['output'];
  dueDate: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  quickbooksId?: Maybe<Scalars['String']['output']>;
  amountInCents: Scalars['Int']['output'];
  balanceInCents: Scalars['Int']['output'];
  amountPaidInCents: Scalars['Int']['output'];
  projectStage: ProjectStage;
  lineItems: Array<InvoiceLineItem>;
  lineItemsByCostCode: Array<InvoiceLineItemsByCostCode>;
  drawLineItems: Array<InvoiceDrawLineItem>;
  quickbooksPullOnly: Scalars['Boolean']['output'];
  document?: Maybe<Document>;
  invoiceNumber: Scalars['String']['output'];
  isHistoricalInvoiceNumber: Scalars['Boolean']['output'];
  isFinalInvoice: Scalars['Boolean']['output'];
  history: Array<History>;
  blueprintUrl: Url;
  project: Project;
  intacctAmountPaidInCents: Scalars['Int']['output'];
  documents: Array<InvoiceDocument>;
  quickbooksAmountPaidInCents: Scalars['Int']['output'];
  intacctSyncError?: Maybe<Scalars['String']['output']>;
  approval?: Maybe<Approval>;
  status: InvoiceStatusDetail;
  lineItemCutoffDate?: Maybe<Scalars['Date']['output']>;
  lineItemStartDate?: Maybe<Scalars['Date']['output']>;
  predictedApprovers: Array<ApproverUser>;
  paidDate?: Maybe<Scalars['Date']['output']>;
  creditForInvoice?: Maybe<Invoice>;
  shouldSyncToIntacct: Scalars['Boolean']['output'];
  intacctId?: Maybe<Scalars['String']['output']>;
  type: InvoiceTypeDetail;
  canEdit: PotentialOperation2;
  canDelete: PotentialOperation2;
  pandaDocs: Array<PandaDoc>;
  scheduledLineItems: Array<InvoiceScheduledLineItem>;
  accruedLineItems: Array<InvoiceAccruedLineItem>;
  /**
   * A unified view of all invoice line items (InvoiceLineItem, InvoiceDrawLineItem, InvoiceScheduledLineItem, InvoiceAccruedLineItem)
   * normalized into a single structure for UI display purposes (Pdf / Invoice / ERP).
   */
  displayLineItems: Array<InvoiceDisplayLineItem>;
  updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  isHistorical: Scalars['Boolean']['output'];
  parent?: Maybe<InvoiceParent>;
  source: InvoiceSourceDetail;
  remainingDownPaymentInCents: Scalars['Int']['output'];
  downPaymentConsumingLineItems: Array<InvoiceLineItem>;
  pocInvoicedToDateInCents: Scalars['Int']['output'];
  contractPriceSnapshotInCents: Scalars['Int']['output'];
};


export type InvoiceDisplayLineItemsArgs = {
  mode?: InputMaybe<InvoiceDisplayLineItemMode>;
};

export type Project = {
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  market?: Maybe<Market>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  /**  The address + client name  */
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parent?: Maybe<Project>;
  children: Array<Project>;
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type ProjectTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type ProjectStageArgs = {
  stage: Stage;
};


export type ProjectAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type ProjectToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type ProjectSelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type ProjectHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type ProjectDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type ProjectSnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type ProjectOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type ProjectPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandaloneProject = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & MaybeHasPropcoUrl & {
  __typename?: 'StandaloneProject';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Overridden fields from Project */
  buildAddress: Address;
  market: Market;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project: Project;
  cohort?: Maybe<Cohort>;
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  lotRating?: Maybe<LotRating>;
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  preconContractType?: Maybe<PreconContractType>;
  primaryProject?: Maybe<Project>;
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  shadowProjects: Array<Project>;
  submarket?: Maybe<Submarket>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  propcoUrl?: Maybe<Scalars['String']['output']>;
  /**  The address + client name  */
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parent?: Maybe<Project>;
  children: Array<Project>;
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type StandaloneProjectPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StandaloneProjectTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StandaloneProjectStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type StandaloneProjectStageArgs = {
  stage: Stage;
};


export type StandaloneProjectAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type StandaloneProjectToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type StandaloneProjectSelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type StandaloneProjectHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type StandaloneProjectDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type StandaloneProjectSnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type StandaloneProjectOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StandaloneProjectUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};

export type Region = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Region';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Region specific fields */
  abbreviation: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Overridden fields from Project */
  children: Array<Market>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  market?: Maybe<Market>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  /**  The address + client name  */
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parent?: Maybe<Project>;
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  invoiceScheduleTemplates: Array<InvoiceScheduleTemplate>;
};


export type RegionTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RegionStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type RegionStageArgs = {
  stage: Stage;
};


export type RegionAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type RegionToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type RegionSelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type RegionHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type RegionDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type RegionSnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type RegionOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type RegionPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Market = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Market';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Market specific fields */
  abbreviation: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  salesforceMarketCode?: Maybe<Scalars['String']['output']>;
  submarkets: Array<Submarket>;
  timeZone: Scalars['String']['output'];
  msaName?: Maybe<Scalars['String']['output']>;
  developments: Array<Development>;
  bidItemEstimates: Array<BidItemEstimate>;
  readyPlans: Array<ReadyPlan>;
  optionPricingConfigVariants: Array<OptionPricingConfigVariant>;
  state: Scalars['String']['output'];
  materialLeadTimeConfigVariants: Array<MaterialLeadTimeConfigVariant>;
  standaloneProjects: Array<StandaloneProject>;
  marketDevelopmentContracts: Array<DevelopmentCommitment>;
  drops: Array<Drop>;
  /** Overridden fields from Project */
  market: Market;
  parent: Region;
  children: Array<Community>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  /**  The address + client name  */
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type MarketTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarketStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type MarketStageArgs = {
  stage: Stage;
};


export type MarketAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type MarketToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type MarketSelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type MarketHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type MarketDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type MarketSnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type MarketOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type MarketPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Community = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Community';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Community specific fields */
  productOfferings: Array<ProductOffering>;
  drops: Array<Drop>;
  costCodesWithDraws: Array<CostCode>;
  salesforceNeighborhoodId?: Maybe<Scalars['String']['output']>;
  pricingTeaser?: Maybe<Scalars['String']['output']>;
  /** Overridden fields from Project */
  market: Market;
  parent: Market;
  children: Array<Subdivision>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  /**  The address + client name  */
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  showInCheckout: Scalars['Boolean']['output'];
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
  packageComparison?: Maybe<Asset>;
  globalPlanStageVariants: Array<GlobalPlanStageVariant>;
};


export type CommunityTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CommunityStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type CommunityStageArgs = {
  stage: Stage;
};


export type CommunityAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type CommunityToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type CommunitySelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type CommunityHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type CommunityDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type CommunitySnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type CommunityOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type CommunityPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Subdivision = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Subdivision';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Subdivision specific fields */
  salesforceBusinessDevelopmentOpportunityId?: Maybe<Scalars['String']['output']>;
  salesforceTakedownId?: Maybe<Scalars['String']['output']>;
  /** Overridden fields from Project */
  market: Market;
  parent: Community;
  children: Array<Lot>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  buildAddress?: Maybe<Address>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  /**  The address + client name  */
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type SubdivisionTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubdivisionStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type SubdivisionStageArgs = {
  stage: Stage;
};


export type SubdivisionAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type SubdivisionToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type SubdivisionSelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type SubdivisionHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type SubdivisionDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type SubdivisionSnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type SubdivisionOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type SubdivisionPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Lot = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Lot';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Lot specific fields */
  buildablePlans: Array<ProductOffering>;
  buildableSfhPlans: Array<ProductOffering>;
  /** Overridden fields from Project */
  buildAddress: Address;
  market: Market;
  parent: Subdivision;
  children: Array<Structure>;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  /**  The address + client name + suffix (e.g. - Lot)  */
  name: Scalars['String']['output'];
  /**  The non-suffixed name  */
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type LotTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LotStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type LotStageArgs = {
  stage: Stage;
};


export type LotAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type LotToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type LotSelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type LotHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type LotDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type LotSnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type LotOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type LotPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Structure = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & MaybeHasPropcoUrl & {
  __typename?: 'Structure';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Overridden fields from Project */
  buildAddress: Address;
  market: Market;
  parent: Lot;
  children: Array<Unit>;
  primaryProject?: Maybe<Project>;
  /** Fields unique to Structure */
  showInCheckout: Scalars['Boolean']['output'];
  community: Community;
  modelHomeHardCostsInCents: Scalars['Int']['output'];
  modelHomeSoftCostsInCents: Scalars['Int']['output'];
  mainHouseStructure?: Maybe<Structure>;
  aduStructure?: Maybe<Structure>;
  planType?: Maybe<ReadyPlanTypeDetail>;
  /** Checks today against RTS date on the plan schedule */
  hasStartedConstruction: Scalars['Boolean']['output'];
  isConstructionComplete: Scalars['Boolean']['output'];
  canChangeProductOffering: PotentialOperation2;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  propcoUrl?: Maybe<Scalars['String']['output']>;
  /**  The address + client name + maybe-suffix (e.g. - ADU, - Main)  */
  name: Scalars['String']['output'];
  /**  The non-suffixed name  */
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
  suburbanAssetCategory?: Maybe<SuburbanAssetCategoryDetail>;
  lotSalesStatus?: Maybe<LotSalesStatusDetail>;
};


export type StructureTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StructureStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type StructureStageArgs = {
  stage: Stage;
};


export type StructureAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type StructureToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type StructureSelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type StructureHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type StructureDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type StructureSnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type StructureOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructureUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type StructurePreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Unit = CanCollaborate & Commentable & Referencable & Followable & Project & HasBlueprintUrl & Named & HasDisplayName & MaybeHasProject & HasSchedules & Entity & HasHopUrl & {
  __typename?: 'Unit';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Overridden fields from Project */
  buildAddress: Address;
  market: Market;
  parent: Structure;
  /** Inherited fields from Project */
  collaborators: Array<ProjectCollaborator>;
  coverImage?: Maybe<Asset>;
  teamMembers: Array<ProjectTeamMember>;
  projectLead?: Maybe<ProjectTeamMember>;
  activeStage: StageDetail;
  activeProjectStage?: Maybe<ProjectStage>;
  stages: Array<ProjectStage>;
  stage: ProjectStage;
  blueprintUrl: Url;
  hopUrl: Scalars['String']['output'];
  /**  The address + client name  */
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  availableAssignees: Array<InternalUser>;
  startDate: Scalars['Date']['output'];
  /**  list of features which are enabled on this project  */
  features: Array<ProjectFeature>;
  isTest: Scalars['Boolean']['output'];
  status: ProjectStatusDetail;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  A reference to itself so that it can be accessed generically via interface queries, like `commentable` without special handling  */
  project?: Maybe<Project>;
  googleDriveFolderId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunities: Array<ProjectSalesforceOpportunity>;
  projectStatusChange?: Maybe<ProjectStatusChange>;
  planRoomLink?: Maybe<Scalars['String']['output']>;
  isDisaster?: Maybe<Scalars['Boolean']['output']>;
  intakeStyleNotes?: Maybe<Scalars['String']['output']>;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  productType?: Maybe<ProductType>;
  enableSchedulesV2: Scalars['Boolean']['output'];
  tradePartners: Array<TradePartner>;
  cutoffs: Array<ProjectCutoff>;
  jobLogs: Array<JobLog>;
  salesforcePropertyId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  expenses: Array<Expense>;
  unallocatedExpenses: Array<Expense>;
  unallocatedAmountInCents: Scalars['Int']['output'];
  enableSchedulesV2Gantt: Scalars['Boolean']['output'];
  enableSchedulesCalendar: Scalars['Boolean']['output'];
  readyPlanConfig?: Maybe<ProjectReadyPlanConfig>;
  earnedValueCurves: Array<EarnedValueCurve>;
  enableInvoiceV2: Scalars['Boolean']['output'];
  invoiceSettings?: Maybe<ProjectInvoiceSetting>;
  scopeMode: ScopeModeDetail;
  lotPartitionId?: Maybe<Scalars['String']['output']>;
  budgetFinancials: ProjectBudgetFinancials;
  enableDelayFlags: Scalars['Boolean']['output'];
  warrantyStartDate?: Maybe<Scalars['Date']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  jobLogInsights: ProjectJobLogInsights;
  targetEndDate?: Maybe<Scalars['Date']['output']>;
  latestActiveStage?: Maybe<ProjectStage>;
  primaryHomeowner?: Maybe<Client>;
  toDos?: Maybe<Array<ToDo>>;
  lotDetail: ProjectLotDetail;
  siteSpecificInfos: Array<ProjectSiteSpecificInfo>;
  projectSiteCondition?: Maybe<ProjectSiteCondition>;
  unassignedTaskCount: Scalars['Int']['output'];
  enableHomeownerNotes: Scalars['Boolean']['output'];
  checkoutCustomerConfigId?: Maybe<Scalars['String']['output']>;
  canEditJobLogs: PotentialOperation2;
  canEditPrice: PotentialOperation2;
  canHaveBudget: PotentialOperation2;
  homeownerNotes: Array<HomeownerNote>;
  enableHomeownerJourneyV2: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  homeownerDeliveryDate?: Maybe<Scalars['Date']['output']>;
  tasksCompletedThisWeek: Scalars['Int']['output'];
  contacts: Array<ProjectContact>;
  warrantyTickets: Array<WarrantyTicket>;
  shouldAccrueAsComplete: Scalars['Boolean']['output'];
  directCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectCostMarkupOverrideBasisPoints?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerOwnerEntity?: Maybe<CustomerOwnerEntity>;
  invoiceSchedule?: Maybe<InvoiceSchedule>;
  allowExcludedCostCodesOnPurchaseOrders: Scalars['Boolean']['output'];
  enableProductConfigPlan: Scalars['Boolean']['output'];
  planSchedule?: Maybe<PlanSchedule>;
  builder?: Maybe<Builder>;
  bidOutPercentage: Scalars['Int']['output'];
  enableChangeEventSignatures: Scalars['Boolean']['output'];
  enablePocInvoiceSchedule: Scalars['Boolean']['output'];
  softCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  indirectHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directHardCostMarkupInBasisPoints?: Maybe<Scalars['Int']['output']>;
  legalDescription?: Maybe<Scalars['String']['output']>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
  projectItemAllocations: Array<ProjectItemAllocation>;
  allocationRules: Array<ProjectAllocationRule>;
  warrantyLengthInDays: Scalars['Int']['output'];
  warrantyOverrideLengthInDays?: Maybe<Scalars['Int']['output']>;
  bidPackages: Array<BidPackage>;
  bidContracts: Array<BidContract>;
  selectionsByLocation: Array<HomeownerLocationSelection>;
  hasSelections: Scalars['Boolean']['output'];
  homeownerContracts: Array<HomeownerContract>;
  documents: Array<Document>;
  commitments: Array<Commitment>;
  directCostInCents: Scalars['Int']['output'];
  directPriceInCents: Scalars['Int']['output'];
  totalHardCostInCents: Scalars['Int']['output'];
  totalSoftCostInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  committedCostCodesAtStartInBasisPoints?: Maybe<Scalars['Int']['output']>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  uncommittedCostInCents: Scalars['Int']['output'];
  snapshots: Array<ProjectSnapshot>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
  companyInfo: CompanyInfo;
  invoicePaymentNetDays: Scalars['Int']['output'];
  /**  return the first snapshot before or on the given date  */
  snapshotAsOf?: Maybe<ProjectSnapshot>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectCostCodes: Array<ProjectCostCode>;
  /** Hierarchy Navigation */
  children: Array<Project>;
  parentsRecursive: Array<Project>;
  childrenRecursive: Array<Project>;
  siblingProjects: Array<Project>;
  sellableProjects: Array<Project>;
  isSellableProject: Scalars['Boolean']['output'];
  /** Hierarchy Budget Page Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated fields for StandaloneProject. Do not add new fields below this.
   * @deprecated only implemented for StandaloneProject
   */
  cohort?: Maybe<Cohort>;
  /** @deprecated only implemented for StandaloneProject */
  constructionConfidenceFactor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRating?: Maybe<LotRating>;
  /** @deprecated only implemented for StandaloneProject */
  preConBudgetLineItems: Array<PreConBudgetCostDivisionLineItem>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractType?: Maybe<PreconContractType>;
  /** @deprecated only implemented for StandaloneProject and Structure */
  primaryProject?: Maybe<Project>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated only implemented for StandaloneProject */
  shadowProjects: Array<Project>;
  /** @deprecated only implemented for StandaloneProject */
  submarket?: Maybe<Submarket>;
  /**
   * Deprecated fields. Do not add new fields below this.
   * @deprecated homeowner can be accessed through collaborators
   */
  client?: Maybe<Client>;
  /** @deprecated replaced by blueprintUrl */
  url: Scalars['String']['output'];
  /**
   *  The same as name, just a previous name.
   * @deprecated replaced by name.
   */
  projectName: Scalars['String']['output'];
  /** @deprecated replaced by activeSalesforceOpportunity */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being removed from our SFDC data model */
  activeSalesforceOpportunity?: Maybe<ProjectSalesforceOpportunity>;
  /** @deprecated use lotType instead */
  dictionary: ProjectDictionary;
};


export type UnitTeamMembersArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UnitStagesArgs = {
  stage?: InputMaybe<Stage>;
  filter?: InputMaybe<ProjectStagesFilter>;
};


export type UnitStageArgs = {
  stage: Stage;
};


export type UnitAvailableAssigneesArgs = {
  role?: InputMaybe<ProjectRole>;
};


export type UnitToDosArgs = {
  type?: InputMaybe<ToDoType>;
};


export type UnitSelectionsByLocationArgs = {
  filter?: InputMaybe<SelectionsByLocationFilter>;
};


export type UnitHasSelectionsArgs = {
  filter?: InputMaybe<HasSelectionsFilter>;
};


export type UnitDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};


export type UnitSnapshotAsOfArgs = {
  date: Scalars['Date']['input'];
};


export type UnitOriginalCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitStartCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitChangeEventCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitProjectedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitRevisedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitCommittedCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitAvailableCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitBilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitUnbilledCostInCentsArgs = {
  filter?: InputMaybe<ProjectBudgetFilter>;
};


export type UnitPreConBudgetLineItemsArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectItem = CanCollaborate & Commentable & Referencable & Followable & ProjectItemLike & Named & HasDisplayName & HasBlueprintUrl & MaybeHasProject & {
  __typename?: 'ProjectItem';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectStage: ProjectStage;
  slot: ItemSlot;
  item: Item;
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by totalMarkupInCents */
  markupInCents: Scalars['Int']['output'];
  /** @deprecated Replaced by unitPriceInCents */
  priceInCents: Scalars['Int']['output'];
  /** @deprecated Replaced by unitCostInCents */
  costInCents: Scalars['Int']['output'];
  unitCostInCents: Scalars['Int']['output'];
  unitPriceInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  totalMarkupInCents: Scalars['Int']['output'];
  markupBasisPoints?: Maybe<Scalars['Int']['output']>;
  projectMarkupBasisPoints: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  location: Location;
  quantityCalculated?: Maybe<Scalars['Int']['output']>;
  isSelection: Scalars['Boolean']['output'];
  billedBills: Array<Bill>;
  bills: Array<Bill>;
  /**  A derived display name incorporating the cost code and item code as well as its name  */
  displayName: Scalars['String']['output'];
  billLineItems: Array<BillLineItem>;
  commitmentLineItems: Array<CommitmentLineItem>;
  signedCommitmentLineItems: Array<CommitmentLineItem>;
  /**  The total signed commitments.  */
  totalCommittedCostInCents: Scalars['Int']['output'];
  /**  The total of signed/draft/send, but not voided, commitments.  */
  allCommittedCostInCents: Scalars['Int']['output'];
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  estimateLineItems: Array<EstimateLineItem>;
  blueprintUrl: Url;
  unitOfMeasure: UnitOfMeasure;
  homeownerPaidInCents?: Maybe<Scalars['Int']['output']>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  specifications?: Maybe<Scalars['String']['output']>;
  history: Array<History>;
  changeEventLineItems: Array<ChangeEventLineItem>;
  /**  The current/active HomeownerSelection.  */
  homeownerSelection?: Maybe<HomeownerSelection>;
  isPendingChangeEvent: Scalars['Boolean']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  project: Project;
  costConfidence: CostConfidenceDetail;
  buyoutStatus: BuyoutStatus;
  buyoutStatusDetail: BuyoutStatusDetail;
  canEditCost: PotentialOperation2;
  protoCommitmentLineItemToBuyout?: Maybe<ProtoCommitmentLineItemToBuyout>;
  scopeHistory: Array<ProjectItemScopeChange>;
  canEditScope: PotentialOperation2;
  canEditName: PotentialOperation2;
  canEditCostConfidence: PotentialOperation2;
  canEditBuyoutStatus: PotentialOperation2;
  itemTemplateItem?: Maybe<BaseItemLike>;
  modifyingTemplateItems: Array<BaseItemLike>;
  task?: Maybe<Task>;
  currentTradePartner?: Maybe<TradePartner>;
  currentCommitment?: Maybe<CommitmentLike>;
  originalBudgetInCents: Scalars['Int']['output'];
  originalPriceInCents: Scalars['Int']['output'];
  contractBudgetChangesInCents: Scalars['Int']['output'];
  budgetReallocationsInCents: Scalars['Int']['output'];
  revisedApprovedBudgetInCents: Scalars['Int']['output'];
  uncommittedBudgetAmountInCents: Scalars['Int']['output'];
  unbilledCommittedInCents: Scalars['Int']['output'];
  /** @deprecated renamed to tradeBilledInCents */
  actualCostInCents: Scalars['Int']['output'];
  costToCompleteInCents: Scalars['Int']['output'];
  homeownerContractLineItems: Array<HomeownerContractLineItem>;
  internalBudgetChangeInCents: Scalars['Int']['output'];
  /**  The pre-negotiated bid contract that is currently delivering this ProjectItem.  */
  bidContractLineItem?: Maybe<BidContractLineItem>;
  /**  The BCLI might already be set, but once a non-finalized, non-draft CE merges it might update the PI so that becomes the Probable BCLI.  */
  probableBidContractLineItem?: Maybe<BidContractLineItem>;
  /**  The bid contract line items that are available to deliver this ProjectItem's scope.  */
  potentialBidContractLineItems: Array<PotentialBidContractLineItem>;
  /**  This is a single selection from `potentialBidContractLineItems` that is a preferred choice to default to  */
  preferredPotentialBidContractLineItem?: Maybe<PotentialBidContractLineItem>;
  /**  If this ProjectItem has applied from a ReadyHome template, i.e. it will be locked, and can be bid on via a BidContract. */
  isFromReadyHomeTemplate: Scalars['Boolean']['output'];
  /**  If this ProjectItem has originally in the contract, but has subsequently been removed by a ChangeEvent. */
  isRemovedScope: Scalars['Boolean']['output'];
  expenseAllocations: Array<ExpenseAllocation>;
  /** @deprecated redundant and will be removed after budget screen rework */
  budgetRollupInCents: BudgetPhaseRollup;
  prebidBudgetChangeInCents: Scalars['Int']['output'];
  awardedBudgetChangeInCents: Scalars['Int']['output'];
  revisedBudgetChangeInCents: Scalars['Int']['output'];
  costLineItems: Array<CostLineItem>;
  workAuthorizations: Array<WorkAuthorization>;
  bidItem?: Maybe<BidItem>;
  externalBudgetChangeInCents: Scalars['Int']['output'];
  budgetFinancials: ProjectItemBudgetFinancials;
  tradePartnerPaidInCents: Scalars['Int']['output'];
  tradeBilledInCents: Scalars['Int']['output'];
  canAssignBidContractLineItem: PotentialOperation2;
  product?: Maybe<Product>;
  currentPriceInCents: Scalars['Int']['output'];
  allocationReason?: Maybe<Scalars['String']['output']>;
  configuredOptions: Array<ReadyPlanOption>;
  baseOrOptionName: Scalars['String']['output'];
  materialVariant?: Maybe<MaterialVariant>;
  lastAcceptedChangeEventLineItem?: Maybe<ChangeEventLineItem>;
  allocations: Array<ProjectItemAllocation>;
  directCostAtStartInCents?: Maybe<Scalars['Int']['output']>;
  directCostVarianceInCents?: Maybe<Scalars['Int']['output']>;
  projectCostCode: ProjectCostCode;
  /** Hierarchy Budget Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  revisedPriceInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  bidTask?: Maybe<GlobalPlanTask>;
  packageDesignNotes?: Maybe<Scalars['String']['output']>;
};

export type Estimate = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & MaybeHasProject & {
  __typename?: 'Estimate';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  status: EstimateStatusDetail;
  type: EstimateTypeDetail;
  projectStage: ProjectStage;
  lineItems: Array<EstimateLineItem>;
  title: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalMarkupInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  project: Project;
  changeEvent?: Maybe<ChangeEvent>;
  history: Array<History>;
  homeownerContractChangeOrder?: Maybe<HomeownerContractChangeOrder>;
  canEditStatus: PotentialOperation2;
  softCostInCents: Scalars['Int']['output'];
  hardCostInCents: Scalars['Int']['output'];
  directHardCostInCents: Scalars['Int']['output'];
  indirectHardCostInCents: Scalars['Int']['output'];
  annotatedCosts: Array<AnnotatedCost>;
};

export type DevelopmentCommitment = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & HasPandaDoc & {
  __typename?: 'DevelopmentCommitment';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  tradePartner?: Maybe<TradePartner>;
  projects: Array<Project>;
  commitments: Array<Commitment>;
  tradeCategories: Array<TradeCategory>;
  market: Market;
  status: CommitmentStatus;
  statusDetail: CommitmentStatusDetail;
  statusText: Scalars['String']['output'];
  type?: Maybe<DevelopmentCommitmentType>;
  typeDetail?: Maybe<DevelopmentCommitmentTypeDetail>;
  name: Scalars['String']['output'];
  executionDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  releasedDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated use releasedDate instead */
  releasedAt?: Maybe<Scalars['Date']['output']>;
  contractExhibits?: Maybe<Scalars['String']['output']>;
  contractSchedule?: Maybe<Scalars['String']['output']>;
  contractTerms?: Maybe<Scalars['String']['output']>;
  contractExclusions?: Maybe<Scalars['String']['output']>;
  committedInCents: Scalars['Int']['output'];
  pandaDoc?: Maybe<PandaDoc>;
  headOfConstruction?: Maybe<InternalUser>;
  homeboundAuthorizedSignatory?: Maybe<InternalUser>;
  conOpsProjectManager?: Maybe<InternalUser>;
  areaManager?: Maybe<InternalUser>;
  canCreatePandaDoc: PotentialOperation2;
  history: Array<History>;
  summary: DevelopmentCommitmentSummary;
  blueprintUrl: Url;
  stage: Stage;
  stageDetail: StageDetail;
  costTypes?: Maybe<Array<CostTypeDetail>>;
  internalNote?: Maybe<Scalars['String']['output']>;
  costCodes: Array<CostCode>;
  costCodeSummary: Array<DevelopmentCommitmentCostCodeSummary>;
  canBeEdited: Scalars['Boolean']['output'];
  development: Development;
  document?: Maybe<Document>;
  signatoryContact?: Maybe<TradePartnerContact>;
};

export type Commitment = CanCollaborate & Commentable & Referencable & Followable & Entity & CommitmentLike & Named & HasDisplayName & HasBlueprintUrl & MaybeHasProject & HasPandaDoc & {
  __typename?: 'Commitment';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  accountingNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  commitmentType: CommitmentTypeDetail;
  projectStage: ProjectStage;
  tradePartner?: Maybe<TradePartner>;
  internalNote?: Maybe<Scalars['String']['output']>;
  costChangeInCents: Scalars['Int']['output'];
  executionDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Document>;
  pandaDoc?: Maybe<PandaDoc>;
  canCreatePandaDoc: PotentialOperation2;
  changeOrders: Array<CommitmentChangeOrder>;
  lineItems: Array<CommitmentLineItem>;
  bills: Array<Bill>;
  expenseAllocations: Array<ExpenseAllocation>;
  lineItemSummaries: Array<CommitmentLineItemSummary>;
  /**  Just the initial contract w/o any change orders (an alias of costChangeInCents)  */
  committedInCents: Scalars['Int']['output'];
  taxableCostInCents: Scalars['Int']['output'];
  remainingInCents: Scalars['Int']['output'];
  pendingRemainingInCents: Scalars['Int']['output'];
  billedInCents?: Maybe<Scalars['Int']['output']>;
  pendingBilledInCents?: Maybe<Scalars['Int']['output']>;
  unbilledInCents: Scalars['Int']['output'];
  paidInCents?: Maybe<Scalars['Int']['output']>;
  balanceInCents?: Maybe<Scalars['Int']['output']>;
  blueprintUrl: Url;
  project: Project;
  protoCommitmentLineItemsToBuyout: Array<ProtoCommitmentLineItemToBuyout>;
  hasPartiallyBoughtOutScope: Scalars['Boolean']['output'];
  status: CommitmentStatus;
  statusDetail: CommitmentStatusDetail;
  statusText: Scalars['String']['output'];
  developmentCommitment?: Maybe<DevelopmentCommitment>;
  contractExhibits?: Maybe<Scalars['String']['output']>;
  contractSchedule?: Maybe<Scalars['String']['output']>;
  contractTerms?: Maybe<Scalars['String']['output']>;
  contractExclusions?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  tradeCategories: Array<TradeCategory>;
  costTypes: Array<CostTypeDetail>;
  costCodeSummary: CommitmentCostCodeSummary;
  changeEvent?: Maybe<ChangeEvent>;
  canEditLineItems: PotentialOperation2;
  canBeReleased: PotentialOperation2;
  isBidCommitment: Scalars['Boolean']['output'];
  bidContractRevision?: Maybe<BidContractRevision>;
  canBeVoided: PotentialOperation2;
  canDelete: PotentialOperation2;
  canBeEdited: Scalars['Boolean']['output'];
  costCodes: Array<CostCode>;
  items: Array<Item>;
  potentialBidContractRevisions: Array<PotentialBidContractRevision>;
  pandaDocRecipients: Array<PandaDocIntendedRecipient>;
  preferredBidContractRevision?: Maybe<PotentialBidContractRevision>;
  history?: Maybe<Array<History>>;
  tradeSignatory?: Maybe<TradePartnerContact>;
  readyPlanConfigOptions?: Maybe<Array<ProjectReadyPlanConfigOption>>;
  percentagePaid: Scalars['Int']['output'];
  releaseWhenReady?: Maybe<Scalars['Boolean']['output']>;
  eventuallyVoidedBy?: Maybe<Commitment>;
  voidsCommitments: Array<Commitment>;
  sentDate?: Maybe<Scalars['Date']['output']>;
  depositInBasisPoints?: Maybe<Scalars['Float']['output']>;
  depositScheduleTask?: Maybe<Task>;
  depositBill?: Maybe<Bill>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  drop?: Maybe<Drop>;
  draws: Array<CommitmentDraw>;
  billingSchedule: Array<CommitmentBillingScheduleItem>;
};

export type Document = CanCollaborate & Commentable & Referencable & Followable & Entity & Named & HasDisplayName & HasBlueprintUrl & {
  __typename?: 'Document';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  documentType: DocumentTypeDetail;
  name: Scalars['String']['output'];
  sizeInBytes: Scalars['Int']['output'];
  /** @deprecated Use `asset` field */
  url: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  homeownerVisible: Scalars['Boolean']['output'];
  asset: Asset;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  createdBy: User;
  pandaDoc?: Maybe<PandaDoc>;
  assets: Array<Asset>;
  canDelete: PotentialOperation2;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  parent: DocumentParent;
  category: DocumentCategory;
  categoryDetail?: Maybe<DocumentCategoryDetail>;
  tasks: Array<Task>;
  isFavorited: Scalars['Boolean']['output'];
  blueprintUrl: Url;
  issuanceDate?: Maybe<Scalars['Date']['output']>;
  ownerWorkAuthorization?: Maybe<WorkAuthorization>;
  /**  Projects connected to a document via the ProjectDocumentAssociations entity. Must be in the document's development. */
  associatedProjects: Array<Project>;
  owner?: Maybe<DocumentOwner>;
  homeownerContract?: Maybe<HomeownerContract>;
  homeownerContractChangeOrder?: Maybe<HomeownerContractChangeOrder>;
  attachOn: Array<DocumentAttachmentPlace>;
  lienWaiver?: Maybe<LienWaiver>;
  active: Scalars['Boolean']['output'];
  canEdit: PotentialOperation2;
  canArchive: PotentialOperation2;
};

export type Product = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & {
  __typename?: 'Product';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  custom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  items: Array<Item>;
  description?: Maybe<Scalars['String']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  manufacturerUrl?: Maybe<Scalars['String']['output']>;
  costInCents?: Maybe<Scalars['Int']['output']>;
  msrpInCents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Price is now tracked only at the project level */
  priceInCents?: Maybe<Scalars['Int']['output']>;
  /**  Indicates the last time that the costInCents or msrpInCents for this product was changed  */
  priceLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated use priceLastUpdatedAt instead */
  priceLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  variantOfProduct?: Maybe<Product>;
  variants?: Maybe<Array<Product>>;
  attributes: Array<ProductAttribute>;
  dimensions: Array<ProductDimension>;
  images: Array<Asset>;
  airtableId?: Maybe<Scalars['String']['output']>;
  airtableData?: Maybe<Scalars['String']['output']>;
  status: ProductStatusDetail;
  unitOfMeasure: UnitOfMeasure;
  internalNote?: Maybe<Scalars['String']['output']>;
  promotionStatus?: Maybe<PromotionStatusDetail>;
  specifications?: Maybe<Scalars['String']['output']>;
  blueprintUrl: Url;
  history: Array<History>;
  /** @deprecated product->bidItem link has been deleted */
  bidItems: Array<BidItem>;
  attachments: Array<Attachment>;
};


export type ProductAttributesArgs = {
  type?: InputMaybe<Array<ProductAttributeType>>;
};

export type ItemTemplateItemVersion = CanCollaborate & Commentable & Referencable & Followable & Named & HasDisplayName & HasBlueprintUrl & BaseItemLike & {
  __typename?: 'ItemTemplateItemVersion';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  template: ItemTemplate;
  scope: ItemTemplateItem;
  scopeChangeType: ScopeChangeType;
  scopeChangeTypeDetail: ScopeChangeTypeDetail;
  scopeChangeReason?: Maybe<ScopeChangeReason>;
  slot: ItemSlot;
  item: Item;
  location: Location;
  quantity?: Maybe<Scalars['Int']['output']>;
  baseProduct?: Maybe<Product>;
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  isSelection: Scalars['Boolean']['output'];
  specifications?: Maybe<Scalars['String']['output']>;
  unitOfMeasure: UnitOfMeasure;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  parent: ItemTemplate;
  readyPlan: ReadyPlanLike;
  first: ItemTemplate;
  basedOn?: Maybe<ItemTemplateItem>;
  totalCostInCents: Scalars['Int']['output'];
  unitCostInCents: Scalars['Int']['output'];
  canDeleteItem: PotentialOperation2;
  canEdit: PotentialOperation2;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  bidItemTemplateItem?: Maybe<ItemTemplateItem>;
  potentialBidItems: Array<BidItem>;
  /**  Helper for the FE multi-select dropdown  */
  elevationIds: Array<Scalars['ID']['output']>;
  /**  Helper for the FE multi-select dropdown  */
  specOptionIds: Array<Scalars['ID']['output']>;
  /**  Helper for the FE multi-select dropdown  */
  otherOptionIds: Array<Scalars['ID']['output']>;
  /**  All of the elevation + specOption + option RPOs as a single list.  */
  options: Array<ReadyPlanOption>;
  customPlaceholderName?: Maybe<Scalars['String']['output']>;
  blueprintUrl: Url;
  scopeChangeReasonNote?: Maybe<Scalars['String']['output']>;
  task?: Maybe<GlobalPlanTask>;
  materialVariant?: Maybe<MaterialVariant>;
  development?: Maybe<Development>;
  laborLine?: Maybe<ItemTemplateItemVersion>;
  costEstimate: CostEstimate;
};

export type JobLogNote = CanCollaborate & Commentable & Referencable & Followable & Entity & Named & HasBlueprintUrl & {
  __typename?: 'JobLogNote';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  title?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  type?: Maybe<JobLogNoteType>;
  typeDetail?: Maybe<JobLogNoteTypeDetail>;
  internalUser: InternalUser;
  jobLog: JobLog;
  tradePartner?: Maybe<TradePartner>;
  jobLogImages?: Maybe<Array<JobLogImage>>;
  flags: Array<JobLogFlag>;
  scheduleTasks: Array<ScheduleTask>;
  history: Array<History>;
  clientPlatform: ClientPlatformDetail;
  additionalContext?: Maybe<Scalars['JSONObject']['output']>;
};

export type TradePartnerAvailabilityRequest = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & {
  __typename?: 'TradePartnerAvailabilityRequest';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  internalUser: InternalUser;
  task: Task;
  tradePartnerContacts: Array<TradePartnerContact>;
  tradePartnerConfirmationDate?: Maybe<Scalars['Date']['output']>;
  emails: Array<TradePartnerAvailabilityRequestEmail>;
  textMessages: Array<TradePartnerAvailabilityRequestTextMessage>;
  rescheduleDates?: Maybe<Array<Scalars['Date']['output']>>;
  status: TradePartnerAvailabilityRequestStatusDetail;
  tradePartner: TradePartner;
  canSave: PotentialOperation2;
  rescheduleReasonNote?: Maybe<Scalars['String']['output']>;
};

export type PunchlistItemTodo = CanCollaborate & Commentable & Referencable & Followable & Entity & Named & HasBlueprintUrl & {
  __typename?: 'PunchlistItemTodo';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  order: Scalars['String']['output'];
  urgent: Scalars['Boolean']['output'];
  status: ToDoStatusDetail;
  type: ToDoTypeDetail;
  createdBy: User;
  attachments: Array<Attachment>;
  assignees: Array<User>;
  parent?: Maybe<ToDoParent>;
  location?: Maybe<Location>;
  tradePartner?: Maybe<TradePartner>;
  blueprintUrl: Url;
};

export type WarrantyTicket = CanCollaborate & Commentable & Referencable & Followable & HasBlueprintUrl & Named & {
  __typename?: 'WarrantyTicket';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<WarrantyTicketTypeDetail>;
  project: Project;
  projectContacts: Array<ProjectContact>;
  availabilities: Array<WarrantyTicketAvailability>;
  items: Array<WarrantyTicketItem>;
  title: Scalars['String']['output'];
  homeownerVisible: Scalars['Boolean']['output'];
  blueprintUrl: Url;
  urgent: Scalars['Boolean']['output'];
  history: Array<History>;
  attachments: Array<Attachment>;
  totalItems: Scalars['Int']['output'];
  totalAvailableItems: Scalars['Int']['output'];
  totalCompletedItems: Scalars['Int']['output'];
  totalRejectedItems: Scalars['Int']['output'];
  status: WarrantyTicketStatusDetail;
  assignees: Array<InternalUser>;
};


export type WarrantyTicketItemsArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<WarrantyTicketItemStatus>>;
  createdDateRange?: InputMaybe<DateFilter2>;
};

export type HomeownerContract = CanCollaborate & Commentable & Referencable & Followable & Named & HomeownerContractLike & HasBlueprintUrl & MaybeHasProject & {
  __typename?: 'HomeownerContract';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectStage: ProjectStage;
  name: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  priceChangeInCents: Scalars['Int']['output'];
  budgetChangeInCents: Scalars['Int']['output'];
  invoicedInCents?: Maybe<Scalars['Int']['output']>;
  amountPaidInCents?: Maybe<Scalars['Int']['output']>;
  balanceInCents?: Maybe<Scalars['Int']['output']>;
  uninvoicedInCents?: Maybe<Scalars['Int']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  contractType: ContractType;
  contractTypeDetail: ContractTypeDetail;
  costPlusMarkupBasisPoints?: Maybe<Scalars['Int']['output']>;
  document?: Maybe<Document>;
  draws: Array<HomeownerContractDraw>;
  changeOrders: Array<HomeownerContractChangeOrder>;
  lineItems: Array<HomeownerContractLineItem>;
  /** Returns the non-draw original contract + change order line items for potential invoicing. */
  lineItemsByProjectItem: Array<HomeownerContractLineItemsByProjectItem>;
  title: Scalars['String']['output'];
  blueprintUrl: Url;
  project: Project;
  softCostBudgetInCents: Scalars['Int']['output'];
  directHardCostBudgetInCents: Scalars['Int']['output'];
  indirectHardCostBudgetInCents: Scalars['Int']['output'];
  totalMarkupInCents: Scalars['Int']['output'];
  annotatedCosts: Array<AnnotatedCost>;
  projectFinancials: Array<ContractProjectFinancials>;
};


export type HomeownerContractLineItemsByProjectItemArgs = {
  contractType?: InputMaybe<ContractType>;
};

export type HomeownerContractChangeOrder = CanCollaborate & Commentable & Referencable & Followable & Named & HomeownerContractLike & HasBlueprintUrl & {
  __typename?: 'HomeownerContractChangeOrder';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  contract: HomeownerContract;
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  priceChangeInCents: Scalars['Int']['output'];
  budgetChangeInCents: Scalars['Int']['output'];
  invoicedInCents?: Maybe<Scalars['Int']['output']>;
  amountPaidInCents?: Maybe<Scalars['Int']['output']>;
  balanceInCents?: Maybe<Scalars['Int']['output']>;
  uninvoicedInCents?: Maybe<Scalars['Int']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  contractType: ContractType;
  costPlusMarkupBasisPoints?: Maybe<Scalars['Int']['output']>;
  document?: Maybe<Document>;
  draws: Array<HomeownerContractDraw>;
  lineItems: Array<HomeownerContractLineItem>;
  title: Scalars['String']['output'];
  blueprintUrl: Url;
  changeEvent?: Maybe<ChangeEvent>;
  estimate?: Maybe<Estimate>;
  softCostBudgetInCents: Scalars['Int']['output'];
  directHardCostBudgetInCents: Scalars['Int']['output'];
  indirectHardCostBudgetInCents: Scalars['Int']['output'];
  totalMarkupInCents: Scalars['Int']['output'];
  annotatedCosts: Array<AnnotatedCost>;
  projectFinancials: Array<ContractProjectFinancials>;
  isContractAddendum: Scalars['Boolean']['output'];
};

export type ReadyPlan = CanCollaborate & Commentable & Referencable & Followable & ReadyPlanLike & HasBlueprintUrl & Named & HasDisplayName & BaseItemParent & {
  __typename?: 'ReadyPlan';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  development?: Maybe<Development>;
  itemTemplates: Array<ItemTemplate>;
  options: Array<ReadyPlanOption>;
  hasOptions: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  activeOptionsCount: Scalars['Int']['output'];
  type?: Maybe<ReadyPlanTypeDetail>;
  isValidForReadyPlanConfiguration: Scalars['Boolean']['output'];
  /**  The `type` + `code`, i.e. SFH-TX-1-001  */
  displayCode?: Maybe<Scalars['String']['output']>;
  programData: ProgramData;
  maxProgramData: ProgramData;
  minProgramData: ProgramData;
  optionGroups: Array<ReadyPlanOptionGroup>;
  userEvents: Array<UserEvent>;
  blueprintUrl: Url;
  /**  The current template version used for computing UW costs.  */
  underwritingTemplate?: Maybe<ItemTemplate>;
  constructionDocumentCompletePercentage: Scalars['Int']['output'];
  programDatas: Array<ReadyPlanProgramData>;
  assets: Array<ReadyPlanAsset>;
  lotTypes: Array<LotType>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  version: ReadyPlanAggregateVersion;
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  canCreateNewVersion: PotentialOperation2;
  canEditLineItems: PotentialOperation2;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']['output']>;
  canEdit: PotentialOperation2;
  documents: Array<Document>;
  requiredOptions: Array<ReadyPlanRequiredOption>;
  /**  All downstream PRPCs referencing this ReadyPlan, either directly or indirectly via a ProductOffering  */
  projectConfigs: Array<ProjectReadyPlanConfig>;
  owner?: Maybe<InternalUser>;
  cloneInProgress: Scalars['Boolean']['output'];
};


export type ReadyPlanOptionGroupsArgs = {
  filter?: InputMaybe<ReadyPlanOptionGroupsFilter>;
};

export type PlanPackage = CanCollaborate & Commentable & Referencable & Followable & ReadyPlanLike & HasBlueprintUrl & Named & HasDisplayName & BaseItemParent & {
  __typename?: 'PlanPackage';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  type: ReadyPlanTypeDetail;
  code?: Maybe<Scalars['String']['output']>;
  displayCode?: Maybe<Scalars['String']['output']>;
  blueprintUrl: Url;
  constructionDocumentCompletePercentage: Scalars['Int']['output'];
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  development?: Maybe<Development>;
  maxProgramData: ProgramData;
  minProgramData: ProgramData;
  programData: ProgramData;
  itemTemplates: Array<ItemTemplate>;
  /**
   * Helper to get the latest takeoff item template for this plan package
   * @deprecated Use version and takeoffLineItems instead
   */
  takeoff: ItemTemplate;
  projectConfigs: Array<ProjectReadyPlanConfig>;
  options: Array<ReadyPlanOption>;
  optionGroups: Array<ReadyPlanOptionGroup>;
  productOfferings: Array<ProductOffering>;
  designPackages: Array<DesignPackage>;
  designPackageSources: Array<DesignPackageSource>;
  incomingSlots: Array<PlanPackageIncomingSlot>;
  lotTypes?: Maybe<Array<LotType>>;
  programDatas: Array<ReadyPlanProgramData>;
  assets: Array<ReadyPlanAsset>;
  activeOptionsCount: Scalars['Int']['output'];
  projectCount: Scalars['Int']['output'];
  designPackageCount: Scalars['Int']['output'];
  productOfferingCount: Scalars['Int']['output'];
  asGlobalOption?: Maybe<GlobalOption>;
  markets: Array<Market>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  version: ReadyPlanAggregateVersion;
  /**  The Locations in-use by the current TLIs  */
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  canEditLineItems: PotentialOperation2;
  locations: Array<Location>;
  /** Default filter is locationType: [Level, Room] */
  roomLocations: Array<ReadyPlanLocation>;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']['output']>;
  canEdit: PotentialOperation2;
  documents: Array<Document>;
  insideMapsProjectId?: Maybe<Scalars['String']['output']>;
  /**
   * JSON config for inside maps that will be parsed and validated on save.
   * This is a string value (along with the input) to enable easy copy/paste via a textbox field.
   * The fully typed version of this config can be accessed via `CheckoutConfig.insideMapsConfig`.
   * Note this is unversioned for the time being along with the other inside maps attributes.
   */
  insideMapsConfig?: Maybe<Scalars['String']['output']>;
  requiredOptions: Array<ReadyPlanRequiredOption>;
  owner?: Maybe<InternalUser>;
  cloneInProgress: Scalars['Boolean']['output'];
};


export type PlanPackageRoomLocationsArgs = {
  filter?: InputMaybe<RoomLocationFilter>;
};

export type GlobalOption = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & {
  __typename?: 'GlobalOption';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  group: GlobalOptionGroup;
  readyPlanOptions: Array<ReadyPlanOption>;
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  blueprintUrl: Url;
  description?: Maybe<Scalars['String']['output']>;
  isPlanSpecific?: Maybe<Scalars['Boolean']['output']>;
  standardDetailRequired?: Maybe<Scalars['Boolean']['output']>;
  status: GlobalOptionStatus;
  statusDetail: GlobalOptionStatusDetail;
  type: GlobalOptionType;
  /** Only locations used in active `readyPlanOptions` */
  locations: Array<Location>;
  /** @deprecated Use locations instead */
  locationsInUse: Array<Location>;
  activeDate?: Maybe<Scalars['Date']['output']>;
  archivedDate?: Maybe<Scalars['Date']['output']>;
  elevationRequired?: Maybe<Scalars['Boolean']['output']>;
  requiredInPlanDrawing?: Maybe<Scalars['Boolean']['output']>;
  shopDrawingRequired?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<GlobalOptionTag>;
  /** List of tags which are allowed on this specific GlobalOption */
  supportedTags: Array<GlobalOptionTag>;
  canEditType: PotentialOperation2;
  /** @deprecated No longer used */
  canEditLocations: PotentialOperation2;
  code: Scalars['String']['output'];
  designUpgradeIconName?: Maybe<Scalars['String']['output']>;
  defaultOrder?: Maybe<Scalars['Int']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  asset?: Maybe<Asset>;
  estimatedLeadTimeInDays: Scalars['Int']['output'];
  marketingDescription?: Maybe<Scalars['String']['output']>;
  permits: Array<Permit>;
  attachments: Array<Attachment>;
  /**  For product personalization options, the material this option represents.  */
  materialVariant?: Maybe<MaterialVariant>;
  optionPricingConfig?: Maybe<OptionPricingConfig>;
  version: Scalars['Int']['output'];
  history: Array<History>;
  readyPlan?: Maybe<ReadyPlan>;
};

export type ProjectCostCode = CanCollaborate & Commentable & Referencable & Followable & Named & HasBlueprintUrl & {
  __typename?: 'ProjectCostCode';
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
  /** @deprecated replaced by streams */
  commentStreams: CommentStreams;
  streams: Array<CommentStream>;
  supportedVisibilities: Array<CommentStreamVisibility>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  costCode: CostCode;
  project: Project;
  projectItems: Array<ProjectItem>;
  committedAtStartInCents: Scalars['Int']['output'];
  /** Hierarchy Budget Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
};

export type CollaborationParent = ScheduleSubPhase | Approval | BidContract | BidItem | BidPackageRequest | Bill | ChangeEvent | ChangeRequest | ChangeRequestToDo | Commitment | DevelopmentCommitment | Document | Estimate | GlobalOption | HomeownerContract | HomeownerContractChangeOrder | Invoice | ItemTemplateItemVersion | JobLogNote | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Product | ProjectCostCode | ProjectItem | PunchlistItemTodo | ReadyPlan | Task | ToDo | TradePartnerAvailabilityRequest | SchedulePhase | WarrantyTicket;

export type Comment = Entity & {
  __typename?: 'Comment';
  id: Scalars['ID']['output'];
  html: Scalars['String']['output'];
  text: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  stream: CommentStream;
  author: User;
  permissions: Permissions;
  attachments: Array<Attachment>;
  tags: Array<CommentTag>;
};

export type SaveCommentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  commentStreamId?: InputMaybe<Scalars['ID']['input']>;
  /** only used for stream creation, use commentStreamId for existing threads */
  tradePartnerContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** only used for homeowner/internal threads, use tradePartnerContacts instead */
  streamVisibility?: InputMaybe<CommentStreamVisibility>;
  commentableId?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
  internalUserTags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveCommentResult = {
  __typename?: 'SaveCommentResult';
  comment?: Maybe<Comment>;
  userErrors: Array<UserError>;
};

export type DeleteCommentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCommentResult = {
  __typename?: 'DeleteCommentResult';
  stream?: Maybe<CommentStream>;
  userErrors: Array<UserError>;
};

export type CommentStream = {
  __typename?: 'CommentStream';
  id: Scalars['ID']['output'];
  streamVisibility: CommentStreamVisibilityDetail;
  name: Scalars['String']['output'];
  commentable: Commentable;
  comments: Array<Comment>;
  latestComment?: Maybe<Comment>;
  commentCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
  fromAddress: Scalars['String']['output'];
  tradePartnerUsers: Array<TradePartnerUser>;
};

export type MarkCommentStreamAsReadInput = {
  id: Scalars['ID']['input'];
};

export type CommentStreams = {
  __typename?: 'CommentStreams';
  internalStream?: Maybe<CommentStream>;
  /** @deprecated more than 1 trades stream can now be present. use commentable.streams instead */
  tradesStream?: Maybe<CommentStream>;
  homeownerStream?: Maybe<CommentStream>;
  commentCount: Scalars['Int']['output'];
};

export type UserRelevantCommentStreamsFilter = {
  internalUser: Array<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  parentTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserRelevantCommentStreamsResult = {
  __typename?: 'UserRelevantCommentStreamsResult';
  entities: Array<CommentStream>;
  pageInfo: PageInfo;
};

export type CommentTag = {
  __typename?: 'CommentTag';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  comment: Comment;
  internalUser: InternalUser;
};

export type Commentable = {
  id: Scalars['ID']['output'];
  commentStreams: CommentStreams;
  /**  We lazy create comment streams, so we might support internal/homeowner streams even though they don't exist yet.  */
  supportedVisibilities: Array<CommentStreamVisibility>;
  /** Implicitly contains all visible streams for the current user */
  streams: Array<CommentStream>;
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type ProjectStage = MaybeHasProject & MaybeHasInterval & {
  __typename?: 'ProjectStage';
  commitments: Array<Commitment>;
  /**  Returns commitment or commitment change orders for the stage.  */
  commitmentLikes: Array<CommitmentLike>;
  homeownerContracts: Array<HomeownerContract>;
  id: Scalars['ID']['output'];
  project: Project;
  stage: StageDetail;
  hasSignedContract: Scalars['Boolean']['output'];
  /**
   * If this is a false, a Homeowner final estimate and/or contract has locked in the
   * initial scope and change events must be used to edit project items.
   *
   * A better name for this is probably `canEditProjectScope`, i.e. specifically quantity
   * and price. We do let cost continue to "float" / be edited even while scope is locked,
   * as we get in new bids/etc. from Trade Partners. The cost becomes locked once we have
   * Commitments in place. (Or until we build bid/RFP support.)
   * @deprecated Deprecated in favor of canEditProjectScope
   */
  canEditProjectItemsDirectly: Scalars['Boolean']['output'];
  canEditProjectScope: PotentialOperation2;
  canCreateFinalEstimate: Scalars['Boolean']['output'];
  canCompleteStage: PotentialOperation2;
  canPublishSchedule: PotentialOperation;
  nextStage?: Maybe<ProjectStage>;
  previousStage?: Maybe<ProjectStage>;
  status: ProjectStageStatusDetail;
  interval: CalendarInterval;
  baselineInterval: CalendarInterval;
  schedulePhases: Array<SchedulePhase>;
  bills: Array<Bill>;
  priceInCents: Scalars['Int']['output'];
  progress: StageProgress;
  /** @deprecated The CMS integration is being decommissioned - Do not use */
  cmsId?: Maybe<Scalars['String']['output']>;
  invoices: Array<Invoice>;
  homeownerFinancials: ProjectStageHomeownerFinancials;
  estimates: Array<Estimate>;
  hocFinancials: ProjectStageHocFinancials;
  projectItems: Array<ProjectItem>;
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  changeEvents: Array<ChangeEvent>;
  totalCostInCents: Scalars['Int']['output'];
  clientPresentationDate?: Maybe<Scalars['Date']['output']>;
  /**  A list of 'dumb' / non-ReadyHome templates that have been applied to the project.  */
  appliedTemplates: Array<ItemTemplate>;
  /**  A list of ReadyHome 'smart' templates, i.e. they have spec levels and are re-configurable.  */
  templateConfigs: Array<ProjectStageTemplateConfig>;
  readyHomePlanTemplate?: Maybe<ProjectStageTemplateConfig>;
  /**  The percent of items that are bought out, i.e. on signed/released commitments.  */
  percentReleased: Scalars['Int']['output'];
  unallocatedExpenses: Array<Expense>;
  hasDrawsToInvoice: Scalars['Boolean']['output'];
  hasCostsToInvoice: Scalars['Boolean']['output'];
  hasFixedToInvoice: Scalars['Boolean']['output'];
  workAuthorizations: Array<WorkAuthorization>;
  allContractDraws: Array<HomeownerContractDraw>;
};


export type ProjectStageCommitmentsArgs = {
  filter?: InputMaybe<CommitmentsFilter>;
};


export type ProjectStageCommitmentLikesArgs = {
  isBidCommitment?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectStageSchedulePhasesArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectStageProgressArgs = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectStageInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  order?: InputMaybe<InvoiceOrder>;
};


export type ProjectStageProjectItemsArgs = {
  filter?: InputMaybe<ProjectItemFilter>;
};


export type ProjectStageItemLocationsArgs = {
  filter?: InputMaybe<ItemLocationsFilter>;
};


export type ProjectStageChangeEventsArgs = {
  filter?: InputMaybe<ChangeEventFilter>;
};


export type ProjectStageWorkAuthorizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CommitmentLike = {
  accountingNumber: Scalars['Int']['output'];
  blueprintUrl: Url;
  commitmentType: CommitmentTypeDetail;
  committedInCents: Scalars['Int']['output'];
  taxableCostInCents: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  executionDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lineItems: Array<CommitmentLineItem>;
  costCodes: Array<CostCode>;
  items: Array<Item>;
  name: Scalars['String']['output'];
  pandaDoc?: Maybe<PandaDoc>;
  document?: Maybe<Document>;
  status: CommitmentStatus;
  statusText: Scalars['String']['output'];
  tradePartner?: Maybe<TradePartner>;
  updatedAt: Scalars['DateTime']['output'];
  canCreatePandaDoc: PotentialOperation2;
  tradeSignatory?: Maybe<TradePartnerContact>;
  changeEvent?: Maybe<ChangeEvent>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

/**  A per-cost code summary of a commitment + its chan ge orders.  */
export type CommitmentLineItemSummary = {
  __typename?: 'CommitmentLineItemSummary';
  costCode: CostCode;
  /**  original commitment amount  */
  committedInCents: Scalars['Int']['output'];
  /**  total across change orders  */
  changeOrderInCents: Scalars['Int']['output'];
  /**  originalCommitmentInCents - changeOrderInCents  */
  totalCommittedInCents: Scalars['Int']['output'];
  billedInCents: Scalars['Int']['output'];
  paidInCents: Scalars['Int']['output'];
  balanceInCents: Scalars['Int']['output'];
};

export type CommitmentsPage = {
  __typename?: 'CommitmentsPage';
  commitments: Array<Commitment>;
  pageInfo: PageInfo;
};

export type PotentialBidContractRevision = {
  __typename?: 'PotentialBidContractRevision';
  bidContractRevision: BidContractRevision;
  totalCostInCents: Scalars['Int']['output'];
};

export type CommitmentCostCodeSummary = {
  __typename?: 'CommitmentCostCodeSummary';
  lineItems: Array<CommitmentCostCodeSummaryLineItem>;
};

export type CommitmentCostCodeSummaryLineItem = {
  __typename?: 'CommitmentCostCodeSummaryLineItem';
  costCode: CostCode;
  quantity: Scalars['Int']['output'];
};

export type SaveCommitmentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  accountingNumber?: InputMaybe<Scalars['Int']['input']>;
  commitmentType?: InputMaybe<CommitmentType>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  lineItems?: InputMaybe<Array<SaveCommitmentLineItemInput>>;
  contractExhibits?: InputMaybe<Scalars['String']['input']>;
  contractSchedule?: InputMaybe<Scalars['String']['input']>;
  contractTerms?: InputMaybe<Scalars['String']['input']>;
  contractExclusions?: InputMaybe<Scalars['String']['input']>;
  costTypes?: InputMaybe<Array<CostType>>;
  status?: InputMaybe<CommitmentStatus>;
  releaseWhenReady?: InputMaybe<Scalars['Boolean']['input']>;
  depositInBasisPoints?: InputMaybe<Scalars['Float']['input']>;
  depositScheduleTaskId?: InputMaybe<Scalars['ID']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommitmentLineItemsInput = {
  lineItemIds: Array<Scalars['ID']['input']>;
};

export type DeleteCommitmentInput = {
  id: Scalars['ID']['input'];
};

export type ReleaseCommitmentInput = {
  id: Scalars['ID']['input'];
};

export type SaveCommitmentResult = {
  __typename?: 'SaveCommitmentResult';
  commitment: Commitment;
};

export type SaveBidToCommitmentsInput = {
  commitmentId: Scalars['ID']['input'];
  bidContractRevisionId: Scalars['ID']['input'];
};

export type AssignWorkToBidContractInput = {
  /**  If provided, will assign work to specified BCR (through PIs) and will void prior Commitment on New Commitment release  */
  commitmentId?: InputMaybe<Scalars['ID']['input']>;
  /**  Assign these to a new BCR without creating a Commitment -- unless autoRelease is provided, in which case non-voiding Commitments are generated  */
  projectItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bidContractRevisionId?: InputMaybe<Scalars['ID']['input']>;
  bidContractLineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Infers True (overridable) if a prior commitmentId is provided. For the projectItemIds flow, not-null will force non-voiding Commitments to be generated  */
  autoRelease?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnassignWorkFromBidContractInput = {
  projectItemIds: Array<Scalars['ID']['input']>;
};

export type SaveCommitmentsResult = {
  __typename?: 'SaveCommitmentsResult';
  commitments: Array<Commitment>;
};

export type CommitmentsFilter = {
  /** @deprecated More than one project could be related, use projectIds instead */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<Array<Stage>>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  commitmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradePartners?: InputMaybe<Array<Scalars['ID']['input']>>;
  costCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<CommitmentStatus>>;
  executionDate?: InputMaybe<DateFilter2>;
  marketId?: InputMaybe<Array<Scalars['ID']['input']>>;
  sentDate?: InputMaybe<DateFilter2>;
  /** used to query scenarios when commitment could appear in multiple projects */
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectCostCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MoveCommitmentsToNewTradePartnerInput = {
  projectId: Scalars['ID']['input'];
  sourceTradePartnerId: Scalars['ID']['input'];
  targetTradePartnerId: Scalars['ID']['input'];
};

export type CommitmentOrder = {
  id?: InputMaybe<Order>;
  accountingNumber?: InputMaybe<Order>;
  development?: InputMaybe<Order>;
  projectAddress?: InputMaybe<Order>;
  executionDate?: InputMaybe<Order>;
  bidContractRevision?: InputMaybe<Order>;
  committedInCents?: InputMaybe<Order>;
  billedInCents?: InputMaybe<Order>;
  remainingInCents?: InputMaybe<Order>;
  paidInCents?: InputMaybe<Order>;
  balanceInCents?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
};

export type CreateCommitmentFromBillInput = {
  billId: Scalars['ID']['input'];
  lineItems?: InputMaybe<Array<SaveCommitmentLineItemInput>>;
  changeEvent?: InputMaybe<SaveChangeEventInput>;
};

export type CreateCommitmentFromBillResult = {
  __typename?: 'CreateCommitmentFromBillResult';
  commitment?: Maybe<Commitment>;
  changeEvent?: Maybe<ChangeEvent>;
};

export type CommitmentBillingScheduleItem = {
  __typename?: 'CommitmentBillingScheduleItem';
  commitmentDraw?: Maybe<CommitmentDraw>;
  isDeposit: Scalars['Boolean']['output'];
  committedInCents: Scalars['Int']['output'];
  pendingBilledInCents: Scalars['Int']['output'];
  pendingUnbilledInCents: Scalars['Int']['output'];
  lineItems: Array<CommitmentBillingScheduleLineItem>;
};

export type CommitmentBillingScheduleLineItem = {
  __typename?: 'CommitmentBillingScheduleLineItem';
  amountInCents: Scalars['Int']['output'];
  commitmentLineItem: CommitmentLineItem;
};

export type CommitmentChangeOrder = CommitmentLike & HasBlueprintUrl & Named & HasDisplayName & HasPandaDoc & {
  __typename?: 'CommitmentChangeOrder';
  id: Scalars['ID']['output'];
  accountingNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  commitment: Commitment;
  commitmentType: CommitmentTypeDetail;
  identifier: Scalars['String']['output'];
  costChangeInCents: Scalars['Int']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Document>;
  lineItems: Array<CommitmentLineItem>;
  bills: Array<Bill>;
  /**  An alias of costChangeInCents  */
  committedInCents: Scalars['Int']['output'];
  taxableCostInCents: Scalars['Int']['output'];
  remainingInCents: Scalars['Int']['output'];
  pendingRemainingInCents: Scalars['Int']['output'];
  billedInCents?: Maybe<Scalars['Int']['output']>;
  pendingBilledInCents?: Maybe<Scalars['Int']['output']>;
  unbilledInCents: Scalars['Int']['output'];
  paidInCents?: Maybe<Scalars['Int']['output']>;
  balanceInCents?: Maybe<Scalars['Int']['output']>;
  blueprintUrl: Url;
  updatedAt: Scalars['DateTime']['output'];
  tradeCategories: Array<TradeCategory>;
  tradePartner?: Maybe<TradePartner>;
  changeEvent?: Maybe<ChangeEvent>;
  status: CommitmentStatus;
  statusDetail: CommitmentStatusDetail;
  statusText: Scalars['String']['output'];
  pandaDoc?: Maybe<PandaDoc>;
  canEditLineItems: PotentialOperation2;
  canCreatePandaDoc: PotentialOperation2;
  isBidCommitment: Scalars['Boolean']['output'];
  canBeEdited: Scalars['Boolean']['output'];
  costCodes: Array<CostCode>;
  items: Array<Item>;
  canDelete: PotentialOperation2;
  canVoid: PotentialOperation2;
  canBeReleased: PotentialOperation2;
  tradeSignatory?: Maybe<TradePartnerContact>;
  percentagePaid: Scalars['Int']['output'];
  sentDate?: Maybe<Scalars['Date']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

export type SaveCommitmentChangeOrderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  commitmentId?: InputMaybe<Scalars['ID']['input']>;
  accountingNumber?: InputMaybe<Scalars['Int']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  lineItems?: InputMaybe<Array<SaveCommitmentLineItemInput>>;
  status?: InputMaybe<CommitmentStatus>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCommitmentChangeOrderResult = {
  __typename?: 'SaveCommitmentChangeOrderResult';
  commitmentChangeOrder: CommitmentChangeOrder;
};

export type DeleteCommitmentChangeOrderInput = {
  id: Scalars['ID']['input'];
};

export type CommitmentDraw = Entity & {
  __typename?: 'CommitmentDraw';
  id: Scalars['ID']['output'];
  amountInBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  bidContractRevisionDraw: BidContractRevisionDraw;
  commitment: Commitment;
  task: Task;
  costCode: CostCode;
};

export type CommitmentLineItem = {
  __typename?: 'CommitmentLineItem';
  id: Scalars['ID']['output'];
  /**  The immediate parent, either a commitment or a change order.  */
  owner: CommitmentLike;
  /** The owning commitment, even if on a change order, that change order's original commitment. */
  ownerCommitment: Commitment;
  costChangeInCents?: Maybe<Scalars['Int']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  costCode: CostCode;
  /**  An alias of costChangeInCents  */
  committedInCents: Scalars['Int']['output'];
  billedInCents?: Maybe<Scalars['Int']['output']>;
  unbilledInCents: Scalars['Int']['output'];
  pendingBilledInCents: Scalars['Int']['output'];
  pendingUnbilledInCents: Scalars['Int']['output'];
  billableLimitInCents: Scalars['Int']['output'];
  paidInCents?: Maybe<Scalars['Int']['output']>;
  balanceInCents?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  projectItem: ProjectItem;
  specifications?: Maybe<Scalars['String']['output']>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  changeEventLineItem?: Maybe<ChangeEventLineItem>;
  newTaxableCostInCents: Scalars['Int']['output'];
  newTaxInCents: Scalars['Int']['output'];
  newTotalCostInCents: Scalars['Int']['output'];
  originalTaxableCostInCents: Scalars['Int']['output'];
  originalTaxInCents: Scalars['Int']['output'];
  originalTotalCostInCents: Scalars['Int']['output'];
  originalQuantity: Scalars['Int']['output'];
  newQuantity: Scalars['Int']['output'];
  bidItem?: Maybe<BidItem>;
  primaryBidContractLineItem?: Maybe<BidContractLineItem>;
  modifyingBidContractLineItems: Array<BidContractLineItem>;
  expenseAllocations: Array<ExpenseAllocation>;
  isTaxExempt: Scalars['Boolean']['output'];
  taxableCostInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  allocations: Array<CommitmentLineItemAllocation>;
};

export type ProtoCommitmentLineItemToBuyout = {
  __typename?: 'ProtoCommitmentLineItemToBuyout';
  projectItem: ProjectItem;
  quantity?: Maybe<Scalars['Int']['output']>;
  costChangeInCents?: Maybe<Scalars['Int']['output']>;
  specifications?: Maybe<Scalars['String']['output']>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
};

export type SaveCommitmentLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated replaced with taxableCostInCents */
  costChangeInCents?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  costCodeId?: InputMaybe<Scalars['ID']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  projectItemId?: InputMaybe<Scalars['ID']['input']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  taxableCostInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type CommitmentLineItemAllocation = {
  __typename?: 'CommitmentLineItemAllocation';
  id: Scalars['ID']['output'];
  costInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  commitmentLineItem: CommitmentLineItem;
  projectItemAllocation: ProjectItemAllocation;
  billLineItemAllocations: Array<BillLineItemAllocation>;
};

export type SaveCommunityInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']['input']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']['input']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']['input']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']['input']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  builderId?: InputMaybe<Scalars['ID']['input']>;
  legalDescription?: InputMaybe<Scalars['String']['input']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  communityType?: InputMaybe<CommunityType>;
  salesforceNeighborhoodId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pricingTeaser?: InputMaybe<Scalars['String']['input']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  packageComparison?: InputMaybe<AssetInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveCommunityResult = {
  __typename?: 'SaveCommunityResult';
  community: Community;
};

export type CommunitiesPageResult = {
  __typename?: 'CommunitiesPageResult';
  entities: Array<Community>;
  pageInfo: PageInfo;
};

export type CostCode = Named & HasDisplayName & HasMaterialLeadTimeConfigData & {
  __typename?: 'CostCode';
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
  division: CostDivision;
  number: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The `number name`, i.e. `2101 Framing. */
  displayName: Scalars['String']['output'];
  quickbooksCategoryId?: Maybe<Scalars['String']['output']>;
  quickbooksItemId?: Maybe<Scalars['String']['output']>;
  items: Array<Item>;
  tsaSpecifications?: Maybe<Scalars['String']['output']>;
  intacctApAccountId?: Maybe<Scalars['String']['output']>;
  costClassification: CostClassificationTypeDetail;
  costSubClassification?: Maybe<CostSubClassificationTypeDetail>;
  excludeFromPurchaseOrders: Scalars['Boolean']['output'];
  billType?: Maybe<BillTypeDetail>;
  changeEventAutoAcceptThresholdInCents?: Maybe<Scalars['Int']['output']>;
  isPriceOnly?: Maybe<Scalars['Boolean']['output']>;
  optionPricingConfig?: Maybe<OptionPricingConfig>;
  materialLeadTimeConfig?: Maybe<MaterialLeadTimeConfig>;
  /** The minLeadTimeInDays for items under this CostCode, either defined directly by an MaterialLeadTimeConfig or falling back to a default value. */
  minLeadTimeInDays: Scalars['Int']['output'];
  /** The expectedLeadTimeInDays for items under this CostCode, either defined directly by an MaterialLeadTimeConfig or falling back to a default value. */
  expectedLeadTimeInDays: Scalars['Int']['output'];
  /** The maxLeadTimeInDays for items under this CostCode, either defined directly by an MaterialLeadTimeConfig or falling back to a default value. */
  maxLeadTimeInDays: Scalars['Int']['output'];
  history: Array<History>;
  isUnderwritingBudget: Scalars['Boolean']['output'];
  finishScheduleOrder?: Maybe<Scalars['Int']['output']>;
  invoiceCategory?: Maybe<CostCodeInvoiceCategoryDetail>;
};

export type CostCodeFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  version?: InputMaybe<Array<Scalars['Int']['input']>>;
  number?: InputMaybe<Array<Scalars['String']['input']>>;
  costClassification?: InputMaybe<Array<CostClassificationType>>;
  costSubClassification?: InputMaybe<Array<CostSubClassificationType>>;
  tradePartnerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  billType?: InputMaybe<Array<BillType>>;
  isUnderwritingBudget?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveCostCodesInput = {
  costCodes: Array<SaveCostCodeInput>;
};

export type SaveCostCodeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  divisionId?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksCategoryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksItemId?: InputMaybe<Scalars['String']['input']>;
  tsaSpecifications?: InputMaybe<Scalars['String']['input']>;
  intacctApAccountId?: InputMaybe<Scalars['String']['input']>;
  costClassification?: InputMaybe<CostClassificationType>;
  costSubClassification?: InputMaybe<CostSubClassificationType>;
  excludeFromPurchaseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  billType?: InputMaybe<BillType>;
  changeEventAutoAcceptThresholdInCents?: InputMaybe<Scalars['Int']['input']>;
  isPriceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  optionPricingConfig?: InputMaybe<SavePersonalizationOptionPricingConfigInput>;
  materialLeadTimeConfig?: InputMaybe<SavePersonalizationMaterialLeadTimeConfigInput>;
  isUnderwritingBudget?: InputMaybe<Scalars['Boolean']['input']>;
  finishScheduleOrder?: InputMaybe<Scalars['Int']['input']>;
  invoiceCategory?: InputMaybe<CostCodeInvoiceCategory>;
};

export type SaveCostCodesResult = {
  __typename?: 'SaveCostCodesResult';
  costCodes: Array<CostCode>;
};

export type DeleteCostCodeInput = {
  id: Scalars['ID']['input'];
};

export type CostDivision = Named & HasDisplayName & {
  __typename?: 'CostDivision';
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The `number name`, i.e. `2100 Framing`. */
  displayName: Scalars['String']['output'];
  stage: StageDetail;
  selectionCutoff?: Maybe<SelectionCutoffDetail>;
  costCodes: Array<CostCode>;
  tsaPolicySection?: Maybe<Scalars['String']['output']>;
  tsaPaymentSection?: Maybe<Scalars['String']['output']>;
  tsaWarrantySection?: Maybe<Scalars['String']['output']>;
  tsaGeneralScope?: Maybe<Scalars['String']['output']>;
};

export type CostDivisionFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  version?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SaveCostDivisionsInput = {
  costDivisions: Array<SaveCostDivisionInput>;
};

export type SaveCostDivisionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Stage>;
  selectionCutoff?: InputMaybe<SelectionCutoff>;
  tsaPolicySection?: InputMaybe<Scalars['String']['input']>;
  tsaPaymentSection?: InputMaybe<Scalars['String']['input']>;
  tsaWarrantySection?: InputMaybe<Scalars['String']['input']>;
  tsaGeneralScope?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCostDivisionsResult = {
  __typename?: 'SaveCostDivisionsResult';
  costDivisions: Array<CostDivision>;
};

export type DeleteCostDivisionInput = {
  id: Scalars['ID']['input'];
};

export type CostLineItemAllocation = {
  __typename?: 'CostLineItemAllocation';
  id: Scalars['ID']['output'];
  invoicedAmountInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  billLineItem?: Maybe<BillLineItem>;
  expenseAllocation?: Maybe<ExpenseAllocation>;
  invoiceLineItem: InvoiceLineItem;
  costAmountInCents: Scalars['Int']['output'];
  costLineItemId: Scalars['ID']['output'];
};

export type Customer = Named & {
  __typename?: 'Customer';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  softCostMarkupInBasisPoints: Scalars['Int']['output'];
  indirectHardCostMarkupInBasisPoints: Scalars['Int']['output'];
  directHardCostMarkupInBasisPoints: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  isHti?: Maybe<Scalars['Boolean']['output']>;
  itemConfigs: Array<CustomerItemConfig>;
  shouldCoverConstructionCosts: Scalars['Boolean']['output'];
};

export type SaveCustomerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  softCostMarkupInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectHardCostMarkupInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  directHardCostMarkupInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  isHti?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCoverConstructionCosts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveCustomerResult = {
  __typename?: 'SaveCustomerResult';
  customer: Customer;
};

export type CustomerItemConfig = {
  __typename?: 'CustomerItemConfig';
  id: Scalars['ID']['output'];
  markupInBasisPoints: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  customer: Customer;
  item: Item;
};

export type SaveCustomerItemConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  markupInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveCustomerItemConfigResult = {
  __typename?: 'SaveCustomerItemConfigResult';
  customerItemConfig: CustomerItemConfig;
};

export type CustomerOwnerEntity = Named & {
  __typename?: 'CustomerOwnerEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  intacctId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated Replaced by customer.isHTI */
  isHti: Scalars['Boolean']['output'];
  warrantyLengthInDays: Scalars['Int']['output'];
};

export type SaveCustomerOwnerEntityInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  intacctId?: InputMaybe<Scalars['String']['input']>;
  warrantyLengthInDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveCustomerOwnerEntityResult = {
  __typename?: 'SaveCustomerOwnerEntityResult';
  customerOwnerEntity: CustomerOwnerEntity;
};

export type CustomerOwnerEntityFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Cutoff = {
  __typename?: 'Cutoff';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  items: Array<Item>;
  projects: Array<ProjectCutoff>;
};

export type SaveCutoffInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCutoffResult = {
  __typename?: 'SaveCutoffResult';
  cutoff: Cutoff;
};

export type SendTestDailyLotSummaryDigestInput = {
  users: Array<Scalars['ID']['input']>;
  developments?: InputMaybe<Array<Scalars['ID']['input']>>;
  date?: InputMaybe<Scalars['Date']['input']>;
};

export type DeleteDataCacheEntryInput = {
  name: Scalars['String']['input'];
  keyParts: Array<Scalars['String']['input']>;
};

export type ClearDataCacheInput = {
  name: Scalars['String']['input'];
};

export type DesignPackage = ReadyPlanLike & HasBlueprintUrl & Named & HasDisplayName & BaseItemParent & {
  __typename?: 'DesignPackage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  code?: Maybe<Scalars['String']['output']>;
  /**  The `type` + `code`, i.e. SFH-TX-1-001  */
  displayCode?: Maybe<Scalars['String']['output']>;
  blueprintUrl: Url;
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  options: Array<ReadyPlanOption>;
  optionGroups: Array<ReadyPlanOptionGroup>;
  interiorDesignPackageProductOfferings: Array<ProductOffering>;
  exteriorDesignPackageProductOfferings: Array<ProductOffering>;
  planPackages: Array<PlanPackage>;
  designPackageSources: Array<DesignPackageSource>;
  copyInProgress: Scalars['Boolean']['output'];
  slots: Array<DesignPackageSlot>;
  assets: Array<ReadyPlanAsset>;
  lotTypes: Array<LotType>;
  location: DesignPackageLocationDetail;
  markets: Array<Market>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  availableUpdates: Array<DesignPackagePlanUpdate>;
  version: ReadyPlanAggregateVersion;
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  canEditLineItems: PotentialOperation2;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']['output']>;
  canEdit: PotentialOperation2;
  syncErrors?: Maybe<Scalars['String']['output']>;
  readyPlanLocations: Array<ReadyPlanLocation>;
  potentialPersonalizationOptions: Array<ReadyPlanOptionGroup>;
  /**
   * List of potential add-on options associated with this design package via its source plans.
   * The active source plan RPOs are returned directly, mutated to the version of the source plan last sync'd into the DP.
   */
  potentialAddOnOptions: Array<ReadyPlanOption>;
  documents: Array<Document>;
  /**
   * By default generate combinations based on the RPOs and their prerequisites.
   * Use `fullCartesian: true` to bypass this and get the full cartesian product.
   * `optionGroupIds` can be used to limit the RPOGs used for combination generation.
   */
  combinations: Array<DesignPackageOptionCombination>;
  /**  List of relevant RPOGs that can be used as target groups for product cards and personalization options.  */
  availableTargetGroups: Array<ReadyPlanOptionGroup>;
  requiredOptions: Array<ReadyPlanRequiredOption>;
  /**  All downstream PRPCs referencing this DesignPackage via a ProductOffering  */
  projectConfigs: Array<ProjectReadyPlanConfig>;
  owner?: Maybe<InternalUser>;
  cabinetNotes?: Maybe<Scalars['String']['output']>;
  cloneInProgress: Scalars['Boolean']['output'];
};


export type DesignPackageSlotsArgs = {
  rpavId?: InputMaybe<Scalars['ID']['input']>;
  slotIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type DesignPackageReadyPlanLocationsArgs = {
  filter?: InputMaybe<ReadyPlanLocationsSubFilter>;
};


export type DesignPackagePotentialPersonalizationOptionsArgs = {
  placeholderTliId: Scalars['ID']['input'];
};


export type DesignPackageCombinationsArgs = {
  optionGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fullCartesian?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReadyPlanLocationsSubFilter = {
  /**  Only return RPLs with the same RoomType as this Location  */
  alternatesToLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDesignPackageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadyPlanStatus>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  planPackageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lotTypes?: InputMaybe<Array<LotType>>;
  location?: InputMaybe<DesignPackageLocation>;
  markets?: InputMaybe<Array<Scalars['ID']['input']>>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The FE will send in 'two levels' of options; the `options` in this list will
   * always be the top-level Elevation (for Exterior DPs) or Interior Scheme (for
   * Interior DPs) and any child options (like Spec Levels) will always be nested
   * within the `optionPrereqChildren` arrays.
   */
  options?: InputMaybe<Array<SaveDesignPackageOptionInput>>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDesignPackageOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /**  The global option group ID to create a new RPO for.  */
  globalOptionGroupId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The global option type ID to create a new RPO for. This is needed when creating scoped options for a new DP
   * (i.e., Interior Scheme and Exterior Scheme options). The GOG won't exist yet and will be created using the GOT ID.
   */
  globalOptionTypeId?: InputMaybe<Scalars['ID']['input']>;
  /**  The name of the new RPO, it might create a new global option within the group.  */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  Custom code used for Interior/Exterior Scheme options.  */
  code?: InputMaybe<Scalars['String']['input']>;
  /**  The list of RPOs that this RPO is a prereq for.  */
  optionPrereqChildren?: InputMaybe<Array<SaveDesignPackageOptionPrereqInput>>;
};

export type SaveDesignPackageOptionPrereqInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  globalOptionGroupId?: InputMaybe<Scalars['ID']['input']>;
  globalOptionTypeId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**  Usage: (slotId) | (itemId, locationId, customSlotName) to identify an ItemSlot, then (attributeValueIds, templateId) to configure it.  */
export type CreateDesignPackagePlaceholderTliInput = {
  /**  Reuse and add to an existing slot  */
  itemSlotId?: InputMaybe<Scalars['ID']['input']>;
  /**  For a net-new slot (i.e. LeftNav)  */
  itemId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /**  Differentiate a standard `Kitchen Sink` from a `Kitchen Bar Sink` by name.  */
  customSlotName?: InputMaybe<Scalars['String']['input']>;
  /**  Required, as Attribute Values distinguish one family from another. Could technically be empty to allow `Any` values. May conflict with an existing `Any` family at this slot; should throw if necessary.  */
  attributeValueIds: Array<Scalars['ID']['input']>;
  readyPlanId: Scalars['ID']['input'];
  /** Omitted or [] => one PlanPackageIncomingSlot automatically created per PlanPackage linked via active DesignPackageSource. */
  applicablePlanPackageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CopyDesignPackageInput = {
  sourcePackageId: Scalars['ID']['input'];
  sourcePackageVersionId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDesignPackagePlaceholderTliResult = {
  __typename?: 'CreateDesignPackagePlaceholderTliResult';
  placeholderTli: TakeoffLineItem;
  readyPlanAggregateVersion: ReadyPlanAggregateVersion;
  planPackageIncomingSlots: Array<PlanPackageIncomingSlot>;
};

export type SaveDesignPackageResult = {
  __typename?: 'SaveDesignPackageResult';
  designPackage: DesignPackage;
};

export type AcceptDesignPackageUpdatesInput = {
  designPackageId: Scalars['ID']['input'];
  designPackagePlanUpdateIds: Array<Scalars['ID']['input']>;
};

export type SaveDesignPackageUpdatesResult = {
  __typename?: 'SaveDesignPackageUpdatesResult';
  designPackage: DesignPackage;
};

export type DesignPackageFilter = {
  status?: InputMaybe<Array<ReadyPlanStatus>>;
};

export type DesignPackageOrderBy = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type DesignPackagesPageResult = {
  __typename?: 'DesignPackagesPageResult';
  entities: Array<DesignPackage>;
  pageInfo: PageInfo;
};

/**
 * Drives the left-nav of main Design Package UX, which focuses on "assigning products to slots".
 *
 * Disclaimer that "slot" is an overloaded term, insofar as within a DPS we may have multiple
 * family/requirement groups, i.e. "34in Kitchen Sink" or "36in Kitchen Sink" which have the same
 * `ItemSlot`, but a) different requirement placeholders/bid items, and b) are each their own "slot"
 * of a product for the user to fill-in.
 *
 * The label for these DPS slots is currently the material code, i.e. "Cabinet Hardware", and so
 * arguably the "best" identity for a DPS would be an `Item` + `Location` combination, i.e.
 * all of the "Cabinet Hardware" items/placeholders within the "Kitchen > Nook" location.
 *
 * This would also free-up the "slot regrouping" feature to use `ITI.name` to store the user-driven
 * placeholder names, i.e. to split/regroup `Cabinet Hardware` into `Door Hardware` vs. `Drawer Hardware`,
 * instead of our current `customPlaceholderName` field.
 */
export type DesignPackageSlot = {
  __typename?: 'DesignPackageSlot';
  /**  adhoc ID for ApolloCache to merge queries/mutation results together to keep a slot up to date. i.e. when adding/removing items from a slot auto-update with new items or coverage status via mutation results without having to refetch.  */
  id: Scalars['ID']['output'];
  slot: ItemSlot;
  coverage: Scalars['Int']['output'];
  isFullyAssigned: Scalars['Boolean']['output'];
  items: Array<TakeoffLineItem>;
  hasPendingPlanPackageIncomingSlots: Scalars['Boolean']['output'];
};

export type DesignPackageOptionCombination = {
  __typename?: 'DesignPackageOptionCombination';
  id: Scalars['ID']['output'];
  /** @deprecated use options instead */
  combination: Array<ReadyPlanOption>;
  options: Array<ReadyPlanOption>;
  name: Scalars['String']['output'];
};

export type DesignPackageFinishScheduleFilter = {
  designRpavId: Scalars['ID']['input'];
  planRpavIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationInPath?: InputMaybe<Array<Scalars['ID']['input']>>;
  costCodeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  combinations?: InputMaybe<Array<Array<Scalars['ID']['input']>>>;
};

export type DesignPackageFinishSchedulePageResult = {
  __typename?: 'DesignPackageFinishSchedulePageResult';
  entities: Array<TakeoffLineItem>;
  pageInfo: PageInfo;
};

export type PlaceholderCombinationsInput = {
  placeholderId: Scalars['ID']['input'];
  productCardId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The placeholder's target groups which determines the combinations available for its product cards.
   * This along with a product card's target combinations can be edited together and affects combinations on sibling cards.
   * If `productCardId` is not provided and `targetCombinations` is provided, it's assumed that we're adding a new product card.
   */
  targetGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
  /**  Determines which 'subgroup' of product cards to manage (i.e., all plans, Plan 1, Plan 2, etc.)  */
  targetPlanId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlaceholderCombinationsResult = {
  __typename?: 'PlaceholderCombinationsResult';
  takeoffLineItem: TakeoffLineItem;
  combinations: Array<DesignPackageOptionCombination>;
};

export type SavePersonalizationOptionGroupInput = {
  /**  The RPOG id to update, if updating.  */
  id?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**  The design package id, if creating.  */
  designPackageId?: InputMaybe<Scalars['ID']['input']>;
  /**  The personalization type, if creating.  */
  type?: InputMaybe<ReadyPlanOptionGroupPersonalizationType>;
  /**  Enable package options to group by feature  */
  groupByFeature?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  marketingDescription?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Scalars['Int']['input']>;
  /**  The list of (non-shadow) placeholders that this RPOG (and it's shadow placeholder) will drive, with optional ordering.  */
  controlledSlots?: InputMaybe<Array<SavePersonalizationControlledSlotInput>>;
  /**  The list of RPOGs that can be used to set target combinations for product/package options.  */
  personalizationTargetGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  The list of products in the optional pool, for type=single & type=linked personalization options. */
  productOptions?: InputMaybe<Array<SavePersonalizationProductOptionInput>>;
  /**  The list of personalization options for type=package option groups (e.g. GE, Samsung, etc.).  */
  packageOptions?: InputMaybe<Array<SavePersonalizationPackageOptionInput>>;
  /**  If true, the RPO/TLI locations will be set to RPOG.location, even if the RPOG.location is currently correct.  */
  forceLocationCascade?: InputMaybe<Scalars['Boolean']['input']>;
  /**  If true, displays this option group as a single product in checkout instead of separate package options  */
  displayPackageOptionsAsSingleProduct?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  A placeholder to be controlled by a personalization option group, with optional ordering.  */
export type SavePersonalizationControlledSlotInput = {
  placeholderId: Scalars['ID']['input'];
  /**  The display order for this slot within the personalization option group.  */
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type SavePersonalizationPackageOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  The list of product cards that this package option owns (e.g. Fridge SKU 123).  */
  products?: InputMaybe<Array<SavePersonalizationPackageOptionProductInput>>;
  /**  The list of option combinations that this package option is the default for.  */
  personalizationTargetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
};

/**  A cell/product in the table of package options (rows are options, columns are placeholders).  */
export type SavePersonalizationPackageOptionProductInput = {
  /**  The column, i.e. Sink (32in) or Tile. */
  placeholderMaterialId: Scalars['ID']['input'];
  /**  The column's location, e.g. Bathroom > Floor or Bathroom > Shower, which is required for groupByFeature=true.  */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /**  The product (e.g., GE Fridge SKU 123) or null for 'No Product'  */
  productMaterialId?: InputMaybe<Scalars['ID']['input']>;
};

export type SavePersonalizationProductOptionInput = {
  materialVariantId: Scalars['ID']['input'];
  personalizationTargetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
};

export type SaveTargetCombinationInput = {
  options: Array<Scalars['ID']['input']>;
};

export type SavePersonalizationOptionGroupResult = {
  __typename?: 'SavePersonalizationOptionGroupResult';
  /**  The latest RPAV, which might be a new draft created by the save.  */
  version: ReadyPlanAggregateVersion;
  /**  The mutateToVersion-d option group.  */
  optionGroup: ReadyPlanOptionGroup;
};

export type CopyDesignPackageCardsInput = {
  sourcePlaceholderTliId: Scalars['ID']['input'];
  targetPlaceholderTliIds: Array<Scalars['ID']['input']>;
};

export type CopyDesignPackageCardsResult = {
  __typename?: 'CopyDesignPackageCardsResult';
  sourePlaceholderTli: TakeoffLineItem;
  targetPlaceholderTlis: Array<TakeoffLineItem>;
  addedTlis: Array<TakeoffLineItem>;
  /**  The latest RPAV, which might be a new draft created by the save.  */
  version: ReadyPlanAggregateVersion;
};

export type CopyDesignPackageSelectionsInput = {
  sourceOptionId: Scalars['ID']['input'];
  targetOptionId: Scalars['ID']['input'];
};

export type CopyDesignPackageSelectionsResult = {
  __typename?: 'CopyDesignPackageSelectionsResult';
  updatedTakeoffLineItems: Array<TakeoffLineItem>;
  updatedReadyPlanOptions: Array<ReadyPlanOption>;
  updatedReadyPlanRequiredOptions: Array<ReadyPlanRequiredOption>;
};

export type AutoAssignPackageOptionMaterialsInput = {
  designPackageOptionGroupIds: Array<Scalars['ID']['input']>;
};

export type DesignPackagePlanUpdate = {
  __typename?: 'DesignPackagePlanUpdate';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  source: DesignPackageSource;
  /** @deprecated Prefer source instead */
  designPackage: DesignPackage;
  accepted: Scalars['Boolean']['output'];
  /**  The PlanPackage RPAV that creates this update.  */
  planVersion: ReadyPlanAggregateVersion;
  /**  The DesignPackage RPAV that accepted this update.  */
  acceptedInVersion?: Maybe<ReadyPlanAggregateVersion>;
};

export type DesignPackageSource = {
  __typename?: 'DesignPackageSource';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  readyPlan: DesignPackage;
  planPackage: PlanPackage;
  copyInProgress: Scalars['Boolean']['output'];
  active: Scalars['Boolean']['output'];
  /**  We can version the DPS (turn it on/off) over time.  */
  versions: Array<DesignPackageSourceVersion>;
  /**  All incoming DPPUs that we've received from our PlanPackage. */
  planUpdates: Array<DesignPackagePlanUpdate>;
  planPackageVersion?: Maybe<ReadyPlanAggregateVersion>;
};

export type SaveDesignPackageSourceResult = {
  __typename?: 'SaveDesignPackageSourceResult';
  designPackageSource: DesignPackageSource;
};

export type DesignPackageSourceVersion = {
  __typename?: 'DesignPackageSourceVersion';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  identity: DesignPackageSource;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
};

export type DesignPackageVersion = {
  __typename?: 'DesignPackageVersion';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  code?: Maybe<Scalars['String']['output']>;
  contingencyMarkupPercentage?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type: ReadyPlanTypeDetail;
  lotTypes: Array<LotType>;
  identity: DesignPackage;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  markets: Array<Market>;
  owner?: Maybe<InternalUser>;
};

export type MaybeHasMarket = {
  id: Scalars['ID']['output'];
  market?: Maybe<Market>;
};

export type Development = Named & HasSchedules & HasBlueprintUrl & MaybeHasMarket & {
  __typename?: 'Development';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  market: Market;
  cohorts?: Maybe<Array<Cohort>>;
  schedules: Array<Schedule>;
  /**  The list of all ReadyHome templates for this Development, both plans and options.  */
  itemTemplates: Array<ItemTemplate>;
  commitments: Array<DevelopmentCommitment>;
  documents: Array<Document>;
  bidContracts: Array<BidContract>;
  readyPlans: Array<ReadyPlan>;
  directorOfConstruction?: Maybe<InternalUser>;
  teamMembers: Array<DevelopmentTeamMember>;
  toDos: Array<ToDo>;
  options: Array<DevelopmentOption>;
  /**  For a development, the project-level schedule templates that may be used for projects.  */
  scheduleTemplates: Array<ScheduleTemplate>;
  sequenceSheetFollowers: Array<InternalUser>;
  /**
   * Indicates if the specified user will receive notifications,
   * based on either being a sequenceSheetFollowers or development team member
   */
  isSequenceSheetFollower: Scalars['Boolean']['output'];
  /**  Indicates if the specified user is a team member.  */
  isTeamMember: Scalars['Boolean']['output'];
  /**  Indicates if someone who is a follower can stop following. Returns false for development team members */
  canStopFollowingSequenceSheet: PotentialOperation2;
  /**  Indicates whether the development can generate templates from ready plans  */
  canGenerateTemplates: PotentialOperation2;
  itemMappings: Array<DevelopmentItemMapping>;
  /**
   * Obtains the cost mapping progress for a development
   * Not safe to be called for a large number of developments at once
   */
  costMappingProgress: CostMappingProgress;
  internalBudgetEstimate: BidContract;
  specOptions: Array<GlobalOption>;
  featureFlags: Array<FeatureFlag>;
  /**  Returns unique Trade Partners/Cost Codes related to all commitments within a development.  */
  tradePartners: Array<TradePartner>;
  costCodes: Array<CostCode>;
  drops: Array<Drop>;
  costCodesWithDraws: Array<CostCode>;
  schedulingExclusionDates: Array<SchedulingExclusionDate>;
  salesTaxOverrideInBasisPoints?: Maybe<Scalars['Int']['output']>;
  salesTaxInBasisPoints: Scalars['Int']['output'];
};


export type DevelopmentItemTemplatesArgs = {
  filter?: InputMaybe<DevelopmentItemTemplateFilter>;
};


export type DevelopmentIsSequenceSheetFollowerArgs = {
  internalUserId: Scalars['ID']['input'];
};


export type DevelopmentIsTeamMemberArgs = {
  internalUserId: Scalars['ID']['input'];
};


export type DevelopmentCanStopFollowingSequenceSheetArgs = {
  internalUserId: Scalars['ID']['input'];
};


export type DevelopmentCanGenerateTemplatesArgs = {
  requireArchivedTemplatesAssigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DevelopmentItemMappingsArgs = {
  filter?: InputMaybe<DevelopmentItemMappingFilter>;
};

export type SaveDevelopmentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  cohortIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  schedulingExclusionDates?: InputMaybe<Array<SaveSchedulingExclusionDateInput>>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveDevelopmentsInput = {
  developments: Array<SaveDevelopmentInput>;
};

export type SaveDevelopmentsResult = {
  __typename?: 'SaveDevelopmentsResult';
  developments: Array<Development>;
};

export type DevelopmentItemMapping = {
  __typename?: 'DevelopmentItemMapping';
  item: Item;
  costType: CostType;
  location: Location;
  stage: Stage;
  scheduleTemplateItemMappings: Array<ScheduleTemplateItemMapping>;
};

export type BulkTemplateFilter = {
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  planIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  GlobalOption ids e.g. `go:115`  */
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DevelopmentItemMappingFilter = {
  stage?: InputMaybe<Stage>;
};

export type DevelopmentFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DevelopmentItemTemplateFilter = {
  status?: InputMaybe<Array<ItemTemplateStatus>>;
};

export type CostMappingProgress = {
  __typename?: 'CostMappingProgress';
  totalScheduleTemplateItemMappings: Scalars['Int']['output'];
  totalMappingsForDevelopment: Scalars['Int']['output'];
  showCostMappingProgress: Scalars['Boolean']['output'];
};

export type DevelopmentLotSummaryChartsResult = {
  __typename?: 'DevelopmentLotSummaryChartsResult';
  development: Development;
  acquired: Array<CohortLotSummaryChart>;
  totalAcquired: Scalars['Int']['output'];
  permitSubmitted: Array<CohortLotSummaryChart>;
  totalPermitSubmitted: Scalars['Int']['output'];
  permitReceived: Array<CohortLotSummaryChart>;
  totalPermitReceived: Scalars['Int']['output'];
  verticalMobilization: Array<CohortLotSummaryChart>;
  totalVerticalMobilization: Scalars['Int']['output'];
  verticalComplete: Array<CohortLotSummaryChart>;
  totalVerticalComplete: Scalars['Int']['output'];
  delivered: Array<CohortLotSummaryChart>;
  totalDelivered: Scalars['Int']['output'];
};

export type CohortLotSummaryChart = {
  __typename?: 'CohortLotSummaryChart';
  cohort: Cohort;
  total: Scalars['Int']['output'];
};

export type DevelopmentCommitmentSummaryLineItem = {
  __typename?: 'DevelopmentCommitmentSummaryLineItem';
  costInCents: Scalars['Int']['output'];
  numberOfProjects: Scalars['Int']['output'];
  item: Item;
  quantity: Scalars['Int']['output'];
};

export type DevelopmentCommitmentSummary = {
  __typename?: 'DevelopmentCommitmentSummary';
  lineItems: Array<DevelopmentCommitmentSummaryLineItem>;
};

export type SaveDevelopmentCommitmentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  costTypes?: InputMaybe<Array<CostType>>;
  tradeCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Combinations of item+location+cost type to bulk-add PIs to the new-or-existing dev commitment.  */
  potentialLineItems?: InputMaybe<Array<DevelopmentCommitmentPotentialLineItemInput>>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<CommitmentStatus>;
  type?: InputMaybe<DevelopmentCommitmentType>;
  name?: InputMaybe<Scalars['String']['input']>;
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  contractExhibits?: InputMaybe<Scalars['String']['input']>;
  contractSchedule?: InputMaybe<Scalars['String']['input']>;
  contractTerms?: InputMaybe<Scalars['String']['input']>;
  contractExclusions?: InputMaybe<Scalars['String']['input']>;
  releasedDate?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated use releasedDate instead */
  releasedAt?: InputMaybe<Scalars['Date']['input']>;
  stage?: InputMaybe<Stage>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteDevelopmentCommitmentInput = {
  id: Scalars['ID']['input'];
  /**  Whether to delete signed (but not paid) commitments, for admins/tech coordinators, until we have a void feature.  */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveDevelopmentCommitmentResult = {
  __typename?: 'SaveDevelopmentCommitmentResult';
  developmentCommitment: DevelopmentCommitment;
};

export type DevelopmentCommitmentFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<CommitmentStatus>>;
  tradePartnerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A flat list of item+cost type+location (grouped across all lots).
 *
 * The UI will client-side group these by the item's cost-code.
 */
export type DevelopmentCommitmentPotentialLineItem = {
  __typename?: 'DevelopmentCommitmentPotentialLineItem';
  item: Item;
  costType: CostType;
  location: Location;
  totalCostInCents: Scalars['Int']['output'];
  projects: Array<Scalars['ID']['output']>;
};

export type DevelopmentCommitmentPotentialLineItemInput = {
  itemId: Scalars['ID']['input'];
  costType: CostType;
  locationId: Scalars['ID']['input'];
};

export type DevelopmentCommitmentCostCodeSummary = {
  __typename?: 'DevelopmentCommitmentCostCodeSummary';
  costCode: CostCode;
  numberOfProjects: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type DeleteDevelopmentCommitmentProjectsAndCommitmentsResult = {
  __typename?: 'DeleteDevelopmentCommitmentProjectsAndCommitmentsResult';
  developmentCommitment: DevelopmentCommitment;
};

export type DeleteDevelopmentCommitmentProjectsAndCommitmentsInput = {
  developmentCommitmentId: Scalars['ID']['input'];
  projectIds: Array<Scalars['ID']['input']>;
  commitmentIds: Array<Scalars['ID']['input']>;
};

export type DevelopmentCommitmentsPage = {
  __typename?: 'DevelopmentCommitmentsPage';
  entities: Array<DevelopmentCommitment>;
  pageInfo: PageInfo;
};

export type DevelopmentOption = {
  __typename?: 'DevelopmentOption';
  id: Scalars['ID']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  development: Development;
  globalOption: GlobalOption;
};

export type SaveDevelopmentOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  globalOptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDevelopmentOptionsInput = {
  saveDevelopmentOptions: Array<SaveDevelopmentOptionInput>;
};

export type SaveDevelopmentOptionsResult = {
  __typename?: 'SaveDevelopmentOptionsResult';
  developmentOptions: Array<DevelopmentOption>;
};

export type DevelopmentTeamMember = {
  __typename?: 'DevelopmentTeamMember';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  projectRole: ProjectRoleDetail;
  development: Development;
  internalUser: InternalUser;
};

export type SaveDevelopmentTeamMemberInput = {
  projectRole: ProjectRole;
  developmentId: Scalars['ID']['input'];
  internalUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentsPageResult = {
  __typename?: 'DocumentsPageResult';
  entities: Array<Document>;
  pageInfo: PageInfo;
};

export type DeleteDocumentsResult = {
  __typename?: 'DeleteDocumentsResult';
  parents: Array<DocumentParent>;
  /** @deprecated adding for backwards compatibility over the wire, should be removed in the future */
  emptyResult?: Maybe<Scalars['String']['output']>;
  /** @deprecated adding for backwards compatibility over the wire, should be removed in the future */
  dummyString?: Maybe<Scalars['String']['output']>;
};

export type CreateDocumentPendingUploadInput = {
  parentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sizeInBytes: Scalars['Int']['input'];
  documentType: DocumentType;
  /** Optional. Will default to 'application/pdf' */
  contentType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDocumentPendingUploadResult = {
  __typename?: 'CreateDocumentPendingUploadResult';
  signedUrl: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
};

export type MarkDocumentAsUploadedInput = {
  documentId: Scalars['ID']['input'];
};

export type MarkDocumentAsUploadedResult = {
  __typename?: 'MarkDocumentAsUploadedResult';
  document: Document;
};

export type ToggleDocumentAsFavoritedInput = {
  documentId: Scalars['ID']['input'];
};

export type ToggleDocumentAsFavoritedResult = {
  __typename?: 'ToggleDocumentAsFavoritedResult';
  document: Document;
};

export type SaveDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  asset?: InputMaybe<AssetInput>;
  documentType?: InputMaybe<DocumentType>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sizeInBytes?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Setting category is now a no-op and will be derived by documentType */
  category?: InputMaybe<DocumentCategory>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuanceDate?: InputMaybe<Scalars['Date']['input']>;
  ownerWorkAuthorizationId?: InputMaybe<Scalars['ID']['input']>;
  projectDocumentAssociations?: InputMaybe<Array<ProjectDocumentAssociationInput>>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  attachOn?: InputMaybe<Array<DocumentAttachmentPlace>>;
};

export type SaveDocumentsInput = {
  documents: Array<SaveDocumentInput>;
};

export type SaveDocumentsResult = {
  __typename?: 'SaveDocumentsResult';
  documents: Array<Document>;
};

export type DocumentsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Request token type will take precedence */
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** If an ID of a shadow project is provided, documents associated with its primary project will be included */
  parentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  versionId?: InputMaybe<Scalars['ID']['input']>;
  documentType?: InputMaybe<Array<DocumentType>>;
  category?: InputMaybe<Array<DocumentCategory>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated includeUncategorized is now a no-op. All docs now have a category. */
  includeUncategorized?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentsOrder = {
  createdAt?: InputMaybe<Order>;
};

export type DocumentParent = Development | PlanPackage | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type DocumentOwner = HomeownerContract | HomeownerContractChangeOrder | Commitment | CommitmentChangeOrder | DevelopmentCommitment | InvoiceDocument | Development | PlanPackage | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | BidContractRevision | LienWaiver | ChangeEvent;

export type Drop = {
  __typename?: 'Drop';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costCode: CostCode;
  development?: Maybe<Development>;
  globalPlanTask: GlobalPlanTask;
  locations: Array<Location>;
  order: Scalars['Int']['output'];
  commitments: Array<Commitment>;
  productOfferingIncomingUpdates: Array<ProductOfferingIncomingUpdate>;
  project?: Maybe<Project>;
};

export type SaveDropInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  costCodeId?: InputMaybe<Scalars['ID']['input']>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveDropResult = {
  __typename?: 'SaveDropResult';
  drop: Drop;
};

export type DeleteDropInput = {
  id: Scalars['ID']['input'];
};

export type DropsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Entity = {
  id: Scalars['ID']['output'];
};

export enum ActivityPlanningState {
  Draft = 'DRAFT',
  ReadyForReview = 'READY_FOR_REVIEW',
  InReview = 'IN_REVIEW',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ActivityPlanningStateDetail = {
  __typename?: 'ActivityPlanningStateDetail';
  code: ActivityPlanningState;
  name: Scalars['String']['output'];
};

export enum ActivityResponsibility {
  Homebound = 'HOMEBOUND',
  OwnersConsultant = 'OWNERS_CONSULTANT',
  NotApplicable = 'NOT_APPLICABLE'
}

export type ActivityResponsibilityDetail = {
  __typename?: 'ActivityResponsibilityDetail';
  code: ActivityResponsibility;
  name: Scalars['String']['output'];
};

export enum ActivityType {
  PreconPlanning = 'PRECON_PLANNING',
  PreconConstructionDoc = 'PRECON_CONSTRUCTION_DOC'
}

export type ActivityTypeDetail = {
  __typename?: 'ActivityTypeDetail';
  code: ActivityType;
  name: Scalars['String']['output'];
};

export enum AggregateVersionStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type AggregateVersionStatusDetail = {
  __typename?: 'AggregateVersionStatusDetail';
  code: AggregateVersionStatus;
  name: Scalars['String']['output'];
};

export enum AllocationStrategy {
  SizeBased = 'SIZE_BASED',
  EqualShare = 'EQUAL_SHARE',
  MarketValue = 'MARKET_VALUE'
}

export type AllocationStrategyDetail = {
  __typename?: 'AllocationStrategyDetail';
  code: AllocationStrategy;
  name: Scalars['String']['output'];
};

export enum ApprovalStatus {
  ChangesNeeded = 'CHANGES_NEEDED',
  Requested = 'REQUESTED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ApprovalStatusDetail = {
  __typename?: 'ApprovalStatusDetail';
  code: ApprovalStatus;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum ApproverStatus {
  Pending = 'PENDING',
  ActionRequired = 'ACTION_REQUIRED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ApproverStatusDetail = {
  __typename?: 'ApproverStatusDetail';
  code: ApproverStatus;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum BidContractRevisionStatus {
  Draft = 'DRAFT',
  Uploaded = 'UPLOADED',
  Sent = 'SENT',
  Signed = 'SIGNED',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Archived = 'ARCHIVED'
}

export type BidContractRevisionStatusDetail = {
  __typename?: 'BidContractRevisionStatusDetail';
  code: BidContractRevisionStatus;
  name: Scalars['String']['output'];
};

export enum BidContractType {
  UnitBased = 'UNIT_BASED',
  ItemTemplateBased = 'ITEM_TEMPLATE_BASED',
  GroupedByPlanAndOption = 'GROUPED_BY_PLAN_AND_OPTION'
}

export type BidContractTypeDetail = {
  __typename?: 'BidContractTypeDetail';
  code: BidContractType;
  name: Scalars['String']['output'];
};

export enum BidPackageStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Received = 'RECEIVED',
  Awarded = 'AWARDED'
}

export type BidPackageStatusDetail = {
  __typename?: 'BidPackageStatusDetail';
  code: BidPackageStatus;
  name: Scalars['String']['output'];
};

export enum BidScopeSource {
  Community = 'COMMUNITY',
  Subdivision = 'SUBDIVISION',
  Lot = 'LOT',
  ProductOffering = 'PRODUCT_OFFERING'
}

export type BidScopeSourceDetail = {
  __typename?: 'BidScopeSourceDetail';
  code: BidScopeSource;
  name: Scalars['String']['output'];
};

export enum BillGmailAttachmentResult {
  NotPdf = 'NOT_PDF',
  MissingPo = 'MISSING_PO',
  MissingTrade = 'MISSING_TRADE',
  MissingProject = 'MISSING_PROJECT',
  MissingInvoiceNumber = 'MISSING_INVOICE_NUMBER',
  Duplicate = 'DUPLICATE',
  ClickToPay = 'CLICK_TO_PAY',
  BillCreated = 'BILL_CREATED',
  MissingConstructionStage = 'MISSING_CONSTRUCTION_STAGE',
  ProcessingError = 'PROCESSING_ERROR',
  NotAnInvoice = 'NOT_AN_INVOICE'
}

export type BillGmailAttachmentResultDetail = {
  __typename?: 'BillGmailAttachmentResultDetail';
  code: BillGmailAttachmentResult;
  name: Scalars['String']['output'];
};

export enum BillGmailMessageResult {
  NotFound = 'NOT_FOUND',
  NoAttachments = 'NO_ATTACHMENTS',
  NoPdfs = 'NO_PDFS',
  Parsed = 'PARSED',
  Parsing = 'PARSING'
}

export type BillGmailMessageResultDetail = {
  __typename?: 'BillGmailMessageResultDetail';
  code: BillGmailMessageResult;
  name: Scalars['String']['output'];
};

export enum BillReviewReason {
  MissingPo = 'MISSING_PO',
  UnsignedPo = 'UNSIGNED_PO',
  NeedVpo = 'NEED_VPO',
  InsufficientBudget = 'INSUFFICIENT_BUDGET',
  AutoParsed = 'AUTO_PARSED',
  NeedClarification = 'NEED_CLARIFICATION'
}

export type BillReviewReasonDetail = {
  __typename?: 'BillReviewReasonDetail';
  code: BillReviewReason;
  name: Scalars['String']['output'];
};

export enum BillSource {
  Manual = 'MANUAL',
  ClickToPay = 'CLICK_TO_PAY',
  AutoParsed = 'AUTO_PARSED'
}

export type BillSourceDetail = {
  __typename?: 'BillSourceDetail';
  code: BillSource;
  name: Scalars['String']['output'];
};

export enum BillStatus {
  Draft = 'DRAFT',
  ChangesRequested = 'CHANGES_REQUESTED',
  ReleaseScheduled = 'RELEASE_SCHEDULED',
  PendingApproval = 'PENDING_APPROVAL',
  ReadyToPay = 'READY_TO_PAY',
  Rejected = 'REJECTED',
  Paid = 'PAID',
  Reversed = 'REVERSED',
  Cancelled = 'CANCELLED',
  PendingConditionalLienWaiver = 'PENDING_CONDITIONAL_LIEN_WAIVER',
  PendingUnconditionalLienWaiver = 'PENDING_UNCONDITIONAL_LIEN_WAIVER',
  Unreleased = 'UNRELEASED',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export type BillStatusDetail = {
  __typename?: 'BillStatusDetail';
  code: BillStatus;
  name: Scalars['String']['output'];
};

export enum BillType {
  Standard = 'STANDARD',
  Deposit = 'DEPOSIT',
  Overhead = 'OVERHEAD',
  RepairAndMaintenance = 'REPAIR_AND_MAINTENANCE',
  Warranty = 'WARRANTY'
}

export type BillTypeDetail = {
  __typename?: 'BillTypeDetail';
  code: BillType;
  name: Scalars['String']['output'];
};

export enum BusinessFunctionType {
  Architecture = 'ARCHITECTURE',
  Construction = 'CONSTRUCTION',
  Design = 'DESIGN',
  Marketing = 'MARKETING',
  Purchasing = 'PURCHASING',
  Accounting = 'ACCOUNTING',
  Sales = 'SALES',
  Warranty = 'WARRANTY',
  CustomerExperience = 'CUSTOMER_EXPERIENCE',
  Underwriting = 'UNDERWRITING',
  Precon = 'PRECON',
  MarketLaunch = 'MARKET_LAUNCH',
  LandAcquisition = 'LAND_ACQUISITION',
  Legal = 'LEGAL'
}

export type BusinessFunctionTypeDetail = {
  __typename?: 'BusinessFunctionTypeDetail';
  code: BusinessFunctionType;
  name: Scalars['String']['output'];
};

export enum BuyoutStatus {
  NotBoughtOut = 'NOT_BOUGHT_OUT',
  BoughtOut = 'BOUGHT_OUT',
  PartiallyBoughtOut = 'PARTIALLY_BOUGHT_OUT'
}

export type BuyoutStatusDetail = {
  __typename?: 'BuyoutStatusDetail';
  code: BuyoutStatus;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export enum ChangeEventBudgetPhase {
  Prebid = 'PREBID',
  Awarded = 'AWARDED',
  Revised = 'REVISED'
}

export type ChangeEventBudgetPhaseDetail = {
  __typename?: 'ChangeEventBudgetPhaseDetail';
  code: ChangeEventBudgetPhase;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum ChangeEventLineItemType {
  Add = 'ADD',
  Modify = 'MODIFY',
  Cutoff = 'CUTOFF'
}

export type ChangeEventLineItemTypeDetail = {
  __typename?: 'ChangeEventLineItemTypeDetail';
  code: ChangeEventLineItemType;
  name: Scalars['String']['output'];
};

export enum ChangeEventStatus {
  Draft = 'DRAFT',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Proposed = 'PROPOSED',
  Requested = 'REQUESTED',
  Void = 'VOID',
  PendingSignature = 'PENDING_SIGNATURE'
}

export type ChangeEventStatusDetail = {
  __typename?: 'ChangeEventStatusDetail';
  code: ChangeEventStatus;
  name: Scalars['String']['output'];
};

export enum ChangeEventType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  BudgetReallocation = 'BUDGET_REALLOCATION'
}

export type ChangeEventTypeDetail = {
  __typename?: 'ChangeEventTypeDetail';
  code: ChangeEventType;
  name: Scalars['String']['output'];
};

export enum ChangeRequestAssetPlatform {
  Blueprint = 'BLUEPRINT',
  Salesforce = 'SALESFORCE',
  UnderwritingApp = 'UNDERWRITING_APP',
  Mls = 'MLS',
  Zillow = 'ZILLOW',
  Gdrive = 'GDRIVE',
  Figma = 'FIGMA',
  PhysicalColateral = 'PHYSICAL_COLATERAL',
  GoogleSlides = 'GOOGLE_SLIDES',
  GoogleSheet = 'GOOGLE_SHEET',
  Checkout = 'CHECKOUT',
  Airtable = 'AIRTABLE',
  HomeboundCom = 'HOMEBOUND_COM',
  LyonelaneCom = 'LYONELANE_COM',
  Air = 'AIR'
}

export type ChangeRequestAssetPlatformDetail = {
  __typename?: 'ChangeRequestAssetPlatformDetail';
  code: ChangeRequestAssetPlatform;
  name: Scalars['String']['output'];
};

export enum ChangeRequestAssetScope {
  Project = 'PROJECT',
  Development = 'DEVELOPMENT'
}

export type ChangeRequestAssetScopeDetail = {
  __typename?: 'ChangeRequestAssetScopeDetail';
  code: ChangeRequestAssetScope;
  name: Scalars['String']['output'];
};

export enum ChangeRequestPriority {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
  Urgent = 'URGENT',
  Expedited = 'EXPEDITED'
}

export type ChangeRequestPriorityDetail = {
  __typename?: 'ChangeRequestPriorityDetail';
  code: ChangeRequestPriority;
  name: Scalars['String']['output'];
};

export enum ChangeRequestSource {
  Na = 'NA',
  ValueEngineering = 'VALUE_ENGINEERING',
  UpSpecing = 'UP_SPECING',
  CustomerRequestPersonalization = 'CUSTOMER_REQUEST_PERSONALIZATION',
  FieldDirective = 'FIELD_DIRECTIVE',
  FrameWalkAdjustments = 'FRAME_WALK_ADJUSTMENTS',
  ProviderUpdate = 'PROVIDER_UPDATE',
  InternalSalesFeedback = 'INTERNAL_SALES_FEEDBACK',
  BoylCustomerRequestPersonalization = 'BOYL_CUSTOMER_REQUEST_PERSONALIZATION',
  ProductRefresh = 'PRODUCT_REFRESH',
  InternalDesignFeedback = 'INTERNAL_DESIGN_FEEDBACK',
  FeeBuildProjectChange = 'FEE_BUILD_PROJECT_CHANGE'
}

export type ChangeRequestSourceDetail = {
  __typename?: 'ChangeRequestSourceDetail';
  code: ChangeRequestSource;
  name: Scalars['String']['output'];
};

export enum ChangeRequestStatus {
  NeedsReview = 'NEEDS_REVIEW',
  ReadyForReview = 'READY_FOR_REVIEW',
  ReadyForApproval = 'READY_FOR_APPROVAL',
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Completed = 'COMPLETED',
  Reversed = 'REVERSED',
  Blocked = 'BLOCKED'
}

export type ChangeRequestStatusDetail = {
  __typename?: 'ChangeRequestStatusDetail';
  code: ChangeRequestStatus;
  name: Scalars['String']['output'];
};

export enum ChangeRequestToDoType {
  InitialReview = 'INITIAL_REVIEW',
  ImpactEstimate = 'IMPACT_ESTIMATE',
  Implementation = 'IMPLEMENTATION',
  ImplementationReview = 'IMPLEMENTATION_REVIEW'
}

export type ChangeRequestToDoTypeDetail = {
  __typename?: 'ChangeRequestToDoTypeDetail';
  code: ChangeRequestToDoType;
  name: Scalars['String']['output'];
};

export enum ChangeType {
  Na = 'NA',
  ProgramChange = 'PROGRAM_CHANGE',
  ArchitechturalDesign = 'ARCHITECHTURAL_DESIGN',
  StructuralDesign = 'STRUCTURAL_DESIGN',
  MepDesign = 'MEP_DESIGN',
  AddRemoveModifyProducts = 'ADD_REMOVE_MODIFY_PRODUCTS',
  ModifyOptionsProgram = 'MODIFY_OPTIONS_PROGRAM',
  NewDesignPackage = 'NEW_DESIGN_PACKAGE',
  UpdateExistingDesignPackage = 'UPDATE_EXISTING_DESIGN_PACKAGE',
  NewExteriorStyle = 'NEW_EXTERIOR_STYLE',
  ImplementationError = 'IMPLEMENTATION_ERROR',
  ProductRefresh = 'PRODUCT_REFRESH'
}

export type ChangeTypeDetail = {
  __typename?: 'ChangeTypeDetail';
  code: ChangeType;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type CheckoutConfigOptionGroupStepDetail = {
  __typename?: 'CheckoutConfigOptionGroupStepDetail';
  code: CheckoutConfigOptionGroupStep;
  name: Scalars['String']['output'];
};

export enum CheckoutConfigStatus {
  Draft = 'DRAFT',
  Reserved = 'RESERVED',
  Expired = 'EXPIRED'
}

export type CheckoutConfigStatusDetail = {
  __typename?: 'CheckoutConfigStatusDetail';
  code: CheckoutConfigStatus;
  name: Scalars['String']['output'];
};

export enum ClientPlatform {
  Web = 'WEB',
  Mobile = 'MOBILE'
}

export type ClientPlatformDetail = {
  __typename?: 'ClientPlatformDetail';
  code: ClientPlatform;
  name: Scalars['String']['output'];
};

export enum CommentStreamVisibility {
  Internal = 'INTERNAL',
  Homeowner = 'HOMEOWNER',
  Trades = 'TRADES'
}

export type CommentStreamVisibilityDetail = {
  __typename?: 'CommentStreamVisibilityDetail';
  code: CommentStreamVisibility;
  name: Scalars['String']['output'];
};

export enum CommitmentStatus {
  Draft = 'DRAFT',
  Uploaded = 'UPLOADED',
  Sent = 'SENT',
  Signed = 'SIGNED',
  Voided = 'VOIDED',
  PartiallySigned = 'PARTIALLY_SIGNED'
}

export type CommitmentStatusDetail = {
  __typename?: 'CommitmentStatusDetail';
  code: CommitmentStatus;
  name: Scalars['String']['output'];
};

export enum CommitmentType {
  PurchaseOrder = 'PURCHASE_ORDER',
  Subcontract = 'SUBCONTRACT'
}

export type CommitmentTypeDetail = {
  __typename?: 'CommitmentTypeDetail';
  code: CommitmentType;
  name: Scalars['String']['output'];
};

export enum CommunicationChannel {
  Email = 'EMAIL',
  Text = 'TEXT'
}

export type CommunicationChannelDetail = {
  __typename?: 'CommunicationChannelDetail';
  code: CommunicationChannel;
  name: Scalars['String']['output'];
};

export enum CommunityType {
  Infill = 'INFILL',
  Suburban = 'SUBURBAN'
}

export type CommunityTypeDetail = {
  __typename?: 'CommunityTypeDetail';
  code: CommunityType;
  name: Scalars['String']['output'];
};

export enum ConstructionType {
  TypeIii = 'TYPE_III',
  TypeIv = 'TYPE_IV',
  TypeV = 'TYPE_V'
}

export type ConstructionTypeDetail = {
  __typename?: 'ConstructionTypeDetail';
  code: ConstructionType;
  name: Scalars['String']['output'];
};

export enum ContractType {
  Fixed = 'FIXED',
  CostPlus = 'COST_PLUS',
  BudgetReallocation = 'BUDGET_REALLOCATION'
}

export type ContractTypeDetail = {
  __typename?: 'ContractTypeDetail';
  code: ContractType;
  name: Scalars['String']['output'];
};

export enum CostClassificationType {
  Soft = 'SOFT',
  Hard = 'HARD'
}

export type CostClassificationTypeDetail = {
  __typename?: 'CostClassificationTypeDetail';
  code: CostClassificationType;
  name: Scalars['String']['output'];
};

export enum CostCodeInvoiceCategory {
  PreCon = 'PRE_CON',
  Foundation = 'FOUNDATION',
  Framing = 'FRAMING',
  Hardscape = 'HARDSCAPE',
  InsulationDrywall = 'INSULATION_DRYWALL',
  InteriorFinishes = 'INTERIOR_FINISHES',
  Roofing = 'ROOFING',
  RoughIn = 'ROUGH_IN',
  Siding = 'SIDING',
  SubstantialCompletion = 'SUBSTANTIAL_COMPLETION',
  ArchitecturePlan = 'ARCHITECTURE_PLAN',
  ArchitectureFee = 'ARCHITECTURE_FEE',
  Exterior = 'EXTERIOR',
  MechanicalSystems = 'MECHANICAL_SYSTEMS',
  GeneralConditions = 'GENERAL_CONDITIONS',
  Contingency = 'CONTINGENCY',
  HoldBack = 'HOLD_BACK',
  Deposit = 'DEPOSIT'
}

export type CostCodeInvoiceCategoryDetail = {
  __typename?: 'CostCodeInvoiceCategoryDetail';
  code: CostCodeInvoiceCategory;
  name: Scalars['String']['output'];
  includeInInvoiceScheduleProration: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum CostConfidence {
  Low = 'LOW',
  High = 'HIGH',
  HardBid = 'HARD_BID'
}

export type CostConfidenceDetail = {
  __typename?: 'CostConfidenceDetail';
  code: CostConfidence;
  name: Scalars['String']['output'];
};

export enum CostSubClassificationType {
  Indirect = 'INDIRECT',
  Direct = 'DIRECT'
}

export type CostSubClassificationTypeDetail = {
  __typename?: 'CostSubClassificationTypeDetail';
  code: CostSubClassificationType;
  name: Scalars['String']['output'];
};

export enum CostType {
  Labor = 'LABOR',
  Materials = 'MATERIALS',
  Subcontractor = 'SUBCONTRACTOR',
  Equipment = 'EQUIPMENT',
  Other = 'OTHER'
}

export type CostTypeDetail = {
  __typename?: 'CostTypeDetail';
  code: CostType;
  name: Scalars['String']['output'];
  tradePartnerName: Scalars['String']['output'];
};

export enum DayOfWeek {
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY'
}

export type DayOfWeekDetail = {
  __typename?: 'DayOfWeekDetail';
  code: DayOfWeek;
  name: Scalars['String']['output'];
  isBusinessDay: Scalars['Boolean']['output'];
};

export enum DesignPackageLocation {
  Interior = 'INTERIOR',
  Exterior = 'EXTERIOR'
}

export type DesignPackageLocationDetail = {
  __typename?: 'DesignPackageLocationDetail';
  code: DesignPackageLocation;
  name: Scalars['String']['output'];
};

export enum DevelopmentCommitmentType {
  Materials = 'MATERIALS',
  Labor = 'LABOR',
  LaborAndMaterials = 'LABOR_AND_MATERIALS'
}

export type DevelopmentCommitmentTypeDetail = {
  __typename?: 'DevelopmentCommitmentTypeDetail';
  code: DevelopmentCommitmentType;
  name: Scalars['String']['output'];
};

export enum DocumentAttachmentPlace {
  PurchaseOrder = 'PURCHASE_ORDER',
  BidContract = 'BID_CONTRACT'
}

export type DocumentAttachmentPlaceDetail = {
  __typename?: 'DocumentAttachmentPlaceDetail';
  code: DocumentAttachmentPlace;
  name: Scalars['String']['output'];
};

export enum DocumentCategory {
  Contractual = 'CONTRACTUAL',
  Permits = 'PERMITS',
  Design = 'DESIGN',
  Procurement = 'PROCUREMENT',
  Accounting = 'ACCOUNTING',
  SalesMarketing = 'SALES_MARKETING',
  Warranty = 'WARRANTY',
  Engineering = 'ENGINEERING',
  General = 'GENERAL',
  LotAcquisition = 'LOT_ACQUISITION',
  Valuation = 'VALUATION',
  Insurance = 'INSURANCE',
  AssetManagement = 'ASSET_MANAGEMENT'
}

export type DocumentCategoryDetail = {
  __typename?: 'DocumentCategoryDetail';
  code: DocumentCategory;
  name: Scalars['String']['output'];
};

export enum DocumentType {
  PreconAgreement = 'PRECON_AGREEMENT',
  ConstructionAgreement = 'CONSTRUCTION_AGREEMENT',
  PurchaseOrder = 'PURCHASE_ORDER',
  Subcontract = 'SUBCONTRACT',
  PreconAgreementChangeOrder = 'PRECON_AGREEMENT_CHANGE_ORDER',
  ConstructionAgreementChangeOrder = 'CONSTRUCTION_AGREEMENT_CHANGE_ORDER',
  PurchaseOrderChangeOrder = 'PURCHASE_ORDER_CHANGE_ORDER',
  SubcontractChangeOrder = 'SUBCONTRACT_CHANGE_ORDER',
  Bill = 'BILL',
  Invoice = 'INVOICE',
  MeetingNote = 'MEETING_NOTE',
  Insurance = 'INSURANCE',
  Sales = 'SALES',
  ArchitectureAndEngineering = 'ARCHITECTURE_AND_ENGINEERING',
  SiteReport = 'SITE_REPORT',
  Correspondence = 'CORRESPONDENCE',
  General = 'GENERAL',
  Permitting = 'PERMITTING',
  ApprovedPlan = 'APPROVED_PLAN',
  Photo = 'PHOTO',
  DesignStudio = 'DESIGN_STUDIO',
  DevelopmentCommitment = 'DEVELOPMENT_COMMITMENT',
  BidContract = 'BID_CONTRACT',
  Expense = 'EXPENSE',
  WorkAuthorization = 'WORK_AUTHORIZATION',
  PriceAgreementChangeOrder = 'PRICE_AGREEMENT_CHANGE_ORDER',
  PriceAgreementBidContractRevision = 'PRICE_AGREEMENT_BID_CONTRACT_REVISION',
  PriceAgreementDevelopmentCommitment = 'PRICE_AGREEMENT_DEVELOPMENT_COMMITMENT',
  PriceAgreementCommitment = 'PRICE_AGREEMENT_COMMITMENT',
  Plan = 'PLAN',
  Drawing = 'DRAWING',
  FinishSchedule = 'FINISH_SCHEDULE',
  BoundarySurveys = 'BOUNDARY_SURVEYS',
  TopoSurveys = 'TOPO_SURVEYS',
  GeotechReportSoilsReport = 'GEOTECH_REPORT_SOILS_REPORT',
  ElevationCertificate = 'ELEVATION_CERTIFICATE',
  MiscellaneousGeneral = 'MISCELLANEOUS_GENERAL',
  Legal = 'LEGAL',
  CertificateOfOccupancy = 'CERTIFICATE_OF_OCCUPANCY',
  FloodInsurancePolicy = 'FLOOD_INSURANCE_POLICY',
  PreBuildAppraisal = 'PRE_BUILD_APPRAISAL',
  PurchaseAgreement = 'PURCHASE_AGREEMENT',
  PurchaseAgreementAmendmentLotAcq = 'PURCHASE_AGREEMENT_AMENDMENT_LOT_ACQ',
  SettlementStatementPreliminary = 'SETTLEMENT_STATEMENT_PRELIMINARY',
  SettlementStatementFinal = 'SETTLEMENT_STATEMENT_FINAL',
  Deed = 'DEED',
  RecordedDeed = 'RECORDED_DEED',
  TitleInsurancePolicy = 'TITLE_INSURANCE_POLICY',
  PropertySurvey = 'PROPERTY_SURVEY',
  EarnestMoneyReceiptLotAcq = 'EARNEST_MONEY_RECEIPT_LOT_ACQ',
  BuildingPermit = 'BUILDING_PERMIT',
  DemoPermit = 'DEMO_PERMIT',
  RetainingWallPermit = 'RETAINING_WALL_PERMIT',
  WaterPermit = 'WATER_PERMIT',
  GradingPermit = 'GRADING_PERMIT',
  PoolPermit = 'POOL_PERMIT',
  Vpo = 'VPO',
  PurchaseAgreementFinal = 'PURCHASE_AGREEMENT_FINAL',
  PurchaseAgreementCounterOffer = 'PURCHASE_AGREEMENT_COUNTER_OFFER',
  PurchaseAgreementAmendmentSales = 'PURCHASE_AGREEMENT_AMENDMENT_SALES',
  PurchaseAgreementAddendum = 'PURCHASE_AGREEMENT_ADDENDUM',
  EarnestMoneyReceiptSales = 'EARNEST_MONEY_RECEIPT_SALES',
  Disclosures = 'DISCLOSURES',
  MiscellaneousSales = 'MISCELLANEOUS_SALES',
  AppraisalPrecon = 'APPRAISAL_PRECON',
  AppraisalPostCoo = 'APPRAISAL_POST_COO',
  InsuranceHazard = 'INSURANCE_HAZARD',
  InsuranceBuildersRisk = 'INSURANCE_BUILDERS_RISK',
  HomeownerOrientation = 'HOMEOWNER_ORIENTATION',
  LienWaiver = 'LIEN_WAIVER',
  ChangeEvent = 'CHANGE_EVENT',
  ThirdPartyInspection = 'THIRD_PARTY_INSPECTION',
  CityInspection = 'CITY_INSPECTION',
  Warranty = 'WARRANTY',
  Rendering = 'RENDERING'
}

export type DocumentTypeDetail = {
  __typename?: 'DocumentTypeDetail';
  code: DocumentType;
  name: Scalars['String']['output'];
  systemControlled: Scalars['Boolean']['output'];
  defaultHomeownerVisible: Scalars['Boolean']['output'];
  boolDefaultHomeownerVisible: Scalars['Boolean']['output'];
};

export enum ErpAccrualType {
  TaskCompletion = 'TASK_COMPLETION',
  TaskAllocationChange = 'TASK_ALLOCATION_CHANGE',
  TaskReversal = 'TASK_REVERSAL',
  PurchaseOrderSigned = 'PURCHASE_ORDER_SIGNED',
  PurchaseOrderVoid = 'PURCHASE_ORDER_VOID',
  ChangeOrderVoid = 'CHANGE_ORDER_VOID',
  ChangeOrderSigned = 'CHANGE_ORDER_SIGNED',
  DepositBillPayment = 'DEPOSIT_BILL_PAYMENT',
  DepositBillPaymentVoid = 'DEPOSIT_BILL_PAYMENT_VOID',
  ApBillApproval = 'AP_BILL_APPROVAL',
  ApBillReversal = 'AP_BILL_REVERSAL',
  OverheadBillApproval = 'OVERHEAD_BILL_APPROVAL',
  OverheadBillReversal = 'OVERHEAD_BILL_REVERSAL',
  EomAccrual = 'EOM_ACCRUAL',
  BillLineItemAllocation = 'BILL_LINE_ITEM_ALLOCATION',
  BillLineItemAllocationReversal = 'BILL_LINE_ITEM_ALLOCATION_REVERSAL',
  EomAccrualReversal = 'EOM_ACCRUAL_REVERSAL',
  ExpenseCostAllocation = 'EXPENSE_COST_ALLOCATION',
  ExpenseCostAllocationReversal = 'EXPENSE_COST_ALLOCATION_REVERSAL'
}

export type ErpAccrualTypeDetail = {
  __typename?: 'ErpAccrualTypeDetail';
  code: ErpAccrualType;
  name: Scalars['String']['output'];
};

export enum ErpRevenueLineItemSourceEvent {
  ContractPriceChange = 'CONTRACT_PRICE_CHANGE',
  ContractPriceChangeVoid = 'CONTRACT_PRICE_CHANGE_VOID',
  DirectExpense = 'DIRECT_EXPENSE',
  DirectExpenseVoid = 'DIRECT_EXPENSE_VOID',
  CostAccrual = 'COST_ACCRUAL',
  InitialBalance = 'INITIAL_BALANCE',
  OverheadBillApproval = 'OVERHEAD_BILL_APPROVAL',
  OverheadBillReversal = 'OVERHEAD_BILL_REVERSAL',
  BudgetChange = 'BUDGET_CHANGE',
  BudgetChangeVoid = 'BUDGET_CHANGE_VOID'
}

export type ErpRevenueLineItemSourceEventDetail = {
  __typename?: 'ErpRevenueLineItemSourceEventDetail';
  code: ErpRevenueLineItemSourceEvent;
  name: Scalars['String']['output'];
};

export enum ErpTransactionGroupEvent {
  TaskCompletion = 'TASK_COMPLETION',
  DepositBill = 'DEPOSIT_BILL',
  ApBillApproval = 'AP_BILL_APPROVAL',
  EomAccrual = 'EOM_ACCRUAL',
  RevenueRecognition = 'REVENUE_RECOGNITION',
  RevenueEomAccrual = 'REVENUE_EOM_ACCRUAL',
  CostAllocation = 'COST_ALLOCATION'
}

export type ErpTransactionGroupEventDetail = {
  __typename?: 'ErpTransactionGroupEventDetail';
  code: ErpTransactionGroupEvent;
  name: Scalars['String']['output'];
};

export enum ErpTransactionGroupStatus {
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Draft = 'DRAFT'
}

export type ErpTransactionGroupStatusDetail = {
  __typename?: 'ErpTransactionGroupStatusDetail';
  code: ErpTransactionGroupStatus;
  name: Scalars['String']['output'];
};

export enum ErpTransactionStatus {
  Pending = 'PENDING',
  Mismatching = 'MISMATCHING',
  Synced = 'SYNCED'
}

export type ErpTransactionStatusDetail = {
  __typename?: 'ErpTransactionStatusDetail';
  code: ErpTransactionStatus;
  name: Scalars['String']['output'];
};

export enum EstimateStatus {
  Draft = 'DRAFT',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type EstimateStatusDetail = {
  __typename?: 'EstimateStatusDetail';
  code: EstimateStatus;
  name: Scalars['String']['output'];
};

export enum EstimateType {
  Preliminary = 'PRELIMINARY',
  Final = 'FINAL'
}

export type EstimateTypeDetail = {
  __typename?: 'EstimateTypeDetail';
  code: EstimateType;
  name: Scalars['String']['output'];
};

export enum FeatureFlagStatus {
  Active = 'ACTIVE',
  Released = 'RELEASED',
  Archived = 'ARCHIVED'
}

export type FeatureFlagStatusDetail = {
  __typename?: 'FeatureFlagStatusDetail';
  code: FeatureFlagStatus;
  name: Scalars['String']['output'];
};

export enum FeatureFlagType {
  TestFeature = 'TEST_FEATURE',
  TradePartnerCommunicationsSms = 'TRADE_PARTNER_COMMUNICATIONS_SMS',
  ChangeRequestMvp = 'CHANGE_REQUEST_MVP',
  DigitalBuildingExperiments = 'DIGITAL_BUILDING_EXPERIMENTS',
  TradePortalAccess = 'TRADE_PORTAL_ACCESS',
  MaterialCatalog = 'MATERIAL_CATALOG',
  DynamicSchedules = 'DYNAMIC_SCHEDULES',
  CostAccruals = 'COST_ACCRUALS',
  ProductConfig = 'PRODUCT_CONFIG',
  MobilePunchlistPolling = 'MOBILE_PUNCHLIST_POLLING',
  DynamicSchedulesTradeComms = 'DYNAMIC_SCHEDULES_TRADE_COMMS',
  RevenueRecognition = 'REVENUE_RECOGNITION',
  MobileProjectGeofence = 'MOBILE_PROJECT_GEOFENCE',
  OptionsCatalogV2 = 'OPTIONS_CATALOG_V2',
  DesignPackagePersonalization = 'DESIGN_PACKAGE_PERSONALIZATION',
  ProductionWarningBanner = 'PRODUCTION_WARNING_BANNER',
  MobileLeaderboard = 'MOBILE_LEADERBOARD',
  MobileScheduleSimDraftMode = 'MOBILE_SCHEDULE_SIM_DRAFT_MODE',
  MobileAiChatbotV2 = 'MOBILE_AI_CHATBOT_V2',
  VideoSightlineAnalysis = 'VIDEO_SIGHTLINE_ANALYSIS',
  MobileIncrementalSync = 'MOBILE_INCREMENTAL_SYNC',
  DesignerModifiedSlots = 'DESIGNER_MODIFIED_SLOTS'
}

export type FeatureFlagTypeDetail = {
  __typename?: 'FeatureFlagTypeDetail';
  code: FeatureFlagType;
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  presentational: Scalars['Boolean']['output'];
};

export enum FloodPlain {
  Fp_0 = 'FP_0',
  Fp_100 = 'FP_100',
  Fp_500 = 'FP_500'
}

export type FloodPlainDetail = {
  __typename?: 'FloodPlainDetail';
  code: FloodPlain;
  name: Scalars['String']['output'];
};

export enum FloodZone {
  FzNone = 'FZ_NONE',
  FzAe = 'FZ_AE',
  FzCoastalA = 'FZ_COASTAL_A',
  FzVe = 'FZ_VE'
}

export type FloodZoneDetail = {
  __typename?: 'FloodZoneDetail';
  code: FloodZone;
  name: Scalars['String']['output'];
};

export enum FoundationType {
  Slab = 'SLAB',
  Elevated = 'ELEVATED',
  Piers = 'PIERS'
}

export type FoundationTypeDetail = {
  __typename?: 'FoundationTypeDetail';
  code: FoundationType;
  name: Scalars['String']['output'];
};

export enum GlobalOptionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  PendingApproval = 'PENDING_APPROVAL'
}

export type GlobalOptionStatusDetail = {
  __typename?: 'GlobalOptionStatusDetail';
  code: GlobalOptionStatus;
  name: Scalars['String']['output'];
};

export enum GlobalOptionTypeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type GlobalOptionTypeStatusDetail = {
  __typename?: 'GlobalOptionTypeStatusDetail';
  code: GlobalOptionTypeStatus;
  name: Scalars['String']['output'];
};

export enum HomeownerSelectionOptionPricingType {
  None = 'NONE',
  Included = 'INCLUDED',
  Downgrade = 'DOWNGRADE',
  Upgrade = 'UPGRADE'
}

export type HomeownerSelectionOptionPricingTypeDetail = {
  __typename?: 'HomeownerSelectionOptionPricingTypeDetail';
  code: HomeownerSelectionOptionPricingType;
  name: Scalars['String']['output'];
};

export enum HomeownerSelectionStatus {
  Declined = 'DECLINED',
  Undecided = 'UNDECIDED',
  Selected = 'SELECTED',
  Finalized = 'FINALIZED'
}

export type HomeownerSelectionStatusDetail = {
  __typename?: 'HomeownerSelectionStatusDetail';
  code: HomeownerSelectionStatus;
  name: Scalars['String']['output'];
};

export enum InboxItemStatus {
  Read = 'READ',
  Unread = 'UNREAD',
  Archived = 'ARCHIVED'
}

export type InboxItemStatusDetail = {
  __typename?: 'InboxItemStatusDetail';
  code: InboxItemStatus;
  name: Scalars['String']['output'];
};

export enum InvoiceDocumentSource {
  Quickbooks = 'QUICKBOOKS',
  Intacct = 'INTACCT',
  Blueprint = 'BLUEPRINT'
}

export type InvoiceDocumentSourceDetail = {
  __typename?: 'InvoiceDocumentSourceDetail';
  code: InvoiceDocumentSource;
  name: Scalars['String']['output'];
};

export enum InvoiceScheduleAmountType {
  Cost = 'COST',
  Margin = 'MARGIN',
  CostAndMargin = 'COST_AND_MARGIN'
}

export type InvoiceScheduleAmountTypeDetail = {
  __typename?: 'InvoiceScheduleAmountTypeDetail';
  code: InvoiceScheduleAmountType;
  name: Scalars['String']['output'];
};

export enum InvoiceScheduleItemFrequency {
  Once = 'ONCE',
  Monthly = 'MONTHLY',
  Dynamic = 'DYNAMIC'
}

export type InvoiceScheduleItemFrequencyDetail = {
  __typename?: 'InvoiceScheduleItemFrequencyDetail';
  code: InvoiceScheduleItemFrequency;
  name: Scalars['String']['output'];
};

export enum InvoiceScheduleTriggerType {
  Date = 'DATE',
  Task = 'TASK',
  Cost = 'COST',
  None = 'NONE',
  EndOfMonth = 'END_OF_MONTH',
  PercentageOfCompletion = 'PERCENTAGE_OF_COMPLETION'
}

export type InvoiceScheduleTriggerTypeDetail = {
  __typename?: 'InvoiceScheduleTriggerTypeDetail';
  code: InvoiceScheduleTriggerType;
  name: Scalars['String']['output'];
};

export enum InvoiceSource {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type InvoiceSourceDetail = {
  __typename?: 'InvoiceSourceDetail';
  code: InvoiceSource;
  name: Scalars['String']['output'];
};

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Requested = 'REQUESTED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Approved = 'APPROVED',
  Paid = 'PAID',
  Rejected = 'REJECTED',
  Void = 'VOID'
}

export type InvoiceStatusDetail = {
  __typename?: 'InvoiceStatusDetail';
  code: InvoiceStatus;
  name: Scalars['String']['output'];
};

export enum InvoiceType {
  PercentageOfCompletion = 'PERCENTAGE_OF_COMPLETION',
  DownPayment = 'DOWN_PAYMENT',
  Standard = 'STANDARD'
}

export type InvoiceTypeDetail = {
  __typename?: 'InvoiceTypeDetail';
  code: InvoiceType;
  name: Scalars['String']['output'];
};

export enum ItemStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ItemStatusDetail = {
  __typename?: 'ItemStatusDetail';
  code: ItemStatus;
  name: Scalars['String']['output'];
};

export enum ItemTemplateItemCostStatus {
  InternalEstimate = 'INTERNAL_ESTIMATE',
  Contracted = 'CONTRACTED',
  NoCostSource = 'NO_COST_SOURCE'
}

export type ItemTemplateItemCostStatusDetail = {
  __typename?: 'ItemTemplateItemCostStatusDetail';
  code: ItemTemplateItemCostStatus;
  name: Scalars['String']['output'];
};

export enum ItemTemplateStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  SystemDraft = 'SYSTEM_DRAFT'
}

export type ItemTemplateStatusDetail = {
  __typename?: 'ItemTemplateStatusDetail';
  code: ItemTemplateStatus;
  name: Scalars['String']['output'];
};

export enum JobLogFlag {
  ChangeOrderDelay = 'CHANGE_ORDER_DELAY',
  ClientDelay = 'CLIENT_DELAY',
  ConsultantDelay = 'CONSULTANT_DELAY',
  DesignDelay = 'DESIGN_DELAY',
  GroundWet = 'GROUND_WET',
  HealthDelay = 'HEALTH_DELAY',
  MaterialsDelay = 'MATERIALS_DELAY',
  QualityControlDelay = 'QUALITY_CONTROL_DELAY',
  TradePartnerDelay = 'TRADE_PARTNER_DELAY',
  WeatherDelay = 'WEATHER_DELAY',
  DeliveryDelay = 'DELIVERY_DELAY',
  InspectionDelay = 'INSPECTION_DELAY',
  InternalDelay = 'INTERNAL_DELAY'
}

export type JobLogFlagDetail = {
  __typename?: 'JobLogFlagDetail';
  code: JobLogFlag;
  name: Scalars['String']['output'];
};

export enum JobLogNoteType {
  Delay = 'DELAY',
  Delivery = 'DELIVERY',
  Incident = 'INCIDENT',
  Injury = 'INJURY',
  Inspection = 'INSPECTION',
  Issue = 'ISSUE',
  Holiday = 'HOLIDAY',
  RequestForInformation = 'REQUEST_FOR_INFORMATION',
  TradePartnerWork = 'TRADE_PARTNER_WORK',
  UpcomingActivity = 'UPCOMING_ACTIVITY',
  Visitor = 'VISITOR',
  Warranty = 'WARRANTY',
  Weather = 'WEATHER',
  Other = 'OTHER',
  ClientCommunication = 'CLIENT_COMMUNICATION',
  Internal = 'INTERNAL',
  PreCon = 'PRE_CON',
  AiSummary = 'AI_SUMMARY'
}

export type JobLogNoteTypeDetail = {
  __typename?: 'JobLogNoteTypeDetail';
  code: JobLogNoteType;
  name: Scalars['String']['output'];
};

export enum LienWaiverCondition {
  Unconditional = 'UNCONDITIONAL',
  Conditional = 'CONDITIONAL'
}

export type LienWaiverConditionDetail = {
  __typename?: 'LienWaiverConditionDetail';
  code: LienWaiverCondition;
  name: Scalars['String']['output'];
};

export enum LienWaiverStatus {
  Draft = 'DRAFT',
  Uploaded = 'UPLOADED',
  Sent = 'SENT',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Signed = 'SIGNED',
  Pending = 'PENDING'
}

export type LienWaiverStatusDetail = {
  __typename?: 'LienWaiverStatusDetail';
  code: LienWaiverStatus;
  name: Scalars['String']['output'];
};

export enum LienWaiverType {
  Progress = 'PROGRESS',
  Final = 'FINAL'
}

export type LienWaiverTypeDetail = {
  __typename?: 'LienWaiverTypeDetail';
  code: LienWaiverType;
  name: Scalars['String']['output'];
};

export enum LocationType {
  Group = 'GROUP',
  Level = 'LEVEL',
  Room = 'ROOM',
  Feature = 'FEATURE',
  Scope = 'SCOPE'
}

export type LocationTypeDetail = {
  __typename?: 'LocationTypeDetail';
  code: LocationType;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum LotSalesStatus {
  NotAvailable = 'NOT_AVAILABLE',
  Available = 'AVAILABLE',
  ModelHome = 'MODEL_HOME',
  Reserved = 'RESERVED',
  Sold = 'SOLD'
}

export type LotSalesStatusDetail = {
  __typename?: 'LotSalesStatusDetail';
  code: LotSalesStatus;
  name: Scalars['String']['output'];
};

export enum LotType {
  Boyl = 'BOYL',
  Bool = 'BOOL',
  Hbl = 'HBL',
  Btr = 'BTR',
  Fee = 'FEE'
}

export type LotTypeDetail = {
  __typename?: 'LotTypeDetail';
  code: LotType;
  name: Scalars['String']['output'];
  clientContract: Scalars['String']['output'];
  clientNoun: Scalars['String']['output'];
  initialBudget: Scalars['String']['output'];
  shortClientNoun: Scalars['String']['output'];
  clientInvoice: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export enum MarkupApplicationMethod {
  PerLineItem = 'PER_LINE_ITEM',
  PerTotalCost = 'PER_TOTAL_COST'
}

export type MarkupApplicationMethodDetail = {
  __typename?: 'MarkupApplicationMethodDetail';
  code: MarkupApplicationMethod;
  name: Scalars['String']['output'];
};

export enum MaterialAttributeDimensionType {
  Number = 'NUMBER',
  Select = 'SELECT',
  Boolean = 'BOOLEAN'
}

export type MaterialAttributeDimensionTypeDetail = {
  __typename?: 'MaterialAttributeDimensionTypeDetail';
  code: MaterialAttributeDimensionType;
  name: Scalars['String']['output'];
};

export enum MaterialAttributeValueType {
  Exact = 'EXACT',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  Between = 'BETWEEN'
}

export type MaterialAttributeValueTypeDetail = {
  __typename?: 'MaterialAttributeValueTypeDetail';
  code: MaterialAttributeValueType;
  name: Scalars['String']['output'];
};

export enum MaterialType {
  Placeholder = 'PLACEHOLDER',
  Product = 'PRODUCT',
  Construction = 'CONSTRUCTION'
}

export type MaterialTypeDetail = {
  __typename?: 'MaterialTypeDetail';
  code: MaterialType;
  name: Scalars['String']['output'];
};

export enum MobileSyncUpdateType {
  Created = 'CREATED',
  Updated = 'UPDATED',
  Deleted = 'DELETED'
}

export type MobileSyncUpdateTypeDetail = {
  __typename?: 'MobileSyncUpdateTypeDetail';
  code: MobileSyncUpdateType;
  name: Scalars['String']['output'];
};

export enum PandaDocRole {
  User = 'USER',
  TradePartner = 'TRADE_PARTNER',
  HeadOfConstruction = 'HEAD_OF_CONSTRUCTION',
  ProjectManager = 'PROJECT_MANAGER',
  HomeboundAuthorizedSignatory = 'HOMEBOUND_AUTHORIZED_SIGNATORY',
  AreaManager = 'AREA_MANAGER',
  LeadEstimator = 'LEAD_ESTIMATOR',
  Homeowner = 'HOMEOWNER',
  Signatory = 'SIGNATORY'
}

export type PandaDocRoleDetail = {
  __typename?: 'PandaDocRoleDetail';
  code: PandaDocRole;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export enum PandaDocStatus {
  Pending = 'PENDING',
  Uploaded = 'UPLOADED',
  Sent = 'SENT',
  Viewed = 'VIEWED',
  WaitingApproval = 'WAITING_APPROVAL',
  Rejected = 'REJECTED',
  Approved = 'APPROVED',
  WaitingPay = 'WAITING_PAY',
  Paid = 'PAID',
  Completed = 'COMPLETED',
  Voided = 'VOIDED',
  Declined = 'DECLINED',
  AwaitingDelete = 'AWAITING_DELETE',
  UploadFailed = 'UPLOAD_FAILED',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Draft = 'DRAFT'
}

export type PandaDocStatusDetail = {
  __typename?: 'PandaDocStatusDetail';
  code: PandaDocStatus;
  name: Scalars['String']['output'];
  externalCode: Scalars['String']['output'];
  externalNumber: Scalars['Int']['output'];
};

export enum PandaDocWorkspace {
  Homebound = 'HOMEBOUND',
  HomeboundFinance = 'HOMEBOUND_FINANCE',
  HomeboundCalifornia = 'HOMEBOUND_CALIFORNIA'
}

export type PandaDocWorkspaceDetail = {
  __typename?: 'PandaDocWorkspaceDetail';
  code: PandaDocWorkspace;
  name: Scalars['String']['output'];
};

export enum PaymentTermDueFrom {
  FromInvoiceBillDate = 'FROM_INVOICE_BILL_DATE',
  OfTheMonthOfInvoiceBillDate = 'OF_THE_MONTH_OF_INVOICE_BILL_DATE',
  OfNextMonthFromInvoiceBillDate = 'OF_NEXT_MONTH_FROM_INVOICE_BILL_DATE',
  Of_2NdMonthFromInvoiceBillDate = 'OF_2ND_MONTH_FROM_INVOICE_BILL_DATE',
  Of_3RdMonthFromInvoiceBillDate = 'OF_3RD_MONTH_FROM_INVOICE_BILL_DATE',
  Of_4ThMonthFromInvoiceBillDate = 'OF_4TH_MONTH_FROM_INVOICE_BILL_DATE',
  Of_5ThMonthFromInvoiceBillDate = 'OF_5TH_MONTH_FROM_INVOICE_BILL_DATE',
  Of_6ThMonthFromInvoiceBillDate = 'OF_6TH_MONTH_FROM_INVOICE_BILL_DATE'
}

export type PaymentTermDueFromDetail = {
  __typename?: 'PaymentTermDueFromDetail';
  code: PaymentTermDueFrom;
  name: Scalars['String']['output'];
};

export enum Permit {
  Zoning = 'ZONING',
  Structural = 'STRUCTURAL',
  Electrical = 'ELECTRICAL',
  Plumbing = 'PLUMBING',
  Hvac = 'HVAC'
}

export type PermitDetail = {
  __typename?: 'PermitDetail';
  code: Permit;
  name: Scalars['String']['output'];
};

export enum ProductAttributeType {
  Finish = 'FINISH',
  Brand = 'BRAND',
  Vendor = 'VENDOR',
  Material = 'MATERIAL',
  Style = 'STYLE',
  Fuel = 'FUEL',
  Market = 'MARKET',
  Status = 'STATUS',
  Unit = 'UNIT',
  DesignPackage = 'DESIGN_PACKAGE',
  DesignPackageItem = 'DESIGN_PACKAGE_ITEM',
  DesignPackageLocation = 'DESIGN_PACKAGE_LOCATION',
  Line = 'LINE'
}

export type ProductAttributeTypeDetail = {
  __typename?: 'ProductAttributeTypeDetail';
  code: ProductAttributeType;
  name: Scalars['String']['output'];
};

export enum ProductDimensionType {
  Width = 'WIDTH',
  Length = 'LENGTH',
  Height = 'HEIGHT',
  MaxHeight = 'MAX_HEIGHT',
  Depth = 'DEPTH',
  Diameter = 'DIAMETER',
  Volume = 'VOLUME',
  Thickness = 'THICKNESS',
  Note = 'NOTE'
}

export type ProductDimensionTypeDetail = {
  __typename?: 'ProductDimensionTypeDetail';
  code: ProductDimensionType;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  abbreviation: Scalars['String']['output'];
};

export enum ProductStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ProductStatusDetail = {
  __typename?: 'ProductStatusDetail';
  code: ProductStatus;
  name: Scalars['String']['output'];
};

export enum ProgramDataBasementConfig {
  No = 'NO',
  PartialUnfinished = 'PARTIAL_UNFINISHED',
  FullFinished = 'FULL_FINISHED',
  FullUnfinished = 'FULL_UNFINISHED',
  WalkoutUnfinished = 'WALKOUT_UNFINISHED',
  WalkoutFinished = 'WALKOUT_FINISHED',
  GardenLevelUnfinished = 'GARDEN_LEVEL_UNFINISHED',
  GardenLevelFinished = 'GARDEN_LEVEL_FINISHED'
}

export type ProgramDataBasementConfigDetail = {
  __typename?: 'ProgramDataBasementConfigDetail';
  code: ProgramDataBasementConfig;
  name: Scalars['String']['output'];
};

export enum ProgramDataGarageConfig {
  FrontLoad = 'FRONT_LOAD',
  AlleyLoad = 'ALLEY_LOAD',
  SideLoad = 'SIDE_LOAD',
  SplitLoad = 'SPLIT_LOAD'
}

export type ProgramDataGarageConfigDetail = {
  __typename?: 'ProgramDataGarageConfigDetail';
  code: ProgramDataGarageConfig;
  name: Scalars['String']['output'];
};

export enum ProgramDataMatchState {
  Matches = 'MATCHES',
  DeviationPendingReview = 'DEVIATION_PENDING_REVIEW',
  DeviationAcknowledged = 'DEVIATION_ACKNOWLEDGED'
}

export type ProgramDataMatchStateDetail = {
  __typename?: 'ProgramDataMatchStateDetail';
  code: ProgramDataMatchState;
  name: Scalars['String']['output'];
};

export enum ProgramDataPrimaryBedroomConfig {
  Up = 'UP',
  Down = 'DOWN'
}

export type ProgramDataPrimaryBedroomConfigDetail = {
  __typename?: 'ProgramDataPrimaryBedroomConfigDetail';
  code: ProgramDataPrimaryBedroomConfig;
  name: Scalars['String']['output'];
};

export enum ProgramDataWindowColor {
  White = 'WHITE',
  Black = 'BLACK'
}

export type ProgramDataWindowColorDetail = {
  __typename?: 'ProgramDataWindowColorDetail';
  code: ProgramDataWindowColor;
  name: Scalars['String']['output'];
};

export enum ProjectCollaboratorRole {
  Homeowner = 'HOMEOWNER',
  Family = 'FAMILY',
  Designer = 'DESIGNER',
  Legal = 'LEGAL',
  Other = 'OTHER'
}

export type ProjectCollaboratorRoleDetail = {
  __typename?: 'ProjectCollaboratorRoleDetail';
  code: ProjectCollaboratorRole;
  name: Scalars['String']['output'];
};

export enum ProjectFeature {
  SelectionsV1 = 'SELECTIONS_V1',
  HopHideFinancials = 'HOP_HIDE_FINANCIALS',
  HopVizWalkthrough = 'HOP_VIZ_WALKTHROUGH',
  BpProjectSettings = 'BP_PROJECT_SETTINGS',
  HideAllHopPricing = 'HIDE_ALL_HOP_PRICING',
  HopPricingMsrpNoHb = 'HOP_PRICING_MSRP_NO_HB',
  HopPricingHbNoMsrp = 'HOP_PRICING_HB_NO_MSRP',
  HopSelectionsIncludedUpgradePricing = 'HOP_SELECTIONS_INCLUDED_UPGRADE_PRICING',
  SchedulesV2 = 'SCHEDULES_V2',
  SchedulesV2Gantt = 'SCHEDULES_V2_GANTT',
  SchedulesCalendar = 'SCHEDULES_CALENDAR',
  InvoiceV2 = 'INVOICE_V2',
  HopHidePreconFinancials = 'HOP_HIDE_PRECON_FINANCIALS',
  DelayFlags = 'DELAY_FLAGS',
  HomeownerNotes = 'HOMEOWNER_NOTES',
  HomeownerJourneyV2 = 'HOMEOWNER_JOURNEY_V2',
  ProductConfigPlan = 'PRODUCT_CONFIG_PLAN',
  ChangeEventSignatures = 'CHANGE_EVENT_SIGNATURES'
}

export type ProjectFeatureDetail = {
  __typename?: 'ProjectFeatureDetail';
  code: ProjectFeature;
  name: Scalars['String']['output'];
};

export enum ProjectReadyPlanConfigOrientation {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type ProjectReadyPlanConfigOrientationDetail = {
  __typename?: 'ProjectReadyPlanConfigOrientationDetail';
  code: ProjectReadyPlanConfigOrientation;
  name: Scalars['String']['output'];
};

export enum ProjectRole {
  HeadOfConstruction = 'HEAD_OF_CONSTRUCTION',
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  ConOpsProjectManager = 'CON_OPS_PROJECT_MANAGER',
  Designer = 'DESIGNER',
  Legal = 'LEGAL',
  AreaManager = 'AREA_MANAGER',
  Accounting = 'ACCOUNTING',
  PurchasingOne = 'PURCHASING_ONE',
  ConstructionCoordinator = 'CONSTRUCTION_COORDINATOR',
  Cx = 'CX',
  DesignLead = 'DESIGN_LEAD',
  HomeboundAuthorizedSignatory = 'HOMEBOUND_AUTHORIZED_SIGNATORY',
  AAndDProgramManager = 'A_AND_D_PROGRAM_MANAGER',
  WarrantyManager = 'WARRANTY_MANAGER',
  Superintendent = 'SUPERINTENDENT',
  PreConProjectManager = 'PRE_CON_PROJECT_MANAGER',
  PreConLead = 'PRE_CON_LEAD',
  PurchasingTwo = 'PURCHASING_TWO',
  HeadOfAccountsPayable = 'HEAD_OF_ACCOUNTS_PAYABLE',
  ApAccountant = 'AP_ACCOUNTANT',
  ArchitectAssociate = 'ARCHITECT_ASSOCIATE',
  MarketLead = 'MARKET_LEAD',
  ArchitectureLead = 'ARCHITECTURE_LEAD',
  OptionsManager = 'OPTIONS_MANAGER',
  AAndDOperations = 'A_AND_D_OPERATIONS',
  GraphicDesigner = 'GRAPHIC_DESIGNER',
  PurchasingManager = 'PURCHASING_MANAGER',
  SalesLead = 'SALES_LEAD',
  RiskManager = 'RISK_MANAGER',
  HeadOfPurchasing = 'HEAD_OF_PURCHASING',
  TransactionCoordinator = 'TRANSACTION_COORDINATOR',
  ConOpsProjectManagerTwo = 'CON_OPS_PROJECT_MANAGER_TWO',
  SuperintendentTwo = 'SUPERINTENDENT_TWO',
  GeneralManager = 'GENERAL_MANAGER',
  UnderwritingLead = 'UNDERWRITING_LEAD',
  AAndDStrategy = 'A_AND_D_STRATEGY',
  NationalNetworkManager = 'NATIONAL_NETWORK_MANAGER',
  ProductOps = 'PRODUCT_OPS',
  LwInvoiceSignatory = 'LW_INVOICE_SIGNATORY',
  LandAcquisitionLead = 'LAND_ACQUISITION_LEAD'
}

export type ProjectRoleDetail = {
  __typename?: 'ProjectRoleDetail';
  code: ProjectRole;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export enum ProjectStageStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT'
}

export type ProjectStageStatusDetail = {
  __typename?: 'ProjectStageStatusDetail';
  code: ProjectStageStatus;
  name: Scalars['String']['output'];
};

export enum ProjectStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Closed = 'CLOSED',
  Hold = 'HOLD',
  UnderWarranty = 'UNDER_WARRANTY'
}

export type ProjectStatusDetail = {
  __typename?: 'ProjectStatusDetail';
  code: ProjectStatus;
  name: Scalars['String']['output'];
};

export enum ProjectUpdateActionType {
  ActivityComplete = 'ACTIVITY_COMPLETE',
  UnitComplete = 'UNIT_COMPLETE',
  DocumentAvailable = 'DOCUMENT_AVAILABLE',
  NewHomeownerNote = 'NEW_HOMEOWNER_NOTE'
}

export type ProjectUpdateActionTypeDetail = {
  __typename?: 'ProjectUpdateActionTypeDetail';
  code: ProjectUpdateActionType;
  name: Scalars['String']['output'];
};

export enum PromotionStatus {
  Requested = 'REQUESTED',
  Denied = 'DENIED',
  Approved = 'APPROVED'
}

export type PromotionStatusDetail = {
  __typename?: 'PromotionStatusDetail';
  code: PromotionStatus;
  name: Scalars['String']['output'];
};

export enum PushNotificationEnvironment {
  Sandbox = 'SANDBOX',
  Production = 'PRODUCTION'
}

export type PushNotificationEnvironmentDetail = {
  __typename?: 'PushNotificationEnvironmentDetail';
  code: PushNotificationEnvironment;
  name: Scalars['String']['output'];
};

export enum PushNotificationPlatform {
  Ios = 'IOS',
  Android = 'ANDROID',
  Web = 'WEB'
}

export type PushNotificationPlatformDetail = {
  __typename?: 'PushNotificationPlatformDetail';
  code: PushNotificationPlatform;
  name: Scalars['String']['output'];
};

export enum ReadyPlanAssetType {
  CoverPhoto = 'COVER_PHOTO',
  Preview = 'PREVIEW',
  FloorPlan = 'FLOOR_PLAN',
  MoodBoard = 'MOOD_BOARD',
  GroundBasementFloorPlan = 'GROUND_BASEMENT_FLOOR_PLAN',
  FirstFloorPlan = 'FIRST_FLOOR_PLAN',
  SecondFloorPlan = 'SECOND_FLOOR_PLAN',
  AduFirstFloorPlan = 'ADU_FIRST_FLOOR_PLAN',
  AduSecondFloorPlan = 'ADU_SECOND_FLOOR_PLAN',
  AduExterior = 'ADU_EXTERIOR',
  AduKitchen = 'ADU_KITCHEN',
  AduLiving = 'ADU_LIVING',
  AduBathroom = 'ADU_BATHROOM',
  AduBedroom = 'ADU_BEDROOM'
}

export type ReadyPlanAssetTypeDetail = {
  __typename?: 'ReadyPlanAssetTypeDetail';
  code: ReadyPlanAssetType;
  name: Scalars['String']['output'];
};

export enum ReadyPlanOptionGroupPersonalizationType {
  SingleProduct = 'SINGLE_PRODUCT',
  LinkedProduct = 'LINKED_PRODUCT',
  Package = 'PACKAGE'
}

export type ReadyPlanOptionGroupPersonalizationTypeDetail = {
  __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail';
  code: ReadyPlanOptionGroupPersonalizationType;
  name: Scalars['String']['output'];
};

export enum ReadyPlanStatus {
  Draft = 'DRAFT',
  Archived = 'ARCHIVED',
  Active = 'ACTIVE'
}

export type ReadyPlanStatusDetail = {
  __typename?: 'ReadyPlanStatusDetail';
  code: ReadyPlanStatus;
  name: Scalars['String']['output'];
};

export enum ReadyPlanType {
  Sfh = 'SFH',
  Adu = 'ADU',
  Mfu = 'MFU'
}

export type ReadyPlanTypeDetail = {
  __typename?: 'ReadyPlanTypeDetail';
  code: ReadyPlanType;
  name: Scalars['String']['output'];
};

export enum ScheduleFlagReasonType {
  Client = 'CLIENT',
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  Permitting = 'PERMITTING',
  Field = 'FIELD',
  Inspection = 'INSPECTION',
  MaterialSupply = 'MATERIAL_SUPPLY',
  Other = 'OTHER',
  TradePartner = 'TRADE_PARTNER',
  Weather = 'WEATHER'
}

export type ScheduleFlagReasonTypeDetail = {
  __typename?: 'ScheduleFlagReasonTypeDetail';
  code: ScheduleFlagReasonType;
  name: Scalars['String']['output'];
};

export enum ScheduleStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT'
}

export type ScheduleStatusDetail = {
  __typename?: 'ScheduleStatusDetail';
  code: ScheduleStatus;
  name: Scalars['String']['output'];
};

export enum ScheduleTemplateStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED'
}

export type ScheduleTemplateStatusDetail = {
  __typename?: 'ScheduleTemplateStatusDetail';
  code: ScheduleTemplateStatus;
  name: Scalars['String']['output'];
};

export enum ScopeChangeType {
  None = 'NONE',
  Add = 'ADD',
  Replace = 'REPLACE',
  Minor = 'MINOR',
  Major = 'MAJOR',
  Removed = 'REMOVED',
  System = 'SYSTEM'
}

export type ScopeChangeTypeDetail = {
  __typename?: 'ScopeChangeTypeDetail';
  code: ScopeChangeType;
  name: Scalars['String']['output'];
};

export enum ScopeMode {
  None = 'NONE',
  ReleaseToTrades = 'RELEASE_TO_TRADES',
  Full = 'FULL',
  BudgetSafe = 'BUDGET_SAFE'
}

export type ScopeModeDetail = {
  __typename?: 'ScopeModeDetail';
  code: ScopeMode;
  name: Scalars['String']['output'];
};

export enum SelectionCutoff {
  Cutoff_1 = 'CUTOFF_1',
  Cutoff_2A = 'CUTOFF_2A',
  Cutoff_2B = 'CUTOFF_2B',
  Cutoff_3 = 'CUTOFF_3'
}

export type SelectionCutoffDetail = {
  __typename?: 'SelectionCutoffDetail';
  code: SelectionCutoff;
  name: Scalars['String']['output'];
};

export enum SelectionPricingMode {
  None = 'NONE',
  MsrpOnly = 'MSRP_ONLY',
  HbPriceOnly = 'HB_PRICE_ONLY',
  MsrpAndHbPricing = 'MSRP_AND_HB_PRICING',
  PriceDelta = 'PRICE_DELTA'
}

export type SelectionPricingModeDetail = {
  __typename?: 'SelectionPricingModeDetail';
  code: SelectionPricingMode;
  name: Scalars['String']['output'];
};

export enum Stage {
  PreConPlanning = 'PRE_CON_PLANNING',
  PreConExecution = 'PRE_CON_EXECUTION',
  Construction = 'CONSTRUCTION',
  Development = 'DEVELOPMENT'
}

export type StageDetail = {
  __typename?: 'StageDetail';
  code: Stage;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  forDevelopment: Scalars['Boolean']['output'];
  forProject: Scalars['Boolean']['output'];
  isDeprecated: Scalars['Boolean']['output'];
};

export enum SuburbanAssetCategory {
  Inventory = 'INVENTORY',
  ModelHome = 'MODEL_HOME',
  BuildToOrder = 'BUILD_TO_ORDER'
}

export type SuburbanAssetCategoryDetail = {
  __typename?: 'SuburbanAssetCategoryDetail';
  code: SuburbanAssetCategory;
  name: Scalars['String']['output'];
};

export enum SystemChangeRequestAsset {
  PandaDoc = 'PANDA_DOC',
  UpdateClientAndContract = 'UPDATE_CLIENT_AND_CONTRACT',
  ChangeEvent = 'CHANGE_EVENT'
}

export type SystemChangeRequestAssetDetail = {
  __typename?: 'SystemChangeRequestAssetDetail';
  code: SystemChangeRequestAsset;
  name: Scalars['String']['output'];
};

export enum SystemPlanMilestone {
  MobilizationStart = 'MOBILIZATION_START',
  VerticalComplete = 'VERTICAL_COMPLETE',
  PreMobilizationComplete = 'PRE_MOBILIZATION_COMPLETE',
  CustomerContractSigned = 'CUSTOMER_CONTRACT_SIGNED',
  BuildingPermitIssued = 'BUILDING_PERMIT_ISSUED',
  FinalPunchOut = 'FINAL_PUNCH_OUT',
  MobilizationComplete = 'MOBILIZATION_COMPLETE',
  DeliveryComplete = 'DELIVERY_COMPLETE',
  BuildingPermitSubmitted = 'BUILDING_PERMIT_SUBMITTED'
}

export type SystemPlanMilestoneDetail = {
  __typename?: 'SystemPlanMilestoneDetail';
  code: SystemPlanMilestone;
  name: Scalars['String']['output'];
};

export enum SystemTask {
  ConstructionRts = 'CONSTRUCTION_RTS',
  FramingComplete = 'FRAMING_COMPLETE',
  DrywallComplete = 'DRYWALL_COMPLETE',
  DeliveryComplete = 'DELIVERY_COMPLETE',
  VerticalComplete = 'VERTICAL_COMPLETE',
  Acquired = 'ACQUIRED',
  PermitSubmitted = 'PERMIT_SUBMITTED',
  PermitReceived = 'PERMIT_RECEIVED',
  MlsDate = 'MLS_DATE',
  SalesReady = 'SALES_READY',
  BuyerWalkthrough = 'BUYER_WALKTHROUGH',
  PunchList = 'PUNCH_LIST'
}

export type SystemTaskDetail = {
  __typename?: 'SystemTaskDetail';
  code: SystemTask;
  name: Scalars['String']['output'];
};

export enum TakeoffLineItemDesignPackageType {
  RegularPlaceholder = 'REGULAR_PLACEHOLDER',
  RegularProductCard = 'REGULAR_PRODUCT_CARD',
  IdpShadowPlaceholder = 'IDP_SHADOW_PLACEHOLDER',
  IdpShadowProductCard = 'IDP_SHADOW_PRODUCT_CARD',
  RpoShadowPlaceholder = 'RPO_SHADOW_PLACEHOLDER',
  RpoShadowProductCard = 'RPO_SHADOW_PRODUCT_CARD'
}

export type TakeoffLineItemDesignPackageTypeDetail = {
  __typename?: 'TakeoffLineItemDesignPackageTypeDetail';
  code: TakeoffLineItemDesignPackageType;
  name: Scalars['String']['output'];
};

export enum TakeoffLineItemType {
  Iti = 'ITI',
  Tliv = 'TLIV'
}

export type TakeoffLineItemTypeDetail = {
  __typename?: 'TakeoffLineItemTypeDetail';
  code: TakeoffLineItemType;
  name: Scalars['String']['output'];
};

export enum TaskDeadlineType {
  Cutoff = 'CUTOFF',
  KeyMilestone = 'KEY_MILESTONE'
}

export type TaskDeadlineTypeDetail = {
  __typename?: 'TaskDeadlineTypeDetail';
  code: TaskDeadlineType;
  name: Scalars['String']['output'];
};

export enum TaskDependencyType {
  FinishStart = 'FINISH_START',
  StartStart = 'START_START',
  StartFinish = 'START_FINISH',
  FinishFinish = 'FINISH_FINISH'
}

export type TaskDependencyTypeDetail = {
  __typename?: 'TaskDependencyTypeDetail';
  code: TaskDependencyType;
  name: Scalars['String']['output'];
  shorthand: Scalars['String']['output'];
};

export enum TaskStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE',
  OnHold = 'ON_HOLD',
  Delayed = 'DELAYED'
}

export type TaskStatusDetail = {
  __typename?: 'TaskStatusDetail';
  code: TaskStatus;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum TaskType {
  ScheduleTask = 'SCHEDULE_TASK',
  PlanTask = 'PLAN_TASK'
}

export type TaskTypeDetail = {
  __typename?: 'TaskTypeDetail';
  code: TaskType;
  name: Scalars['String']['output'];
};

export enum TimeFrequency {
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS'
}

export type TimeFrequencyDetail = {
  __typename?: 'TimeFrequencyDetail';
  code: TimeFrequency;
  name: Scalars['String']['output'];
};

export enum TimeOfDay {
  Morning = 'MORNING',
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING'
}

export type TimeOfDayDetail = {
  __typename?: 'TimeOfDayDetail';
  code: TimeOfDay;
  name: Scalars['String']['output'];
};

export enum ToDoStatus {
  Backlog = 'BACKLOG',
  UpNext = 'UP_NEXT',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export type ToDoStatusDetail = {
  __typename?: 'ToDoStatusDetail';
  code: ToDoStatus;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum ToDoType {
  Submittals = 'SUBMITTALS',
  JobList = 'JOB_LIST',
  SkAsi = 'SK_ASI',
  RfiQuestions = 'RFI_QUESTIONS',
  MeetingNotes = 'MEETING_NOTES',
  Purchasing = 'PURCHASING',
  Design = 'DESIGN',
  Reviews = 'REVIEWS',
  Finance = 'FINANCE',
  General = 'GENERAL',
  ProductOps = 'PRODUCT_OPS',
  PunchList = 'PUNCH_LIST',
  Warranty = 'WARRANTY',
  Inspection = 'INSPECTION',
  Delivery = 'DELIVERY',
  ProductFeedback = 'PRODUCT_FEEDBACK',
  ScheduleReview = 'SCHEDULE_REVIEW'
}

export type ToDoTypeDetail = {
  __typename?: 'ToDoTypeDetail';
  code: ToDoType;
  name: Scalars['String']['output'];
};

export enum TrackedJobStatus {
  Pending = 'PENDING',
  Running = 'RUNNING',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type TrackedJobStatusDetail = {
  __typename?: 'TrackedJobStatusDetail';
  code: TrackedJobStatus;
  name: Scalars['String']['output'];
};

export enum TradePartnerAvailabilityRequestStatus {
  Waiting = 'WAITING',
  RescheduleNeeded = 'RESCHEDULE_NEEDED',
  Confirmed = 'CONFIRMED',
  Canceled = 'CANCELED'
}

export type TradePartnerAvailabilityRequestStatusDetail = {
  __typename?: 'TradePartnerAvailabilityRequestStatusDetail';
  code: TradePartnerAvailabilityRequestStatus;
  name: Scalars['String']['output'];
};

export enum TradePartnerMarketRole {
  BillApprover = 'BILL_APPROVER',
  ContractSignatory = 'CONTRACT_SIGNATORY',
  PoSignatory = 'PO_SIGNATORY',
  PoRecipient_1 = 'PO_RECIPIENT_1',
  PoRecipient_2 = 'PO_RECIPIENT_2',
  Estimating = 'ESTIMATING',
  Scheduling = 'SCHEDULING',
  LwSignatory = 'LW_SIGNATORY',
  SchedulingRecipient_2 = 'SCHEDULING_RECIPIENT_2'
}

export type TradePartnerMarketRoleDetail = {
  __typename?: 'TradePartnerMarketRoleDetail';
  code: TradePartnerMarketRole;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export enum TradePartnerOnboardingStatus {
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE',
  DoNotUse = 'DO_NOT_USE',
  Inactive = 'INACTIVE'
}

export type TradePartnerOnboardingStatusDetail = {
  __typename?: 'TradePartnerOnboardingStatusDetail';
  code: TradePartnerOnboardingStatus;
  name: Scalars['String']['output'];
};

export enum TradePartnerRequirementStatus {
  Meets = 'MEETS',
  DoesNotMeet = 'DOES_NOT_MEET',
  Na = 'NA',
  Waiver = 'WAIVER'
}

export type TradePartnerRequirementStatusDetail = {
  __typename?: 'TradePartnerRequirementStatusDetail';
  code: TradePartnerRequirementStatus;
  name: Scalars['String']['output'];
};

export enum TradePartnerRequirementType {
  W9 = 'W9',
  WorkersComp = 'WORKERS_COMP',
  Msa = 'MSA',
  GeneralLiability = 'GENERAL_LIABILITY',
  ProfessionalLiability = 'PROFESSIONAL_LIABILITY',
  IndustryLicense = 'INDUSTRY_LICENSE',
  AutomobileLiability = 'AUTOMOBILE_LIABILITY',
  UmbrellaLiability = 'UMBRELLA_LIABILITY',
  TradeSpecificAgreement = 'TRADE_SPECIFIC_AGREEMENT',
  Appliances = 'APPLIANCES',
  CabinetsAndCabinetHardware = 'CABINETS_AND_CABINET_HARDWARE',
  CmuWalls = 'CMU_WALLS',
  Concrete = 'CONCRETE',
  Countertops = 'COUNTERTOPS',
  Drywall = 'DRYWALL',
  Electrical = 'ELECTRICAL',
  ExteriorSheatingFinishWindowsExtDoorsWaterproofing = 'EXTERIOR_SHEATING_FINISH_WINDOWS_EXT_DOORS_WATERPROOFING',
  FencesAndGates = 'FENCES_AND_GATES',
  FireplaceInstall = 'FIREPLACE_INSTALL',
  FireSupression = 'FIRE_SUPRESSION',
  FlooringAndWallSurfaces = 'FLOORING_AND_WALL_SURFACES',
  Framing = 'FRAMING',
  GarageDoors = 'GARAGE_DOORS',
  GeneralConditions = 'GENERAL_CONDITIONS',
  Gutters = 'GUTTERS',
  Hvac = 'HVAC',
  Insulation = 'INSULATION',
  InteriorMillworkDoorsHardware = 'INTERIOR_MILLWORK_DOORS_HARDWARE',
  LowVoltage = 'LOW_VOLTAGE',
  MasonryWallCladding = 'MASONRY_WALL_CLADDING',
  MirrorAndShowerEclosures = 'MIRROR_AND_SHOWER_ECLOSURES',
  Paint = 'PAINT',
  PlantingAndIrrigation = 'PLANTING_AND_IRRIGATION',
  Plumbing = 'PLUMBING',
  ProgressinveCleanup = 'PROGRESSINVE_CLEANUP',
  Roofing = 'ROOFING',
  Sitework = 'SITEWORK',
  SolarPanels = 'SOLAR_PANELS',
  StairRailings = 'STAIR_RAILINGS',
  StuccoAndThinVenner = 'STUCCO_AND_THIN_VENNER',
  SwppAndErosionControl = 'SWPP_AND_EROSION_CONTROL',
  Termite = 'TERMITE',
  WasteRemoval = 'WASTE_REMOVAL'
}

export type TradePartnerRequirementTypeDetail = {
  __typename?: 'TradePartnerRequirementTypeDetail';
  code: TradePartnerRequirementType;
  name: Scalars['String']['output'];
  hasExpirationDate: Scalars['Boolean']['output'];
  hasCoverageAmount: Scalars['Boolean']['output'];
  hasLicenseNumber: Scalars['Boolean']['output'];
  hasSignedDate: Scalars['Boolean']['output'];
  isTsa: Scalars['Boolean']['output'];
};

export enum TradePartnerTaskStatus {
  NeedsConfirmation = 'NEEDS_CONFIRMATION',
  Confirmed = 'CONFIRMED',
  Unavailable = 'UNAVAILABLE',
  CompletedJob = 'COMPLETED_JOB',
  NeedsReconfirmation = 'NEEDS_RECONFIRMATION',
  NotSent = 'NOT_SENT'
}

export type TradePartnerTaskStatusDetail = {
  __typename?: 'TradePartnerTaskStatusDetail';
  code: TradePartnerTaskStatus;
  name: Scalars['String']['output'];
};

export enum UserEventType {
  Created = 'CREATED',
  Updated = 'UPDATED',
  Assigned = 'ASSIGNED',
  ScheduleChange = 'SCHEDULE_CHANGE',
  Completed = 'COMPLETED',
  Tagged = 'TAGGED',
  Finalized = 'FINALIZED',
  Approved = 'APPROVED',
  Commented = 'COMMENTED',
  Attached = 'ATTACHED',
  ProjectCohortChange = 'PROJECT_COHORT_CHANGE',
  LotRelease = 'LOT_RELEASE',
  PrpcApplied = 'PRPC_APPLIED',
  PrpcReset = 'PRPC_RESET',
  Flagged = 'FLAGGED',
  RequestedChanges = 'REQUESTED_CHANGES',
  Rejected = 'REJECTED',
  ItemAdded = 'ITEM_ADDED',
  ItemRemoved = 'ITEM_REMOVED',
  Published = 'PUBLISHED'
}

export type UserEventTypeDetail = {
  __typename?: 'UserEventTypeDetail';
  code: UserEventType;
  name: Scalars['String']['output'];
  allowedEntities: Scalars['String']['output'];
};

export enum UserType {
  Anonymous = 'ANONYMOUS',
  System = 'SYSTEM',
  Internal = 'INTERNAL',
  Homeowner = 'HOMEOWNER',
  TradePartner = 'TRADE_PARTNER'
}

export type UserTypeDetail = {
  __typename?: 'UserTypeDetail';
  code: UserType;
  name: Scalars['String']['output'];
};

export enum WarrantyTicketItemStatus {
  Submitted = 'SUBMITTED',
  Rejected = 'REJECTED',
  Accepted = 'ACCEPTED',
  OnHold = 'ON_HOLD',
  Scheduled = 'SCHEDULED',
  Completed = 'COMPLETED',
  MaterialsOrdered = 'MATERIALS_ORDERED',
  InProgress = 'IN_PROGRESS',
  TradeContacted = 'TRADE_CONTACTED',
  PendingInfoFromHomeowner = 'PENDING_INFO_FROM_HOMEOWNER'
}

export type WarrantyTicketItemStatusDetail = {
  __typename?: 'WarrantyTicketItemStatusDetail';
  code: WarrantyTicketItemStatus;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum WarrantyTicketItemType {
  Mechanical = 'MECHANICAL',
  Electrical = 'ELECTRICAL',
  Plumbing = 'PLUMBING',
  MiscInterior = 'MISC_INTERIOR',
  MiscExterior = 'MISC_EXTERIOR'
}

export type WarrantyTicketItemTypeDetail = {
  __typename?: 'WarrantyTicketItemTypeDetail';
  code: WarrantyTicketItemType;
  name: Scalars['String']['output'];
};

export enum WarrantyTicketStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Closed = 'CLOSED'
}

export type WarrantyTicketStatusDetail = {
  __typename?: 'WarrantyTicketStatusDetail';
  code: WarrantyTicketStatus;
  name: Scalars['String']['output'];
};

export enum WarrantyTicketType {
  ItemsOfContinuance = 'ITEMS_OF_CONTINUANCE',
  ThirtyDay = 'THIRTY_DAY',
  OneYear = 'ONE_YEAR',
  TwoYear = 'TWO_YEAR',
  TenYear = 'TEN_YEAR'
}

export type WarrantyTicketTypeDetail = {
  __typename?: 'WarrantyTicketTypeDetail';
  code: WarrantyTicketType;
  name: Scalars['String']['output'];
};

export enum WeatherType {
  ClearDay = 'CLEAR_DAY',
  PartlyCloudyDay = 'PARTLY_CLOUDY_DAY',
  Cloudy = 'CLOUDY',
  Wind = 'WIND',
  Fog = 'FOG',
  ShowersDay = 'SHOWERS_DAY',
  Rain = 'RAIN',
  ThunderShowersDay = 'THUNDER_SHOWERS_DAY',
  ThunderDay = 'THUNDER_DAY',
  SnowShowersDay = 'SNOW_SHOWERS_DAY',
  Snow = 'SNOW',
  Sleet = 'SLEET',
  Hail = 'HAIL',
  Haze = 'HAZE',
  Ice = 'ICE',
  Smoke = 'SMOKE',
  Dust = 'DUST'
}

export type WeatherTypeDetail = {
  __typename?: 'WeatherTypeDetail';
  code: WeatherType;
  name: Scalars['String']['output'];
};

export type AllEnumDetails = {
  __typename?: 'AllEnumDetails';
  activityPlanningState: Array<ActivityPlanningStateDetail>;
  activityResponsibility: Array<ActivityResponsibilityDetail>;
  activityType: Array<ActivityTypeDetail>;
  aggregateVersionStatus: Array<AggregateVersionStatusDetail>;
  allocationStrategy: Array<AllocationStrategyDetail>;
  approvalStatus: Array<ApprovalStatusDetail>;
  approverStatus: Array<ApproverStatusDetail>;
  bidContractRevisionStatus: Array<BidContractRevisionStatusDetail>;
  bidContractType: Array<BidContractTypeDetail>;
  bidPackageStatus: Array<BidPackageStatusDetail>;
  bidScopeSource: Array<BidScopeSourceDetail>;
  billGmailAttachmentResult: Array<BillGmailAttachmentResultDetail>;
  billGmailMessageResult: Array<BillGmailMessageResultDetail>;
  billReviewReason: Array<BillReviewReasonDetail>;
  billSource: Array<BillSourceDetail>;
  billStatus: Array<BillStatusDetail>;
  billType: Array<BillTypeDetail>;
  businessFunctionType: Array<BusinessFunctionTypeDetail>;
  buyoutStatus: Array<BuyoutStatusDetail>;
  changeEventBudgetPhase: Array<ChangeEventBudgetPhaseDetail>;
  changeEventLineItemType: Array<ChangeEventLineItemTypeDetail>;
  changeEventStatus: Array<ChangeEventStatusDetail>;
  changeEventType: Array<ChangeEventTypeDetail>;
  changeRequestAssetPlatform: Array<ChangeRequestAssetPlatformDetail>;
  changeRequestAssetScope: Array<ChangeRequestAssetScopeDetail>;
  changeRequestPriority: Array<ChangeRequestPriorityDetail>;
  changeRequestSource: Array<ChangeRequestSourceDetail>;
  changeRequestStatus: Array<ChangeRequestStatusDetail>;
  changeRequestToDoType: Array<ChangeRequestToDoTypeDetail>;
  changeType: Array<ChangeTypeDetail>;
  checkoutConfigOptionGroupStep: Array<CheckoutConfigOptionGroupStepDetail>;
  checkoutConfigStatus: Array<CheckoutConfigStatusDetail>;
  clientPlatform: Array<ClientPlatformDetail>;
  commentStreamVisibility: Array<CommentStreamVisibilityDetail>;
  commitmentStatus: Array<CommitmentStatusDetail>;
  commitmentType: Array<CommitmentTypeDetail>;
  communicationChannel: Array<CommunicationChannelDetail>;
  communityType: Array<CommunityTypeDetail>;
  constructionType: Array<ConstructionTypeDetail>;
  contractType: Array<ContractTypeDetail>;
  costClassificationType: Array<CostClassificationTypeDetail>;
  costCodeInvoiceCategory: Array<CostCodeInvoiceCategoryDetail>;
  costConfidence: Array<CostConfidenceDetail>;
  costSubClassificationType: Array<CostSubClassificationTypeDetail>;
  costType: Array<CostTypeDetail>;
  dayOfWeek: Array<DayOfWeekDetail>;
  designPackageLocation: Array<DesignPackageLocationDetail>;
  developmentCommitmentType: Array<DevelopmentCommitmentTypeDetail>;
  documentAttachmentPlace: Array<DocumentAttachmentPlaceDetail>;
  documentCategory: Array<DocumentCategoryDetail>;
  documentType: Array<DocumentTypeDetail>;
  erpAccrualType: Array<ErpAccrualTypeDetail>;
  erpRevenueLineItemSourceEvent: Array<ErpRevenueLineItemSourceEventDetail>;
  erpTransactionGroupEvent: Array<ErpTransactionGroupEventDetail>;
  erpTransactionGroupStatus: Array<ErpTransactionGroupStatusDetail>;
  erpTransactionStatus: Array<ErpTransactionStatusDetail>;
  estimateStatus: Array<EstimateStatusDetail>;
  estimateType: Array<EstimateTypeDetail>;
  featureFlagStatus: Array<FeatureFlagStatusDetail>;
  featureFlagType: Array<FeatureFlagTypeDetail>;
  floodPlain: Array<FloodPlainDetail>;
  floodZone: Array<FloodZoneDetail>;
  foundationType: Array<FoundationTypeDetail>;
  globalOptionStatus: Array<GlobalOptionStatusDetail>;
  globalOptionTypeStatus: Array<GlobalOptionTypeStatusDetail>;
  homeownerSelectionOptionPricingType: Array<HomeownerSelectionOptionPricingTypeDetail>;
  homeownerSelectionStatus: Array<HomeownerSelectionStatusDetail>;
  inboxItemStatus: Array<InboxItemStatusDetail>;
  invoiceDocumentSource: Array<InvoiceDocumentSourceDetail>;
  invoiceScheduleAmountType: Array<InvoiceScheduleAmountTypeDetail>;
  invoiceScheduleItemFrequency: Array<InvoiceScheduleItemFrequencyDetail>;
  invoiceScheduleTriggerType: Array<InvoiceScheduleTriggerTypeDetail>;
  invoiceSource: Array<InvoiceSourceDetail>;
  invoiceStatus: Array<InvoiceStatusDetail>;
  invoiceType: Array<InvoiceTypeDetail>;
  itemStatus: Array<ItemStatusDetail>;
  itemTemplateItemCostStatus: Array<ItemTemplateItemCostStatusDetail>;
  itemTemplateStatus: Array<ItemTemplateStatusDetail>;
  jobLogFlag: Array<JobLogFlagDetail>;
  jobLogNoteType: Array<JobLogNoteTypeDetail>;
  lienWaiverCondition: Array<LienWaiverConditionDetail>;
  lienWaiverStatus: Array<LienWaiverStatusDetail>;
  lienWaiverType: Array<LienWaiverTypeDetail>;
  locationType: Array<LocationTypeDetail>;
  lotSalesStatus: Array<LotSalesStatusDetail>;
  lotType: Array<LotTypeDetail>;
  markupApplicationMethod: Array<MarkupApplicationMethodDetail>;
  materialAttributeDimensionType: Array<MaterialAttributeDimensionTypeDetail>;
  materialAttributeValueType: Array<MaterialAttributeValueTypeDetail>;
  materialType: Array<MaterialTypeDetail>;
  mobileSyncUpdateType: Array<MobileSyncUpdateTypeDetail>;
  pandaDocRole: Array<PandaDocRoleDetail>;
  pandaDocStatus: Array<PandaDocStatusDetail>;
  pandaDocWorkspace: Array<PandaDocWorkspaceDetail>;
  paymentTermDueFrom: Array<PaymentTermDueFromDetail>;
  permit: Array<PermitDetail>;
  productAttributeType: Array<ProductAttributeTypeDetail>;
  productDimensionType: Array<ProductDimensionTypeDetail>;
  productStatus: Array<ProductStatusDetail>;
  programDataBasementConfig: Array<ProgramDataBasementConfigDetail>;
  programDataGarageConfig: Array<ProgramDataGarageConfigDetail>;
  programDataMatchState: Array<ProgramDataMatchStateDetail>;
  programDataPrimaryBedroomConfig: Array<ProgramDataPrimaryBedroomConfigDetail>;
  programDataWindowColor: Array<ProgramDataWindowColorDetail>;
  projectCollaboratorRole: Array<ProjectCollaboratorRoleDetail>;
  projectFeature: Array<ProjectFeatureDetail>;
  projectReadyPlanConfigOrientation: Array<ProjectReadyPlanConfigOrientationDetail>;
  projectRole: Array<ProjectRoleDetail>;
  projectStageStatus: Array<ProjectStageStatusDetail>;
  projectStatus: Array<ProjectStatusDetail>;
  projectUpdateActionType: Array<ProjectUpdateActionTypeDetail>;
  promotionStatus: Array<PromotionStatusDetail>;
  pushNotificationEnvironment: Array<PushNotificationEnvironmentDetail>;
  pushNotificationPlatform: Array<PushNotificationPlatformDetail>;
  readyPlanAssetType: Array<ReadyPlanAssetTypeDetail>;
  readyPlanOptionGroupPersonalizationType: Array<ReadyPlanOptionGroupPersonalizationTypeDetail>;
  readyPlanStatus: Array<ReadyPlanStatusDetail>;
  readyPlanType: Array<ReadyPlanTypeDetail>;
  scheduleFlagReasonType: Array<ScheduleFlagReasonTypeDetail>;
  scheduleStatus: Array<ScheduleStatusDetail>;
  scheduleTemplateStatus: Array<ScheduleTemplateStatusDetail>;
  scopeChangeType: Array<ScopeChangeTypeDetail>;
  scopeMode: Array<ScopeModeDetail>;
  selectionCutoff: Array<SelectionCutoffDetail>;
  selectionPricingMode: Array<SelectionPricingModeDetail>;
  stage: Array<StageDetail>;
  suburbanAssetCategory: Array<SuburbanAssetCategoryDetail>;
  systemChangeRequestAsset: Array<SystemChangeRequestAssetDetail>;
  systemPlanMilestone: Array<SystemPlanMilestoneDetail>;
  systemTask: Array<SystemTaskDetail>;
  takeoffLineItemDesignPackageType: Array<TakeoffLineItemDesignPackageTypeDetail>;
  takeoffLineItemType: Array<TakeoffLineItemTypeDetail>;
  taskDeadlineType: Array<TaskDeadlineTypeDetail>;
  taskDependencyType: Array<TaskDependencyTypeDetail>;
  taskStatus: Array<TaskStatusDetail>;
  taskType: Array<TaskTypeDetail>;
  timeFrequency: Array<TimeFrequencyDetail>;
  timeOfDay: Array<TimeOfDayDetail>;
  toDoStatus: Array<ToDoStatusDetail>;
  toDoType: Array<ToDoTypeDetail>;
  trackedJobStatus: Array<TrackedJobStatusDetail>;
  tradePartnerAvailabilityRequestStatus: Array<TradePartnerAvailabilityRequestStatusDetail>;
  tradePartnerMarketRole: Array<TradePartnerMarketRoleDetail>;
  tradePartnerOnboardingStatus: Array<TradePartnerOnboardingStatusDetail>;
  tradePartnerRequirementStatus: Array<TradePartnerRequirementStatusDetail>;
  tradePartnerRequirementType: Array<TradePartnerRequirementTypeDetail>;
  tradePartnerTaskStatus: Array<TradePartnerTaskStatusDetail>;
  userEventType: Array<UserEventTypeDetail>;
  userType: Array<UserTypeDetail>;
  warrantyTicketItemStatus: Array<WarrantyTicketItemStatusDetail>;
  warrantyTicketItemType: Array<WarrantyTicketItemTypeDetail>;
  warrantyTicketStatus: Array<WarrantyTicketStatusDetail>;
  warrantyTicketType: Array<WarrantyTicketTypeDetail>;
  weatherType: Array<WeatherTypeDetail>;
};

export type IdentifyProjectAccrualAdjustmentsInput = {
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum CostAccrualAdjustmentType {
  TaskWithOverbilled = 'TASK_WITH_OVERBILLED',
  TaskCompleteWithUnbilled = 'TASK_COMPLETE_WITH_UNBILLED',
  UnallocatedWithUnbilled = 'UNALLOCATED_WITH_UNBILLED'
}

export type IdentifyProjectAccrualAdjustmentsResult = {
  __typename?: 'IdentifyProjectAccrualAdjustmentsResult';
  type: CostAccrualAdjustmentType;
  commitmentLineItem: CommitmentLineItem;
  commitmentLikeReference: Scalars['String']['output'];
  adjustInCents: Scalars['Int']['output'];
  intacctVendorId: Scalars['String']['output'];
  intacctGLAccountNo: Scalars['String']['output'];
  intacctProjectId: Scalars['String']['output'];
  intacctItemId: Scalars['String']['output'];
  intacctCustomerId: Scalars['String']['output'];
  intacctLocationId: Scalars['String']['output'];
};

export type ErpAccrualLineItemSourceLine = BillLineItemAllocation | CommitmentDraw | CommitmentLineItem | ExpenseAllocationAllocation | ProjectItem | CostCode;

export type ErpRevenueInitialBalanceInput = {
  projectIds: Array<Scalars['ID']['input']>;
};

export type SaveEstimateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EstimateStatus>;
  type?: InputMaybe<EstimateType>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  changeEventId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveEstimateResult = {
  __typename?: 'SaveEstimateResult';
  estimate: Estimate;
};

export type EstimateFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AnnotatedCost = {
  __typename?: 'AnnotatedCost';
  item: Item;
  totalPriceInCents: Scalars['Int']['output'];
};

export type EstimateLineItem = {
  __typename?: 'EstimateLineItem';
  id: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  estimate: Estimate;
  projectItem: ProjectItem;
  projectItemHasDiverged: Scalars['Boolean']['output'];
  isPlaceholder: Scalars['Boolean']['output'];
  unitCostInCents: Scalars['Int']['output'];
  unitPriceInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  changeEventLineItem?: Maybe<ChangeEventLineItem>;
  unitOfMeasure: UnitOfMeasure;
  displayName: Scalars['String']['output'];
};

export type Expense = {
  __typename?: 'Expense';
  id: Scalars['ID']['output'];
  amountInCents: Scalars['Int']['output'];
  unallocatedAmountInCents: Scalars['Int']['output'];
  expenseDate: Scalars['Date']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costCode?: Maybe<CostCode>;
  intacctApBillId: Scalars['String']['output'];
  intacctApBillLineId: Scalars['String']['output'];
  intacctItemId: Scalars['String']['output'];
  intacctVendorName: Scalars['String']['output'];
  intacctVendorBlueprintId?: Maybe<Scalars['String']['output']>;
  amountPaidInCents: Scalars['Int']['output'];
  stage: StageDetail;
  project: Project;
  potentialProjectItems: Array<ProjectItem>;
  intacctVendorId: Scalars['String']['output'];
  document?: Maybe<Document>;
  allocations: Array<ExpenseAllocation>;
  changeEvents: Array<ChangeEvent>;
  documents: Array<Document>;
  tradeNumber?: Maybe<Scalars['String']['output']>;
  allLineItemsAreExpenses: Scalars['Boolean']['output'];
  canBeConvertedToBill: PotentialOperation2;
  isBrex: Scalars['Boolean']['output'];
};

export type SaveExpenseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  expenseDate?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  costCodeId?: InputMaybe<Scalars['ID']['input']>;
  intacctApBillId?: InputMaybe<Scalars['String']['input']>;
  intacctApBillLineId?: InputMaybe<Scalars['String']['input']>;
  intacctItemId?: InputMaybe<Scalars['String']['input']>;
  intacctVendorName?: InputMaybe<Scalars['String']['input']>;
  intacctVendorBlueprintId?: InputMaybe<Scalars['String']['input']>;
  amountPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  intacctVendorId?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documents?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradeNumber?: InputMaybe<Scalars['String']['input']>;
  allLineItemsAreExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SaveExpensesInput = {
  expenses: Array<SaveExpenseInput>;
};

export type SaveExpensesResult = {
  __typename?: 'SaveExpensesResult';
  expenses: Array<Expense>;
};

export type ExpenseFilter = {
  intacctApBillId?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId?: InputMaybe<Array<Scalars['ID']['input']>>;
  unallocated?: InputMaybe<Scalars['Boolean']['input']>;
  allocated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConvertExpenseToBillInput = {
  expenseId: Scalars['ID']['input'];
};

export type ConvertExpenseToBillResult = {
  __typename?: 'ConvertExpenseToBillResult';
  bill: Bill;
};

export type ExpensesPage = {
  __typename?: 'ExpensesPage';
  entities: Array<Expense>;
  pageInfo: PageInfo;
};

export type ExpenseAllocation = {
  __typename?: 'ExpenseAllocation';
  id: Scalars['ID']['output'];
  amountInCents: Scalars['Int']['output'];
  paidAmountInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  expense: Expense;
  projectItem: ProjectItem;
  historicExpenseAmountInvoiced?: Maybe<Scalars['Int']['output']>;
  costLineItemAllocations: Array<CostLineItemAllocation>;
  commitmentLineItem?: Maybe<CommitmentLineItem>;
  invoiceAccruedLineItems: Array<InvoiceAccruedLineItem>;
  allocations: Array<ExpenseAllocationAllocation>;
};

export type SaveExpenseAllocationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  expenseId?: InputMaybe<Scalars['ID']['input']>;
  projectItemId?: InputMaybe<Scalars['ID']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  historicExpenseAmountInvoiced?: InputMaybe<Scalars['Int']['input']>;
  commitmentLineItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveExpenseAllocationsInput = {
  expenseAllocations: Array<SaveExpenseAllocationInput>;
};

export type SaveExpenseAllocationsResult = {
  __typename?: 'SaveExpenseAllocationsResult';
  expenseAllocations: Array<ExpenseAllocation>;
};

export type ExpenseAllocationAllocation = {
  __typename?: 'ExpenseAllocationAllocation';
  id: Scalars['ID']['output'];
  costInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  expenseAllocation: ExpenseAllocation;
  projectItemAllocation: ProjectItemAllocation;
};

export type FeatureFlag = Entity & {
  __typename?: 'FeatureFlag';
  id: Scalars['ID']['output'];
  type: FeatureFlagTypeDetail;
  status: FeatureFlagStatusDetail;
  targets: Array<FeatureFlagTarget>;
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isPresentational: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  releaseVersion: Scalars['Int']['output'];
};

export type SaveFeatureFlagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FeatureFlagType>;
  isPresentational?: InputMaybe<Scalars['Boolean']['input']>;
  targetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<FeatureFlagStatus>;
  releaseVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveFeatureFlagResult = {
  __typename?: 'SaveFeatureFlagResult';
  featureFlag: FeatureFlag;
};

export type FeatureFlagFilter = {
  type?: InputMaybe<Array<FeatureFlagType>>;
  status?: InputMaybe<Array<FeatureFlagStatus>>;
  isPresentational?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureFlagTarget = {
  __typename?: 'FeatureFlagTarget';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  featureFlag: FeatureFlag;
  target?: Maybe<FeatureFlagTargetTarget>;
};

export type SaveFeatureFlagTargetInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  featureFlagId?: InputMaybe<Scalars['ID']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveFeatureFlagTargetResult = {
  __typename?: 'SaveFeatureFlagTargetResult';
  featureFlagTarget: FeatureFlagTarget;
};

export type FeatureFlagTargetTarget = Development | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | User | UserGroup;

export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
};

export enum DateOperation {
  Before = 'BEFORE',
  On = 'ON',
  After = 'AFTER',
  Between = 'BETWEEN',
  OnOrBefore = 'ON_OR_BEFORE',
  OnOrAfter = 'ON_OR_AFTER'
}

/**
 * An easier-to-data-bind DateFilter that value-izes the operation.
 *
 * Previously the DateFilter pattern of `someDay: { eq: jan1UTC } }` was fairly annoying
 * to data-bind UIs against b/c the value of the "on/before/after" drop-down would
 * mean dynamically changing which key to set in the filter, vs. just changing the
 * value of some basically-statically-identified key.
 *
 * This avoids that by making `op` an explicit key.
 */
export type DateFilter2 = {
  op: DateOperation;
  value: Scalars['Date']['input'];
  value2?: InputMaybe<Scalars['Date']['input']>;
};

export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type IntervalFilter = {
  startDate?: InputMaybe<DateFilter>;
  endDate?: InputMaybe<DateFilter>;
  durationInDays?: InputMaybe<IntFilter>;
};

export type IntervalFilter2 = {
  startDate?: InputMaybe<DateFilter2>;
  endDate?: InputMaybe<DateFilter2>;
  durationInDays?: InputMaybe<IntFilter>;
};

export type FollowSequenceSheetInput = {
  /**  Developments to be followed or unfollowed  */
  developmentIds: Array<Scalars['ID']['input']>;
  /**  Users to be added/removed as followers */
  internalUserIds: Array<Scalars['ID']['input']>;
  /**  Whether the users should be added or removed as followers  */
  follow: Scalars['Boolean']['input'];
};

export type FollowSequenceSheetResult = {
  __typename?: 'FollowSequenceSheetResult';
  developments: Array<Development>;
  internalUsers: Array<InternalUser>;
};

export type Followable = {
  id: Scalars['ID']['output'];
  followers: Array<InternalUser>;
  availableFollowers: Array<InternalUser>;
  isFollowed: Scalars['Boolean']['output'];
};

export type SaveFollowersInput = {
  followableId: Scalars['ID']['input'];
  followerIds: Array<Scalars['ID']['input']>;
  /**  Whether this follow was a side-effect of being tagged. */
  fromTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveFollowersResult = {
  __typename?: 'SaveFollowersResult';
  /** @deprecated Placeholder to avoid a breaking change. */
  emptyResult?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the root commentable to allow refetching the latest followers.
   * @deprecated Use followable instead
   */
  commentable: Commentable;
  /** Returns the root followable to allow refetching the latest followers. */
  followable: Followable;
};

export type SaveGlobalOptionsInput = {
  globalOptions: Array<SaveGlobalOptionInput>;
};

export type SaveGlobalOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isPlanSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  standardDetailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<GlobalOptionStatus>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  elevationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInPlanDrawing?: InputMaybe<Scalars['Boolean']['input']>;
  shopDrawingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When specified, must include all tags you wish to have associated with the GlobalOptionType.
   * NOTE: May only be set to a sub-set of tags from the associated `GlobalOptionType.tags` list.
   */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  designUpgradeIconName?: InputMaybe<Scalars['String']['input']>;
  defaultOrder?: InputMaybe<Scalars['Int']['input']>;
  asset?: InputMaybe<AssetInput>;
  estimatedLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  marketingDescription?: InputMaybe<Scalars['String']['input']>;
  permits?: InputMaybe<Array<Permit>>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
  optionPricingConfig?: InputMaybe<SaveOptionPricingConfigInput>;
};

export type SaveGlobalOptionsResult = {
  __typename?: 'SaveGlobalOptionsResult';
  globalOptions: Array<GlobalOption>;
};

export type BackfillGlobalOptionNamesInput = {
  skipGlobalOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BackfillGlobalOptionNamesResult = {
  __typename?: 'BackfillGlobalOptionNamesResult';
  globalOptions: Array<GlobalOption>;
};

export type GlobalOptionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  isPlanSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  standardDetailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  elevationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInPlanDrawing?: InputMaybe<Scalars['Boolean']['input']>;
  shopDrawingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<GlobalOptionStatus>>;
  type?: InputMaybe<Array<Scalars['ID']['input']>>;
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  activeDate?: InputMaybe<DateFilter>;
  archivedDate?: InputMaybe<DateFilter>;
  isElevation?: InputMaybe<Scalars['Boolean']['input']>;
  isAddOnV2?: InputMaybe<Scalars['Boolean']['input']>;
  isStructuralV2?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Indicates whether the option is managed by the catalog.  */
  isCatalogV2?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Indicates the version of the catalog that the option belongs to.  */
  version?: InputMaybe<Array<Scalars['Int']['input']>>;
  isExteriorPalette?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Setting `isExteriorType` will trump `isElevation` and `isExteriorPalette` filters.
   * Setting `isExteriorType: true` filter will return GlobalOptionTypes where `isElevation` OR `isExteriorPalette` are true.
   * Setting `isExteriorType: false` will return GlobalOptionTypes where `isElevation` AND `isExteriorPalette` are false
   */
  isExteriorType?: InputMaybe<Scalars['Boolean']['input']>;
  isPlanPackageType?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignUpgradeIcon?: InputMaybe<Scalars['Boolean']['input']>;
  developments?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * GlobalOptionGroup.readyPlan is an optional relation that is used to scope GOGs to specific Ready Plans.
   * Allows null IDs to support filtering regular/non-scoped GOs and scoped GOs at the same time (e.g., [null, "rp:1"]).
   */
  readyPlan?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type MigrateGlobalOptionInput = {
  sourceId: Scalars['ID']['input'];
  targetGroupId: Scalars['ID']['input'];
  clearLocations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MigrateGlobalOptionsInput = {
  sourceGroupId: Scalars['ID']['input'];
  targetGroupId: Scalars['ID']['input'];
  clearLocations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GlobalOptionGroup = {
  __typename?: 'GlobalOptionGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  globalOptions: Array<GlobalOption>;
  type: GlobalOptionType;
  isSingleOptionGroup: Scalars['Boolean']['output'];
  isMultiOptionGroup: Scalars['Boolean']['output'];
  salesforceFieldName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage: Scalars['Boolean']['output'];
  forDesignInterior: Scalars['Boolean']['output'];
  /** @deprecated No longer used */
  forDesignUpgrade: Scalars['Boolean']['output'];
  /** @deprecated use `forDesignExterior` instead */
  forExteriors: Scalars['Boolean']['output'];
  forDesignExterior: Scalars['Boolean']['output'];
  /**  helper for `forDesignInterior || forDesignExterior` so you don't have to do it by hand everywhere  */
  forDesignPackages: Scalars['Boolean']['output'];
  /**  Default value for ReadyPlanOptionGroup.required to be applied on creation  */
  defaultRequired: Scalars['Boolean']['output'];
  designPackageTagColor?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  canEditType: PotentialOperation2;
  readyPlan?: Maybe<ReadyPlanLike>;
};

export type SaveGlobalOptionGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  salesforceFieldName?: InputMaybe<Scalars['String']['input']>;
  isSingleOptionGroup?: InputMaybe<Scalars['Boolean']['input']>;
  defaultRequired?: InputMaybe<Scalars['Boolean']['input']>;
  designPackageTagColor?: InputMaybe<Scalars['String']['input']>;
};

export type SaveGlobalOptionGroupResult = {
  __typename?: 'SaveGlobalOptionGroupResult';
  entity: GlobalOptionGroup;
};

export type GlobalOptionGroupFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isSingleOptionGroup?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<GlobalOptionTypesFilter>;
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage?: InputMaybe<Scalars['Boolean']['input']>;
  forDesignInterior?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer used */
  forDesignUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use `forDesignExterior` instead */
  forExteriors?: InputMaybe<Scalars['Boolean']['input']>;
  forDesignExterior?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Indicates the version of the catalog that the option group belongs to.  */
  version?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * GlobalOptionGroup.readyPlan is an optional relation that is used to scope GOGs to specific Ready Plans.
   * Setting readyPlan to null will filter regular/non-scoped GOGs.
   */
  readyPlan?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GlobalOptionTag = Named & {
  __typename?: 'GlobalOptionTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  globalOptions: Array<GlobalOption>;
  globalOptionTypes: Array<GlobalOptionType>;
};

export type GlobalOptionTagsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveGlobalOptionTagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  globalOptionTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveGlobalOptionTagsInput = {
  globalOptionTags: Array<SaveGlobalOptionTagInput>;
};

export type SaveGlobalOptionTagsResult = {
  __typename?: 'SaveGlobalOptionTagsResult';
  globalOptionTags: Array<GlobalOptionTag>;
};

export type GlobalOptionType = Named & {
  __typename?: 'GlobalOptionType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  changesProgramData?: Maybe<Scalars['Boolean']['output']>;
  changesSpecsAndSelections?: Maybe<Scalars['Boolean']['output']>;
  status: GlobalOptionTypeStatus;
  statusDetail: GlobalOptionTypeStatusDetail;
  /**  Identifies the singular `GlobalOptionGroup` of Elevation: Farmhouse, Coastal, etc.  */
  isElevation: Scalars['Boolean']['output'];
  /**  Identifies the singular `GlobalOptionGroup` of Exterior Palette: Gray, etc.  */
  isExteriorPalette: Scalars['Boolean']['output'];
  /**  Identifies the singular `GlobalOptionGroup` of Spec Level: Essential, Deluxe, etc.  */
  isSpecLevel: Scalars['Boolean']['output'];
  /**
   * Identifies the singular `GlobalOptionGroup` of Interior Scheme: Bold, Modern, Traditional, etc.
   *
   * Replaced the old Interior Style in H1 tech/version 2.
   */
  isInteriorScheme: Scalars['Boolean']['output'];
  /**
   * Identifies the singular `GlobalOptionGroup` of Exterior Scheme: Gray Scheme, Red Scheme, etc.
   *
   * Replaced the old Exterior Palette in H1 tech/version 2.
   */
  isExteriorScheme: Scalars['Boolean']['output'];
  /**  Identifies the singular `GlobalOptionGroup` of 'Plan Package' for Design Package plan-based tagging.  */
  isPlanPackage: Scalars['Boolean']['output'];
  /**  Identifies `GlobalOptionGroup`s that are Interior Options, like Add Bedroom, or Garage.  */
  isInterior: Scalars['Boolean']['output'];
  /**  Identifies `GlobalOptionGroup`s that change the floor plan, like Convert Attic to Bedroom.  */
  isFloorPlan: Scalars['Boolean']['output'];
  tags: Array<GlobalOptionTag>;
  globalOptionsCount: Scalars['Int']['output'];
  allowsLocations: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  /**  Identifies `GlobalOptionGroup`s that can form Interior Design Package IDPs, i.e. Spec Level & Interior Scheme.  */
  forDesignInterior: Scalars['Boolean']['output'];
  /**  Identifies `GlobalOptionGroup`s that can form Exterior Design Package IDPs, i.e. Elevation & Exterior Scheme.  */
  forDesignExterior: Scalars['Boolean']['output'];
  /**
   *  Identities `GlobalOptionGroup`s that are applicable to design upgrades, i.e. 'Add Bedroom Sink'.
   * @deprecated No longer used
   */
  forDesignUpgrade: Scalars['Boolean']['output'];
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage: Scalars['Boolean']['output'];
  /** @deprecated use `forDesignExterior` instead */
  forExteriors: Scalars['Boolean']['output'];
  /** @deprecated Use GlobalOptionGroups instead */
  globalOptions: Array<GlobalOption>;
  isAddOnV2?: Maybe<Scalars['Boolean']['output']>;
  isStructuralV2?: Maybe<Scalars['Boolean']['output']>;
  isCatalogV2?: Maybe<Scalars['Boolean']['output']>;
  isProductOptionV2: Scalars['Boolean']['output'];
  isPackageOptionV2: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
};

export type SaveGlobalOptionTypesInput = {
  globalOptionTypes: Array<SaveGlobalOptionTypeInput>;
  /**
   * Used to indicate consent that additional side effects may occur.
   * In this case, confirmation is required to remove a GlobalOptionTag from a GlobalOptionType, if it is currently in use by one or more GlobalOptions.
   */
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveGlobalOptionTypeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  changesProgramData?: InputMaybe<Scalars['Boolean']['input']>;
  changesSpecsAndSelections?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<GlobalOptionTypeStatus>;
  isElevation?: InputMaybe<Scalars['Boolean']['input']>;
  isExteriorPalette?: InputMaybe<Scalars['Boolean']['input']>;
  isInterior?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When specified, must include all tags you wish to have associated with the GlobalOptionType
   * NOTE: Accepts IDs or tag names. When a String is specified for a `GlobalOptionTag` which does not yet exist, it will be created.
   * NOTE: If a tag is removed which is currently referenced by an associated GlobalOption, this operation will fail unless `SaveGlobalOptionTypesInput.confirm: true` is specified.
   */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowsLocations?: InputMaybe<Scalars['Boolean']['input']>;
  isFloorPlan?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecLevel?: InputMaybe<Scalars['Boolean']['input']>;
  isInteriorScheme?: InputMaybe<Scalars['Boolean']['input']>;
  isExteriorScheme?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage?: InputMaybe<Scalars['Boolean']['input']>;
  forDesignInterior?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer used */
  forDesignUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use `forDesignExterior` instead */
  forExteriors?: InputMaybe<Scalars['Boolean']['input']>;
  forDesignExterior?: InputMaybe<Scalars['Boolean']['input']>;
  isAddOnV2?: InputMaybe<Scalars['Boolean']['input']>;
  isStructuralV2?: InputMaybe<Scalars['Boolean']['input']>;
  isCatalogV2?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveGlobalOptionTypesResult = {
  __typename?: 'SaveGlobalOptionTypesResult';
  globalOptionTypes: Array<GlobalOptionType>;
};

export type GlobalOptionTypesFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  changesProgramData?: InputMaybe<Scalars['Boolean']['input']>;
  changesSpecsAndSelections?: InputMaybe<Scalars['Boolean']['input']>;
  isElevation?: InputMaybe<Scalars['Boolean']['input']>;
  isExteriorPalette?: InputMaybe<Scalars['Boolean']['input']>;
  isInterior?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecLevel?: InputMaybe<Scalars['Boolean']['input']>;
  isAddOnV2?: InputMaybe<Scalars['Boolean']['input']>;
  isStructuralV2?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Indicates whether the option is managed by the catalog.  */
  isCatalogV2?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Indicates the version of the catalog that the option type belongs to.  */
  version?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Array<GlobalOptionTypeStatus>>;
  isPlanPackage?: InputMaybe<Scalars['Boolean']['input']>;
  isProductOptionV2?: InputMaybe<Scalars['Boolean']['input']>;
  isPackageOptionV2?: InputMaybe<Scalars['Boolean']['input']>;
  isInteriorScheme?: InputMaybe<Scalars['Boolean']['input']>;
  isExteriorScheme?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GlobalPhaseFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Limit to only active GlobalPhases  */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Obtain a list of GlobalPhases used on the specified parent(s)  */
  parent?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Obtain a list of GlobalPhases used on the specified schedule(s)  */
  schedule?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Limit by GlobalPhase stage  */
  stage?: InputMaybe<Array<Stage>>;
};

export type GlobalPhase = {
  __typename?: 'GlobalPhase';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  cmsId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  stage: Stage;
  stageDetail: StageDetail;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  globalSubPhases: Array<GlobalSubPhase>;
  globalTasks: Array<GlobalTask>;
};

export type SaveGlobalPhasesInput = {
  globalPhases: Array<SaveGlobalPhaseInput>;
};

export type SaveGlobalPhaseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  /**  CAUTION - This will change the name of the GlobalPhase on all Schedules where it is used  */
  name?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Stage>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveGlobalPhasesResult = {
  __typename?: 'SaveGlobalPhasesResult';
  globalPhases: Array<GlobalPhase>;
};

export type GlobalPlanAllowance = HasGlobalConstraintItem & {
  __typename?: 'GlobalPlanAllowance';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  constraintItem: GlobalPlanConstraintItem;
  task: GlobalPlanTask;
};

export type GlobalPlanConstraint = HasGlobalConstraintItem & {
  __typename?: 'GlobalPlanConstraint';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  task: GlobalPlanTask;
  constraintItem: GlobalPlanConstraintItem;
};

export type GlobalPlanConstraintItem = Named & {
  __typename?: 'GlobalPlanConstraintItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  allowances: Array<GlobalPlanAllowance>;
  constraints: Array<GlobalPlanConstraint>;
  numberOfTimesUsed: Scalars['Int']['output'];
  constrainedPlanTasks: Array<PlanTask>;
  allowingPlanTasks: Array<PlanTask>;
  lagInDays: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type GlobalPlanConstraintItemConstrainedPlanTasksArgs = {
  scheduleOrTask: Scalars['ID']['input'];
};


export type GlobalPlanConstraintItemAllowingPlanTasksArgs = {
  scheduleOrTask: Scalars['ID']['input'];
};

export type SaveGlobalPlanConstraintItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  lagInDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveGlobalPlanConstraintItemResult = {
  __typename?: 'SaveGlobalPlanConstraintItemResult';
  globalPlanConstraintItem: GlobalPlanConstraintItem;
};

export type SaveGlobalPlanConstraintItemsResult = {
  __typename?: 'SaveGlobalPlanConstraintItemsResult';
  globalPlanConstraintItems: Array<GlobalPlanConstraintItem>;
};

export type HasGlobalConstraintItem = {
  id: Scalars['ID']['output'];
  constraintItem: GlobalPlanConstraintItem;
};

export type DeleteGlobalPlanConstraintItemInput = {
  id: Scalars['ID']['input'];
};

export type GlobalPlanMilestone = Named & {
  __typename?: 'GlobalPlanMilestone';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  planMilestones: Array<PlanMilestone>;
  groups: Array<GlobalPlanMilestoneGroup>;
  constraints: Array<GlobalPlanConstraintItem>;
  systemPlanMilestone?: Maybe<SystemPlanMilestoneDetail>;
  isHomeownerVisible: Scalars['Boolean']['output'];
  homeownerName?: Maybe<Scalars['String']['output']>;
  homeownerDescription?: Maybe<Scalars['String']['output']>;
  homeownerIcon?: Maybe<Asset>;
  description?: Maybe<Scalars['String']['output']>;
};

export type SaveGlobalPlanMilestoneInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<SaveGlobalPlanMilestoneGroupInput>>;
  constraints?: InputMaybe<Array<SaveGlobalPlanMilestoneConstraintItemInput>>;
  systemPlanMilestone?: InputMaybe<SystemPlanMilestone>;
  isHomeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  homeownerName?: InputMaybe<Scalars['String']['input']>;
  homeownerDescription?: InputMaybe<Scalars['String']['input']>;
  homeownerIcon?: InputMaybe<AssetInput>;
};

export type SaveGlobalPlanMilestonesInput = {
  globalPlanMilestones: Array<SaveGlobalPlanMilestoneInput>;
};

export type SaveGlobalPlanMilestoneGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanMilestoneConstraintItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  op: ConstraintItemIncrementalCollectionOp;
};

export type GlobalPlanMilestoneFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  isFromInvoiceAutomation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GlobalPlanMilestoneOrder = {
  createdAt?: InputMaybe<Order>;
};

export type SaveGlobalPlanMilestoneResult = {
  __typename?: 'SaveGlobalPlanMilestoneResult';
  globalPlanMilestone: GlobalPlanMilestone;
};

export type GlobalPlanMilestonesPageResult = {
  __typename?: 'GlobalPlanMilestonesPageResult';
  entities: Array<GlobalPlanMilestone>;
  pageInfo: PageInfo;
};

export type SaveGlobalPlanMilestonesResult = {
  __typename?: 'SaveGlobalPlanMilestonesResult';
  globalPlanMilestones: Array<GlobalPlanMilestone>;
};

export enum ConstraintItemIncrementalCollectionOp {
  Include = 'include',
  Remove = 'remove'
}

export type GlobalPlanMilestoneGroup = {
  __typename?: 'GlobalPlanMilestoneGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  businessFunctionType: BusinessFunctionTypeDetail;
  globalPlanMilestones: Array<GlobalPlanMilestone>;
};

export type SaveGlobalMilestoneGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  businessFunctionType?: InputMaybe<BusinessFunctionType>;
};

export type SaveGlobalPlanMilestoneGroupResult = {
  __typename?: 'SaveGlobalPlanMilestoneGroupResult';
  globalPlanMilestoneGroup: GlobalPlanMilestoneGroup;
};

export type GlobalPlanStage = {
  __typename?: 'GlobalPlanStage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  globalPlanTasks: Array<GlobalPlanTask>;
  globalPlanTaskVariants: Array<GlobalPlanTaskVariant>;
  variants: Array<GlobalPlanStageVariant>;
  orderForProject?: Maybe<Scalars['Int']['output']>;
};


export type GlobalPlanStageOrderForProjectArgs = {
  projectId: Scalars['ID']['input'];
};

export type SaveGlobalPlanStageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  globalPlanTasks?: InputMaybe<Array<SaveGlobalPlanStageTaskInput>>;
};

export type SaveGlobalPlanStageTaskInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanStageResult = {
  __typename?: 'SaveGlobalPlanStageResult';
  globalPlanStage: GlobalPlanStage;
};

export type GlobalPlanStageVariant = {
  __typename?: 'GlobalPlanStageVariant';
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  globalPlanStage: GlobalPlanStage;
  project: Project;
};

export type SaveGlobalPlanStageVariantInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  globalPlanStageId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveGlobalPlanStageVariantsInput = {
  globalPlanStageVariants: Array<SaveGlobalPlanStageVariantInput>;
};

export type SaveGlobalPlanStageVariantsResult = {
  __typename?: 'SaveGlobalPlanStageVariantsResult';
  globalPlanStageVariants: Array<GlobalPlanStageVariant>;
};

export type GlobalPlanTag = {
  __typename?: 'GlobalPlanTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  tasks: Array<GlobalPlanTask>;
  /** When true, tasks with this tag are excluded from schedule views and draft schedule results. */
  isHiddenFromSchedule: Scalars['Boolean']['output'];
};

export type SaveGlobalPlanTagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Array<SaveGlobalPlanTagTaskInput>>;
  isHiddenFromSchedule?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveGlobalPlanTagTaskInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanTagResult = {
  __typename?: 'SaveGlobalPlanTagResult';
  globalPlanTag: GlobalPlanTag;
};

export type BulkSaveGlobalPlanTagsResult = {
  __typename?: 'BulkSaveGlobalPlanTagsResult';
  globalPlanTags: Array<GlobalPlanTag>;
};

export type GlobalPlanTask = Named & {
  __typename?: 'GlobalPlanTask';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Returns the name within the context of the given entityId. entityId must either be a project id or an id for an
   * entity with a project or market relation.  This behavior is grandfathered in to support passing a development, it is
   * not recommended to replicate this behavior elsewhere.
   */
  nameForEntity: Scalars['String']['output'];
  externalName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  archived: Scalars['Boolean']['output'];
  optimisticDurationInDays: Scalars['Int']['output'];
  expectedDurationInDays: Scalars['Int']['output'];
  pessimisticDurationInDays: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  businessFunctionType: BusinessFunctionTypeDetail;
  projectRole?: Maybe<ProjectRoleDetail>;
  tradeCategory?: Maybe<TradeCategory>;
  allowances: Array<GlobalPlanAllowance>;
  constraints: Array<GlobalPlanConstraint>;
  tags: Array<GlobalPlanTag>;
  scopes: Array<GlobalPlanTaskScope>;
  applyToAllSchedules: Scalars['Boolean']['output'];
  budgetItem: Item;
  itemPlanTaskMappings: Array<ItemPlanTaskMapping>;
  planTasks: Array<PlanTask>;
  numberOfTimesUsed: Scalars['Int']['output'];
  checklistItems: Array<GlobalPlanTaskChecklistItem>;
  globalRequiredTaskDocuments: Array<GlobalRequiredTaskDocument>;
  canEditBudgetItem: PotentialOperation2;
  bidContractRevisionDraws: Array<BidContractRevisionDraw>;
  stage?: Maybe<GlobalPlanStage>;
  variants: Array<GlobalPlanTaskVariant>;
  drops: Array<Drop>;
  parent?: Maybe<GlobalPlanTask>;
  children: Array<GlobalPlanTask>;
};


export type GlobalPlanTaskNameForEntityArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveGlobalPlanTaskInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  externalName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  optimisticDurationInDays?: InputMaybe<Scalars['Int']['input']>;
  expectedDurationInDays?: InputMaybe<Scalars['Int']['input']>;
  pessimisticDurationInDays?: InputMaybe<Scalars['Int']['input']>;
  businessFunctionType?: InputMaybe<BusinessFunctionType>;
  projectRole?: InputMaybe<ProjectRole>;
  tradeCategoryId?: InputMaybe<Scalars['ID']['input']>;
  constraints?: InputMaybe<Array<SaveConstraintItemInput>>;
  allowances?: InputMaybe<Array<SaveConstraintItemInput>>;
  tags?: InputMaybe<Array<SaveGlobalPlanTaskTagInput>>;
  scopes?: InputMaybe<Array<SaveGlobalPlanTaskScopeInput>>;
  checklistItems?: InputMaybe<Array<SaveGlobalPlanTaskChecklistInputInput>>;
  applyToAllSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
  globalRequiredTaskDocuments?: InputMaybe<Array<SaveGlobalPlanTaskRequiredDocumentInput>>;
  itemPlanTaskMappings?: InputMaybe<Array<IncrementalSaveItemPlanTaskMappingInput>>;
  stageId?: InputMaybe<Scalars['ID']['input']>;
  variants?: InputMaybe<Array<SaveGlobalPlanTaskVariantIncrementalInput>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveConstraintItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  op: IncrementalCollectionOp;
  constraintItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveGlobalPlanTaskTagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  op: IncrementalCollectionOp;
};

export type GlobalPlanTaskFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  team?: InputMaybe<Array<BusinessFunctionType>>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  applyToAllSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  costCode?: InputMaybe<Array<Scalars['ID']['input']>>;
  isChildTask?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveGlobalPlanTaskScopeInput = {
  /** The ID of the GlobalPlanTaskScope record (only used for deletes) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The (tagged) ID of the Region/Market/Community/Subdivision that this scope applies to. */
  targetId?: InputMaybe<Scalars['ID']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanTaskChecklistInputInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveGlobalPlanTaskRequiredDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<DocumentType>;
  watchers?: InputMaybe<Array<ProjectRole>>;
  /**  Remove is not a valid option for this field  */
  op: IncrementalCollectionOp;
};

export type IncrementalSaveItemPlanTaskMappingInput = {
  op: IncrementalCollectionOp;
  id?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  estimatedLaborCostInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveVariantConstraintItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveGlobalPlanTaskVariantIncrementalInput = {
  op: IncrementalCollectionOp;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optimisticDurationInDays?: InputMaybe<Scalars['Int']['input']>;
  expectedDurationInDays?: InputMaybe<Scalars['Int']['input']>;
  pessimisticDurationInDays?: InputMaybe<Scalars['Int']['input']>;
  constraints?: InputMaybe<Array<SaveVariantConstraintItemInput>>;
  allowances?: InputMaybe<Array<SaveVariantConstraintItemInput>>;
  stageId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveGlobalPlanTaskResult = {
  __typename?: 'SaveGlobalPlanTaskResult';
  globalPlanTask: GlobalPlanTask;
};

export type SaveGlobalPlanTasksResult = {
  __typename?: 'SaveGlobalPlanTasksResult';
  globalPlanTasks: Array<GlobalPlanTask>;
};

export type GlobalPlanTasksPageResult = {
  __typename?: 'GlobalPlanTasksPageResult';
  entities: Array<GlobalPlanTask>;
  pageInfo: PageInfo;
};

export type GlobalPlanTaskChecklistItem = {
  __typename?: 'GlobalPlanTaskChecklistItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  globalPlanTask: GlobalPlanTask;
};

export type GlobalPlanTaskScope = {
  __typename?: 'GlobalPlanTaskScope';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  globalPlanTask: GlobalPlanTask;
  target: Project;
};

export type GlobalPlanTaskScopeTarget = Community | Market | Region | Subdivision;

export type GlobalPlanTaskVariant = {
  __typename?: 'GlobalPlanTaskVariant';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  optimisticDurationInDays?: Maybe<Scalars['Int']['output']>;
  expectedDurationInDays?: Maybe<Scalars['Int']['output']>;
  pessimisticDurationInDays?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  globalPlanTask: GlobalPlanTask;
  allowances: Array<GlobalPlanConstraintItem>;
  constraints: Array<GlobalPlanConstraintItem>;
  stage?: Maybe<GlobalPlanStage>;
  project: Project;
};

export type GlobalRequiredTaskDocument = {
  __typename?: 'GlobalRequiredTaskDocument';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  documentType: DocumentTypeDetail;
  watchers: Array<ProjectRole>;
  canEditDocumentType: PotentialOperation2;
};

export type SaveGlobalRequiredTaskDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<DocumentType>;
  watchers?: InputMaybe<Array<ProjectRole>>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveGlobalRequiredTaskDocumentResult = {
  __typename?: 'SaveGlobalRequiredTaskDocumentResult';
  globalRequiredTaskDocument: GlobalRequiredTaskDocument;
};

/** Wrap the low-level record to hold eventual metadata like matched substring. */
export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  record: GlobalSearchRecord;
};

export type GlobalSearchRecord = {
  __typename?: 'GlobalSearchRecord';
  id: Scalars['ID']['output'];
  search?: Maybe<Scalars['String']['output']>;
  parent: GlobalSearchRecordParent;
};

export type GlobalSearchRecordParent = Bill | Commitment | CommitmentChangeOrder | Community | DesignPackage | Lot | Market | PlanPackage | ProductOffering | Region | StandaloneProject | Structure | Subdivision | TradePartner;

export type GlobalSubPhasesFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * TODO: Implement in sc-7912
   *
   * Obtain a list of GlobalSubPhases used on the specified parent(s)
   */
  parent?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * TODO: Implement in sc-7912
   *
   * NOT IMPLEMENTED - Obtain a list of GlobalSubPhases used on the specified schedules(s)
   */
  schedule?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GlobalSubPhase = {
  __typename?: 'GlobalSubPhase';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  globalPhase: GlobalPhase;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  stage: Stage;
  stageDetail: StageDetail;
  cmsId?: Maybe<Scalars['String']['output']>;
};

export type SaveGlobalSubPhasesInput = {
  globalSubPhases: Array<SaveGlobalSubPhaseInput>;
};

export type SaveGlobalSubPhaseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  globalPhase?: InputMaybe<Scalars['ID']['input']>;
  /**  CAUTION - This will change the name of the GlobalSubPhase on all projects where it is used  */
  name?: InputMaybe<Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  globalPhaseId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveGlobalSubPhasesResult = {
  __typename?: 'SaveGlobalSubPhasesResult';
  globalSubPhases: Array<GlobalSubPhase>;
};

export type ReplaceGlobalSubPhaseInput = {
  replace: Scalars['ID']['input'];
  with: Scalars['ID']['input'];
  /**  Will hard delete any activities which are left behind post-merge - by default they will be soft-deleted  */
  hardDeleteExisting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReplaceGlobalSubPhaseResult = {
  __typename?: 'ReplaceGlobalSubPhaseResult';
  replaced: GlobalSubPhase;
  with: GlobalSubPhase;
  impactedCount: Scalars['Int']['output'];
  impacted: Array<ScheduleSubPhase>;
};

export type GlobalTask = Named & {
  __typename?: 'GlobalTask';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  isMilestone: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  globalPhase: GlobalPhase;
  determinesStartDateForStage?: Maybe<Stage>;
  beginsStage?: Maybe<Stage>;
  systemTask?: Maybe<SystemTask>;
  sendEvent: Scalars['Boolean']['output'];
  globalPlanMilestone?: Maybe<GlobalPlanMilestone>;
};

export type SaveGlobalTasksInput = {
  globalTasks: Array<SaveGlobalTaskInput>;
};

export type SaveGlobalTaskInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  isMilestone?: InputMaybe<Scalars['Boolean']['input']>;
  globalPhaseId?: InputMaybe<Scalars['ID']['input']>;
  determinesStartDateForStage?: InputMaybe<Stage>;
  beginsStage?: InputMaybe<Stage>;
  systemTask?: InputMaybe<SystemTask>;
  sendEvent?: InputMaybe<Scalars['Boolean']['input']>;
  globalPlanMilestoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveGlobalTasksResult = {
  __typename?: 'SaveGlobalTasksResult';
  globalTasks: Array<GlobalTask>;
};

export type GlobalTasksFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isMilestone?: InputMaybe<Scalars['Boolean']['input']>;
  globalPhase?: InputMaybe<Array<Scalars['ID']['input']>>;
  systemTask?: InputMaybe<Array<SystemTask>>;
};

export type History = {
  __typename?: 'History';
  recordedAt: Scalars['DateTime']['output'];
  avatar: Scalars['String']['output'];
  title: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type HomeboundHoliday = {
  __typename?: 'HomeboundHoliday';
  id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SaveHomeboundHolidayInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaveHomeboundHolidayResult = {
  __typename?: 'SaveHomeboundHolidayResult';
  homeboundHoliday: HomeboundHoliday;
};

export type Homeowner = {
  __typename?: 'Homeowner';
  id: Scalars['ID']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  canViewCheckout: Scalars['Boolean']['output'];
  checkoutConfigs: Array<CheckoutConfig>;
};


export type HomeownerCheckoutConfigsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeownersFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  canViewCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateFilter2>;
};

export type HomeownersOrder = {
  id?: InputMaybe<Order>;
  firstName?: InputMaybe<Order>;
  lastName?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
};

export type HomeownersPage = {
  __typename?: 'HomeownersPage';
  entities: Array<Homeowner>;
  pageInfo: PageInfo;
};

export type SaveHomeownerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  canViewCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Direct users magic link to checkout */
  redirectToCheckout?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignUpHomeownerInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SaveHomeownerResult = {
  __typename?: 'SaveHomeownerResult';
  homeowner: Homeowner;
};

/**  A per-project item summary of a homeowner contract + its change orders.  */
export type HomeownerContractLineItemsByProjectItem = {
  __typename?: 'HomeownerContractLineItemsByProjectItem';
  projectItem: ProjectItem;
  lineItems: Array<HomeownerContractLineItem>;
};

export type HomeownerContractLike = {
  id: Scalars['ID']['output'];
  contractType: ContractType;
  costPlusMarkupBasisPoints?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  lineItems: Array<HomeownerContractLineItem>;
};

export type SaveHomeownerContractInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  /**  When creating a new contract (in SpecsAndSelections), estimateId is required to copy/paste the line items from.  */
  estimateId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  contractType?: InputMaybe<ContractType>;
  costPlusMarkupBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<SaveHomeownerContractDrawInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveHomeownerContractChangeOrderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  contractType?: InputMaybe<ContractType>;
  costPlusMarkupBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<SaveHomeownerContractDrawInput>>;
  lineItems?: InputMaybe<Array<SaveHomeownerContractLineItemInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  changeEventId?: InputMaybe<Scalars['ID']['input']>;
  estimateId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteHomeownerContractChangeOrderInput = {
  id: Scalars['ID']['input'];
};

export type SaveHomeownerContractResult = {
  __typename?: 'SaveHomeownerContractResult';
  homeownerContract: HomeownerContract;
};

export type SaveHomeownerContractChangeOrderResult = {
  __typename?: 'SaveHomeownerContractChangeOrderResult';
  homeownerContractChangeOrder: HomeownerContractChangeOrder;
};

export type HomeownerContractFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HomeownerContractChangeOrderFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ContractProjectFinancials = {
  __typename?: 'ContractProjectFinancials';
  project: Project;
  softCostBudgetInCents: Scalars['Int']['output'];
  directHardCostBudgetInCents: Scalars['Int']['output'];
  indirectHardCostBudgetInCents: Scalars['Int']['output'];
  totalMarkupInCents: Scalars['Int']['output'];
};

export type HomeownerContractDraw = Named & {
  __typename?: 'HomeownerContractDraw';
  id: Scalars['ID']['output'];
  parent: HomeownerContractLike;
  task: Task;
  percent: Scalars['Int']['output'];
  amountInCents: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  isDrawn: Scalars['Boolean']['output'];
  /** The contract short name (i.e. 'Prime' or 'CO #1') + draw order number. */
  name: Scalars['String']['output'];
  /** The draw name + the percentage/task milestone it's linked to. */
  description: Scalars['String']['output'];
  /** The invoice line item that is collecting this draw, if drawn. */
  invoiceDrawLineItem?: Maybe<InvoiceDrawLineItem>;
};

export type SaveHomeownerContractDrawInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  percent?: InputMaybe<Scalars['Int']['input']>;
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeownerContractLineItemAllocation = {
  __typename?: 'HomeownerContractLineItemAllocation';
  id: Scalars['ID']['output'];
  costInCents: Scalars['Int']['output'];
  priceInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  homeownerContractLineItem: HomeownerContractLineItem;
  projectItemAllocation: ProjectItemAllocation;
  changeEventLineItemAllocation?: Maybe<ChangeEventLineItemAllocation>;
};

export type HomeownerNote = {
  __typename?: 'HomeownerNote';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /**
   * NOTE: In the future, there will be an `images` field that will either be a
   * `JobLogImage` or a `HomeownerImage`. For now, we're only supporting
   * `JobLogImage`.
   */
  jobLogImages: Array<JobLogImage>;
  scheduleTasks: Array<ScheduleTask>;
  project: Project;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  schedulePhases: Array<SchedulePhase>;
};

export type SaveHomeownerNoteInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jobLogImageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduleTaskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveHomeownerNoteResult = {
  __typename?: 'SaveHomeownerNoteResult';
  homeownerNote: HomeownerNote;
};

export type HomeownerNoteFilter = {
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdDate?: InputMaybe<DateFilter2>;
};

export type HomeownerSelection = {
  __typename?: 'HomeownerSelection';
  id: Scalars['ID']['output'];
  isDeclinable: Scalars['Boolean']['output'];
  canEdit: PotentialOperation2;
  canPublish: PotentialOperation2;
  /**
   * A list of all possible custom products from this Project which are suitable for this HomeownerSelection.
   *
   * NOTE: DO NOT QUERY THIS IN A LIST VIEW
   */
  potentialCustomProducts: Array<Product>;
  status: HomeownerSelectionStatusDetail;
  isPublished: Scalars['Boolean']['output'];
  options: Array<HomeownerSelectionOption>;
  projectItem: ProjectItem;
  relatedSelections: Array<HomeownerSelection>;
  selectedOption?: Maybe<HomeownerSelectionOption>;
  recommendedOption?: Maybe<HomeownerSelectionOption>;
  baseOption?: Maybe<HomeownerSelectionOption>;
  publishedDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated use publishedDate instead */
  publishedAt?: Maybe<Scalars['Date']['output']>;
  /**
   * A combined list of HomeownerSelectionOption's and HomeownerSelectionProductOption's for this HomeownerSelection.
   * It returns ALL HomeownerSelectionOptions plus the `first` X HomeownerSelectionProductOption (default X=300)
   * WARNING: Do not query this from list views.
   */
  productOptions: Array<HomeownerSelectionOptionLike>;
  selectionPricingMode: SelectionPricingMode;
  selectionPricingModeDetail: SelectionPricingModeDetail;
  projectCutoff?: Maybe<ProjectCutoff>;
  undecidedUnitCostInCents?: Maybe<Scalars['Int']['output']>;
  undecidedUnitPriceInCents?: Maybe<Scalars['Int']['output']>;
  changeEventLineItem?: Maybe<ChangeEventLineItem>;
  isProposedSelection: Scalars['Boolean']['output'];
};


export type HomeownerSelectionOptionsArgs = {
  filter?: InputMaybe<HomeownerSelectionOptionFilter>;
};


export type HomeownerSelectionProductOptionsArgs = {
  filter?: InputMaybe<ProductFilter>;
  order?: InputMaybe<ProductOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeownerLocationSelection = {
  __typename?: 'HomeownerLocationSelection';
  location: Location;
  finalizedSelectionCount: Scalars['Int']['output'];
  totalSelectionCount: Scalars['Int']['output'];
  selections: Array<HomeownerSelection>;
};

export type HomeownerSelectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /** uniquely identifies a HomeownerSelection and can be used instead of id */
  projectItemId?: InputMaybe<Scalars['ID']['input']>;
  baseOptionId?: InputMaybe<Scalars['ID']['input']>;
  selectedOptionId?: InputMaybe<Scalars['ID']['input']>;
  recommendedOptionId?: InputMaybe<Scalars['ID']['input']>;
  isDeclinable?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<HomeownerSelectionStatus>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  projectCutoffId?: InputMaybe<Scalars['ID']['input']>;
  undecidedUnitCostInCents?: InputMaybe<Scalars['Int']['input']>;
  undecidedUnitPriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveHomeownerSelectionResult = {
  __typename?: 'SaveHomeownerSelectionResult';
  homeownerSelection: HomeownerSelection;
};

export type SelectionsByLocationFilter = {
  location?: InputMaybe<LocationFilter>;
  status?: InputMaybe<Array<HomeownerSelectionStatus>>;
};

export type HasSelectionsFilter = {
  /**  will return true even if the selections are unpublished  */
  includeUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MakeHomeownerSelectionInput = {
  homeownerSelectionOptionId: Scalars['ID']['input'];
  homeownerSelectionStatus: HomeownerSelectionStatus;
};

export type MakeHomeownerSelectionResult = {
  __typename?: 'MakeHomeownerSelectionResult';
  homeownerSelectionOption: HomeownerSelectionOption;
};

export type HomeownerSelectionOptionLike = {
  /**   `Product.ID` or `HSO.ID`   */
  id: Scalars['ID']['output'];
  isHomeownerVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  unitCostInCents?: Maybe<Scalars['Int']['output']>;
  unitPriceInCents?: Maybe<Scalars['Int']['output']>;
  markupInCents?: Maybe<Scalars['Int']['output']>;
  markupBasisPoints?: Maybe<Scalars['Int']['output']>;
  product: Product;
  homeownerSelection: HomeownerSelection;
  isBaseOption: Scalars['Boolean']['output'];
  isRecommendedOption: Scalars['Boolean']['output'];
  isSelectedOption: Scalars['Boolean']['output'];
  canEditPrice: PotentialOperation2;
  priceDeltaInCents?: Maybe<Scalars['Int']['output']>;
  pricingType: HomeownerSelectionOptionPricingType;
  pricingTypeDetail: HomeownerSelectionOptionPricingTypeDetail;
  specifications?: Maybe<Scalars['String']['output']>;
  bidContractLineItem?: Maybe<BidContractLineItem>;
};

export type HomeownerSelectionOption = Named & HomeownerSelectionOptionLike & {
  __typename?: 'HomeownerSelectionOption';
  /**   `HSO.ID`   */
  id: Scalars['ID']['output'];
  isHomeownerVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  unitCostInCents?: Maybe<Scalars['Int']['output']>;
  unitPriceInCents?: Maybe<Scalars['Int']['output']>;
  markupInCents?: Maybe<Scalars['Int']['output']>;
  markupBasisPoints?: Maybe<Scalars['Int']['output']>;
  product: Product;
  homeownerSelection: HomeownerSelection;
  isBaseOption: Scalars['Boolean']['output'];
  isRecommendedOption: Scalars['Boolean']['output'];
  isSelectedOption: Scalars['Boolean']['output'];
  canEditPrice: PotentialOperation2;
  priceDeltaInCents?: Maybe<Scalars['Int']['output']>;
  pricingType: HomeownerSelectionOptionPricingType;
  pricingTypeDetail: HomeownerSelectionOptionPricingTypeDetail;
  specifications?: Maybe<Scalars['String']['output']>;
  bidContractLineItem?: Maybe<BidContractLineItem>;
};

export type HomeownerSelectionProductOption = Named & HomeownerSelectionOptionLike & {
  __typename?: 'HomeownerSelectionProductOption';
  /**   `Product.ID`   */
  id: Scalars['ID']['output'];
  isHomeownerVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  unitCostInCents?: Maybe<Scalars['Int']['output']>;
  unitPriceInCents?: Maybe<Scalars['Int']['output']>;
  markupInCents?: Maybe<Scalars['Int']['output']>;
  markupBasisPoints?: Maybe<Scalars['Int']['output']>;
  product: Product;
  homeownerSelection: HomeownerSelection;
  isBaseOption: Scalars['Boolean']['output'];
  isRecommendedOption: Scalars['Boolean']['output'];
  isSelectedOption: Scalars['Boolean']['output'];
  canEditPrice: PotentialOperation2;
  priceDeltaInCents?: Maybe<Scalars['Int']['output']>;
  pricingType: HomeownerSelectionOptionPricingType;
  pricingTypeDetail: HomeownerSelectionOptionPricingTypeDetail;
  specifications?: Maybe<Scalars['String']['output']>;
  bidContractLineItem?: Maybe<BidContractLineItem>;
};

export type HomeownerSelectionOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  homeownerSelectionId?: InputMaybe<Scalars['ID']['input']>;
  /**  Specify a product from the global product catalog to associate with this option  */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /**  Specify to create/update a custom product to associate with this option  */
  product?: InputMaybe<ProductInput>;
  isHomeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Override the global product catalog name - for custom products specify product.name  */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  Override the global product catalog description - for custom products specify product.description  */
  description?: InputMaybe<Scalars['String']['input']>;
  /**  Override the global product catalog costInCents - for custom products specify product.costInCents  */
  unitCostInCents?: InputMaybe<Scalars['Int']['input']>;
  /**  Override the global product catalog priceInCents - for custom products specify product.priceInCents  */
  unitPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  markupBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  isBaseOption?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommendedOption?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectedOption?: InputMaybe<Scalars['Boolean']['input']>;
  priceDeltaInCents?: InputMaybe<Scalars['Int']['input']>;
  pricingType?: InputMaybe<HomeownerSelectionOptionPricingType>;
  specifications?: InputMaybe<Scalars['String']['input']>;
  bidContractLineItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type HomeownerSelectionOptionFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  productId?: InputMaybe<Array<Scalars['ID']['input']>>;
  isHomeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveHomeownerSelectionOptionResult = {
  __typename?: 'SaveHomeownerSelectionOptionResult';
  homeownerSelectionOption: HomeownerSelectionOption;
};

export type SyncCostsForHomeownerSelectionOptionsResult = {
  __typename?: 'SyncCostsForHomeownerSelectionOptionsResult';
  homeownerSelectionOptions: Array<HomeownerSelectionOption>;
};

export type SyncCostsForHomeownerSelectionOptionsInput = {
  projectId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveHomeownerSelectionOptionInput = {
  bidContractLineItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type InsideMapsRoomRendering = {
  __typename?: 'InsideMapsRoomRendering';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  asset?: Maybe<Asset>;
  readyPlanLocation: ReadyPlanLocation;
};

export type InternalUser = Named & {
  __typename?: 'InternalUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  avatar: Scalars['String']['output'];
  projectRole?: Maybe<ProjectRole>;
  projectRoleDetail?: Maybe<ProjectRoleDetail>;
  user: User;
  /** Approvals this user has SUBMIT */
  approvals: Array<Approval>;
  /** Approvals this user is an Approver on. Defaults to only ActionRequired status. */
  approvers: Array<Approver>;
  projectDashboardConfig?: Maybe<DashboardConfig>;
  warrantyTickets: Array<WarrantyTicket>;
};


export type InternalUserApproversArgs = {
  status?: InputMaybe<Array<ApproverStatus>>;
};

export type SaveInternalUserInput = {
  /** email is inferred from the current/impersonating user if not explicitly passed */
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  projectRole?: InputMaybe<ProjectRole>;
  projectDashboardConfig?: InputMaybe<DashboardConfigInput>;
  impersonateTradePartnerUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type InternalUserFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  projectRole?: InputMaybe<Array<ProjectRole>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveInternalUserResult = {
  __typename?: 'SaveInternalUserResult';
  internalUser: InternalUser;
};

export type DashboardConfigInput = {
  tileConfigs?: InputMaybe<Array<DashboardTileConfigInput>>;
};

export type DashboardTileConfigInput = {
  tile: DashboardTile;
  size: DashboardTileSize;
};

export type DashboardConfig = {
  __typename?: 'DashboardConfig';
  tileConfigs?: Maybe<Array<DashboardTileConfig>>;
};

export type DashboardTileConfig = {
  __typename?: 'DashboardTileConfig';
  tile: DashboardTile;
  size: DashboardTileSize;
};

export type ReassignTeamMembersInput = {
  sourceUserEmail: Scalars['String']['input'];
  targetUserEmail: Scalars['String']['input'];
};

export enum DashboardTile {
  ProjectSchedule = 'ProjectSchedule',
  ProjectInfo = 'ProjectInfo',
  ProjectFinances = 'ProjectFinances',
  ProjectDocuments = 'ProjectDocuments',
  ProjectToDos = 'ProjectToDos',
  ProjectJobLogs = 'ProjectJobLogs',
  ProjectTeamMembers = 'ProjectTeamMembers',
  ProjectPhotos = 'ProjectPhotos',
  ProjectHomeownerNotes = 'ProjectHomeownerNotes'
}

export enum DashboardTileSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE'
}

export type InvoiceParent = PlanMilestone | Task | ScheduleTask | PlanTask;

export type SaveInvoiceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  quickbooksId?: InputMaybe<Scalars['String']['input']>;
  amountPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  lineItems?: InputMaybe<Array<SaveInvoiceLineItemInput>>;
  drawLineItems?: InputMaybe<Array<SaveInvoiceDrawLineItemInput>>;
  quickbooksPullOnly?: InputMaybe<Scalars['Boolean']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  intacctAmountPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  quickbooksAmountPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  intacctSyncError?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  lineItemCutoffDate?: InputMaybe<Scalars['Date']['input']>;
  lineItemStartDate?: InputMaybe<Scalars['Date']['input']>;
  paidDate?: InputMaybe<Scalars['Date']['input']>;
  creditForInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  intacctId?: InputMaybe<Scalars['String']['input']>;
  /** The update source (e.g intacct). Used to determine if the invoice should be synced to Intacct. */
  updateSource?: InputMaybe<UpdateInvoiceSource>;
  type?: InputMaybe<InvoiceType>;
};

export type SaveInvoicesInput = {
  invoices: Array<SaveInvoiceInput>;
};

export type SyncInvoiceToIntacctInput = {
  id: Scalars['ID']['input'];
};

export type SaveInvoiceResult = {
  __typename?: 'SaveInvoiceResult';
  invoice: Invoice;
};

export type SaveInvoicesResult = {
  __typename?: 'SaveInvoicesResult';
  invoices: Array<Invoice>;
};

export type InvoiceLineItemsByCostCode = {
  __typename?: 'InvoiceLineItemsByCostCode';
  costCode: CostCode;
  totalAmountInCents: Scalars['Int']['output'];
  lineItems: Array<InvoiceLineItem>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  id: Scalars['ID']['output'];
  amountInCents: Scalars['Int']['output'];
  /** used for bool invoice sync to correctly calculate journal entries, can be ignored by non-bool invoices */
  marginInCents?: Maybe<Scalars['Int']['output']>;
  homeownerContractLineItem: HomeownerContractLineItem;
  invoice: Invoice;
  costLineItemAllocations: Array<CostLineItemAllocation>;
  downPaymentInvoice?: Maybe<Invoice>;
};

export type SaveInvoiceLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  homeownerContractLineItemId?: InputMaybe<Scalars['ID']['input']>;
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  costLineItemAllocations?: InputMaybe<Array<SaveInvoiceCostLineItemAllocationInput>>;
};

export type SaveInvoiceCostLineItemAllocationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  costLineItemId?: InputMaybe<Scalars['ID']['input']>;
  costAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  invoicedAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceDrawLineItem = {
  __typename?: 'InvoiceDrawLineItem';
  id: Scalars['ID']['output'];
  draw: HomeownerContractDraw;
  invoice: Invoice;
};

export type InvoiceScheduledLineItem = {
  __typename?: 'InvoiceScheduledLineItem';
  id: Scalars['ID']['output'];
  amountInCents: Scalars['Int']['output'];
  amountInBasisPoints: Scalars['Int']['output'];
  marginInCents: Scalars['Int']['output'];
  invoice: Invoice;
  invoiceScheduleItem: InvoiceScheduleItem;
  invoiceLineItems: Array<InvoiceLineItem>;
};

export type InvoiceAccruedLineItem = {
  __typename?: 'InvoiceAccruedLineItem';
  id: Scalars['ID']['output'];
  amountInCents: Scalars['Int']['output'];
  marginInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costClassificationType: CostClassificationTypeDetail;
  invoice: Invoice;
  invoiceCategory?: Maybe<CostCodeInvoiceCategoryDetail>;
};

/**
 * A unified representation of invoice line items from different sources
 * (regular, scheduled, accrued, and draw) normalized for UI display.
 */
export type InvoiceDisplayLineItem = {
  __typename?: 'InvoiceDisplayLineItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  costClassificationType?: Maybe<CostClassificationTypeDetail>;
  amountInCents: Scalars['Int']['output'];
  marginInCents?: Maybe<Scalars['Int']['output']>;
};

export type SaveInvoiceDrawLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  drawId?: InputMaybe<Scalars['ID']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteInvoiceInput = {
  id: Scalars['ID']['input'];
};

export type InvoiceFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  quickbooksId?: InputMaybe<Array<Scalars['String']['input']>>;
  dueDate?: InputMaybe<DateFilter2>;
  marketId?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Array<Scalars['ID']['input']>>;
  assigneeId?: InputMaybe<Array<Scalars['ID']['input']>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Array<Stage>>;
  status?: InputMaybe<Array<InvoiceStatus>>;
};

export type InvoiceOrder = {
  id?: InputMaybe<Order>;
  invoiceDate?: InputMaybe<Order>;
  dueDate?: InputMaybe<Order>;
  paidDate?: InputMaybe<Order>;
};

export type InvoicesPage = {
  __typename?: 'InvoicesPage';
  entities: Array<Invoice>;
  pageInfo: PageInfo;
};

export enum UpdateInvoiceSource {
  Intacct = 'INTACCT'
}

export enum InvoiceDisplayLineItemMode {
  Pdf = 'PDF',
  Invoice = 'INVOICE'
}

export type InvoiceDocument = {
  __typename?: 'InvoiceDocument';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  documentSource: InvoiceDocumentSourceDetail;
  document: Document;
  invoice: Invoice;
};

export type SaveInvoiceDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  documentSource?: InputMaybe<InvoiceDocumentSource>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveInvoiceDocumentResult = {
  __typename?: 'SaveInvoiceDocumentResult';
  invoiceDocument: InvoiceDocument;
};

export type DeleteInvoiceScheduleInput = {
  projectIds: Array<Scalars['ID']['input']>;
};

export type DeleteInvoiceScheduleResult = {
  __typename?: 'DeleteInvoiceScheduleResult';
  projects: Array<Project>;
};

export type InvoiceSchedule = {
  __typename?: 'InvoiceSchedule';
  id: Scalars['ID']['output'];
  softCostDayOfMonth?: Maybe<Scalars['Int']['output']>;
  hardCostDayOfMonth?: Maybe<Scalars['Int']['output']>;
  hardCostAmountType: InvoiceScheduleAmountTypeDetail;
  softCostAmountType: InvoiceScheduleAmountTypeDetail;
  hardCostTriggerType: InvoiceScheduleTriggerTypeDetail;
  softCostTriggerType: InvoiceScheduleTriggerTypeDetail;
  invoiceScheduleTemplate: InvoiceScheduleTemplate;
  project: Project;
  items: Array<InvoiceScheduleItem>;
};

export type InvoiceScheduleItem = {
  __typename?: 'InvoiceScheduleItem';
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  iteration: Scalars['Int']['output'];
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  amountInBasisPoints: Scalars['Int']['output'];
  originalAmountInCents: Scalars['Int']['output'];
  changeOrderAmountInCents: Scalars['Int']['output'];
  revisedAmountInCents: Scalars['Int']['output'];
  costClassificationType: CostClassificationTypeDetail;
  invoiceScheduleItemFrequency: InvoiceScheduleItemFrequencyDetail;
  invoiceSchedule: InvoiceSchedule;
  parent?: Maybe<InvoiceScheduleItemParent>;
  globalParent: InvoiceScheduleItemGlobalParent;
  invoiceScheduledLineItems: Array<InvoiceScheduledLineItem>;
  changeOrders: Array<HomeownerContractChangeOrder>;
  invoiceDelayInDays: Scalars['Int']['output'];
};

export type InvoiceScheduleItemParent = PlanMilestone | ScheduleTask;

export type InvoiceScheduleItemGlobalParent = GlobalPlanMilestone | GlobalTask;

export type InvoiceScheduleTemplate = Named & {
  __typename?: 'InvoiceScheduleTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  softCostDayOfMonth?: Maybe<Scalars['Int']['output']>;
  hardCostDayOfMonth?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  hardCostAmountType: InvoiceScheduleAmountTypeDetail;
  softCostAmountType: InvoiceScheduleAmountTypeDetail;
  hardCostTriggerType: InvoiceScheduleTriggerTypeDetail;
  softCostTriggerType: InvoiceScheduleTriggerTypeDetail;
  lotType: LotTypeDetail;
  communityType?: Maybe<CommunityTypeDetail>;
  customer?: Maybe<Customer>;
  items: Array<InvoiceScheduleTemplateItem>;
  invoiceSchedules: Array<InvoiceSchedule>;
  region?: Maybe<Region>;
};

export type SaveInvoiceScheduleTemplateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  softCostDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  hardCostDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  hardCostAmountType?: InputMaybe<InvoiceScheduleAmountType>;
  softCostAmountType?: InputMaybe<InvoiceScheduleAmountType>;
  hardCostTriggerType?: InputMaybe<InvoiceScheduleTriggerType>;
  softCostTriggerType?: InputMaybe<InvoiceScheduleTriggerType>;
  lotType?: InputMaybe<LotType>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<SaveInvoiceScheduleTemplateItemInput>>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  communityType?: InputMaybe<CommunityType>;
};

export type SaveInvoiceScheduleTemplateResult = {
  __typename?: 'SaveInvoiceScheduleTemplateResult';
  invoiceScheduleTemplate: InvoiceScheduleTemplate;
};

export type InvoiceScheduleTemplateItem = {
  __typename?: 'InvoiceScheduleTemplateItem';
  id: Scalars['ID']['output'];
  iterations: Scalars['Int']['output'];
  amountInBasisPoints: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costClassificationType: CostClassificationTypeDetail;
  frequency: InvoiceScheduleItemFrequencyDetail;
  /** @deprecated use globalPlanMilestone instead */
  globalTask?: Maybe<GlobalTask>;
  invoiceScheduleTemplate: InvoiceScheduleTemplate;
  globalPlanMilestone: GlobalPlanMilestone;
  invoiceDelayInDays: Scalars['Int']['output'];
};

export type SaveInvoiceScheduleTemplateItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  iterations?: InputMaybe<Scalars['Int']['input']>;
  amountInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  costClassificationType?: InputMaybe<CostClassificationType>;
  frequency?: InputMaybe<InvoiceScheduleItemFrequency>;
  invoiceScheduleTemplateId?: InputMaybe<Scalars['ID']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  globalPlanMilestoneId?: InputMaybe<Scalars['ID']['input']>;
  invoiceDelayInDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveItemsInput = {
  items: Array<SaveItemInput>;
};

export type SaveItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  isSelection?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Moving an item to a new cost code after creation is not supported.  */
  costCodeId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ItemStatus>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Scalars['String']['input']>;
  tradePartnerNote?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  tradeCategoryId?: InputMaybe<Scalars['ID']['input']>;
  cutoffId?: InputMaybe<Scalars['ID']['input']>;
  materialAttributeDimensions?: InputMaybe<Array<SaveItemMaterialAttributeDimensionInput>>;
  materialCodePrefix?: InputMaybe<Scalars['String']['input']>;
  isAnnotated?: InputMaybe<Scalars['Boolean']['input']>;
  materialNameFormat?: InputMaybe<Scalars['String']['input']>;
  designPackageLocation?: InputMaybe<DesignPackageLocation>;
  isMaterialModifier?: InputMaybe<Scalars['Boolean']['input']>;
  parentModifierItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionPricingConfig?: InputMaybe<SavePersonalizationOptionPricingConfigInput>;
  materialLeadTimeConfig?: InputMaybe<SavePersonalizationMaterialLeadTimeConfigInput>;
};

export type SaveItemMaterialAttributeDimensionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  isAdminManaged?: InputMaybe<Scalars['Boolean']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  materialAttributeValues?: InputMaybe<Array<SaveMaterialAttributeDimensionValueInput>>;
  type?: InputMaybe<MaterialAttributeDimensionType>;
  useInTakeoff?: InputMaybe<Scalars['Boolean']['input']>;
  useInVisualModePdf?: InputMaybe<Scalars['Boolean']['input']>;
  showInFinishSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  op: IncrementalCollectionOp;
};

export type Item = Named & HasDisplayName & HasMaterialLeadTimeConfigData & {
  __typename?: 'Item';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**  I.e. 3100.001 Appliance Installation  */
  displayName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  costCode: CostCode;
  /**  Just the trailing `001` code of this item within it's cost code.  */
  itemCode: Scalars['Int']['output'];
  /**  The cost code number + item code, i.e. `3100.001`.  */
  fullCode: Scalars['String']['output'];
  isSelection: Scalars['Boolean']['output'];
  status: ItemStatusDetail;
  internalNote?: Maybe<Scalars['String']['output']>;
  specifications?: Maybe<Scalars['String']['output']>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  unitOfMeasure: UnitOfMeasure;
  tradeCategory?: Maybe<TradeCategory>;
  cutoff?: Maybe<Cutoff>;
  bidItems: Array<BidItem>;
  isContingency?: Maybe<Scalars['Boolean']['output']>;
  materialAttributeDimensions: Array<MaterialAttributeDimension>;
  materialListings: Array<MaterialListing>;
  materialBrands: Array<MaterialBrand>;
  materialCodePrefix?: Maybe<Scalars['String']['output']>;
  placeholderMaterialListing?: Maybe<MaterialListing>;
  isAnnotated: Scalars['Boolean']['output'];
  planTaskMappings: Array<ItemPlanTaskMapping>;
  /**  Item version pulled from cost code  */
  version: Scalars['Int']['output'];
  /**  Format used for materials related to this Item. For example: '{depth}x{width} - {length} {name}' where depth, width, and length are material attribute dimensions.  */
  materialNameFormat?: Maybe<Scalars['String']['output']>;
  designPackageLocation: DesignPackageLocationDetail;
  isMaterialModifier: Scalars['Boolean']['output'];
  /**  Determines if this is an Assembly parent-or-item (either a MAC assembly_id or component_id). Please only call this on a per-item basis and not in bulk.  */
  isAssemblyRelated: Scalars['Boolean']['output'];
  /**  The parent Items that this modifier Item is allowed to modify.  */
  parentModifierItems: Array<Item>;
  /**  The modifier Items registered as children of this parent Item.  */
  childModifierItems: Array<Item>;
  canBecomeMaterialModifier: PotentialOperation2;
  optionPricingConfig?: Maybe<OptionPricingConfig>;
  materialLeadTimeConfig?: Maybe<MaterialLeadTimeConfig>;
  /**  The minLeadTimeInDays for this Item, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its CostCode.  */
  minLeadTimeInDays: Scalars['Int']['output'];
  /**  The expectedLeadTimeInDays for this Item, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its CostCode.  */
  expectedLeadTimeInDays: Scalars['Int']['output'];
  /**  The maxLeadTimeInDays for this Item, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its CostCode.  */
  maxLeadTimeInDays: Scalars['Int']['output'];
  history: Array<History>;
};

export type DeleteItemInput = {
  id: Scalars['ID']['input'];
};

export type ItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  version?: InputMaybe<Array<Scalars['Int']['input']>>;
  costCode?: InputMaybe<Array<Scalars['ID']['input']>>;
  isSelection?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ItemStatus>>;
  designPackageLocation?: InputMaybe<DesignPackageLocation>;
};

export type ItemPlanTaskMapping = {
  __typename?: 'ItemPlanTaskMapping';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  item: Item;
  location?: Maybe<Location>;
  task: GlobalPlanTask;
  estimatedLaborCostInCents?: Maybe<Scalars['Int']['output']>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};

export type SaveItemPlanTaskMappingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  estimatedLaborCostInCents?: InputMaybe<Scalars['Int']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteItemPlanTaskMappingInput = {
  id: Scalars['ID']['input'];
};

export type SaveItemPlanTaskMappingResult = {
  __typename?: 'SaveItemPlanTaskMappingResult';
  itemPlanTaskMapping: ItemPlanTaskMapping;
};

export type ItemPlanTaskMappingPage = {
  __typename?: 'ItemPlanTaskMappingPage';
  entities: Array<ItemPlanTaskMapping>;
  pageInfo: PageInfo;
};

export type ItemSlot = Named & {
  __typename?: 'ItemSlot';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  item: Item;
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  isSelection: Scalars['Boolean']['output'];
};

export type SaveItemSlotInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  costType?: InputMaybe<CostType>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  isSelection?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveItemSlotResult = {
  __typename?: 'SaveItemSlotResult';
  itemSlot: ItemSlot;
};

export type ItemTemplate = Named & HasDisplayName & HasDisplayVersion & BaseItemParent & BaseItemParentVersion & {
  __typename?: 'ItemTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  items: Array<ItemTemplateItem>;
  status: ItemTemplateStatus;
  statusDetail: ItemTemplateStatusDetail;
  /**  Whether this is a plan template (only one per stage) or an option template (many per stage) */
  isPlanTemplate: Scalars['Boolean']['output'];
  stage: Stage;
  stageDetail: StageDetail;
  description?: Maybe<Scalars['String']['output']>;
  applyTemplatePlan: Array<ItemTemplateItemPlan>;
  applyTemplatePlanChangeEvent: Array<ItemTemplateItemPlan>;
  development?: Maybe<Development>;
  specOptions: Array<ReadyPlanOption>;
  totalCostInCents: Scalars['Int']['output'];
  isReadyHomeTemplate: Scalars['Boolean']['output'];
  /** @deprecated This operation is now always allowed */
  canCopyItemsToTemplate: PotentialOperation2;
  canApplyTo: PotentialOperation2;
  canUnlock: PotentialOperation2;
  /** Indicates whether this template can be activated */
  canActivate: PotentialOperation2;
  canCreateNewVersion: PotentialOperation2;
  canEditLineItems: PotentialOperation2;
  /** Indicates whether this template can be deleted individually */
  canDelete: PotentialOperation2;
  readyPlan?: Maybe<ReadyPlan>;
  displayName: Scalars['String']['output'];
  /** Indicates if there are any templates which can be cloned to from this template */
  hasCloneToTargets: PotentialOperation2;
  /** List of templates within the development which can be cloned to from this template */
  cloneToTargets: Array<ItemTemplate>;
  /** Timestamp when the template was activated, if it has been activated */
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the template was archived, if it has been archived */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A collection of templates which represent the different versions of this template over time.
   *
   * Templates which do not have a collection are not versioned, but can become versioned if desired.
   */
  collection?: Maybe<ItemTemplateCollection>;
  /** ItemTemplateVersions in this particular template */
  itemVersions: Array<ItemTemplateItemVersion>;
  major: Scalars['Int']['output'];
  minor: Scalars['Int']['output'];
  scopeChangeType: ScopeChangeType;
  scopeChangeTypeDetail: ScopeChangeTypeDetail;
  scopeChangeReason?: Maybe<ScopeChangeReason>;
  /** The template on which this template was based */
  basedOn?: Maybe<ItemTemplate>;
  /** All templates which have been based off of this template */
  templatesBasedOn: Array<ItemTemplate>;
  isVersioned: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  /** Returns the amount of projects this templates has being applied to */
  appliedToCount: Scalars['Int']['output'];
  isLatest: Scalars['Boolean']['output'];
  isLatestActive: Scalars['Boolean']['output'];
  scopeChangeReasonNote?: Maybe<Scalars['String']['output']>;
  /** Returns the unique options which are associated with ITIs in this template */
  options: Array<ReadyPlanOption>;
  /** Template version number in format v[major].[minor] */
  version: Scalars['String']['output'];
  /** Template version number which includes whether the template is currently being drafted off a prior version. EX: Editing from v[major].[minor] */
  displayVersion: Scalars['String']['output'];
  /** Experimental feature to detect issues in scope templates */
  anomalies: Array<ItemTemplateAnomaly>;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']['output']>;
  /** Flag that will be true if the template has any item template item using an item flagged as contingency */
  hasContingencyLineItem: Scalars['Boolean']['output'];
  sourceForApprovals: Array<Approval>;
  /**  Whether this specific template version is used by UW to drive plan costs & project creation.  */
  isUnderwritingTemplate: Scalars['Boolean']['output'];
  lastUsedAsUnderwritingTemplate?: Maybe<Scalars['Date']['output']>;
  itemLocations: Array<Location>;
  tradeCategories: Array<TradeCategory>;
  costCodes: Array<CostCode>;
};


export type ItemTemplateApplyTemplatePlanArgs = {
  projectStageId: Scalars['ID']['input'];
};


export type ItemTemplateApplyTemplatePlanChangeEventArgs = {
  changeEventId: Scalars['ID']['input'];
};


export type ItemTemplateCanCopyItemsToTemplateArgs = {
  targetTemplate: Scalars['ID']['input'];
};


export type ItemTemplateCanApplyToArgs = {
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

/**  For a given template item, where it can replace a project item on merge.  */
export type ItemTemplateItemPlan = {
  __typename?: 'ItemTemplateItemPlan';
  itemTemplateItem: ItemTemplateItem;
  projectItem?: Maybe<ProjectItem>;
};

export type SaveItemTemplateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ItemTemplateStatus>;
  stage?: InputMaybe<Stage>;
  description?: InputMaybe<Scalars['String']['input']>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  scopeChangeReasonId?: InputMaybe<Scalars['ID']['input']>;
  scopeChangeReasonNote?: InputMaybe<Scalars['String']['input']>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveItemTemplateResult = {
  __typename?: 'SaveItemTemplateResult';
  itemTemplate: ItemTemplate;
};

export type SaveItemTemplatesInput = {
  itemTemplates: Array<SaveItemTemplateInput>;
  /** If true, a reason code specified for a particular template will be propagated to all of its ITIVs */
  applyReasonToAllItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, a reason code specified for a particular template will only be applied if the reason code has not already been set */
  applyReasonWhenNotSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveItemTemplatesResult = {
  __typename?: 'SaveItemTemplatesResult';
  itemTemplates?: Maybe<Array<Maybe<ItemTemplate>>>;
};

export type ApplyItemTemplateInput = {
  id: Scalars['ID']['input'];
  projectStageId: Scalars['ID']['input'];
  /**
   * An optional list of each item to apply, and an optional existing project item it should merge into.
   *
   * If `items` is not provided, then all items in the template are appended to the project scope.
   */
  items?: InputMaybe<Array<ApplyItemTemplateItemInput>>;
};

export type ApplyItemTemplateItemInput = {
  itemTemplateItemId: Scalars['ID']['input'];
  projectItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type ApplyItemTemplateResult = {
  __typename?: 'ApplyItemTemplateResult';
  projectItems: Array<ProjectItem>;
  projectStage: ProjectStage;
  userErrors?: Maybe<Array<UserError>>;
};

export type ItemTemplateFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  stage?: InputMaybe<Array<Stage>>;
  status?: InputMaybe<Array<ItemTemplateStatus>>;
  isReadyHomeTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  canCopyItemsTo?: InputMaybe<Scalars['ID']['input']>;
  readyPlan?: InputMaybe<Array<Scalars['ID']['input']>>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  scopeChangeType?: InputMaybe<Array<ScopeChangeType>>;
};

export type ChildItemTemplateFilter = {
  status?: InputMaybe<Array<ItemTemplateStatus>>;
};

export type ApplyItemTemplateToChangeEventInput = {
  id: Scalars['ID']['input'];
  changeEventId: Scalars['ID']['input'];
  /**
   * An optional list of each item to apply, and an optional existing project item it should merge into.
   *
   * If `items` is not provided, then all items in the template are appended to the project scope.
   */
  items?: InputMaybe<Array<ApplyItemTemplateItemInput>>;
};

export type ApplyItemTemplateToChangeEventResult = {
  __typename?: 'ApplyItemTemplateToChangeEventResult';
  lineItems: Array<ChangeEventLineItem>;
  changeEvent: ChangeEvent;
};

export type CloneItemTemplateInput = {
  original: Scalars['ID']['input'];
  /**
   * When cloneTo is specified, it must either:
   *
   * Reference another Whole House template for the same ReadyPlan, and must not be the same as original.
   *
   * This will have the following side effects:
   * 1) Any ItemTemplateItems in the Whole House template, or any Option Templates, will be deleted
   * 2) ItemTemplateItems from original, and its Option Templates (depending on the value of includeChildren), will be copied into cloneTo and its childTemplates.
   *
   * OR reference a different Development, in which case the cloned template will be created in a different development, and unassigned from any ReadyPlan/Options.
   */
  cloneTo?: InputMaybe<Scalars['ID']['input']>;
  /** Name for the cloned template. Defaults to `[Original Name] Copy` */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CloneItemTemplateResult = {
  __typename?: 'CloneItemTemplateResult';
  original: ItemTemplate;
  clone: ItemTemplate;
};

export type CopyItemTemplateItemsInput = {
  targetTemplateId: Scalars['ID']['input'];
  sourceTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** Accepts only ITIV IDs */
  sourceItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The RPO id to assign to the new items */
  targetOptionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The RPO id to assign as elevation to the new items */
  targetElevationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CopyItemTemplateItemsResult = {
  __typename?: 'CopyItemTemplateItemsResult';
  targetTemplate: ItemTemplate;
  /** The templates from which copied items originated from */
  sourceTemplates: Array<ItemTemplate>;
  /** The sourceItems which were cloned, when sourceItemIds was specified and contained ITIV IDs, otherwise [] */
  sourceItemVersions: Array<ItemTemplateItemVersion>;
  /** The ITIs that were copied during the operation */
  copiedItems: Array<ItemTemplateItem>;
  /** The ITIVs that were copied during the operation */
  copiedItemVersions: Array<ItemTemplateItemVersion>;
};

export type CreateNewItemTemplateVersionsInput = {
  id: Array<Scalars['ID']['input']>;
  /** Optional ScopeChangeReason ID to be applied to all newly created templates/ITIVs */
  scopeChangeReasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateNewItemTemplateVersionsResult = {
  __typename?: 'CreateNewItemTemplateVersionsResult';
  newTemplates: Array<ItemTemplate>;
};

export type ActivateItemTemplateVersionsInput = {
  /**
   * A list of templates to activate and push to projects.
   * If templates specified are already Active, they'll be ignored.
   */
  templateId: Array<Scalars['ID']['input']>;
};

export type ActivateItemTemplateVersionsResult = {
  __typename?: 'ActivateItemTemplateVersionsResult';
  /** Templates which were successfully activated */
  activatedTemplates: Array<ItemTemplate>;
};

export type ArchiveItemTemplateVersionsInput = {
  /** A list of templates to archive. */
  templateId: Array<Scalars['ID']['input']>;
  /**
   * When true, all active versions of this template will be archived. This is useful when an entire ReadyPlan is being archived and no longer needed.
   * When left unspecified or set to false, then only the specific versions of templates specified by `templateId` will be archived.
   */
  archiveAllVersions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemTemplateOrder = {
  id?: InputMaybe<Order>;
  activatedAt?: InputMaybe<Order>;
};

export type ItemTemplateAnomalyParent = ItemTemplate | ItemTemplateItemVersion;

export type ItemTemplateAnomaly = {
  __typename?: 'ItemTemplateAnomaly';
  id: Scalars['ID']['output'];
  type: ItemTemplateAnomalyType;
  parent: ItemTemplateAnomalyParent;
  description: Scalars['String']['output'];
};

export enum ItemTemplateAnomalyType {
  TemplateMissingScopeForOption = 'TEMPLATE_MISSING_SCOPE_FOR_OPTION',
  TemplateIncludesScopeForArchivedOption = 'TEMPLATE_INCLUDES_SCOPE_FOR_ARCHIVED_OPTION',
  LineItemCostHigherThanOthers = 'LINE_ITEM_COST_HIGHER_THAN_OTHERS',
  LineItemCostLowerThanOthers = 'LINE_ITEM_COST_LOWER_THAN_OTHERS',
  LineItemNotPresentOnOthers = 'LINE_ITEM_NOT_PRESENT_ON_OTHERS',
  AddLineItemMissingModifiersFromOthers = 'ADD_LINE_ITEM_MISSING_MODIFIERS_FROM_OTHERS'
}

export type ItemTemplateCollection = {
  __typename?: 'ItemTemplateCollection';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** All templates in this collection */
  templates: Array<ItemTemplate>;
  /** The draft template if there's any, else highest version number that's active */
  latest?: Maybe<ItemTemplate>;
};

export type ItemTemplateCostUpdate = {
  __typename?: 'ItemTemplateCostUpdate';
  id: Scalars['ID']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  bidContractRevision: BidContractRevision;
  itemTemplate: ItemTemplate;
};

export type ItemTemplateItem = Named & HasDisplayName & HasBlueprintUrl & BaseItemLike & {
  __typename?: 'ItemTemplateItem';
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  slot: ItemSlot;
  item: Item;
  template: ItemTemplate;
  location: Location;
  quantity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  baseProduct?: Maybe<Product>;
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  isSelection: Scalars['Boolean']['output'];
  specifications?: Maybe<Scalars['String']['output']>;
  unitOfMeasure: UnitOfMeasure;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /**
   * Returns the associated ItemTemplate.
   * The `displayVersion` field still reaches through to the `ReadyPlan.displayName` which is the most common use case of this field
   */
  parent: ItemTemplate;
  readyPlan?: Maybe<ReadyPlanLike>;
  /**  Same value as `parent`, but provides consistency with TLI[V] access patterns.  */
  first: ItemTemplate;
  totalCostInCents: Scalars['Int']['output'];
  unitCostInCents: Scalars['Int']['output'];
  canDeleteItem: PotentialOperation2;
  /** A convenience accessor for ItemTemplate.canEditLineItems to provide API consistency between ITI/ITIV. */
  canEdit: PotentialOperation2;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  /** Hash of the key fields which make up the logical identity of this ItemTemplateItem */
  identityHash?: Maybe<Scalars['String']['output']>;
  /** Hash of the major fields of this ItemTemplateItem */
  majorHash?: Maybe<Scalars['String']['output']>;
  /** Hash of the minor fields of this ItemTemplateItem */
  minorHash?: Maybe<Scalars['String']['output']>;
  /** All ItemTemplateItemVersions which reference this ItemTemplateItem */
  versions: Array<ItemTemplateItemVersion>;
  /** The ItemTemplateItem on from which this ItemTemplateItem was based on */
  basedOn?: Maybe<ItemTemplateItem>;
  /** Collection of ItemTemplateItems which have been based on this ItemTemplateItem. In most cases it will be 0 or 1, unless someone branched from the same ItemTemplate multiple times. */
  itemsBasedOn: Array<ItemTemplateItem>;
  /** The original ItemTemplateItem from which others are based. */
  original?: Maybe<ItemTemplateItem>;
  bidItem?: Maybe<BidItem>;
  isDisabledMaterialVariant: Scalars['Boolean']['output'];
  potentialBidItems: Array<BidItem>;
  /**  Helper for the FE multi-select dropdown  */
  elevationIds: Array<Scalars['ID']['output']>;
  /**  Helper for the FE multi-select dropdown  */
  specOptionIds: Array<Scalars['ID']['output']>;
  /**  Helper for the FE multi-select dropdown  */
  otherOptionIds: Array<Scalars['ID']['output']>;
  /**  All of the elevation + specOption + option RPOs as a single list.  */
  options: Array<ReadyPlanOption>;
  blueprintUrl: Url;
  bidItemTemplateItem?: Maybe<ItemTemplateItem>;
  task?: Maybe<GlobalPlanTask>;
  costStatus: ItemTemplateItemCostStatusDetail;
  /** @deprecated Use laborLine instead */
  laborIti?: Maybe<ItemTemplateItem>;
  laborLine?: Maybe<ItemTemplateItem>;
  materialVariant?: Maybe<MaterialVariant>;
  development?: Maybe<Development>;
  costEstimate: CostEstimate;
  customPlaceholderName?: Maybe<Scalars['String']['output']>;
};

export type CostEstimate = {
  __typename?: 'CostEstimate';
  costInCents: Scalars['Int']['output'];
};

export type ItemTemplateItemVersionsPage = {
  __typename?: 'ItemTemplateItemVersionsPage';
  items: Array<ItemTemplateItemVersion>;
  pageInfo: PageInfo;
  /** These are totals for items in the template grouped by either cost code or option depending on the primary ordering */
  groupTotals: Array<ItemTemplateItemVersionGroupTotal>;
};

export type ItemTemplateItemVersionGroupTotal = {
  __typename?: 'ItemTemplateItemVersionGroupTotal';
  groupId: Scalars['String']['output'];
  totalCostInCents: Scalars['Int']['output'];
  itivsInGroup: Scalars['Int']['output'];
  itivIdsInGroup: Array<Scalars['ID']['output']>;
  displayName: Scalars['String']['output'];
  /** The number of itis with costType = MATERIAL in the group */
  materialsInGroup: Scalars['Int']['output'];
  /** The number of itis with costType = LABOR in the group */
  tasksInGroup: Scalars['Int']['output'];
};

export type ItiAnomaly = {
  __typename?: 'ItiAnomaly';
  /** Descriptoin of the anomaly detected */
  description: Scalars['String']['output'];
};

export type ItemTemplateItemVersionFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  template?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  scopeChangeType?: InputMaybe<Array<ScopeChangeType>>;
  scopeChangeReason?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Return any ITIV which includes the specified location IDs in its location path */
  locationInPath?: InputMaybe<Array<Scalars['ID']['input']>>;
  item?: InputMaybe<Array<Scalars['ID']['input']>>;
  unitOfMeasure?: InputMaybe<Array<Scalars['ID']['input']>>;
  costType?: InputMaybe<Array<CostType>>;
  costCode?: InputMaybe<Array<Scalars['ID']['input']>>;
  costDivision?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter based on the spec levels assigned to the item. Examples:
   * undefined => no filtering at all based on spec level
   * [] => no items will be returned
   * [null] => items without any associated spec level will be returned
   * [null, "gsl:1", "gsl:2"] => items with GSL 1/2 or no spec level at all will be returned
   */
  specOption?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /**
   * Used to leave itivs that have scopeChangeType = REMOVED out of the result,
   * providing this flag will override any scopeChangeType filter being used, as (all types except Removed)
   */
  excludeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Include 'null' in the list of IDs to return items have elevation === null
   * (which means they are applicable to ALL elevations),
   * in addition to the specific elevation IDs requested
   */
  elevation?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /**
   * Include 'null' in the list of IDs to return items have option === null
   * (which means they are applicable to ALL options),
   * in addition to the specified option IDs requested
   */
  option?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /**
   * Include 'null' in the list of IDs to return items having no options assigned.
   * This means they are applicable to the plan generally, regardless of options chosen.
   * Unlike the option/specOption/elevation filters, this is applied to all assigned options regardless of type.
   */
  options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /**
   * Filter based on underlying Global Option. Useful for loading similar options across multiple
   * templates. More general than `options` filter and IGNORED if `option` is non-empty.
   */
  globalOption?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter based on text search using SQL LIKE */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter based on whether the item have anomalies or not. Currently only true or undefined is supported */
  hasAnomalies?: InputMaybe<Scalars['Boolean']['input']>;
  materialType?: InputMaybe<Array<MaterialType>>;
  globalPlanTask?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveItemTemplateItemVersionsInput = {
  /**
   * The template to which all ITIVs will be associated.
   * This is equivalent to specifying the templateId on each SaveItemTemplateItemVersionInput, and will override it if specified.
   */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  itemTemplateItemVersions: Array<SaveItemTemplateItemVersionInput>;
};

export type SaveItemTemplateItemVersionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Used to associate an existing ITI with a version/template */
  scopeId?: InputMaybe<Scalars['ID']['input']>;
  scopeChangeReasonId?: InputMaybe<Scalars['ID']['input']>;
  scopeChangeReasonNote?: InputMaybe<Scalars['String']['input']>;
  slotId?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  baseProductId?: InputMaybe<Scalars['ID']['input']>;
  costType?: InputMaybe<CostType>;
  specifications?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerNote?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  totalCostInCents?: InputMaybe<Scalars['Int']['input']>;
  isSelection?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Used to delete/remove an ITIV as appropriate based on whether it is hard-deletable  */
  remove?: InputMaybe<Scalars['Boolean']['input']>;
  bidItemId?: InputMaybe<Scalars['ID']['input']>;
  bidItemCode?: InputMaybe<Scalars['String']['input']>;
  /**  Helper for the FE multi-select dropdown  */
  elevationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Helper for the FE multi-select dropdown  */
  specOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Helper for the FE multi-select dropdown  */
  otherOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  preferredBidContractLineItemId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  materialVariantId?: InputMaybe<Scalars['ID']['input']>;
  /** These are FE helpers for CSV imports, to get resolved from real entities */
  itemCode?: InputMaybe<Scalars['String']['input']>;
  costTypeName?: InputMaybe<Scalars['String']['input']>;
  materialVariantCode?: InputMaybe<Scalars['String']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureName?: InputMaybe<Scalars['String']['input']>;
  optionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupTotalsInput = {
  filter?: InputMaybe<ItemTemplateItemVersionFilter>;
  order?: InputMaybe<Array<ItemTemplateItemVersionOrder>>;
};

export type SaveItemTemplateItemVersionsResult = {
  __typename?: 'SaveItemTemplateItemVersionsResult';
  itemTemplateItemVersions: Array<ItemTemplateItemVersion>;
  /** Any ITIVs that were removed from the template, but could not be deleted because they are used on a different version of the template. */
  removed: Array<ItemTemplateItemVersion>;
  /** Any ITIVs that were deleted from the template. */
  deleted: Array<Scalars['ID']['output']>;
  /** Only calculated if groupTotalsInput is provided */
  groupTotals: Array<ItemTemplateItemVersionGroupTotal>;
};

export type DedupeReadyPlanItemTemplateItemVersionsInput = {
  template: Scalars['ID']['input'];
  /** defaults to true, and will not merge items with different costs */
  requireCostMatch?: InputMaybe<Scalars['Boolean']['input']>;
  /** A filter to apply to the ITIVs to be deduped. This is useful for deduping only a subset of the ITIVs in a template. */
  filter?: InputMaybe<ItemTemplateItemVersionFilter>;
  /** A list of options to dedupe across. Or special values "specOption" or "elevation" to dedupe across all spec options or elevations respectively. */
  acrossOptions?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DedupeReadyPlanItemTemplateItemVersionsResult = {
  __typename?: 'DedupeReadyPlanItemTemplateItemVersionsResult';
  dedupedItemTemplateItemVersions: Array<DedupedItemTemplateItemVersion>;
  affectedTemplates: Array<ItemTemplate>;
  affectedDevelopments: Array<Development>;
  affectedReadyPlans: Array<ReadyPlan>;
};

export type DedupedItemTemplateItemVersion = {
  __typename?: 'DedupedItemTemplateItemVersion';
  primary: ItemTemplateItemVersion;
  removes: Array<ItemTemplateItemVersion>;
};

/**
 * The FE will specify at most one of the following order fields, and optionally a groupBy value (defaults to None).
 * The BE will then order first by the groupBy value, and then by the specified order field, and then by whatever other fields
 * it deems appropriate to keep related items close to each other an in a convenient/consistent order.
 */
export type ItemTemplateItemVersionOrder = {
  field: ItivOrderField;
  direction: Order;
};

export enum ItivOrderField {
  Id = 'Id',
  CostCode = 'CostCode',
  CostDivision = 'CostDivision',
  Drop = 'Drop',
  Item = 'Item',
  Elevation = 'Elevation',
  SpecOption = 'SpecOption',
  /**  Orders by all options except spec/elevation options. Used by legacy ReadyPlan scope group by option view, which considered spec/elevation part of the base house.  */
  Option = 'Option',
  /**  Orders by all options regardless of type. Used by new PlanPackage scope group by option view, which considers spec/elevation as separate from base house.  */
  Options = 'Options',
  Location = 'Location',
  LocationPath = 'LocationPath',
  LocationLevel = 'LocationLevel',
  LocationRoom = 'LocationRoom',
  LocationFeature = 'LocationFeature',
  TotalCostInCents = 'TotalCostInCents',
  CostType = 'CostType',
  Quantity = 'Quantity',
  UnitOfMeasure = 'UnitOfMeasure',
  MaterialType = 'MaterialType',
  MaterialCode = 'MaterialCode',
  GlobalPlanTask = 'GlobalPlanTask',
  /**  NOTE: This does not account for changes which occurred to the underlying ITIV.scope  */
  UpdatedAt = 'UpdatedAt'
}

export type AddJobInput = {
  name: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSONObject']['input']>;
  spec?: InputMaybe<JobTaskSpec>;
};

export type AddJobsInput = {
  name: Scalars['String']['input'];
  payloads: Array<Scalars['JSONObject']['input']>;
  spec?: InputMaybe<JobTaskSpec>;
};

export type JobTaskSpec = {
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type JobLog = Entity & {
  __typename?: 'JobLog';
  id: Scalars['ID']['output'];
  logDate: Scalars['Date']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  project: Project;
  notes: Array<JobLogNote>;
  images: Array<JobLogImage>;
  minTemperature?: Maybe<Scalars['String']['output']>;
  maxTemperature?: Maybe<Scalars['String']['output']>;
  humidity?: Maybe<Scalars['String']['output']>;
  wind?: Maybe<Scalars['String']['output']>;
  weatherType?: Maybe<WeatherType>;
  weatherTypeDetail?: Maybe<WeatherTypeDetail>;
  weatherTypeChanged?: Maybe<Scalars['Boolean']['output']>;
};


export type JobLogNotesArgs = {
  filter?: InputMaybe<JobLogNoteFilter>;
};

export type JobLogFilter = {
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  noteType?: InputMaybe<Array<JobLogNoteType>>;
  flags?: InputMaybe<Array<JobLogFlag>>;
  weatherType?: InputMaybe<Array<WeatherType>>;
  logDate?: InputMaybe<DateFilter2>;
  scheduleTasks?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type JobLogNoteFilter = {
  flags?: InputMaybe<Array<JobLogFlag>>;
  includeSoftDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleTasks?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveJobLogInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  logDate?: InputMaybe<Scalars['Date']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  minTemperature?: InputMaybe<Scalars['String']['input']>;
  maxTemperature?: InputMaybe<Scalars['String']['input']>;
  humidity?: InputMaybe<Scalars['String']['input']>;
  wind?: InputMaybe<Scalars['String']['input']>;
  weatherType?: InputMaybe<WeatherType>;
};

export type SaveJobLogResult = {
  __typename?: 'SaveJobLogResult';
  jobLog: JobLog;
};

export type DuplicateJobLogsInput = {
  jobLogId: Scalars['ID']['input'];
  projectIds: Array<Scalars['ID']['input']>;
  targetDates?: InputMaybe<Array<Scalars['Date']['input']>>;
};

export type DuplicateJobLogsResult = {
  __typename?: 'DuplicateJobLogsResult';
  jobLog: JobLog;
  clonedJobLogs: Array<JobLog>;
  copiedJobLogs: Array<JobLog>;
};

export type JobLogImageFilter = {
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type JobLogImageOrder = {
  jobLogDate?: InputMaybe<Order>;
};

export type JobLogOrder = {
  id?: InputMaybe<Order>;
  logDate?: InputMaybe<Order>;
};

export type JobLogsPageResult = {
  __typename?: 'JobLogsPageResult';
  entities: Array<JobLog>;
  pageInfo: PageInfo;
  logDates: Array<Scalars['Date']['output']>;
};

export type JobLogImage = Entity & {
  __typename?: 'JobLogImage';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  asset: Asset;
  jobLog: JobLog;
  parent?: Maybe<JobLogImageParent>;
  sightlineJobId?: Maybe<Scalars['String']['output']>;
  sightlineUrl?: Maybe<Scalars['String']['output']>;
};

export type SaveJobLogImageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  asset?: InputMaybe<AssetInput>;
  parentId: Scalars['ID']['input'];
  /** When set (e.g. by iOS), forwarded to field-ai-service as the video pipeline job UUID. */
  sightlineJobId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteJobLogImageInput = {
  id: Scalars['ID']['input'];
};

export type SaveJobLogImageResult = {
  __typename?: 'SaveJobLogImageResult';
  jobLogImage: JobLogImage;
};

export type DeleteJobLogImageResult = {
  __typename?: 'DeleteJobLogImageResult';
  jobLog: JobLog;
  parent?: Maybe<JobLogImageParent>;
};

export type JobLogImageParent = JobLog | JobLogNote;

export type SaveJobLogNoteInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<JobLogNoteType>;
  internalUserId?: InputMaybe<Scalars['ID']['input']>;
  jobLogId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  flags?: InputMaybe<Array<JobLogFlag>>;
  title?: InputMaybe<Scalars['String']['input']>;
  scheduleTaskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientPlatform?: InputMaybe<ClientPlatform>;
  additionalContext?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type SaveJobLogNoteResult = {
  __typename?: 'SaveJobLogNoteResult';
  jobLogNote: JobLogNote;
};

export type DeleteJobLogNoteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteJobLogNoteResult = {
  __typename?: 'DeleteJobLogNoteResult';
  jobLog: JobLog;
};

export type LienWaiver = {
  __typename?: 'LienWaiver';
  id: Scalars['ID']['output'];
  amountInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  condition: LienWaiverConditionDetail;
  type: LienWaiverTypeDetail;
  pandaDoc?: Maybe<PandaDoc>;
  status: LienWaiverStatusDetail;
  document?: Maybe<Document>;
  parent: LienWaiverParent;
  project: Project;
  throughDate?: Maybe<Scalars['Date']['output']>;
  claimant: LienWaiverClaimant;
  payer: LienWaiverPayer;
  /**  For payers of type Builder, this returns the project's effective company name  */
  payerName: Scalars['String']['output'];
  owner: LienWaiverOwner;
  signatory?: Maybe<LienWaiverSignatory>;
  canCreatePandaDoc: PotentialOperation2;
};

export type SaveLienWaiverInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<LienWaiverCondition>;
  type?: InputMaybe<LienWaiverType>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  throughDate?: InputMaybe<Scalars['Date']['input']>;
  claimantId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveLienWaiverResult = {
  __typename?: 'SaveLienWaiverResult';
  lienWaiver: LienWaiver;
};

export type LienWaiverFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  billId?: InputMaybe<Array<Scalars['ID']['input']>>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradePartner?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type LienWaiverOrder = {
  id?: InputMaybe<Order>;
  project?: InputMaybe<Order>;
};

export type LienWaiversPage = {
  __typename?: 'LienWaiversPage';
  entities: Array<LienWaiver>;
  pageInfo: PageInfo;
};

export type LienWaiverParent = StandaloneProject | Region | Bill | Invoice | Market | Community | Subdivision | Lot | Structure | Unit;

export type LienWaiverClaimant = Builder | TradePartner;

export type LienWaiverPayer = Builder | Client;

export type LienWaiverSignatory = InternalUser | TradePartnerContact;

export type LienWaiverOwner = Customer | Client;

export type SaveLocationsInput = {
  locations: Array<LocationInput>;
};

export type DeleteLocationInput = {
  id: Scalars['ID']['input'];
};

export type CreateLocationsFromPathsInput = {
  /**
   * [
   *   'Whole House~First Floor~some location',
   *   'Whole House~Second Floor~some location'
   * ]
   */
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  newLocationPaths: Array<Scalars['String']['input']>;
};

export type SaveLocationsResult = {
  __typename?: 'SaveLocationsResult';
  locations: Array<Location>;
};

export type LocationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetInput>;
  isWholeHouse?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRendering?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<LocationType>;
  roomTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlanIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Location = Entity & Named & {
  __typename?: 'Location';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  image?: Maybe<Asset>;
  isWholeHouse: Scalars['Boolean']['output'];
  supportsRendering: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  /** Falls back to `name` if `code` is unset */
  effectiveCode: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  type: LocationTypeDetail;
  parent?: Maybe<Location>;
  parents: Array<Location>;
  path?: Maybe<Scalars['String']['output']>;
  pathAsCode?: Maybe<Scalars['String']['output']>;
  pathArray: Array<Scalars['String']['output']>;
  pathIds: Array<Scalars['Int']['output']>;
  group?: Maybe<Location>;
  level?: Maybe<Location>;
  room?: Maybe<Location>;
  displayLocationPath: Scalars['String']['output'];
  locations: Array<Location>;
  roomTypes: Array<RoomType>;
  feature?: Maybe<Location>;
  /**
   *  The first non-scope location.
   * @deprecated Use nonScopeLocation instead
   */
  effectiveLocation: Location;
  /**
   * For scope locations like `g:WH~r:Kitchen 101~f:Island~s:Top Drawer~s:Knob`,
   * returns the first non-scope location, i.e. Island.
   *
   * Fallbacks to itself if no non-scope parent location is found.
   */
  nonScopeLocation: Location;
  /**
   * There is only one non-structural location, and it is used to assign items that are non-structural like Miscellaneous/OH&P/Contingency.
   * This is always included in the locations query when effectiveLocations is true.
   */
  isNonStructural?: Maybe<Scalars['Boolean']['output']>;
  /**  For scope locations, the MaterialVariant that is used for this location  */
  materialVariant?: Maybe<MaterialVariant>;
  isModifiedRoom: Scalars['Boolean']['output'];
};

export type LocationFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LocationsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  supportsRendering?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated tli-cutover: Use rpav instead */
  itemTemplate?: InputMaybe<Array<Scalars['ID']['input']>>;
  rpav?: InputMaybe<Array<Scalars['ID']['input']>>;
  parent?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Array<LocationType>>;
  roomTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNonStructural?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationOrderBy = {
  name?: InputMaybe<Order>;
  path?: InputMaybe<Order>;
  code?: InputMaybe<Order>;
};

export type SaveLotInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']['input']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']['input']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']['input']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']['input']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  builderId?: InputMaybe<Scalars['ID']['input']>;
  legalDescription?: InputMaybe<Scalars['String']['input']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']['input']>;
  buildablePlanIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveLotResult = {
  __typename?: 'SaveLotResult';
  lot: Lot;
};

export type SaveBuildablePlanIncrementalInput = {
  id: Scalars['ID']['input'];
  op: IncrementalCollectionOp;
};

export type LotRating = {
  __typename?: 'LotRating';
  id: Scalars['ID']['output'];
  grade: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  projects: Array<StandaloneProject>;
};

export type SaveLotRatingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type SaveLotRatingResult = {
  __typename?: 'SaveLotRatingResult';
  lotRating: LotRating;
};

export type SaveMarketResult = {
  __typename?: 'SaveMarketResult';
  market: Market;
};

export type SaveMarketInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']['input']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']['input']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']['input']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']['input']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  builderId?: InputMaybe<Scalars['ID']['input']>;
  legalDescription?: InputMaybe<Scalars['String']['input']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salesforceMarketCode?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  msaName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialAssemblyComponent = {
  __typename?: 'MaterialAssemblyComponent';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  assembly: MaterialVariant;
  component: MaterialVariant;
  name?: Maybe<Scalars['String']['output']>;
  qualifier?: Maybe<Scalars['String']['output']>;
};

export type SaveMaterialAssemblyComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  componentId?: InputMaybe<Scalars['ID']['input']>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMaterialAssemblyComponentResult = {
  __typename?: 'SaveMaterialAssemblyComponentResult';
  materialAssemblyComponent: MaterialAssemblyComponent;
};

export type MaterialAttributeDimension = {
  __typename?: 'MaterialAttributeDimension';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  item: Item;
  values: Array<MaterialAttributeValue>;
  isAdminManaged: Scalars['Boolean']['output'];
  unitOfMeasure?: Maybe<UnitOfMeasure>;
  sortOrder: Scalars['Int']['output'];
  type: MaterialAttributeDimensionTypeDetail;
  useInTakeoff: Scalars['Boolean']['output'];
  useInVisualModePdf: Scalars['Boolean']['output'];
  showInFinishSchedule: Scalars['Boolean']['output'];
  showInCabinetsInfo: Scalars['Boolean']['output'];
  copiedFromChildModifier?: Maybe<MaterialAttributeDimension>;
};

export type SaveMaterialAttributeDimensionValueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveMaterialAttributeDimensionResult = {
  __typename?: 'SaveMaterialAttributeDimensionResult';
  materialAttributeDimension: MaterialAttributeDimension;
};

export type SaveMaterialAttributeDimensionResults = {
  __typename?: 'SaveMaterialAttributeDimensionResults';
  materialAttributeDimensions: Array<MaterialAttributeDimension>;
};

export type MaterialAttributeDimensionFilter = {
  itemId?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialAttributeValue = {
  __typename?: 'MaterialAttributeValue';
  id: Scalars['ID']['output'];
  /** @deprecated use `textValue` */
  value: Scalars['String']['output'];
  /**
   * The `value` is stored and returned as a string to ensure the UI displays it exactly as entered.
   * A hook evaluates the value to determine if it represents a number or a range.
   */
  textValue: Scalars['String']['output'];
  valueWithUom: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  dimension: MaterialAttributeDimension;
  materialVariants: Array<MaterialVariant>;
  code?: Maybe<Scalars['String']['output']>;
  type: MaterialAttributeValueTypeDetail;
  min?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
};

export type SaveMaterialAttributeValueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
  dimensionId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MaterialAttributeValueType>;
  min?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveMaterialAttributeValueResult = {
  __typename?: 'SaveMaterialAttributeValueResult';
  materialAttributeValue: MaterialAttributeValue;
};

export type BackfillResponse = {
  __typename?: 'BackfillResponse';
  processed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type MaterialBrandFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  abbreviation?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialBrand = {
  __typename?: 'MaterialBrand';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  abbreviation?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  materialListings: Array<MaterialListing>;
};

export type SaveMaterialBrandInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  abbreviation?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMaterialBrandResult = {
  __typename?: 'SaveMaterialBrandResult';
  materialBrand: MaterialBrand;
};

export type MaterialLeadTimeConfig = {
  __typename?: 'MaterialLeadTimeConfig';
  id: Scalars['ID']['output'];
  minLeadTimeInDays: Scalars['Int']['output'];
  expectedLeadTimeInDays: Scalars['Int']['output'];
  maxLeadTimeInDays: Scalars['Int']['output'];
  reasonNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variants: Array<MaterialLeadTimeConfigVariant>;
  parent?: Maybe<MaterialLeadTimeConfigParent>;
};

export type SaveMaterialLeadTimeConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  minLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  expectedLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  maxLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Array<SaveMaterialLeadTimeConfigVariantIncrementalInput>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type SavePersonalizationMaterialLeadTimeConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  minLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  expectedLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  maxLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Array<SaveMaterialLeadTimeConfigVariantIncrementalInput>>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveMaterialLeadTimeConfigResult = {
  __typename?: 'SaveMaterialLeadTimeConfigResult';
  materialLeadTimeConfig: MaterialLeadTimeConfig;
};

export type MaterialLeadTimeConfigParent = CostCode | Item | MaterialListing;

export type HasMaterialLeadTimeConfigData = {
  minLeadTimeInDays: Scalars['Int']['output'];
  expectedLeadTimeInDays: Scalars['Int']['output'];
  maxLeadTimeInDays: Scalars['Int']['output'];
};

export type MaterialLeadTimeConfigVariant = {
  __typename?: 'MaterialLeadTimeConfigVariant';
  id: Scalars['ID']['output'];
  minLeadTimeInDays?: Maybe<Scalars['Int']['output']>;
  expectedLeadTimeInDays?: Maybe<Scalars['Int']['output']>;
  maxLeadTimeInDays?: Maybe<Scalars['Int']['output']>;
  reasonNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  market?: Maybe<Market>;
  materialLeadTimeConfig: MaterialLeadTimeConfig;
};

export type SaveMaterialLeadTimeConfigVariantIncrementalInput = {
  op: IncrementalCollectionOp;
  id?: InputMaybe<Scalars['ID']['input']>;
  minLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  expectedLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  maxLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  materialLeadTimeConfigId?: InputMaybe<Scalars['ID']['input']>;
};

export type MaterialListing = HasOptionPricingData & HasMaterialLeadTimeConfigData & {
  __typename?: 'MaterialListing';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  item: Item;
  brand?: Maybe<MaterialBrand>;
  materialVariants: Array<MaterialVariant>;
  type: MaterialTypeDetail;
  /** @deprecated Use materialVariants.manufacturerUrl instead - returns the first variant's manufacturerUrl for compatibility with the old UI  */
  manufacturerUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  canEditItem: PotentialOperation2;
  optionPricingConfig?: Maybe<OptionPricingConfig>;
  /**  The pre-cutoff desired margin in basis points for this Material Listing, either defined directly by an OptionPricingConfig or falling back to a default value as set on its Item.  */
  preCutoffDesiredMarginInBasisPoints: Scalars['Int']['output'];
  /**  The post-cutoff desired margin in basis points for this Material Listing, either defined directly by an OptionPricingConfig or falling back to a default value as set on its Item.  */
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  /**  The selection fee this Material Listing, either defined directly by an OptionPricingConfig or falling back to a default value as set on its Item.  */
  selectionFeeInCents?: Maybe<Scalars['Int']['output']>;
  /**  The minimum price in cents for this Material Listing, either defined directly by an OptionPricingConfig or falling back to a default value as set on its Item.  */
  minimumPriceInCents: Scalars['Int']['output'];
  materialLeadTimeConfig?: Maybe<MaterialLeadTimeConfig>;
  /**  The minLeadTimeInDays for this Material Listing, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its Item.  */
  minLeadTimeInDays: Scalars['Int']['output'];
  /**  The expectedLeadTimeInDays for this Material Listing, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its Item.  */
  expectedLeadTimeInDays: Scalars['Int']['output'];
  /**  The maxLeadTimeInDays for this Material Listing, either defined directly by an MaterialLeadTimeConfig or falling back to a default value as set on its Item.  */
  maxLeadTimeInDays: Scalars['Int']['output'];
  history: Array<History>;
  designNote?: Maybe<Scalars['String']['output']>;
};

export type MaterialListingsFilter = {
  brandId?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialListingsPage = {
  __typename?: 'MaterialListingsPage';
  entities: Array<MaterialListing>;
  pageInfo: PageInfo;
};

export type SaveMaterialListingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MaterialType>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**  @deprecated Use materialVariants.manufacturerUrl instead  */
  manufacturerUrl?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  /**  This list of variants can be partial, FE can only send the variants that changed  */
  variants?: InputMaybe<Array<SaveMaterialListingVariantInput>>;
  optionPricingConfig?: InputMaybe<SavePersonalizationOptionPricingConfigInput>;
  materialLeadTimeConfig?: InputMaybe<SavePersonalizationMaterialLeadTimeConfigInput>;
  designNote?: InputMaybe<Scalars['String']['input']>;
};

export type MigrateMaterialListingItemInput = {
  listingIds: Array<Scalars['ID']['input']>;
  itemId: Scalars['ID']['input'];
};

export type MigrateMaterialListingItemResult = {
  __typename?: 'MigrateMaterialListingItemResult';
  listings: Array<MaterialListing>;
};

export type SaveMaterialListingVariantInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturerUrl?: InputMaybe<Scalars['String']['input']>;
  codeOverride?: InputMaybe<Scalars['String']['input']>;
  designFeedback?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  mavIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Accepts a list of tag IDs or the tag name, fails if the tag name does not exist  */
  tags?: InputMaybe<Array<Scalars['IdOrName']['input']>>;
  /**  Images must be exhaustive if included  */
  images?: InputMaybe<Array<SaveMaterialVariantImageInput>>;
  /**  Components must be exhaustive if included  */
  components?: InputMaybe<Array<SaveMaterialVariantAssemblyComponentInput>>;
};

export type MergeMaterialListingsInput = {
  targetId: Scalars['ID']['input'];
  sourceIds: Array<Scalars['ID']['input']>;
};

export type MergeMaterialListingsResult = {
  __typename?: 'MergeMaterialListingsResult';
  target: MaterialListing;
};

export type UploadMaterialVariantsInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Accepts a list of tag IDs or the tag name, creating the tag if needed
   * These tags will be applied to all MaterialVariants created from the uploaded data
   * Additional tags can be specified in the individual MaterialVariant inputs in the data array
   */
  tags?: InputMaybe<Array<Scalars['IdOrName']['input']>>;
  data: Array<Scalars['JSONObject']['input']>;
};

export type UploadMaterialVariantsResult = {
  __typename?: 'UploadMaterialVariantsResult';
  results: Array<UploadMaterialVariantResult>;
};

export type UploadMaterialVariantResult = {
  __typename?: 'UploadMaterialVariantResult';
  /**  Original data that was uploaded  */
  data: Scalars['JSONObject']['output'];
  /**  Indicates whether the MaterialVariant was created or updated  */
  operation: Scalars['String']['output'];
  /**  The MaterialVariant that was created or updated  */
  newMaterialVariant?: Maybe<MaterialVariant>;
  /**  The MaterialVariant that was updated  */
  updatedMaterialVariant?: Maybe<MaterialVariant>;
};

export type MaterialVariant = HasBlueprintUrl & {
  __typename?: 'MaterialVariant';
  id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  modelNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  listing: MaterialListing;
  materialAttributeValues: Array<MaterialAttributeValue>;
  bidItems: Array<BidItem>;
  codeOverride?: Maybe<Scalars['String']['output']>;
  defaultBidItem: BidItem;
  isArchived: Scalars['Boolean']['output'];
  featuredImage?: Maybe<MaterialVariantImage>;
  images: Array<MaterialVariantImage>;
  components: Array<MaterialAssemblyComponent>;
  componentOf: Array<MaterialAssemblyComponent>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  /**  For placeholders, the current MADs + any additional Item.mads that are have useInTakeoff set.  */
  effectiveMADs: Array<MaterialAttributeDimension>;
  designFeedback?: Maybe<Scalars['String']['output']>;
  minCostInMills?: Maybe<Scalars['Int']['output']>;
  maxCostInMills?: Maybe<Scalars['Int']['output']>;
  canEdit: PotentialOperation2;
  tags: Array<MaterialVariantTag>;
  manufacturerUrl?: Maybe<Scalars['String']['output']>;
  blueprintUrl: Url;
  sources: Array<MaterialVariant>;
};

export type SaveMaterialVariantInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  manufacturerUrl?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MaterialType>;
  codeOverride?: InputMaybe<Scalars['String']['input']>;
  mavIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  images?: InputMaybe<Array<SaveMaterialVariantImageInput>>;
  components?: InputMaybe<Array<SaveMaterialVariantAssemblyComponentInput>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  designFeedback?: InputMaybe<Scalars['String']['input']>;
  /**  Accepts a list of tag IDs or the tag name, creating the tag if needed  */
  tags?: InputMaybe<Array<Scalars['IdOrName']['input']>>;
};

export type SaveMaterialVariantAssemblyComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  componentId?: InputMaybe<Scalars['ID']['input']>;
  componentItemId?: InputMaybe<Scalars['ID']['input']>;
  componentValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMaterialVariantImageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  asset?: InputMaybe<AssetInput>;
};

export type SaveMaterialVariantResult = {
  __typename?: 'SaveMaterialVariantResult';
  materialVariant: MaterialVariant;
};

export type MaterialCostSourceOrderBy = {
  createdAt?: InputMaybe<Order>;
};

export type MaterialVariantOrderBy = {
  lastUsedAt?: InputMaybe<Order>;
};

export type MaterialVariantsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemId?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandId?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isMergedAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  attributeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dimensionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Filter for materials that are included as-of the PP/DP/POF version `rpavId`.  */
  rpavId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Array<MaterialType>>;
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Accepts a list of tag IDs or the tag name, fails if the tag name does not exist  */
  tags?: InputMaybe<Array<Scalars['IdOrName']['input']>>;
};

export type MaterialVariantsForPlaceholderTliFilter = {
  takeoffLineItemId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  attributeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MaterialCostSource = BidItemEstimate | BidContractLineItem;

export type MaterialVariantsPage = {
  __typename?: 'MaterialVariantsPage';
  entities: Array<MaterialVariant>;
  pageInfo: PageInfo;
};

export type MaterialVariantCostSourcesPage = {
  __typename?: 'MaterialVariantCostSourcesPage';
  entities: Array<MaterialCostSource>;
  pageInfo: PageInfo;
};

export type MaterialVariantImage = {
  __typename?: 'MaterialVariantImage';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variant: MaterialVariant;
  asset?: Maybe<Asset>;
};

export type MaterialVariantTag = Named & {
  __typename?: 'MaterialVariantTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  materialVariants: Array<MaterialVariant>;
};

export type SaveMaterialVariantTagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMaterialVariantTagResult = {
  __typename?: 'SaveMaterialVariantTagResult';
  materialVariantTag: MaterialVariantTag;
};

export type MermaidResult = {
  __typename?: 'MermaidResult';
  url: Scalars['String']['output'];
  code: Scalars['String']['output'];
};

export type MermaidInput = {
  id: Array<Scalars['ID']['input']>;
  graph: Scalars['JSONObject']['input'];
};

export type MobileSyncUpdatesInput = {
  projectIds: Array<Scalars['ID']['input']>;
  /** Fetch updates created after this timestamp. */
  since?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MobileSyncUpdatesPageResult = {
  __typename?: 'MobileSyncUpdatesPageResult';
  entities: Array<MobileSyncUpdate>;
  pageInfo: PageInfo;
};

export type MobileSyncUpdate = Entity & {
  __typename?: 'MobileSyncUpdate';
  id: Scalars['ID']['output'];
  type: MobileSyncUpdateType;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The tagged Joist ID of the entity (e.g. jl:123). Always present, even for deletes. */
  entityId: Scalars['String']['output'];
  /** The resolved entity. Null if the entity has been deleted. */
  entity?: Maybe<Entity>;
  project: Project;
};

export type OptionPricingConfig = {
  __typename?: 'OptionPricingConfig';
  id: Scalars['ID']['output'];
  selectionFeeInCents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variants: Array<OptionPricingConfigVariant>;
  parent?: Maybe<OptionPricingConfigParent>;
  preCutoffDesiredMarginInBasisPoints: Scalars['Int']['output'];
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  reasonNote?: Maybe<Scalars['String']['output']>;
  minimumPriceInCents: Scalars['Int']['output'];
};

export type SaveOptionPricingConfigsInput = {
  optionPricingConfigs: Array<SaveOptionPricingConfigInput>;
};

export type SaveOptionPricingConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  preCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  postCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  selectionFeeInCents?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  variants?: InputMaybe<Array<SaveOptionPricingConfigVariantIncrementalInput>>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
  minimumPriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

/**  OptionPricingConfigs saved on MaterialListings, Items, and CostCodes should not have OptionPricingConfigVariants.  */
export type SavePersonalizationOptionPricingConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  preCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  postCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  selectionFeeInCents?: InputMaybe<Scalars['Int']['input']>;
  minimumPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
};

export type SaveOptionPricingConfigsResult = {
  __typename?: 'SaveOptionPricingConfigsResult';
  optionPricingConfigs: Array<OptionPricingConfig>;
};

export type DeleteOptionPricingConfigInput = {
  id: Scalars['ID']['input'];
};

export type OptionPricingConfigParent = CostCode | GlobalOption | Item | MaterialListing;

export type HasOptionPricingData = {
  preCutoffDesiredMarginInBasisPoints: Scalars['Int']['output'];
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  selectionFeeInCents?: Maybe<Scalars['Int']['output']>;
  minimumPriceInCents: Scalars['Int']['output'];
};

export type OptionPricingConfigVariant = {
  __typename?: 'OptionPricingConfigVariant';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  optionPricingConfig: OptionPricingConfig;
  preCutoffDesiredMarginInBasisPoints: Scalars['Int']['output'];
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  selectionFeeInCents?: Maybe<Scalars['Int']['output']>;
  reasonNote?: Maybe<Scalars['String']['output']>;
  projects: Array<Project>;
  minimumPriceInCents?: Maybe<Scalars['Int']['output']>;
};

export type SaveOptionPricingConfigVariantIncrementalInput = {
  op: IncrementalCollectionOp;
  id?: InputMaybe<Scalars['ID']['input']>;
  optionPricingConfigId?: InputMaybe<Scalars['ID']['input']>;
  preCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  postCutoffDesiredMarginInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  selectionFeeInCents?: InputMaybe<Scalars['Int']['input']>;
  minimumPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Pagination info. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /**  Soft-deprecated b/c the caller should use their current page + totalCount to know hasNextPage.  */
  hasNextPage: Scalars['Boolean']['output'];
  /**  The total number of rows available for this query.  */
  totalCount: Scalars['Int']['output'];
  /**  The next page to query, unless this is the last page.  */
  nextPage?: Maybe<Page>;
};

/** A generic `page: Page` argument for paginated queries to return as "the next page". */
export type Page = {
  __typename?: 'Page';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

/** A generic `page: PageFilter` argument for paginated queries to use. */
export type PageFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PandaDocSession = {
  __typename?: 'PandaDocSession';
  sessionId: Scalars['String']['output'];
};

export type PandaDoc = Named & {
  __typename?: 'PandaDoc';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  externalPandaDocId?: Maybe<Scalars['String']['output']>;
  externalPandaDocUrl?: Maybe<Scalars['String']['output']>;
  status: PandaDocStatus;
  statusDetail: PandaDocStatusDetail;
  recipients: Array<PandaDocRecipient>;
  /** @deprecated replaced by owner */
  commitment?: Maybe<Commitment>;
  /** @deprecated replaced by owner */
  developmentCommitment?: Maybe<DevelopmentCommitment>;
  /** @deprecated replaced by owner */
  commitmentChangeOrder?: Maybe<CommitmentChangeOrder>;
  tags: Array<Scalars['String']['output']>;
  document?: Maybe<Document>;
  owner?: Maybe<PandaDocOwner>;
  externalError?: Maybe<Scalars['String']['output']>;
  canUpload?: Maybe<PotentialOperation2>;
  canCreatePandaDocSession?: Maybe<PotentialOperation2>;
};

export type CreatePandaDocSessionInput = {
  pandaDocId: Scalars['ID']['input'];
};

export type SavePandaDocInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  externalPandaDocId?: InputMaybe<Scalars['String']['input']>;
  externalPandaDocStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PandaDocStatus>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated replaced by ownerId */
  developmentCommitmentId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated replaced by ownerId */
  commitmentChangeOrderId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated replaced by ownerId */
  commitmentId?: InputMaybe<Scalars['ID']['input']>;
  externalError?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePandaDocInput = {
  id: Scalars['ID']['input'];
};

export type UploadPandaDocInput = {
  id: Scalars['ID']['input'];
};

export type HandlePandaDocWebhookInput = {
  items: Array<PandaDocWebhookItem>;
};

export type PandaDocWebhookItem = {
  id: Scalars['ID']['input'];
  event: PandaDocWebhookEvent;
};

/**  see: https://developers.pandadoc.com/reference/on-document-status-change  */
export enum PandaDocWebhookEvent {
  DocumentStateChanged = 'document_state_changed',
  DocumentUpdated = 'document_updated',
  RecipientCompleted = 'recipient_completed',
  DocumentDeleted = 'document_deleted',
  DocumentCreationFailed = 'document_creation_failed'
}

export type SavePandaDocResult = {
  __typename?: 'SavePandaDocResult';
  pandaDoc: PandaDoc;
};

export type DeletePandaDocResult = {
  __typename?: 'DeletePandaDocResult';
  owner: PandaDocOwner;
};

export type UploadPandaDocResult = {
  __typename?: 'UploadPandaDocResult';
  pandaDoc: PandaDoc;
};

export type PandaDocFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PandaDocOwner = BidContractRevision | ChangeEvent | Commitment | CommitmentChangeOrder | DevelopmentCommitment | Invoice | LienWaiver;

export type HasPandaDoc = {
  id: Scalars['ID']['output'];
  pandaDoc?: Maybe<PandaDoc>;
  document?: Maybe<Document>;
  canCreatePandaDoc: PotentialOperation2;
};

export type PandaDocRecipient = Named & {
  __typename?: 'PandaDocRecipient';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  role: PandaDocRole;
  roleDetail: PandaDocRoleDetail;
  pandaDoc: PandaDoc;
  signingOrder?: Maybe<Scalars['Int']['output']>;
  hasCompleted: Scalars['Boolean']['output'];
};

export type PaymentTerm = {
  __typename?: 'PaymentTerm';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  intacctId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  alignWithPaymentCycle: Scalars['Boolean']['output'];
  dueDay: Scalars['Int']['output'];
  dueFrom: PaymentTermDueFromDetail;
};

export type SavePaymentTermInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alignWithPaymentCycle?: InputMaybe<Scalars['Boolean']['input']>;
  dueDay?: InputMaybe<Scalars['Int']['input']>;
  dueFrom?: InputMaybe<PaymentTermDueFrom>;
};

export type PaymentTermFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavePaymentTermResult = {
  __typename?: 'SavePaymentTermResult';
  paymentTerm: PaymentTerm;
};

/** Current user's permissions for actions on a given entity */
export type Permissions = {
  __typename?: 'Permissions';
  canEdit: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
};

export type PlanMilestone = Named & {
  __typename?: 'PlanMilestone';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  estStartDate?: Maybe<Scalars['Date']['output']>;
  estEndDate?: Maybe<Scalars['Date']['output']>;
  totalDays: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  confidence: Scalars['Int']['output'];
  durationInDays: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  globalPlanMilestone: GlobalPlanMilestone;
  planSchedule: PlanSchedule;
  allowingPlanTasks: Array<PlanTask>;
  taskStatusRollup: TaskStatusDetail;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanMilestoneFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  scheduleParent?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDateRange?: InputMaybe<DateFilter2>;
  endDateRange?: InputMaybe<DateFilter2>;
  team?: InputMaybe<Array<BusinessFunctionType>>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlanMilestoneOrder = {
  estStartDate?: InputMaybe<Order>;
};

export type PlanMilestonesResult = {
  __typename?: 'PlanMilestonesResult';
  entities: Array<PlanMilestone>;
  pageInfo: PageInfo;
};

export type PlanMilestoneSnapshot = {
  __typename?: 'PlanMilestoneSnapshot';
  id: Scalars['ID']['output'];
  range: Scalars['String']['output'];
  estStartDate?: Maybe<Scalars['Date']['output']>;
  estEndDate?: Maybe<Scalars['Date']['output']>;
  durationInDays: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  planMilestone: PlanMilestone;
};

export type RoomLocationFilter = {
  locationType?: InputMaybe<Array<LocationType>>;
};

export type SavePlanPackageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  constructionDocumentCompletePercentage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadyPlanStatus>;
  type?: InputMaybe<ReadyPlanType>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  /**
   *  Deprecated - prefer programDatas - Remove in SC-57703
   * @deprecated Use programDatas instead
   */
  programData?: InputMaybe<SaveProgramDataInput>;
  programDatas?: InputMaybe<Array<SaveReadyPlanProgramDataInput>>;
  lotTypes?: InputMaybe<Array<LotType>>;
  assets?: InputMaybe<Array<SaveReadyPlanAssetInput>>;
  markets?: InputMaybe<Array<Scalars['ID']['input']>>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<SaveReadyPlanOptionInput>>;
  insideMapsProjectId?: InputMaybe<Scalars['String']['input']>;
  insideMapsConfig?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type CopyPlanPackageInput = {
  sourcePackageId: Scalars['ID']['input'];
  sourcePackageVersionId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type SavePlanPackageResult = {
  __typename?: 'SavePlanPackageResult';
  planPackage: PlanPackage;
};

export type PlanPackageFilter = {
  status?: InputMaybe<Array<ReadyPlanStatus>>;
  /**  The latest status based on the latest RPAV  */
  effectiveStatus?: InputMaybe<Array<ReadyPlanStatus>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  markets?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<ReadyPlanType>>;
};

export type PlanPackageOrderBy = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type PlanPackagesPageResult = {
  __typename?: 'PlanPackagesPageResult';
  entities: Array<PlanPackage>;
  pageInfo: PageInfo;
};

export type BackfillPlanPackageOptionGroupLocationsInput = {
  planPackageIds: Array<Scalars['ID']['input']>;
};

export type PlanPackageIncomingSlot = {
  __typename?: 'PlanPackageIncomingSlot';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  planPackage: PlanPackage;
  designPackage: DesignPackage;
  designPackagePlaceholder: TakeoffLineItem;
};

export type DeletePlanPackageIncomingSlotsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type PlanPackageVersion = {
  __typename?: 'PlanPackageVersion';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  code?: Maybe<Scalars['String']['output']>;
  contingencyMarkupPercentage?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type: ReadyPlanTypeDetail;
  lotTypes: Array<LotType>;
  identity: ReadyPlan;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  markets: Array<Market>;
  insideMapsProjectId?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<InternalUser>;
};

export type PlanSchedule = {
  __typename?: 'PlanSchedule';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  tasks: Array<PlanTask>;
  parent: PlanScheduleParent;
  planMilestones: Array<PlanMilestone>;
  recalculatedAt?: Maybe<Scalars['DateTime']['output']>;
  recalculatedBy?: Maybe<User>;
  targetStartDate: Scalars['Date']['output'];
  targetEndDate: Scalars['Date']['output'];
  currentBaselineDate: Scalars['Date']['output'];
  /** `targetCycleTimeInDays` (as input by the user) is in working days */
  targetCycleTimeInDays: Scalars['Int']['output'];
  targetCycleTimeInCalendarDays: Scalars['Int']['output'];
  cycleTimeInWorkingDays?: Maybe<Scalars['Int']['output']>;
  cycleTimeInCalendarDays?: Maybe<Scalars['Int']['output']>;
  verticalCompleteDate?: Maybe<Scalars['Date']['output']>;
  readyToStartDate?: Maybe<Scalars['Date']['output']>;
  targetEndDateProbability?: Maybe<Scalars['Int']['output']>;
  schedulingExclusionDates: Array<SchedulingExclusionDate>;
  canSendTradePartnerAvailabilityRequestEmail: PotentialOperation2;
};

export type SavePlanScheduleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  targetStartDate?: InputMaybe<Scalars['Date']['input']>;
  currentBaselineDate?: InputMaybe<Scalars['Date']['input']>;
  /** Target cycle time 'days' unit is working days */
  targetCycleTimeInDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SavePlanScheduleResult = {
  __typename?: 'SavePlanScheduleResult';
  planSchedule: PlanSchedule;
};

export type PlanScheduleParent = StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type DraftScheduleInput = {
  scheduleParentId: Scalars['ID']['input'];
  draftTaskChanges: Array<DraftPlanTaskInput>;
  tradePartnerAvailabilityRequests?: InputMaybe<Array<DraftTradePartnerAvailabilityRequestInput>>;
  bills?: InputMaybe<Array<SaveBillInput>>;
  /**
   * Used to single out a task to load additional *draft* data for that is too expensive to load for all tasks
   * Primary use case is the task detail sidebar
   */
  taskDetailId?: InputMaybe<Scalars['ID']['input']>;
  /**  Defaults to false, intended to be used to repair schedules that have been neglected for a while by removing the automatic pinning of stale tasks  */
  skipStaleTaskAutoPin?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Used to override what the simulator thinks is 'today'  */
  currentDate?: InputMaybe<Scalars['Date']['input']>;
};

export type DraftTradePartnerAvailabilityRequestInput = {
  taskId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmRequestedReschedule?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DraftScheduleResult = {
  __typename?: 'DraftScheduleResult';
  planTasks: Array<PlanTask>;
  /** Separate from `planTasks` to more efficiently support data heavy views, like the C2P publish step */
  newlyCompletedPlanTasks: Array<PlanTask>;
  /**  Subset of tasks that have changes requiring trade partner confirmation  */
  tradeConfirmPlanTasks: Array<PlanTask>;
  planSchedule: PlanSchedule;
  bills?: Maybe<Array<Bill>>;
  /** Optionally loads additional *draft* data for a single task when `taskDetailId` is provided */
  planTaskDetail?: Maybe<PlanTask>;
};

export type PlanScheduleSnapshotsInput = {
  scheduleParentId: Scalars['ID']['input'];
  /** Default is `PlanSchedule.currentBaselineDate` */
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
};

export type PlanScheduleSnapshotsResult = {
  __typename?: 'PlanScheduleSnapshotsResult';
  taskSnapshots: Array<TaskSnapshot>;
  planMilestoneSnapshots: Array<PlanMilestoneSnapshot>;
};

export type ResetPlanScheduleDatesInput = {
  planScheduleId: Scalars['ID']['input'];
  /**
   * Optional date to use as "today" for simulation purposes.
   * Use this to backdate a schedule (e.g., simulate as if the schedule started in the past).
   */
  scheduleStartOverride?: InputMaybe<Scalars['Date']['input']>;
};

export type SavePlanTaskInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TaskStatus>;
  internalUserId?: InputMaybe<Scalars['ID']['input']>;
  documents?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradePartnerStatus?: InputMaybe<TradePartnerTaskStatus>;
  workDays?: InputMaybe<Array<TaskWorkDayIncrementalInput>>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  customWorkableDaysOfWeek?: InputMaybe<Array<DayOfWeek>>;
};

export type SavePlanTaskResult = {
  __typename?: 'SavePlanTaskResult';
  planTask: PlanTask;
};

export type PlanTasksOrder = {
  id?: InputMaybe<Order>;
  parent?: InputMaybe<Order>;
  internalUser?: InputMaybe<Order>;
  startDate?: InputMaybe<Order>;
  endDate?: InputMaybe<Order>;
};

export type PlanTasksFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  myTasks?: InputMaybe<Scalars['Boolean']['input']>;
  startDateRange?: InputMaybe<DateFilter2>;
  endDateRange?: InputMaybe<DateFilter2>;
  status?: InputMaybe<Array<TaskStatus>>;
  scheduleParent?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tradePartnerStatus?: InputMaybe<Array<TradePartnerTaskStatus>>;
};

export type PlanTasksResult = {
  __typename?: 'PlanTasksResult';
  entities: Array<PlanTask>;
  pageInfo: PageInfo;
};

export type SavePlanTaskScheduleFlagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  oldTaskStartDate?: InputMaybe<Scalars['Date']['input']>;
  newTaskStartDate?: InputMaybe<Scalars['Date']['input']>;
  oldTaskEndDate?: InputMaybe<Scalars['Date']['input']>;
  newTaskEndDate?: InputMaybe<Scalars['Date']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

/** Subset of fields from PlanTaskInput, including those that are only updatable via the draft flow */
export type DraftPlanTaskInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']['input']>;
  isManuallyScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  earliestStartDate?: InputMaybe<Scalars['Date']['input']>;
  knownDurationInDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Effectively sets `knownDurationInDays` to achieve the desired `endDate`
   * @deprecated There is a known issue when combining this input with other changes that indirectly affect this task's startDate. Instrumenting this behavior on the frontend instead for now.
   */
  desiredEndDate?: InputMaybe<Scalars['Date']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleFlags?: InputMaybe<Array<SavePlanTaskScheduleFlagInput>>;
  status?: InputMaybe<TaskStatus>;
  /** Full list of custom workable days; should only be set as an exception to the default Monday-Friday */
  customWorkableDaysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  tradePartnerStatus?: InputMaybe<TradePartnerTaskStatus>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  internalUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type SimulationProbability = {
  __typename?: 'SimulationProbability';
  startDateBasisPoints?: Maybe<Scalars['Int']['output']>;
  endDateBasisPoints?: Maybe<Scalars['Int']['output']>;
  /** Similar to `startDateBasisPoints`, but includes the full range of potential dates and their probabilities vs. the most probable date */
  potentialStartDateBasisPoints?: Maybe<Array<PotentialDateBasisPoints>>;
  /** Similar to `endDateBasisPoints`, but includes the full range of potential dates and their probabilities vs. the most probable date */
  potentialEndDateBasisPoints?: Maybe<Array<PotentialDateBasisPoints>>;
};

export type PotentialDateBasisPoints = {
  __typename?: 'PotentialDateBasisPoints';
  date: Scalars['Date']['output'];
  basisPoints: Scalars['Int']['output'];
};

export type PlanTaskChecklistItem = {
  __typename?: 'PlanTaskChecklistItem';
  id: Scalars['ID']['output'];
  /**  Derived from GlobalPlanTaskChecklistItem  */
  name: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  planTask: PlanTask;
  completedBy?: Maybe<User>;
  globalItem: GlobalPlanTaskChecklistItem;
};

export type SavePlanTaskChecklistItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  globalItemId?: InputMaybe<Scalars['ID']['input']>;
  planTaskId?: InputMaybe<Scalars['ID']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeletePlanTaskChecklistItemInput = {
  id: Scalars['ID']['input'];
};

export type SavePlanTaskChecklistItemResult = {
  __typename?: 'SavePlanTaskChecklistItemResult';
  planTaskChecklistItem: PlanTaskChecklistItem;
};

export type PreconContractType = {
  __typename?: 'PreconContractType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  projects: Array<StandaloneProject>;
  inviteHomeowners: Scalars['Boolean']['output'];
  needsWeeklyUpdate: Scalars['Boolean']['output'];
};

export type SavePreconContractTypeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  inviteHomeowners?: InputMaybe<Scalars['Boolean']['input']>;
  needsWeeklyUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavePreconContractTypeResult = {
  __typename?: 'SavePreconContractTypeResult';
  preconContractType: PreconContractType;
};

export type ProductInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** An exhaustive set of the current item ids (being explicit b/c other collections in this input are incremental). */
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  manufacturerUrl?: InputMaybe<Scalars['String']['input']>;
  costInCents?: InputMaybe<Scalars['Int']['input']>;
  msrpInCents?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated: Price is now tracked only at the project level */
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  variantOfProductId?: InputMaybe<Scalars['ID']['input']>;
  /** Incremental attribute updates, i.e. either remove or append instead of an exhaustive set. */
  attributes?: InputMaybe<Array<ProductAttributeAssociationInput>>;
  /** Incremental dimension updates, i.e. either remove or append instead of an exhaustive set. */
  dimensions?: InputMaybe<Array<SaveProductDimensionInput>>;
  /** Incremental image updates, i.e. either remove or append instead of an exhaustive set. */
  images?: InputMaybe<Array<AssetInput>>;
  airtableId?: InputMaybe<Scalars['String']['input']>;
  airtableData?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  promotionStatus?: InputMaybe<PromotionStatus>;
  specifications?: InputMaybe<Scalars['String']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type SaveProductsInput = {
  products: Array<ProductInput>;
};

export type ProductsPage = {
  __typename?: 'ProductsPage';
  products: Array<Product>;
  pageInfo: PageInfo;
};

export type DeleteProductInput = {
  id: Scalars['ID']['input'];
};

export type ProductFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /**  If true, ONLY custom products will be returned. If false or unspecified, ONLY global products will be returned  */
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  item?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated product->bidItem link has been deleted */
  bidItems?: InputMaybe<Array<Scalars['ID']['input']>>;
  attributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ProductStatus>>;
  promotionStatus?: InputMaybe<Array<PromotionStatus>>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductOrder = {
  asc?: InputMaybe<ProductOrderable>;
  desc?: InputMaybe<ProductOrderable>;
  then?: InputMaybe<ProductOrder>;
};

export enum ProductOrderable {
  Id = 'id',
  Name = 'name',
  Cost = 'cost',
  Msrp = 'msrp',
  PriceLastUpdated = 'priceLastUpdated',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  Status = 'status'
}

export type SaveProductsResult = {
  __typename?: 'SaveProductsResult';
  products: Array<Product>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  id: Scalars['ID']['output'];
  type: ProductAttributeType;
  value: Scalars['String']['output'];
};

export type ProductAttributeFilter = {
  type?: InputMaybe<Array<ProductAttributeType>>;
};

export type SaveProductAttributesResult = {
  __typename?: 'SaveProductAttributesResult';
  attributes: Array<ProductAttribute>;
};

export type DeleteProductAttributeInput = {
  id: Scalars['ID']['input'];
};

export type SaveProductAttributesInput = {
  attributes: Array<ProductAttributeInput>;
};

export type ProductAttributeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ProductAttributeType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProductAttributeAssociationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ProductAttributeType>;
  value?: InputMaybe<Scalars['String']['input']>;
  remove?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductDimension = {
  __typename?: 'ProductDimension';
  id: Scalars['ID']['output'];
  rawValue: Scalars['String']['output'];
  dimensionType: ProductDimensionTypeDetail;
  product: Product;
};

export type SaveProductDimensionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /**  Parses the proided value to populate the rawValue and dimensionType. May be deprecated in the near future. */
  parseValue?: InputMaybe<Scalars['String']['input']>;
  rawValue?: InputMaybe<Scalars['String']['input']>;
  dimensionType?: InputMaybe<ProductDimensionType>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  id: Scalars['ID']['output'];
  product: Product;
  asset: Asset;
};

export type ProductOffering = ReadyPlanLike & HasBlueprintUrl & Named & HasDisplayName & BaseItemParent & {
  __typename?: 'ProductOffering';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  type: ReadyPlanTypeDetail;
  code?: Maybe<Scalars['String']['output']>;
  /**  The `type` + `code`, i.e. SFH-TX-1-001  */
  displayCode?: Maybe<Scalars['String']['output']>;
  blueprintUrl: Url;
  constructionDocumentCompletePercentage: Scalars['Int']['output'];
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  development?: Maybe<Development>;
  underwritingTemplate?: Maybe<ItemTemplate>;
  maxProgramData: ProgramData;
  minProgramData: ProgramData;
  programData: ProgramData;
  itemTemplates: Array<ItemTemplate>;
  options: Array<ReadyPlanOption>;
  optionGroups: Array<ReadyPlanOptionGroup>;
  userEvents: Array<UserEvent>;
  planPackage: PlanPackage;
  programDatas: Array<ReadyPlanProgramData>;
  copyInProgress: Scalars['Boolean']['output'];
  bidPackages: Array<BidPackage>;
  assets: Array<ReadyPlanAsset>;
  lotTypes: Array<LotType>;
  baseConfig?: Maybe<ProductOfferingConfig>;
  configs: Array<ProductOfferingConfig>;
  /**  All downstream PRPCs referencing this ProductOffering  */
  projectConfigs: Array<ProjectReadyPlanConfig>;
  bidOutPercentage: Scalars['Int']['output'];
  coverAsset?: Maybe<Asset>;
  /**  TODO: Deprecate once we move to floorPlanAssets  */
  floorPlanAsset?: Maybe<Asset>;
  /**  Array of floor plan assets for each level (Full, Ground/Basement, First, Second)  */
  floorPlanAssets: Array<ReadyPlanAsset>;
  interiorDesignPackage: DesignPackage;
  exteriorDesignPackage: DesignPackage;
  designPackageCombinations: Array<DesignPackageCombination>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateCheckout?: Maybe<ReadyPlanAggregateVersion>;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  version: ReadyPlanAggregateVersion;
  availableUpdates: Array<ProductOfferingIncomingUpdate>;
  itemLocations: Array<Location>;
  costCodes: Array<CostCode>;
  canEditLineItems: PotentialOperation2;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']['output']>;
  canEdit: PotentialOperation2;
  canEditOptions: PotentialOperation2;
  publishToUnderwriting: Scalars['Boolean']['output'];
  tourUrl?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  checkoutConfigs: Array<CheckoutConfig>;
  showInCheckout: Scalars['Boolean']['output'];
  documents: Array<Document>;
  /**  The latest (exterior) rendering image for the product offering.  */
  rendering?: Maybe<Asset>;
  /**  Interior rendering images for the product offering, used for static renderings in checkout (select communities).  */
  interiorRenderings: Array<InteriorRoomRendering>;
  /**  Generic renderings query that filters by ReadyPlanAssetType and matches by ready plan option IDs. Only matches files with the '-ids=' token format (e.g., 'AduExterior-ids=123_456.png'). Returns type+asset pairs with the highest match score per type.  */
  renderings: Array<RenderingAsset>;
  requiredOptions: Array<ReadyPlanRequiredOption>;
  owner?: Maybe<InternalUser>;
  cloneInProgress: Scalars['Boolean']['output'];
  insideMapsMissingLocations: Array<Scalars['String']['output']>;
  promoteInProgress: Scalars['Boolean']['output'];
  buildableLots: Array<Lot>;
  /**  Computed JSON output for InsideMaps package containing rooms, locations, and material variants.  */
  insideMapsPacket?: Maybe<Scalars['JSONObject']['output']>;
  architectureFeePriceInCents?: Maybe<Scalars['Int']['output']>;
  preconServicesPriceInCents?: Maybe<Scalars['Int']['output']>;
};


export type ProductOfferingCheckoutConfigsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductOfferingRenderingsArgs = {
  type: Array<ReadyPlanAssetType>;
};

export type ProductOfferingsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ReadyPlanStatus>>;
  type?: InputMaybe<Array<ReadyPlanType>>;
  showInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use versionMode: CHECKOUT instead */
  isCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Specifies which aggregate version to pin to for query results  */
  versionMode?: InputMaybe<ProductOfferingVersionMode>;
};

export type ProductOfferingOrder = {
  id?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type ProductOfferingsPageResult = {
  __typename?: 'ProductOfferingsPageResult';
  entities: Array<ProductOffering>;
  pageInfo: PageInfo;
};

export type SaveProductOfferingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadyPlanStatus>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<Array<SaveProductOfferingOptionInput>>;
  optionGroups?: InputMaybe<Array<SaveProductOfferingOptionGroupInput>>;
  planPackageId?: InputMaybe<Scalars['ID']['input']>;
  lotTypes?: InputMaybe<Array<LotType>>;
  baseConfigId?: InputMaybe<Scalars['ID']['input']>;
  interiorDesignPackageId?: InputMaybe<Scalars['ID']['input']>;
  exteriorDesignPackageId?: InputMaybe<Scalars['ID']['input']>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']['input']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']['input']>;
  tourUrl?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  showInCheckoutAllOptions?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  architectureFeePriceInCents?: InputMaybe<Scalars['Int']['input']>;
  preconServicesPriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type AcceptProductOfferingUpdatesInput = {
  productOfferingId: Scalars['ID']['input'];
  productOfferingUpdateIds: Array<Scalars['ID']['input']>;
};

export type SaveProductOfferingOptionInput = {
  id: Scalars['ID']['input'];
  optionDefaultsIfIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']['input']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveProductOfferingOptionGroupInput = {
  id: Scalars['ID']['input'];
  checkoutOrder?: InputMaybe<Scalars['Int']['input']>;
  overrideStep?: InputMaybe<CheckoutConfigOptionGroupStep>;
  overrideSubstepNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveProductOfferingResult = {
  __typename?: 'SaveProductOfferingResult';
  productOffering: ProductOffering;
};

export type DesignPackageCombination = {
  __typename?: 'DesignPackageCombination';
  readyPlanOptions: Array<ReadyPlanOption>;
  bidOutPercentage: Scalars['Int']['output'];
};

export type PotentialOptionsInput = {
  planPackageId: Scalars['ID']['input'];
  designPackageIds: Array<Scalars['ID']['input']>;
};

export type ComputeProductOfferingCostsAndPricesInput = {
  productOfferingId: Scalars['ID']['input'];
  readyPlanOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ReadyPlanOptionCostAndPriceDelta = {
  __typename?: 'ReadyPlanOptionCostAndPriceDelta';
  readyPlanOption: ReadyPlanOption;
  totalCostInCents: Scalars['Int']['output'];
  totalPriceInCents: Scalars['Int']['output'];
  preCutoffTotalPriceInCents: Scalars['Int']['output'];
  preCutoffDesiredMarginInBasisPoints: Scalars['Int']['output'];
  postCutoffTotalPriceInCents?: Maybe<Scalars['Int']['output']>;
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  selectionFeeInCents: Scalars['Int']['output'];
  minimumPriceInCents: Scalars['Int']['output'];
};

export type ComputeProductOfferingCostsAndPricesResponse = {
  __typename?: 'ComputeProductOfferingCostsAndPricesResponse';
  productOffering: ProductOffering;
  baseCostInCents: Scalars['Int']['output'];
  basePriceInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  /** @deprecated Not applicable to the plan-level. */
  preCutoffTotalPriceInCents: Scalars['Int']['output'];
  /** @deprecated Not applicable to the plan-level. */
  postCutoffTotalPriceInCents: Scalars['Int']['output'];
  selectedOptions: Array<ReadyPlanOptionCostAndPriceDelta>;
  unselectedOptions: Array<ReadyPlanOptionCostAndPriceDelta>;
  /**  Combined list of `selectedOptions` and `unselectedOptions`  */
  allOptions: Array<ReadyPlanOptionCostAndPriceDelta>;
};

export type CalculateDefaultOfferingOptionsInput = {
  productOfferingId: Scalars['ID']['input'];
  currentOptionIds: Array<Scalars['ID']['input']>;
};

export type CalculateScopeChangeInput = {
  productOfferingId: Scalars['ID']['input'];
  rpavId?: InputMaybe<Scalars['ID']['input']>;
  oldConfig: Array<Scalars['ID']['input']>;
  newConfig: Array<Scalars['ID']['input']>;
};

export type CalculateScopeChangeResult = {
  __typename?: 'CalculateScopeChangeResult';
  added: Array<TakeoffLineItemVersion>;
  removed: Array<TakeoffLineItemVersion>;
};

export type InteriorRoomRendering = {
  __typename?: 'InteriorRoomRendering';
  /**  The room name this rendering is for (e.g., 'Kitchen', 'Primary Bedroom')  */
  roomName: Scalars['String']['output'];
  /**  The interior scheme this rendering uses (from base config)  */
  interiorScheme: Scalars['String']['output'];
  /**  The rendering asset for this room (null if no matching rendering exists)  */
  asset?: Maybe<Asset>;
};

export type PromoteToCheckoutInput = {
  aggregateVersionId: Scalars['ID']['input'];
};

export type RenderingAsset = {
  __typename?: 'RenderingAsset';
  /**  The ReadyPlanAssetType extracted from the filename (e.g., AduExterior, AduKitchen, AduLiving, AduBathroom, AduBedroom)  */
  type: ReadyPlanAssetTypeDetail;
  /**  The rendering asset  */
  asset: Asset;
};

/**  Specifies which aggregate version to use when querying ProductOfferings  */
export enum ProductOfferingVersionMode {
  /**  Use the latest version (draft if exists, otherwise active) - default behavior  */
  Latest = 'LATEST',
  /**  Use the checkout-pinned version (aggregateCheckout)  */
  Checkout = 'CHECKOUT',
  /**  Use the active/published version only  */
  Active = 'ACTIVE'
}

export type ProductOfferingConfig = ReadyPlanConfigLike & {
  __typename?: 'ProductOfferingConfig';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  createdBy: User;
  productOffering: ProductOffering;
  readyPlan: ReadyPlanLike;
  readyPlanOptions: Array<ReadyPlanOption>;
  baseConfigProductOffering?: Maybe<ProductOffering>;
  archive: Scalars['Boolean']['output'];
  isBaseConfig: Scalars['Boolean']['output'];
  programData: ProgramData;
  totalCostInCents: Scalars['Int']['output'];
  /**  Useful for showing the base config's price in checkout.  */
  totalPriceInCents: Scalars['Int']['output'];
  hasCompleteCost: Scalars['Boolean']['output'];
  publishToUnderwriting: Scalars['Boolean']['output'];
  salesPriceInCents?: Maybe<Scalars['Int']['output']>;
  /** Pre-computed texture swaps and camera data for InsideMaps rendering */
  insideMapsTextureSwaps?: Maybe<InsideMapsTextureSwaps>;
};


export type ProductOfferingConfigInsideMapsTextureSwapsArgs = {
  debugParts?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaveProductOfferingConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productOfferingId?: InputMaybe<Scalars['ID']['input']>;
  readyPlanOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isBaseConfig?: InputMaybe<Scalars['Boolean']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']['input']>;
  salesPriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveProductOfferingConfigResult = {
  __typename?: 'SaveProductOfferingConfigResult';
  productOfferingConfig: ProductOfferingConfig;
};

export type ProductOfferingConfigOrder = {
  updatedAt?: InputMaybe<Order>;
};

export type ProductOfferingConfigsFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  productOfferings?: InputMaybe<Array<Scalars['ID']['input']>>;
  developments?: InputMaybe<Array<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductOfferingConfigsPage = {
  __typename?: 'ProductOfferingConfigsPage';
  entities: Array<ProductOfferingConfig>;
  pageInfo: PageInfo;
};

export type ProductOfferingConfigCostsInput = {
  productOfferingConfigIds: Array<Scalars['ID']['input']>;
};

export type ComputeProductOfferingConfigCostsResult = {
  __typename?: 'ComputeProductOfferingConfigCostsResult';
  configCosts: Array<ConfigCostsResult>;
};

export type ConfigCostsResult = {
  __typename?: 'ConfigCostsResult';
  productOfferingConfig: ProductOfferingConfig;
  /** @deprecated Use baseHouseCostInCents instead. */
  computedBaseCost: Scalars['Int']['output'];
  baseHouseCostInCents: Scalars['Int']['output'];
  /**  Whether the base scope lines, with options=[], all have bids.  */
  baseHouseHasCompleteCost: Scalars['Boolean']['output'];
  computedOptionCosts: Array<ReadyPlanOptionConfigCosts>;
};

export type ReadyPlanOptionConfigCosts = {
  __typename?: 'ReadyPlanOptionConfigCosts';
  readyPlanOption: ReadyPlanOption;
  totalCostInCents: Scalars['Int']['output'];
  hasCompleteCost: Scalars['Boolean']['output'];
};

export type ProductOfferingIncomingUpdate = {
  __typename?: 'ProductOfferingIncomingUpdate';
  id: Scalars['ID']['output'];
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  offering: ProductOffering;
  forDesignPackageUpdate: Scalars['Boolean']['output'];
  forPlanPackageUpdate: Scalars['Boolean']['output'];
  source: ProductOfferingIncomingUpdateSource;
};

export type ProductOfferingIncomingUpdateSource = Drop | ReadyPlanAggregateVersion;

export type ProductOfferingVersion = {
  __typename?: 'ProductOfferingVersion';
  id: Scalars['ID']['output'];
  identity: ReadyPlan;
  name: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ReadyPlanType>;
  lotTypes?: Maybe<Array<LotType>>;
  exteriorDesignPackageVersion: ReadyPlanAggregateVersion;
  interiorDesignPackageVersion: ReadyPlanAggregateVersion;
  planPackageVersion: ReadyPlanAggregateVersion;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  markets: Array<Market>;
  owner?: Maybe<InternalUser>;
};

export type ProductType = {
  __typename?: 'ProductType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  projects: Array<Project>;
};

export type SaveProductTypeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaveProductTypeResult = {
  __typename?: 'SaveProductTypeResult';
  productType: ProductType;
};

export type ProgramData = ProgramDataLike & {
  __typename?: 'ProgramData';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  stories?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  closetsInPrimarySuite?: Maybe<Scalars['Int']['output']>;
  fullBaths?: Maybe<Scalars['Int']['output']>;
  halfBaths?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by depthInFeet. */
  depthInInches?: Maybe<Scalars['Int']['output']>;
  depthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by widthInFeet. */
  widthInInches?: Maybe<Scalars['Int']['output']>;
  widthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by minLotWidthInFeet. */
  minLotWidthInInches?: Maybe<Scalars['Int']['output']>;
  minLotWidthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by minLotDepthInFeet. */
  minLotDepthInInches?: Maybe<Scalars['Int']['output']>;
  minLotDepthInFeet?: Maybe<Scalars['Float']['output']>;
  minLotSizeInSqft?: Maybe<Scalars['Int']['output']>;
  garageAttached?: Maybe<Scalars['Int']['output']>;
  garageDetached?: Maybe<Scalars['Int']['output']>;
  garagePort?: Maybe<Scalars['Int']['output']>;
  garageConfiguration?: Maybe<ProgramDataGarageConfigDetail>;
  basementConfig?: Maybe<ProgramDataBasementConfigDetail>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  sellableBasementSqft?: Maybe<Scalars['Int']['output']>;
  permittableSqft?: Maybe<Scalars['Int']['output']>;
  sellableSqft?: Maybe<Scalars['Int']['output']>;
  netBuildableSqft?: Maybe<Scalars['Int']['output']>;
  grossBuildableSqft?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by sellableAboveGroundSqft. */
  aboveGroundSqft?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  belowGroundSqft?: Maybe<Scalars['Int']['output']>;
  sellableAboveGroundSqft?: Maybe<Scalars['Int']['output']>;
  sellableBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  unfinishedBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  grossBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  imperviousSqft?: Maybe<Scalars['Int']['output']>;
  windowColor?: Maybe<ProgramDataWindowColorDetail>;
  firstFloorBedrooms?: Maybe<Scalars['Int']['output']>;
  diningRoom?: Maybe<Scalars['Int']['output']>;
  casualDining?: Maybe<Scalars['Int']['output']>;
  mediaRooms?: Maybe<Scalars['Int']['output']>;
  loftGameFlexRooms?: Maybe<Scalars['Int']['output']>;
  offices?: Maybe<Scalars['Int']['output']>;
  workspaces?: Maybe<Scalars['Int']['output']>;
  primaryBedroom?: Maybe<ProgramDataPrimaryBedroomConfigDetail>;
  /** @deprecated Field no longer supported */
  multiUseBedrooms?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  primarySuiteDown?: Maybe<Scalars['Int']['output']>;
  buildingHeightInFeet?: Maybe<Scalars['Float']['output']>;
  readyPlanProgramData?: Maybe<ReadyPlanProgramData>;
};

export type ProgramDataLike = {
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  stories?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  closetsInPrimarySuite?: Maybe<Scalars['Int']['output']>;
  fullBaths?: Maybe<Scalars['Int']['output']>;
  halfBaths?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by depthInFeet. */
  depthInInches?: Maybe<Scalars['Int']['output']>;
  depthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by widthInFeet. */
  widthInInches?: Maybe<Scalars['Int']['output']>;
  widthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by minLotWidthInFeet. */
  minLotWidthInInches?: Maybe<Scalars['Int']['output']>;
  minLotWidthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by minLotDepthInFeet. */
  minLotDepthInInches?: Maybe<Scalars['Int']['output']>;
  minLotDepthInFeet?: Maybe<Scalars['Float']['output']>;
  minLotSizeInSqft?: Maybe<Scalars['Int']['output']>;
  garageAttached?: Maybe<Scalars['Int']['output']>;
  garageDetached?: Maybe<Scalars['Int']['output']>;
  garagePort?: Maybe<Scalars['Int']['output']>;
  garageConfiguration?: Maybe<ProgramDataGarageConfigDetail>;
  basementConfig?: Maybe<ProgramDataBasementConfigDetail>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  sellableBasementSqft?: Maybe<Scalars['Int']['output']>;
  permittableSqft?: Maybe<Scalars['Int']['output']>;
  sellableSqft?: Maybe<Scalars['Int']['output']>;
  netBuildableSqft?: Maybe<Scalars['Int']['output']>;
  grossBuildableSqft?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by sellableAboveGroundSqft. */
  aboveGroundSqft?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  belowGroundSqft?: Maybe<Scalars['Int']['output']>;
  sellableAboveGroundSqft?: Maybe<Scalars['Int']['output']>;
  sellableBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  unfinishedBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  grossBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  imperviousSqft?: Maybe<Scalars['Int']['output']>;
  windowColor?: Maybe<ProgramDataWindowColorDetail>;
  firstFloorBedrooms?: Maybe<Scalars['Int']['output']>;
  diningRoom?: Maybe<Scalars['Int']['output']>;
  casualDining?: Maybe<Scalars['Int']['output']>;
  mediaRooms?: Maybe<Scalars['Int']['output']>;
  loftGameFlexRooms?: Maybe<Scalars['Int']['output']>;
  offices?: Maybe<Scalars['Int']['output']>;
  workspaces?: Maybe<Scalars['Int']['output']>;
  primaryBedroom?: Maybe<ProgramDataPrimaryBedroomConfigDetail>;
  /** @deprecated Field no longer supported */
  multiUseBedrooms?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  primarySuiteDown?: Maybe<Scalars['Int']['output']>;
  buildingHeightInFeet?: Maybe<Scalars['Float']['output']>;
};

export type SaveProgramDataInput = {
  stories?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  closetsInPrimarySuite?: InputMaybe<Scalars['Int']['input']>;
  fullBaths?: InputMaybe<Scalars['Int']['input']>;
  halfBaths?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Replaced by depthInFeet. */
  depthInInches?: InputMaybe<Scalars['Int']['input']>;
  depthInFeet?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Replaced by widthInFeet. */
  widthInInches?: InputMaybe<Scalars['Int']['input']>;
  widthInFeet?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Replaced by minLotWidthInFeet. */
  minLotWidthInInches?: InputMaybe<Scalars['Int']['input']>;
  minLotWidthInFeet?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Replaced by minLotDepthInFeet. */
  minLotDepthInInches?: InputMaybe<Scalars['Int']['input']>;
  minLotDepthInFeet?: InputMaybe<Scalars['Float']['input']>;
  minLotSizeInSqft?: InputMaybe<Scalars['Int']['input']>;
  garageAttached?: InputMaybe<Scalars['Int']['input']>;
  garageDetached?: InputMaybe<Scalars['Int']['input']>;
  garagePort?: InputMaybe<Scalars['Int']['input']>;
  garageConfiguration?: InputMaybe<ProgramDataGarageConfig>;
  basementConfig?: InputMaybe<ProgramDataBasementConfig>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  sellableBasementSqft?: InputMaybe<Scalars['Int']['input']>;
  permittableSqft?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated This field is derived now, and can no longer be manually updated. */
  sellableSqft?: InputMaybe<Scalars['Int']['input']>;
  netBuildableSqft?: InputMaybe<Scalars['Int']['input']>;
  grossBuildableSqft?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Replaced by sellableAboveGroundSqft. */
  aboveGroundSqft?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  belowGroundSqft?: InputMaybe<Scalars['Int']['input']>;
  sellableAboveGroundSqft?: InputMaybe<Scalars['Int']['input']>;
  sellableBelowGroundSqft?: InputMaybe<Scalars['Int']['input']>;
  grossBelowGroundSqft?: InputMaybe<Scalars['Int']['input']>;
  imperviousSqft?: InputMaybe<Scalars['Int']['input']>;
  windowColor?: InputMaybe<ProgramDataWindowColor>;
  firstFloorBedrooms?: InputMaybe<Scalars['Int']['input']>;
  diningRoom?: InputMaybe<Scalars['Int']['input']>;
  casualDining?: InputMaybe<Scalars['Int']['input']>;
  mediaRooms?: InputMaybe<Scalars['Int']['input']>;
  loftGameFlexRooms?: InputMaybe<Scalars['Int']['input']>;
  offices?: InputMaybe<Scalars['Int']['input']>;
  workspaces?: InputMaybe<Scalars['Int']['input']>;
  primaryBedroom?: InputMaybe<ProgramDataPrimaryBedroomConfig>;
  buildingHeightInFeet?: InputMaybe<Scalars['Float']['input']>;
};

export type ComputeProgramDataInput = {
  readyPlan: Scalars['ID']['input'];
  readyPlanOptions: Array<Scalars['ID']['input']>;
  /**  For ProductOfferings, specifies which aggregate version to use  */
  versionMode?: InputMaybe<ProductOfferingVersionMode>;
};

export type NewProgramData = ProgramDataLike & {
  __typename?: 'NewProgramData';
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  stories?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  closetsInPrimarySuite?: Maybe<Scalars['Int']['output']>;
  fullBaths?: Maybe<Scalars['Int']['output']>;
  halfBaths?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by depthInFeet. */
  depthInInches?: Maybe<Scalars['Int']['output']>;
  depthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by widthInFeet. */
  widthInInches?: Maybe<Scalars['Int']['output']>;
  widthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by minLotWidthInFeet. */
  minLotWidthInInches?: Maybe<Scalars['Int']['output']>;
  minLotWidthInFeet?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by minLotDepthInFeet. */
  minLotDepthInInches?: Maybe<Scalars['Int']['output']>;
  minLotDepthInFeet?: Maybe<Scalars['Float']['output']>;
  minLotSizeInSqft?: Maybe<Scalars['Int']['output']>;
  garageAttached?: Maybe<Scalars['Int']['output']>;
  garageDetached?: Maybe<Scalars['Int']['output']>;
  garagePort?: Maybe<Scalars['Int']['output']>;
  garageConfiguration?: Maybe<ProgramDataGarageConfigDetail>;
  basementConfig?: Maybe<ProgramDataBasementConfigDetail>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  sellableBasementSqft?: Maybe<Scalars['Int']['output']>;
  permittableSqft?: Maybe<Scalars['Int']['output']>;
  sellableSqft?: Maybe<Scalars['Int']['output']>;
  netBuildableSqft?: Maybe<Scalars['Int']['output']>;
  grossBuildableSqft?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by sellableAboveGroundSqft. */
  aboveGroundSqft?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by sellableBelowGroundSqft. */
  belowGroundSqft?: Maybe<Scalars['Int']['output']>;
  sellableAboveGroundSqft?: Maybe<Scalars['Int']['output']>;
  sellableBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  unfinishedBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  grossBelowGroundSqft?: Maybe<Scalars['Int']['output']>;
  imperviousSqft?: Maybe<Scalars['Int']['output']>;
  windowColor?: Maybe<ProgramDataWindowColorDetail>;
  firstFloorBedrooms?: Maybe<Scalars['Int']['output']>;
  diningRoom?: Maybe<Scalars['Int']['output']>;
  casualDining?: Maybe<Scalars['Int']['output']>;
  mediaRooms?: Maybe<Scalars['Int']['output']>;
  loftGameFlexRooms?: Maybe<Scalars['Int']['output']>;
  offices?: Maybe<Scalars['Int']['output']>;
  workspaces?: Maybe<Scalars['Int']['output']>;
  primaryBedroom?: Maybe<ProgramDataPrimaryBedroomConfigDetail>;
  /** @deprecated Field no longer supported */
  multiUseBedrooms?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  primarySuiteDown?: Maybe<Scalars['Int']['output']>;
  buildingHeightInFeet?: Maybe<Scalars['Float']['output']>;
};

export type ProjectJobLogInsights = {
  __typename?: 'ProjectJobLogInsights';
  delayFlagCount: Scalars['Int']['output'];
  popularFlagReason?: Maybe<ScheduleFlagReason>;
  partnerWithMostDelays?: Maybe<TradePartner>;
  topJobLogCreator?: Maybe<InternalUser>;
  notesToday: Scalars['Int']['output'];
  weekJobLogs: Scalars['Int']['output'];
};

export type ProjectDictionary = {
  __typename?: 'ProjectDictionary';
  clientContract: Scalars['String']['output'];
  clientNoun: Scalars['String']['output'];
  initialBudget: Scalars['String']['output'];
  shortClientNoun: Scalars['String']['output'];
};

export type ProjectInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAddress?: InputMaybe<AddressInput>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']['input']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']['input']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']['input']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']['input']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  builderId?: InputMaybe<Scalars['ID']['input']>;
  legalDescription?: InputMaybe<Scalars['String']['input']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   *  Deprecated inputs for StandaloneProject
   * @deprecated only implemented for StandaloneProject
   */
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated only implemented for StandaloneProject */
  lotRatingId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated only implemented for StandaloneProject */
  preconContractTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated only implemented for StandaloneProject */
  primaryProjectId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated only implemented for StandaloneProject */
  quickbooksCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated only implemented for StandaloneProject */
  submarketId?: InputMaybe<Scalars['ID']['input']>;
  /**  These fields are only used on Structure and StandaloneProject for now */
  grossSalesPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  closingCostsForDirectMarginInCents?: InputMaybe<Scalars['Int']['input']>;
  purchaseCostInCents?: InputMaybe<Scalars['Int']['input']>;
  includedPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  includedOptions?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveProjectResult = {
  __typename?: 'SaveProjectResult';
  project: Project;
};

export type DeleteProjectInput = {
  projectId: Scalars['ID']['input'];
};

/**  Generic progress of any SchedulePhase, ScheduleSubPhase or Task.  */
export enum ProgressSummaryStatus {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Complete = 'COMPLETE'
}

export type ProgressSummary = {
  __typename?: 'ProgressSummary';
  inProgress: Scalars['Int']['output'];
  notStarted: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  status: ProgressSummaryStatus;
};

export type ToggleProjectFeatureInput = {
  projectId: Scalars['ID']['input'];
  feature: ProjectFeature;
  enable: Scalars['Boolean']['input'];
};

export type RecalcProjectDatesInput = {
  projectIds: Array<Scalars['ID']['input']>;
};

export enum SearchBy {
  Project = 'PROJECT',
  Stage = 'STAGE'
}

export type GeocodeProjectsInput = {
  projectIds: Array<Scalars['ID']['input']>;
};

export type ResyncProjectFinancialsInput = {
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  resyncExternals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResyncPreconProjectItemCostInput = {
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ResyncPreconProjectItemCostResult = {
  __typename?: 'ResyncPreconProjectItemCostResult';
  projects: Array<Project>;
  projectItems: Array<ProjectItem>;
};

export type CloneProjectCostAllocationsInput = {
  sourceId: Scalars['ID']['input'];
  targetIds: Array<Scalars['ID']['input']>;
  stage: Array<Stage>;
};

export type CloneProjectCostAllocationsResult = {
  __typename?: 'CloneProjectCostAllocationsResult';
  source: Project;
  targets: Array<Project>;
};

export enum ProjectTypeFilter {
  Region = 'Region',
  Market = 'Market',
  Community = 'Community',
  Subdivision = 'Subdivision',
  Lot = 'Lot',
  Structure = 'Structure',
  Unit = 'Unit',
  StandaloneProject = 'StandaloneProject'
}

export type ProjectFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<ProjectTypeFilter>>;
  status?: InputMaybe<Array<ProjectStatus>>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  stage?: InputMaybe<Array<Stage>>;
  teamMembers?: InputMaybe<Array<Scalars['ID']['input']>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  productType?: InputMaybe<Array<Scalars['ID']['input']>>;
  latestActiveStage?: InputMaybe<Array<Stage>>;
  lotType?: InputMaybe<Array<LotType>>;
  cohort?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  lotPartitionId?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tradePartnerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlans?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlanOptions?: InputMaybe<Array<Scalars['ID']['input']>>;
  showInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  parentRecursive?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Apply specific filters for user-facing construction view (for mobile app and rag system).
   * When true, then:
   *   - set preferShadow as true
   *   - filter out BTR lot type
   *   - filter by [StandaloneProject, Structure] types
   */
  constructionView?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, then prefer shadow projects over primary projects
   * E.g. 123 Main Street (primary) and Pilot 123 Main Street (shadow), returns the latter.
   */
  preferShadow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter projects that have any of the specified feature flags enabled with Active status. */
  hasActiveFeatureFlag?: InputMaybe<Array<FeatureFlagType>>;
};

export type ProjectOrder = {
  id?: InputMaybe<Order>;
  buildAddress?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  latestActiveStage?: InputMaybe<Order>;
  cohort?: InputMaybe<Order>;
  targetEndDate?: InputMaybe<Order>;
  projectLead?: InputMaybe<Order>;
  homeowner?: InputMaybe<Order>;
};

export type ProjectsPageResult = {
  __typename?: 'ProjectsPageResult';
  entities: Array<Project>;
  pageInfo: PageInfo;
};

export type ProjectTeamMemberByRoleFilter = {
  userId: Scalars['ID']['input'];
  role: ProjectRole;
};

export type ProjectStagesFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  stage?: InputMaybe<Array<Stage>>;
};

export type EarnedValueCurve = {
  __typename?: 'EarnedValueCurve';
  label: Scalars['String']['output'];
  data: Array<EarnedValueDataPoint>;
};

export type EarnedValueDataPoint = {
  __typename?: 'EarnedValueDataPoint';
  date: Scalars['Date']['output'];
  value: Scalars['Int']['output'];
};

export type ExportProjectBillsInput = {
  id: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  minBillAmountInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type SiteSpecificCostInput = {
  costCode: Scalars['String']['input'];
  costInCents: Scalars['Int']['input'];
};

export type CreateProjectFromReadyPlanConfigInput = {
  lotPartitionId: Scalars['String']['input'];
  rpcId: Scalars['ID']['input'];
  siteSpecificCosts: Array<SiteSpecificCostInput>;
  buildAddress: AddressInput;
  buildType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};

export type CreateProjectFromReadyPlanInput = {
  /** lotPartitionId is required for non-test projects */
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  /**  Used to create projects from Community product offerings.  */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  rpId: Scalars['ID']['input'];
  rpoIds: Array<Scalars['ID']['input']>;
  siteSpecificCosts: Array<SiteSpecificCostInput>;
  buildAddress: AddressInput;
  buildType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  orientation?: InputMaybe<ProjectReadyPlanConfigOrientation>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  enableProductConfigPlan?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  primaryProjectId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectsToUpdateByTemplatesInput = {
  /**  The template that will be applied to the project, should only be 1.  */
  templates: Array<Scalars['ID']['input']>;
  milestones?: InputMaybe<Array<Scalars['ID']['input']>>;
  milestoneStartDate?: InputMaybe<DateFilter2>;
};

export type ProjectsToUpdateByTemplatesResult = {
  __typename?: 'ProjectsToUpdateByTemplatesResult';
  projectsToUpdate: Array<ProjectToUpdate>;
};

export type ProjectToUpdate = {
  __typename?: 'ProjectToUpdate';
  project: Project;
  /** @deprecated This is expensive to calculate, so returning empty for now */
  optionsToUpdate: Array<OptionToUpdate>;
  /** @deprecated Project do not really have a unified 'current template' */
  currentTemplate?: Maybe<ItemTemplate>;
  /**  The version of the template that will be applied to the project.  */
  proposedTemplate: ItemTemplate;
};

export type OptionToUpdate = {
  __typename?: 'OptionToUpdate';
  affectedPOs: Array<Commitment>;
  affectedPOsCount: Scalars['Int']['output'];
  optionOrReadyPlan: HasDisplayName;
};

export type ProjectBudgetFinancials = {
  __typename?: 'ProjectBudgetFinancials';
  originalBudgetInCents: Scalars['Int']['output'];
  currentBudgetInCents: Scalars['Int']['output'];
  originalRevenueInCents: Scalars['Int']['output'];
  currentRevenueInCents: Scalars['Int']['output'];
};

export type ApplyInvoiceScheduleInput = {
  projectId: Scalars['ID']['input'];
};

export type ApplyInvoiceScheduleResult = {
  __typename?: 'ApplyInvoiceScheduleResult';
  invoiceSchedule?: Maybe<InvoiceSchedule>;
};

export type ExportProjectBillsResult = {
  __typename?: 'ExportProjectBillsResult';
  googleDriveFolderId: Scalars['String']['output'];
};

export type OptionWithCutoffDate = {
  __typename?: 'OptionWithCutoffDate';
  option: ReadyPlanOption;
  cutoffDate?: Maybe<Scalars['Date']['output']>;
};

export type ProjectCompletedTaskBudgetReview = {
  __typename?: 'ProjectCompletedTaskBudgetReview';
  bucket: Scalars['String']['output'];
  costInCents: Scalars['Int']['output'];
};

export type ProjectBudgetFilter = {
  costCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectDirectMarginGraphFilter = {
  childProject?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ProjectStatus>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ProjectDirectMarginGraph = {
  __typename?: 'ProjectDirectMarginGraph';
  resolution: ProjectDirectMarginGraphResolution;
  data: Array<ProjectDirectMarginGraphData>;
};

export type ProjectDirectMarginGraphData = {
  __typename?: 'ProjectDirectMarginGraphData';
  date: Scalars['Date']['output'];
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
};

export enum ProjectDirectMarginGraphResolution {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly'
}

export type ProjectChangeEventGraphsFilter = {
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ProjectStatus>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ProjectChangeEventGraphsResult = {
  __typename?: 'ProjectChangeEventGraphsResult';
  graphs: Array<ProjectChangeEventGraph>;
};

export type ProjectChangeEventGraph = {
  __typename?: 'ProjectChangeEventGraph';
  type: ProjectChangeEventGraphType;
  data: Array<ProjectChangeEventGraphData>;
};

export type ProjectChangeEventGraphData = {
  __typename?: 'ProjectChangeEventGraphData';
  name: Scalars['String']['output'];
  totalCostInCents: Scalars['Int']['output'];
  timesUsed?: Maybe<Scalars['Int']['output']>;
};

export enum ProjectChangeEventGraphType {
  Reason = 'Reason',
  CostDivision = 'CostDivision'
}

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  name: Scalars['String']['output'];
  licenseNumber: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  email: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  federalId: Scalars['String']['output'];
};

export type ProjectAllocationRule = {
  __typename?: 'ProjectAllocationRule';
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  allocationStrategy: AllocationStrategyDetail;
  project: Project;
  costCodes: Array<CostCode>;
  canDelete: PotentialOperation2;
};

export type SaveProjectAllocationRuleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  allocationStrategy?: InputMaybe<AllocationStrategy>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  costCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveProjectAllocationRuleResult = {
  __typename?: 'SaveProjectAllocationRuleResult';
  projectAllocationRule: ProjectAllocationRule;
};

export type ProjectCollaborator = MaybeHasProject & {
  __typename?: 'ProjectCollaborator';
  id: Scalars['ID']['output'];
  project: Project;
  collaborator: Client;
  role: ProjectCollaboratorRole;
  roleDetail: ProjectCollaboratorRoleDetail;
  /** @deprecated use inviteSentAt instead */
  inviteSent?: Maybe<Scalars['DateTime']['output']>;
  inviteSentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SaveProjectCollaboratorInput = {
  projectId: Scalars['ID']['input'];
  client: ClientInput;
  role: ProjectCollaboratorRole;
};

export type SendInviteEmailInput = {
  projectCollaboratorId: Scalars['ID']['input'];
};

export type SendInviteEmailResult = {
  __typename?: 'SendInviteEmailResult';
  projectCollaborator: ProjectCollaborator;
};

export type DeleteProjectCollaboratorInput = {
  projectCollaboratorId: Scalars['ID']['input'];
};

export type ProjectContact = {
  __typename?: 'ProjectContact';
  id: Scalars['ID']['output'];
  fullName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  email: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  project: Project;
  warrantyTickets: Array<WarrantyTicket>;
};

export type SaveProjectContactInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveProjectContactResult = {
  __typename?: 'SaveProjectContactResult';
  projectContact: ProjectContact;
};

export type ProjectCostCodeFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectRecursive?: InputMaybe<Array<Scalars['ID']['input']>>;
  costCode?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectCostCodesPageResult = {
  __typename?: 'ProjectCostCodesPageResult';
  entities: Array<ProjectCostCode>;
  pageInfo: PageInfo;
};

export type ProjectCutoff = {
  __typename?: 'ProjectCutoff';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  cutoff?: Maybe<Cutoff>;
  project: Project;
  homeownerSelections: Array<HomeownerSelection>;
  /** @deprecated Use ScheduleTask instead */
  task?: Maybe<Task>;
  scheduleTask?: Maybe<ScheduleTask>;
  /** @deprecated Use canEditScope b/c better naming convention */
  canChangeScope: Scalars['Boolean']['output'];
  canEditScope: Scalars['Boolean']['output'];
  /**  The cutoff date, which may be null if we're not hooked up to the schedule yet.  */
  date?: Maybe<Scalars['Date']['output']>;
  history: Array<History>;
  changeEvent?: Maybe<ChangeEvent>;
};

export type SaveProjectCutoffInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  cutoffId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveProjectCutoffResult = {
  __typename?: 'SaveProjectCutoffResult';
  projectCutoff: ProjectCutoff;
};

export type ProjectDocumentAssociation = {
  __typename?: 'ProjectDocumentAssociation';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  document: Document;
  project: Project;
};

export type ProjectDocumentAssociationInput = {
  projectId: Scalars['ID']['input'];
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectInvoiceSetting = {
  __typename?: 'ProjectInvoiceSetting';
  id: Scalars['ID']['output'];
  markupValuePercent?: Maybe<Scalars['Int']['output']>;
  insuranceCostInCents?: Maybe<Scalars['Int']['output']>;
  insuranceMarkupPercent?: Maybe<Scalars['Int']['output']>;
  requireWorkAuthorization?: Maybe<Scalars['Boolean']['output']>;
  includesContractIncludesRetainage?: Maybe<Scalars['Boolean']['output']>;
  retainageAmountPercent?: Maybe<Scalars['Int']['output']>;
  requireGFormat?: Maybe<Scalars['Boolean']['output']>;
  requireTpCopiesBills?: Maybe<Scalars['Boolean']['output']>;
  requireTpSummaryListBills?: Maybe<Scalars['Boolean']['output']>;
  requireTpConditionalLw?: Maybe<Scalars['Boolean']['output']>;
  requireTpUnconditionalLw?: Maybe<Scalars['Boolean']['output']>;
  requireHbConditionalLw?: Maybe<Scalars['Boolean']['output']>;
  requireHbUnconditionalLw?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  markupApplicationMethod?: Maybe<MarkupApplicationMethodDetail>;
  project: Project;
};

export type SaveProjectInvoiceSettingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  markupValuePercent?: InputMaybe<Scalars['Int']['input']>;
  insuranceCostInCents?: InputMaybe<Scalars['Int']['input']>;
  insuranceMarkupPercent?: InputMaybe<Scalars['Int']['input']>;
  requireWorkAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  includesContractIncludesRetainage?: InputMaybe<Scalars['Boolean']['input']>;
  retainageAmountPercent?: InputMaybe<Scalars['Int']['input']>;
  requireGFormat?: InputMaybe<Scalars['Boolean']['input']>;
  requireTpCopiesBills?: InputMaybe<Scalars['Boolean']['input']>;
  requireTpSummaryListBills?: InputMaybe<Scalars['Boolean']['input']>;
  requireTpConditionalLw?: InputMaybe<Scalars['Boolean']['input']>;
  requireTpUnconditionalLw?: InputMaybe<Scalars['Boolean']['input']>;
  requireHbConditionalLw?: InputMaybe<Scalars['Boolean']['input']>;
  requireHbUnconditionalLw?: InputMaybe<Scalars['Boolean']['input']>;
  markupApplicationMethod?: InputMaybe<MarkupApplicationMethod>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveProjectInvoiceSettingResult = {
  __typename?: 'SaveProjectInvoiceSettingResult';
  projectInvoiceSetting: ProjectInvoiceSetting;
};

/**  The pre-negotiated bid contract for this scope of work.  */
export type PotentialBidContractLineItem = {
  __typename?: 'PotentialBidContractLineItem';
  /**  The primary add BCLI for this scope (i.e. there could be other option modifications.) */
  bidContractLineItem: BidContractLineItem;
  /**  All BCLIs for this scope, i.e. the plan item + any option modifications item.  */
  bidContractLineItems: Array<BidContractLineItem>;
  /**  The cost for this Trade Partner to do the work (including any option modifications).  */
  totalCostInCents: Scalars['Int']['output'];
};

export type ProjectItemScopeChange = {
  __typename?: 'ProjectItemScopeChange';
  quantity?: Maybe<Scalars['Int']['output']>;
  costInCents: Scalars['Int']['output'];
  priceInCents: Scalars['Int']['output'];
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  specifications?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
};

export type BudgetPhaseRollup = {
  __typename?: 'BudgetPhaseRollup';
  original: Scalars['Int']['output'];
  prebid: Scalars['Int']['output'];
  prebidChange: Scalars['Int']['output'];
  awarded: Scalars['Int']['output'];
  awardedChange: Scalars['Int']['output'];
  revised: Scalars['Int']['output'];
  revisedChange: Scalars['Int']['output'];
};

export type ProjectItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  slotId?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**  priceInCents deprecated in favor of totalPriceInCents and quantity  */
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  totalPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  /**  costInCents deprecated in favor of totalCostInCents and quantity */
  costInCents?: InputMaybe<Scalars['Int']['input']>;
  /**  unitCostInCents deprecated in favor of totalCostInCents and quantity */
  unitCostInCents?: InputMaybe<Scalars['Int']['input']>;
  totalCostInCents?: InputMaybe<Scalars['Int']['input']>;
  markupBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  costType?: InputMaybe<CostType>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerNote?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Scalars['String']['input']>;
  /**  HomeownerSelectionInput's id/projectItemId are ignored for a ProjectItemInput  */
  homeownerSelection?: InputMaybe<HomeownerSelectionInput>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  costConfidence?: InputMaybe<CostConfidence>;
  buyoutStatus?: InputMaybe<BuyoutStatus>;
  /**  The bid contract to use for auto-creating a pre-negotiated Commitment.  */
  bidContractLineItemId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  isSelection?: InputMaybe<Scalars['Boolean']['input']>;
  bidItemId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  allocationReason?: InputMaybe<Scalars['String']['input']>;
  materialVariantId?: InputMaybe<Scalars['ID']['input']>;
  globalPlanTaskId?: InputMaybe<Scalars['ID']['input']>;
  packageDesignNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectItemsInput = {
  projectItems: Array<ProjectItemInput>;
  bidItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type DuplicateProjectItemsInput = {
  projectItemIds: Array<Scalars['ID']['input']>;
};

export type DuplicateProjectItemsResult = {
  __typename?: 'DuplicateProjectItemsResult';
  projectItems: Array<ProjectItem>;
};

export type SaveProjectItemsResult = HasUserErrors & {
  __typename?: 'SaveProjectItemsResult';
  projectItems?: Maybe<Array<ProjectItem>>;
  userErrors?: Maybe<Array<UserError>>;
};

export type ProjectItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectStage?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  item?: InputMaybe<ItemFilter>;
  location?: InputMaybe<LocationFilter>;
  locationInPath?: InputMaybe<Array<Scalars['ID']['input']>>;
  buyoutStatus?: InputMaybe<Array<BuyoutStatus>>;
  costCode?: InputMaybe<Array<Scalars['ID']['input']>>;
  costType?: InputMaybe<Array<CostType>>;
  costClassification?: InputMaybe<Array<CostClassificationType>>;
  division?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates that the ProjectItem has been essentially removed from the project, but is not hard/soft-deleted due to other constraints. */
  isRemovedScope?: InputMaybe<Scalars['Boolean']['input']>;
  /**  @deprecated  */
  isAllowance?: InputMaybe<Scalars['Boolean']['input']>;
  isProduct?: InputMaybe<Scalars['Boolean']['input']>;
  selectionStatus?: InputMaybe<Array<HomeownerSelectionStatus>>;
  templateId?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreatedFromProposedChangeEvent?: InputMaybe<Scalars['Boolean']['input']>;
  excludeBillTypes?: InputMaybe<Array<BillType>>;
  excludeFromPurchaseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUnderwritingBudget?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteProjectItemInput = {
  id: Scalars['ID']['input'];
};

export type ProjectItemLike = {
  name: Scalars['String']['output'];
  specifications?: Maybe<Scalars['String']['output']>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  slot: ItemSlot;
  item: Item;
  quantity?: Maybe<Scalars['Int']['output']>;
  totalPriceInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  costType: CostType;
  preferredPotentialBidContractLineItem?: Maybe<PotentialBidContractLineItem>;
  itemTemplateItem?: Maybe<BaseItemLike>;
  modifyingTemplateItems: Array<BaseItemLike>;
  bidItem?: Maybe<BidItem>;
  product?: Maybe<Product>;
};

export type DeleteProjectItemsInput = {
  id: Array<Scalars['ID']['input']>;
};

export type CostLineItemEntity = Bill | Expense;

export type CostLineItem = {
  __typename?: 'CostLineItem';
  id: Scalars['ID']['output'];
  amountInCents: Scalars['Int']['output'];
  historicAmountInvoiced: Scalars['Int']['output'];
  costDate: Scalars['Date']['output'];
  isTradePartnerCredit: Scalars['Boolean']['output'];
  entity: CostLineItemEntity;
  tradePartnerNumber: Scalars['String']['output'];
};

export type ProjectItemBudgetFinancials = {
  __typename?: 'ProjectItemBudgetFinancials';
  original: Scalars['Int']['output'];
  awarded: Scalars['Int']['output'];
  changeEvents: Scalars['Int']['output'];
  nonChargeableChangeEvents: Scalars['Int']['output'];
  chargeableChangeEvents: Scalars['Int']['output'];
  proposedChangeEvents: Scalars['Int']['output'];
  reallocations: Scalars['Int']['output'];
  revisedInternalBudget: Scalars['Int']['output'];
  revisedExternalBudget: Scalars['Int']['output'];
  committed: Scalars['Int']['output'];
  uncommitted: Scalars['Int']['output'];
  tradeBilled: Scalars['Int']['output'];
  tradePaidToDate: Scalars['Int']['output'];
  unpaidCommitments: Scalars['Int']['output'];
  projected: Scalars['Int']['output'];
};

export type ProjectItemsPage = {
  __typename?: 'ProjectItemsPage';
  projectItems: Array<ProjectItem>;
  pageInfo: PageInfo;
};

export type ProjectItemAllocation = {
  __typename?: 'ProjectItemAllocation';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  childProject: Project;
  parentProjectItem: ProjectItem;
  commitmentLineItemAllocations: Array<CommitmentLineItemAllocation>;
  homeownerContractLineItemAllocations: Array<HomeownerContractLineItemAllocation>;
  changeEventLineItemAllocations: Array<ChangeEventLineItemAllocation>;
  billLineItemAllocations: Array<BillLineItemAllocation>;
  expenseAllocationAllocations: Array<ExpenseAllocationAllocation>;
  isActive: Scalars['Boolean']['output'];
  revisedPriceInCents: Scalars['Int']['output'];
  /** Hierarchy Budget Fields */
  originalCostInCents: Scalars['Int']['output'];
  startCostInCents: Scalars['Int']['output'];
  changeEventCostInCents: Scalars['Int']['output'];
  revisedCostInCents: Scalars['Int']['output'];
  projectedCostInCents: Scalars['Int']['output'];
  committedCostInCents: Scalars['Int']['output'];
  availableCostInCents: Scalars['Int']['output'];
  billedCostInCents: Scalars['Int']['output'];
  unbilledCostInCents: Scalars['Int']['output'];
  /**
   * Deprecated Fields
   * @deprecated renamed to revisedCostInCents
   */
  revisedApprovedBudgetInCents: Scalars['Int']['output'];
};

export type ProjectLotDetail = {
  __typename?: 'ProjectLotDetail';
  id: Scalars['ID']['output'];
  lotNumber?: Maybe<Scalars['Int']['output']>;
  block?: Maybe<Scalars['Int']['output']>;
  section?: Maybe<Scalars['Int']['output']>;
  lotSquareFootage?: Maybe<Scalars['Int']['output']>;
  elevationCertificateDocumentRequired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by setBackFrontInFeet. */
  setBackFront?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by setBackRightInFeet. */
  setBackRight?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by setBackLeftInFeet. */
  setBackLeft?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by setBackRearInFeet. */
  setBackRear?: Maybe<Scalars['Int']['output']>;
  hoa?: Maybe<Scalars['Boolean']['output']>;
  hoaSpecificModifications?: Maybe<Scalars['String']['output']>;
  siteSpecificModifications?: Maybe<Scalars['String']['output']>;
  fireSprinklersRequired?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  constructionType?: Maybe<ConstructionTypeDetail>;
  floodPlain?: Maybe<FloodPlainDetail>;
  foundationType?: Maybe<FoundationTypeDetail>;
  project: Project;
  userEvents: Array<UserEvent>;
  floodZone?: Maybe<FloodZoneDetail>;
  setBackFrontInFeet?: Maybe<Scalars['Float']['output']>;
  setBackLeftInFeet?: Maybe<Scalars['Float']['output']>;
  setBackRightInFeet?: Maybe<Scalars['Float']['output']>;
  setBackRearInFeet?: Maybe<Scalars['Float']['output']>;
};

export type SaveProjectLotDetailsInput = {
  projectLotDetails: Array<SaveProjectLotDetailInput>;
};

export type SaveProjectLotDetailInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  lotNumber?: InputMaybe<Scalars['Int']['input']>;
  block?: InputMaybe<Scalars['Int']['input']>;
  section?: InputMaybe<Scalars['Int']['input']>;
  lotSquareFootage?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Replaced by setBackFrontInFeet. */
  setBackFront?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Replaced by setBackRightInFeet. */
  setBackRight?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Replaced by setBackLeftInFeet. */
  setBackLeft?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Replaced by setBackRearInFeet. */
  setBackRear?: InputMaybe<Scalars['Int']['input']>;
  hoa?: InputMaybe<Scalars['Boolean']['input']>;
  hoaSpecificModifications?: InputMaybe<Scalars['String']['input']>;
  siteSpecificModifications?: InputMaybe<Scalars['String']['input']>;
  fireSprinklersRequired?: InputMaybe<Scalars['Boolean']['input']>;
  constructionType?: InputMaybe<ConstructionType>;
  floodPlain?: InputMaybe<FloodPlain>;
  foundationType?: InputMaybe<FoundationType>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  floodZone?: InputMaybe<FloodZone>;
  setBackFrontInFeet?: InputMaybe<Scalars['Float']['input']>;
  setBackLeftInFeet?: InputMaybe<Scalars['Float']['input']>;
  setBackRightInFeet?: InputMaybe<Scalars['Float']['input']>;
  setBackRearInFeet?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveProjectLotDetailsResult = {
  __typename?: 'SaveProjectLotDetailsResult';
  projectLotDetails: Array<ProjectLotDetail>;
};

export type ProjectLotDetailFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectReadyPlanConfig = HasBlueprintUrl & ReadyPlanConfigLike & {
  __typename?: 'ProjectReadyPlanConfig';
  id: Scalars['ID']['output'];
  project: Project;
  /**  Projects as new as p:1558 still have PRPCs w/o `readyPlan`s set, so leave this as nullable.  */
  readyPlan?: Maybe<ReadyPlanLike>;
  /**
   * The ProductOffering (ReadyPlan v2) associated with this ProjectReadyPlanConfig.
   *
   * This should only be used in H1 tech-only codepaths, as in ReadyPlan v1 codepaths the ReadyPlan
   * won't be a ProductOffering, and for legacy data might also be undefined.
   */
  productOffering?: Maybe<ProductOffering>;
  blueprintUrl: Url;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  orientation: ProjectReadyPlanConfigOrientation;
  orientationDetail: ProjectReadyPlanConfigOrientationDetail;
  constructionStartDate?: Maybe<Scalars['Date']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use options and option types */
  specOption?: Maybe<ProjectReadyPlanConfigOption>;
  /** @deprecated Use options and option types */
  elevationOption?: Maybe<ProjectReadyPlanConfigOption>;
  /** @deprecated Use options and option types */
  exteriorPaletteOption?: Maybe<ProjectReadyPlanConfigOption>;
  /** @deprecated Use options and option types */
  interiorOption?: Maybe<ProjectReadyPlanConfigOption>;
  options: Array<ProjectReadyPlanConfigOption>;
  /**  Returns the ReadyPlanOptions directly, sorted by group order.  */
  readyPlanOptions: Array<ReadyPlanOption>;
  supportedSpecOptions: Array<ReadyPlanOption>;
  applied: Scalars['Boolean']['output'];
  lastAppliedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Indicates whether the current configuration can be applied. Allowed if:
   * 1) An initial `ObligationDocument` has been signed.
   * 2) The configuration is `Complete`, IE a ReadyPlan, spec level, elevation and palette option have been selected at a minimum
   * 3) There are Active templates for all configured options
   * 4) Project effective scope mode is Full
   */
  canApply: PotentialOperation2;
  /**
   * Indicates whether the current configuration can be released to trades. Allowed if the same 3 first reasons from canApply plus:
   * 4) Project effective scope mode is Full or Release to Trades
   */
  canRelease: PotentialOperation2;
  /**
   * When there is a CE open on a Project that was generated from a previous Lot Config, disable
   * edits to that project's configuraiton so we don't end up duplicating changes on a proejct.
   */
  canEdit: PotentialOperation2;
  programData?: Maybe<ProgramData>;
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  configurationUpdatedAt: Scalars['DateTime']['output'];
  programDataMatchState: ProgramDataMatchStateDetail;
  computedProgramData: ProgramData;
  /**
   * This flag will be used in the FE to know wether to auto populate the empty program data fields
   * right now we will only set it to true for newly added configurations, never updated before (createdAt = updatedAt)
   */
  autoPopulateWithComputedProgramData: Scalars['Boolean']['output'];
  insideMapsRoomRenderings: Array<InsideMapsRoomRendering>;
  includedPriceInCents?: Maybe<Scalars['Int']['output']>;
  /** Pre-computed texture swaps and camera data for InsideMaps rendering */
  insideMapsTextureSwaps?: Maybe<InsideMapsTextureSwaps>;
  includedOptions: Array<ReadyPlanOption>;
  /** POF only: Exterior rendering asset for this config */
  exteriorRendering?: Maybe<Asset>;
};


export type ProjectReadyPlanConfigReadyPlanOptionsArgs = {
  forDesignPackages?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectReadyPlanConfigInsideMapsTextureSwapsArgs = {
  debugParts?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaveProjectReadyPlanConfigsInput = {
  projectReadyPlanConfigs: Array<SaveProjectReadyPlanConfigInput>;
  /**  Indicates whether to overwrite the existing program data with the computed ones automatically  */
  overwriteProgramDataWithComputed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveProjectReadyPlanConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When specified, must include all `ProjectReadyPlanConfigOptions` which should be associated.
   * Any existing entities which are omitted will be deleted.
   */
  options?: InputMaybe<Array<SaveProjectReadyPlanConfigOptionInput>>;
  /** When specified, updates the PD data associated with the PRPC. */
  programData?: InputMaybe<SaveProgramDataInput>;
  orientation?: InputMaybe<ProjectReadyPlanConfigOrientation>;
  originalReadyPlanConfigurationId?: InputMaybe<Scalars['ID']['input']>;
  programDataMatchState?: InputMaybe<ProgramDataMatchState>;
  includedPriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveProjectReadyPlanConfigsResult = {
  __typename?: 'SaveProjectReadyPlanConfigsResult';
  projectReadyPlanConfigs: Array<ProjectReadyPlanConfig>;
};

export type ProjectReadyPlanConfigFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlan?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  cohort?: InputMaybe<Array<Scalars['ID']['input']>>;
  globalOption?: InputMaybe<Array<Scalars['ID']['input']>>;
  constructionStartDate?: InputMaybe<DateFilter2>;
};

export type ApplyProjectReadyPlanConfigsInput = {
  /**
   *  Apply the latest ItemTemplate versions for the specified PRPCs.
   * @deprecated Use filter instead
   */
  projectReadyPlanConfigs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Apply the latest ItemTemplate version for PRPCs matching the provided filter.  */
  filter?: InputMaybe<ProjectReadyPlanConfigFilter>;
  /**  Apply specific ItemTemplate versions for the specified PRPCs.  */
  prpcAtVersions?: InputMaybe<Array<ProjectReadyPlanConfigVersion>>;
  /**  Indicates whether to automatically accept change events for the related changes. Defaults to false.  */
  autoAcceptChangeEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectReadyPlanConfigVersion = {
  prpcId: Scalars['ID']['input'];
  /** The ItemTemplate version to apply, it must be associated with the ReadyPlan of the PRPC */
  itemTemplateId: Scalars['ID']['input'];
  /**
   * This option will only apply items which have changed in the specified version of the template.
   *
   * NOTE: For changed modifying option line items, the associated PI will be updated to include the version of the base and other modifying line items from this template, even if those lines were not modified in the specified version.
   */
  onlyChangedInVersion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplyProjectReadyPlanConfigsResult = {
  __typename?: 'ApplyProjectReadyPlanConfigsResult';
  projectReadyPlanConfigs: Array<ProjectReadyPlanConfig>;
};

export type SyncSalesforcePrpcInput = {
  projectId: Scalars['ID']['input'];
  /**  Will sync the PRPC even if the Opportunity has passed Closed Won  */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveProjectReadyPlanConfigOptionsResult = {
  __typename?: 'SaveProjectReadyPlanConfigOptionsResult';
  projectReadyPlanConfigOptions: Array<ProjectReadyPlanConfigOption>;
};

export type ProjectReadyPlanConfigOption = {
  __typename?: 'ProjectReadyPlanConfigOption';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  projectRpConfig: ProjectReadyPlanConfig;
  readyPlanOption: ReadyPlanOption;
  priceInCents: Scalars['Int']['output'];
};

export type SaveProjectReadyPlanConfigOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectRpConfigId?: InputMaybe<Scalars['ID']['input']>;
  readyPlanOptionId?: InputMaybe<Scalars['ID']['input']>;
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSalesforceOpportunity = {
  __typename?: 'ProjectSalesforceOpportunity';
  id: Scalars['ID']['output'];
  salesforceOpportunityId: Scalars['String']['output'];
  salesforceOpportunityRecordType: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  project: Project;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectSiteCondition = HasBlueprintUrl & {
  __typename?: 'ProjectSiteCondition';
  id: Scalars['ID']['output'];
  expectedSlabPourDate?: Maybe<Scalars['Date']['output']>;
  blueprintUrl: Url;
  drivewaySwing?: Maybe<Scalars['String']['output']>;
  gasLocation?: Maybe<Scalars['String']['output']>;
  electricLocation?: Maybe<Scalars['String']['output']>;
  waterLocation?: Maybe<Scalars['String']['output']>;
  curbGutterLinearFoot?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  project: Project;
  additionalNotes?: Maybe<Scalars['String']['output']>;
  attachments: Array<Attachment>;
};

export type SaveProjectSiteConditionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  expectedSlabPourDate?: InputMaybe<Scalars['Date']['input']>;
  drivewaySwing?: InputMaybe<Scalars['String']['input']>;
  gasLocation?: InputMaybe<Scalars['String']['input']>;
  electricLocation?: InputMaybe<Scalars['String']['input']>;
  waterLocation?: InputMaybe<Scalars['String']['input']>;
  curbGutterLinearFoot?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type SaveProjectSiteConditionResult = {
  __typename?: 'SaveProjectSiteConditionResult';
  projectSiteCondition: ProjectSiteCondition;
};

export type SendProjectSiteConditionsNotificationInput = {
  projectSiteConditionId: Scalars['ID']['input'];
  internalUserIds: Array<Scalars['ID']['input']>;
};

export type ProjectSiteSpecificInfo = {
  __typename?: 'ProjectSiteSpecificInfo';
  id: Scalars['ID']['output'];
  perSiteBudgetInCents?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  project: Project;
  siteSpecificInfo: SiteSpecificInfo;
};

export type SaveProjectSiteSpecificInfoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  perSiteBudgetInCents?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  siteSpecificInfoId: Scalars['ID']['input'];
};

export type SaveProjectSiteSpecificInfoResult = {
  __typename?: 'SaveProjectSiteSpecificInfoResult';
  projectSiteSpecificInfo: ProjectSiteSpecificInfo;
};

export type ProjectSnapshot = {
  __typename?: 'ProjectSnapshot';
  id: Scalars['ID']['output'];
  grossSalesPriceInCents?: Maybe<Scalars['Int']['output']>;
  closingCostsForDirectMarginInCents?: Maybe<Scalars['Int']['output']>;
  totalCostInCents?: Maybe<Scalars['Int']['output']>;
  totalHardCostInCents?: Maybe<Scalars['Int']['output']>;
  totalSoftCostInCents?: Maybe<Scalars['Int']['output']>;
  directMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  purchaseCostInCents?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['Date']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
};

export type DeprecatedUnitFilter = {
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StageProgress = {
  __typename?: 'StageProgress';
  /** This will be the associated ProjectStage id */
  id: Scalars['ID']['output'];
  taskProgress: ProgressSummary;
  selectionProgress: Array<HomeownerSelectionStatusProgress>;
};

export type HomeownerSelectionStatusProgress = {
  __typename?: 'HomeownerSelectionStatusProgress';
  status: HomeownerSelectionStatusDetail;
  count: Scalars['Int']['output'];
};

export type CompleteStageInput = {
  projectId: Scalars['ID']['input'];
  stage: Stage;
};

export type SaveProjectStageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /**  Some legacy callers pass in projectId+stage to update the project stage.  */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<Stage>;
  projectStageStatus?: InputMaybe<ProjectStageStatus>;
  clientPresentationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Confirms that an unusual status change transition is intentionally being performed */
  confirmStatusException?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  baselineDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectStageHomeownerFinancials = {
  __typename?: 'ProjectStageHomeownerFinancials';
  homeownerPriceInCents: Scalars['Int']['output'];
  amountInvoicedInCents: Scalars['Int']['output'];
  amountPaidInCents: Scalars['Int']['output'];
  balanceInCents: Scalars['Int']['output'];
  financialsLastUpdate: Scalars['Date']['output'];
};

export type ProjectStageHocFinancials = {
  __typename?: 'ProjectStageHocFinancials';
  originalContractValueInCents: Scalars['Int']['output'];
  originalBudgetedCostInCents: Scalars['Int']['output'];
  originalGrossMarginBasisPoints: Scalars['Int']['output'];
  valueInCents: Scalars['Int']['output'];
  costInCents: Scalars['Int']['output'];
  grossMarginBasisPoints: Scalars['Int']['output'];
  paidFromHomeownerInCents: Scalars['Int']['output'];
  paidToTradesInCents: Scalars['Int']['output'];
  paidNetInCents: Scalars['Int']['output'];
  marginErosionBasisPoints: Scalars['Int']['output'];
};

export type ItemLocationsFilter = {
  isProduct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectStageTemplateConfig = ProjectStageTemplateConfigLike & Named & {
  __typename?: 'ProjectStageTemplateConfig';
  id: Scalars['ID']['output'];
  /** @deprecated Use the parent instead */
  itemTemplate: ItemTemplate;
  parent: BaseItemParentVersion;
  projectStage: ProjectStage;
  /**  Whether this template can be removed/changed, or false if it's too late to change b/c the work is already billed.  */
  canEdit: PotentialOperation2;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  totalCostInCents: Scalars['Int']['output'];
  onlyChangedInVersion?: Maybe<Scalars['Boolean']['output']>;
  changeEvent?: Maybe<ChangeEvent>;
};

/** Allows for the frontend to work with ProjectStageTemplateConfig and ChangeEventTemplateConfig in a polymorphic way. */
export type ProjectStageTemplateConfigLike = {
  id: Scalars['ID']['output'];
  itemTemplate: ItemTemplate;
  projectStage: ProjectStage;
  changeEvent?: Maybe<ChangeEvent>;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  onlyChangedInVersion?: Maybe<Scalars['Boolean']['output']>;
};

export type ProjectStatusChange = {
  __typename?: 'ProjectStatusChange';
  id: Scalars['ID']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  project: Project;
  reason?: Maybe<ProjectStatusChangeReason>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type ProjectStatusChangeInput = {
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
};

export type ProjectStatusChangeReason = Named & {
  __typename?: 'ProjectStatusChangeReason';
  id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projectStatus: ProjectStatus;
  projectStatusDetail: ProjectStatusDetail;
  projectStage: Stage;
  projectStageDetail: StageDetail;
};

export type SaveProjectStatusChangeReasonsInput = {
  projectStatusChangeReasons: Array<SaveProjectStatusChangeReasonInput>;
};

export type SaveProjectStatusChangeReasonInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectStatus: ProjectStatus;
  projectStage: Stage;
};

export type SaveProjectStatusChangeReasonsResult = {
  __typename?: 'SaveProjectStatusChangeReasonsResult';
  projectStatusChangeReasons: Array<ProjectStatusChangeReason>;
  userErrors: Array<Maybe<UserError>>;
};

export type ProjectStatusChangeReasonsFilter = {
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  projectStage?: InputMaybe<Array<Stage>>;
};

export type ProjectTeamMember = {
  __typename?: 'ProjectTeamMember';
  /**
   * Note/TODO This user field really is required at the db level, it is only nullable
   * here because we're semi-abusing the ProjectTeamMember-the-entity type for a
   * ProjectTeamMember-the-UI-row on the Project Roles page, as it wants to render
   * as roles, even if there is no team member assigned to that role yet.
   */
  user?: Maybe<InternalUser>;
  role: ProjectRoleDetail;
};

export type UpdateProjectRoleInput = {
  projectId: Scalars['ID']['input'];
  role: ProjectRole;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProjectRoleResult = {
  __typename?: 'UpdateProjectRoleResult';
  teamMember: ProjectTeamMember;
  /** @deprecated unused in practice, returns empty array */
  tasks: Array<Task>;
};

export type BulkUpdateProjectRoleResult = {
  __typename?: 'BulkUpdateProjectRoleResult';
  teamMember: ProjectTeamMember;
  /** @deprecated unused in practice, returns empty array */
  tasks: Array<Task>;
  project: Project;
};

export type BulkUpdateProjectRolesInput = {
  developmentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  cohortId?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  role: ProjectRole;
  userId: Scalars['ID']['input'];
};

export type ProjectUpdate = MaybeHasProject & {
  __typename?: 'ProjectUpdate';
  id: Scalars['ID']['output'];
  project: Project;
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use createdAt instead */
  eventTime: Scalars['DateTime']['output'];
  actionType: ProjectUpdateActionType;
  actionTypeDetail: ProjectUpdateActionTypeDetail;
  schedulePhase?: Maybe<SchedulePhase>;
  document?: Maybe<Document>;
  scheduleSubPhase?: Maybe<ScheduleSubPhase>;
  homeownerNote?: Maybe<HomeownerNote>;
};

export type EntityReferenceInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  unitId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectUpdateInput = {
  projectId: Scalars['ID']['input'];
  /**  defaults to now if not set  */
  eventTime?: InputMaybe<Scalars['DateTime']['input']>;
  actionType: ProjectUpdateActionType;
  entityReference: EntityReferenceInput;
};

export type PunchlistItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignee?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SavePunchlistItemTodosInput = {
  punchlistItemTodos: Array<SavePunchlistItemTodoInput>;
};

export type SavePunchlistItemTodoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ToDoStatus>;
  type?: InputMaybe<ToDoType>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<SaveToDoAttachmentInput>>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SavePunchlistItemTodosResult = {
  __typename?: 'SavePunchlistItemTodosResult';
  punchlistItemTodos: Array<PunchlistItemTodo>;
};

export type SavePunchlistItemTodoResult = {
  __typename?: 'SavePunchlistItemTodoResult';
  punchlistItemTodo: PunchlistItemTodo;
};

export type SendTradePartnerPunchlistEmailInput = {
  /** list of punchlistItemTodoIds, must be assigned to a trade partner and project */
  punchlistItemTodoId: Array<Scalars['ID']['input']>;
  /** additional trade partner contact ids to include in the email */
  tradePartnerContactId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** additional emails to include in the email */
  additionalEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendTradePartnerPunchlistEmailResults = {
  __typename?: 'SendTradePartnerPunchlistEmailResults';
  results?: Maybe<Array<SendTradePartnerPunchlistEmailResult>>;
};

export type SendTradePartnerPunchlistEmailResult = SendTradePartnerPunchlistEmailSuccess | SendTradePartnerPunchlistEmailFailure;

export type SendTradePartnerPunchlistEmailSuccess = {
  __typename?: 'SendTradePartnerPunchlistEmailSuccess';
  punchlistItemTodo: PunchlistItemTodo;
  emails: Array<Scalars['String']['output']>;
};

export type SendTradePartnerPunchlistEmailFailure = {
  __typename?: 'SendTradePartnerPunchlistEmailFailure';
  punchlistItemTodoId: Scalars['ID']['output'];
  error: Scalars['String']['output'];
};

export type SendPunchlistExportEmailInput = {
  punchlistItemTodoId: Array<Scalars['ID']['input']>;
  emails: Array<Scalars['String']['input']>;
};

export type SendPunchlistExportEmailResults = {
  __typename?: 'SendPunchlistExportEmailResults';
  results?: Maybe<Array<SendPunchlistExportEmailResult>>;
};

export type SendPunchlistExportEmailResult = SendPunchlistExportEmailSuccess | SendPunchlistExportEmailFailure;

export type SendPunchlistExportEmailSuccess = {
  __typename?: 'SendPunchlistExportEmailSuccess';
  punchlistItemTodo: PunchlistItemTodo;
};

export type SendPunchlistExportEmailFailure = {
  __typename?: 'SendPunchlistExportEmailFailure';
  punchlistItemTodoId: Scalars['ID']['output'];
  error: Scalars['String']['output'];
};

export type RegisterPushNotificationTokenInput = {
  token: Scalars['String']['input'];
  platform: PushNotificationPlatform;
  environment: PushNotificationEnvironment;
};

export type RegisterPushNotificationTokenResult = {
  __typename?: 'RegisterPushNotificationTokenResult';
  pushNotificationToken: PushNotificationToken;
};

export type UnregisterPushNotificationTokenInput = {
  token: Scalars['String']['input'];
};

export type PushNotificationToken = {
  __typename?: 'PushNotificationToken';
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  platform: PushNotificationPlatformDetail;
  user: User;
  environment: PushNotificationEnvironmentDetail;
  snsEndpointArn?: Maybe<Scalars['String']['output']>;
};

export type SavePushNotificationTokenInput = {
  environment?: InputMaybe<PushNotificationEnvironment>;
  snsEndpointArn?: InputMaybe<Scalars['String']['input']>;
};

export type ReadyPlanLike = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  code?: Maybe<Scalars['String']['output']>;
  /**  The `type` + `code`, i.e. SFH-TX-1-001  */
  displayCode?: Maybe<Scalars['String']['output']>;
  status: ReadyPlanStatusDetail;
  /**  The latest status based on the latest RPAV, which may be archived depending on the ReadyPlan's status.  */
  effectiveStatus: ReadyPlanStatusDetail;
  options: Array<ReadyPlanOption>;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']['output']>;
  aggregateActive?: Maybe<ReadyPlanAggregateVersion>;
  aggregateDraft?: Maybe<ReadyPlanAggregateVersion>;
  aggregateLatest: ReadyPlanAggregateVersion;
  aggregateVersions: Array<ReadyPlanAggregateVersion>;
  /**
   * This was a String! but that was when some v4 ItemTemplate contained an `it.version` and `it.scopeChangeReason` which are
   * better articulated in whatever "this aggregate I'm viewing" is. So version should now be "this version." This implies if
   * we `query { readyPlan(id: "rp:1", version: 3) { ... } }` then we'll get `rp.version.version = 3` back.
   */
  version: ReadyPlanAggregateVersion;
  /**  Locations used by TLIs in this ReadyPlan.  */
  itemLocations: Array<Location>;
  /**  CostCodes used by TLIs in this ReadyPlan.  */
  costCodes: Array<CostCode>;
  canEditLineItems: PotentialOperation2;
  canEdit: PotentialOperation2;
  documents: Array<Document>;
  /**  All downstream PRPCs referencing this ReadyPlan, either directly or indirectly via a ProductOffering  */
  projectConfigs: Array<ProjectReadyPlanConfig>;
};

export type SaveReadyPlanInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  defaultVariationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ReadyPlanStatus>;
  developmentId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ReadyPlanType>;
  /**  Deprecated - prefer programDatas - Remove in SC-57703  */
  programData?: InputMaybe<SaveProgramDataInput>;
  programDatas?: InputMaybe<Array<SaveReadyPlanProgramDataInput>>;
  /**  Deprecated - now computed - Remove in SC-57703  */
  maxProgramData?: InputMaybe<SaveProgramDataInput>;
  /**  Deprecated - now computed - Remove in SC-57703  */
  minProgramData?: InputMaybe<SaveProgramDataInput>;
  underwritingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  constructionDocumentCompletePercentage?: InputMaybe<Scalars['Int']['input']>;
  lotTypes?: InputMaybe<Array<LotType>>;
  contingencyMarkupPercentage?: InputMaybe<Scalars['Float']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveReadyPlansInput = {
  readyPlans: Array<SaveReadyPlanInput>;
};

export type ReadyPlanFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ReadyPlanStatus>>;
  hasActiveTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnderwritingTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveReadyPlansResult = {
  __typename?: 'SaveReadyPlansResult';
  readyPlans: Array<ReadyPlan>;
};

export type SaveReadyPlanResult = {
  __typename?: 'SaveReadyPlanResult';
  readyPlan: ReadyPlan;
};

export type DeleteReadyPlansInput = {
  ids: Array<Scalars['ID']['input']>;
  deleteNonDraft?: InputMaybe<Scalars['Boolean']['input']>;
  clearPrpc?: InputMaybe<Scalars['Boolean']['input']>;
  deleteBcli?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComputeReadyPlanCostInput = {
  readyPlanId: Scalars['ID']['input'];
  readyPlanOptionIds: Array<Scalars['ID']['input']>;
  /**  Optionally the version of the ReadyPlan to compute costs for, otherwise the latest version will be used.  */
  itemTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /**  Optionally the ReadyPlanAggregateVersion to compute costs for. Ignored if versionMode is specified.  */
  versionId?: InputMaybe<Scalars['ID']['input']>;
  /**  For ProductOfferings, specifies which aggregate version to use. Takes precedence over versionId.  */
  versionMode?: InputMaybe<ProductOfferingVersionMode>;
  /** A list of the RPO IDs that you wish to calculate the cost delta for. If specified as ["all"], all RPOs not included in readyPlanOptionIds will be included. */
  deltaForReadyPlanOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**  This returns the raw trade costs of a ReadyPlan, based on the latest scope template costs, without any opco markup or overhead.  */
export type ComputeReadyPlanCostResult = ReadyPlanCostData & {
  __typename?: 'ComputeReadyPlanCostResult';
  readyPlan: ReadyPlan;
  readyPlanOptions: Array<ReadyPlanOption>;
  /**  Options added while expanding a partial RPv2 config; always empty for RPv1.  */
  includedOptions: Array<ReadyPlanOption>;
  /**  Total cost of the ReadyPlan and specified options, including contingency.  */
  totalCostInCents: Scalars['Int']['output'];
  softCostInCents: Scalars['Int']['output'];
  /**  Direct hard costs of the ReadyPlan and specified options, including contingency.  */
  directHardCostInCents: Scalars['Int']['output'];
  indirectHardCostInCents: Scalars['Int']['output'];
  /**  Contingency amount (also included in the totalCostInCents and directHardCostInCents).  */
  contingencyCostInCents: Scalars['Int']['output'];
  /**  Whether or not the contingency was computed or based on a static contingency ITI.  */
  contingencyComputed: Scalars['Boolean']['output'];
  deltas: Array<ReadyPlanOptionCostDelta>;
  protoProjectItems: Array<ProtoProjectItem>;
  configurationErrors: Array<Scalars['String']['output']>;
};

export type ReadyPlanOptionCostDelta = ReadyPlanCostData & {
  __typename?: 'ReadyPlanOptionCostDelta';
  readyPlanOption: ReadyPlanOption;
  /**  Delta total cost of the ReadyPlan and specified options, including contingency.  */
  totalCostInCents: Scalars['Int']['output'];
  softCostInCents: Scalars['Int']['output'];
  /**  Delta direct hard costs of the ReadyPlan and specified options, including contingency.  */
  directHardCostInCents: Scalars['Int']['output'];
  indirectHardCostInCents: Scalars['Int']['output'];
  /**  Delta contingency amount (also included in the totalCostInCents and directHardCostInCents).  */
  contingencyCostInCents: Scalars['Int']['output'];
  /**  Whether or not the contingency was computed or based on a static contingency ITI.  */
  contingencyComputed: Scalars['Boolean']['output'];
};

export type ReadyPlanCostData = {
  /**  Includes contingency.  */
  totalCostInCents: Scalars['Int']['output'];
  softCostInCents: Scalars['Int']['output'];
  /**  Includes contingency.  */
  directHardCostInCents: Scalars['Int']['output'];
  indirectHardCostInCents: Scalars['Int']['output'];
  /**  Contingency amount (also included in the totalCostInCents and directHardCostInCents).  */
  contingencyCostInCents: Scalars['Int']['output'];
  /**  Whether or not the contingency was computed or based on a static contingency ITI.  */
  contingencyComputed: Scalars['Boolean']['output'];
};

/**  A concrete 1-to-1 implementation of ProjectItemLike to satisfy GraphQL's requirement for return values.  */
export type ProtoProjectItem = ProjectItemLike & {
  __typename?: 'ProtoProjectItem';
  name: Scalars['String']['output'];
  specifications?: Maybe<Scalars['String']['output']>;
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  slot: ItemSlot;
  item: Item;
  quantity?: Maybe<Scalars['Int']['output']>;
  totalPriceInCents: Scalars['Int']['output'];
  totalCostInCents: Scalars['Int']['output'];
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  costType: CostType;
  preferredPotentialBidContractLineItem?: Maybe<PotentialBidContractLineItem>;
  itemTemplateItem?: Maybe<BaseItemLike>;
  modifyingTemplateItems: Array<BaseItemLike>;
  bidItem?: Maybe<BidItem>;
  product?: Maybe<Product>;
};

export type ScopeGlobalOptionGroupsToReadyPlansInput = {
  globalOptionGroupIds: Array<Scalars['ID']['input']>;
};

export type ScopeGlobalOptionGroupsToReadyPlansResult = {
  __typename?: 'ScopeGlobalOptionGroupsToReadyPlansResult';
  globalOptionGroups: Array<GlobalOptionGroup>;
};

export type ReadyPlanAggregateVersion = Named & HasDisplayName & HasDisplayVersion & BaseItemParentVersion & {
  __typename?: 'ReadyPlanAggregateVersion';
  id: Scalars['ID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
  /**  Pass through of readyPlan.name  */
  name: Scalars['String']['output'];
  /**  Pass through of readyPlan.displayName  */
  displayName: Scalars['String']['output'];
  /**  rp replacement for `it.displayVersion  */
  displayVersion: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: AggregateVersionStatusDetail;
  readyPlan: ReadyPlanLike;
  optionGroupVersions: Array<ReadyPlanOptionGroupVersion>;
  optionVersions: Array<ReadyPlanOptionVersion>;
  finalReadyPlanOptionVersions: Array<ReadyPlanOptionVersion>;
  versions: Array<ReadyPlanVersion>;
  removedTliVersions: Array<TakeoffLineItemVersion>;
  tliVersions: Array<TakeoffLineItemVersion>;
  versionNotes?: Maybe<Scalars['String']['output']>;
  designPackagePlanUpdates: Array<DesignPackagePlanUpdate>;
  productOfferingIncomingUpdates: Array<ProductOfferingIncomingUpdate>;
  programDataVersions: Array<ReadyPlanProgramDataVersion>;
  removedProgramDataVersions: Array<ReadyPlanProgramDataVersion>;
  assetVersions: Array<ReadyPlanAssetVersion>;
  designPackageSourceVersions: Array<DesignPackageSourceVersion>;
  tliVersionsCount: Scalars['Int']['output'];
  rplVersions: Array<ReadyPlanLocationVersion>;
  /**   Whether the current RPAV, and all related changes, can be deleted.   */
  canDelete: PotentialOperation2;
  canPublish: PotentialOperation2;
  /**  Only for a DesignPackage RPAV, the incoming DPPUs that we accepted in this version. */
  acceptedDesignPackageUpdates: Array<DesignPackagePlanUpdate>;
  /**  Only for a PlanPackage RPAV, the outgoing DPPUs that we created/pushed out in this version.  */
  outgoingDesignPackageUpdates: Array<DesignPackagePlanUpdate>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  finalReadyPlanRequiredOptionVersions: Array<ReadyPlanRequiredOptionVersion>;
  requiredOptionVersions: Array<ReadyPlanRequiredOptionVersion>;
  designNoteVersions: Array<ReadyPlanDesignNoteVersion>;
  designPackageSources: Array<DesignPackageSource>;
  promotedAt?: Maybe<Scalars['DateTime']['output']>;
  promotedBy?: Maybe<User>;
  createdByPromotion: Scalars['Boolean']['output'];
};

/**  We only allow marking a version as status=active.  */
export type SaveReadyPlanAggregateVersionInput = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<AggregateVersionStatus>;
  versionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type SaveReadyPlanAggregateVersionResult = {
  __typename?: 'SaveReadyPlanAggregateVersionResult';
  readyPlanAggregateVersion: ReadyPlanAggregateVersion;
};

export type ReadyPlanAggregateVersionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlanId?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<AggregateVersionStatus>>;
};

export type DeleteReadyPlanAggregateVersionInput = {
  /**  The ID of the version to delete.  */
  id: Scalars['ID']['input'];
  /**  Allows deletion of the entire plan, if it is still in its first draft and has not been referenced elsewhere  */
  deleteReadyPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Allows deletion of non-draft versions, as long as it is the latest version.  */
  deleteNonDraft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteReadyPlanAggregateVersionResult = {
  __typename?: 'DeleteReadyPlanAggregateVersionResult';
  /** Returns the latest */
  latestReadyPlanAggregateVersion?: Maybe<ReadyPlanAggregateVersion>;
};

export type ReadyPlanAggregateVersionsPageResult = {
  __typename?: 'ReadyPlanAggregateVersionsPageResult';
  entities: Array<ReadyPlanAggregateVersion>;
  pageInfo: PageInfo;
};

export type ReadyPlanAsset = {
  __typename?: 'ReadyPlanAsset';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  type: ReadyPlanAssetTypeDetail;
  asset: Asset;
  parent?: Maybe<ReadyPlanAssetParent>;
  isCoverPhoto: Scalars['Boolean']['output'];
  versions: Array<ReadyPlanAssetVersion>;
  active: Scalars['Boolean']['output'];
  options: Array<ReadyPlanOption>;
};

export type SaveReadyPlanAssetInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ReadyPlanAssetType>;
  asset?: InputMaybe<AssetInput>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReadyPlanAssetParent = ReadyPlan | ReadyPlanLocation | ReadyPlanOption | PlanPackage | DesignPackage | ProductOffering;

export type ReadyPlanAssetVersion = {
  __typename?: 'ReadyPlanAssetVersion';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanAsset;
  asset: Asset;
};

export type ReadyPlanConfigLike = {
  id: Scalars['ID']['output'];
  readyPlan?: Maybe<ReadyPlanLike>;
  readyPlanOptions: Array<ReadyPlanOption>;
  /** Pre-computed texture swaps and camera data for InsideMaps rendering */
  insideMapsTextureSwaps?: Maybe<InsideMapsTextureSwaps>;
};


export type ReadyPlanConfigLikeInsideMapsTextureSwapsArgs = {
  debugParts?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReadyPlanDesignNote = {
  __typename?: 'ReadyPlanDesignNote';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  readyPlan: ReadyPlanLike;
  takeoffLineItem: TakeoffLineItem;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
};

export type SaveReadyPlanDesignNoteInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  takeoffLineItemId?: InputMaybe<Scalars['ID']['input']>;
  targetGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
};

export type SaveReadyPlanDesignNoteResult = {
  __typename?: 'SaveReadyPlanDesignNoteResult';
  readyPlanDesignNote: ReadyPlanDesignNote;
};

export type ReadyPlanDesignNoteVersion = {
  __typename?: 'ReadyPlanDesignNoteVersion';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanDesignNote;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
};

export type ReadyPlanDesignPackage = {
  __typename?: 'ReadyPlanDesignPackage';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  readyPlan: ReadyPlanLike;
  options: Array<ReadyPlanOption>;
  optionDefaultsIfChildren: Array<ReadyPlanOption>;
  optionVersionDefaultsIfChildren: Array<ReadyPlanOptionVersion>;
};

export type ReadyPlanDesignPackageVersion = {
  __typename?: 'ReadyPlanDesignPackageVersion';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanDesignPackage;
};

export type ReadyPlanDocumentVersion = {
  __typename?: 'ReadyPlanDocumentVersion';
  id: Scalars['ID']['output'];
  asset: Asset;
  identity: Document;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uploaded: Scalars['Boolean']['output'];
  sizeInBytes: Scalars['Int']['output'];
  documentType: DocumentTypeDetail;
  category: DocumentCategoryDetail;
};

export type ReadyPlanLocation = Named & {
  __typename?: 'ReadyPlanLocation';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  location: Location;
  readyPlan: ReadyPlan;
  roomNumber?: Maybe<Scalars['Int']['output']>;
  fullRoomNumber?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Location>;
  roomType?: Maybe<RoomType>;
  versions: Array<ReadyPlanLocationVersion>;
  active: Scalars['Boolean']['output'];
  relatedTakeoffLineItemsCount: Scalars['Int']['output'];
  readyPlanAssets: Array<ReadyPlanAsset>;
  readyPlanOptions: Array<ReadyPlanOption>;
  /**  Only non-empty for PlanPackage RPLs  */
  designPackageLocations: Array<ReadyPlanLocation>;
  /**  Only non-empty for DesignPackage RPLs  */
  planLocations: Array<ReadyPlanLocation>;
  name: Scalars['String']['output'];
  isInsideMapsRoom?: Maybe<Scalars['Boolean']['output']>;
  insideMapsRoomOrder?: Maybe<Scalars['Int']['output']>;
  canDelete: PotentialOperation2;
  /**  When no marketingName is set, the location name is returned */
  marketingName: Scalars['String']['output'];
};

export type SaveReadyPlanLocationInput = {
  /**
   * Either call with `id` to update `roomNumber`, or with `readyPlanId+roomType+levelId` to create a
   * RoomRPL, or `readyPlanId+locationId` to create LevelRPL. `delete` cannot be used without `id`.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  roomTypeId?: InputMaybe<Scalars['ID']['input']>;
  levelId?: InputMaybe<Scalars['ID']['input']>;
  /**  Only used on create for LevelRPLs. Should be a type=Level location  */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  roomNumber?: InputMaybe<Scalars['Int']['input']>;
  isInsideMapsRoom?: InputMaybe<Scalars['Boolean']['input']>;
  insideMapsRoomOrder?: InputMaybe<Scalars['Int']['input']>;
  marketingName?: InputMaybe<Scalars['String']['input']>;
};

export type SaveReadyPlanLocationBulkResult = {
  __typename?: 'SaveReadyPlanLocationBulkResult';
  readyPlanLocations: Array<ReadyPlanLocation>;
  affectedTlis: Array<TakeoffLineItem>;
};

/** Specify id/planLocations to remap an existing RPL */
export type SaveDesignPackageLocationPlanMappingInput = {
  id: Scalars['ID']['input'];
  planLocations: Array<Scalars['ID']['input']>;
};

export type SaveDesignPackageLocationPlanMappingsResult = {
  __typename?: 'SaveDesignPackageLocationPlanMappingsResult';
  readyPlanLocations: Array<ReadyPlanLocation>;
  affectedPlaceholders: Array<TakeoffLineItem>;
};

export type CreateDesignPackageAlternateLocationInput = {
  designPackageId: Scalars['ID']['input'];
  /** Right now, the design package left nav UI relies on global locations, so we fetch the RPL using the global location ID. */
  locationId: Scalars['ID']['input'];
};

export type CreateDesignPackageAlternateLocationResult = {
  __typename?: 'CreateDesignPackageAlternateLocationResult';
  readyPlanLocation: ReadyPlanLocation;
};

export type ReadyPlanLocationVersion = {
  __typename?: 'ReadyPlanLocationVersion';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanLocation;
  roomNumber?: Maybe<Scalars['Int']['output']>;
  location: Location;
  changeType: Scalars['String']['output'];
  previous?: Maybe<ReadyPlanLocationVersion>;
  fullRoomNumber?: Maybe<Scalars['Int']['output']>;
  /**  Only non-empty for DesignPackage RPLs  */
  planLocations: Array<ReadyPlanLocation>;
};

export type ReadyPlanOption = HasBlueprintUrl & Named & HasDisplayName & HasOptionPricingData & {
  __typename?: 'ReadyPlanOption';
  id: Scalars['ID']['output'];
  /** Helper to get the GlobalOption.code directly */
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  homeownerChoice: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated Replaced by prerequisites */
  isChildOption: Scalars['Boolean']['output'];
  /** @deprecated Replaced by prerequisites */
  parentOption?: Maybe<ReadyPlanOption>;
  /** @deprecated Replaced by prerequisites */
  isParentOption: Scalars['Boolean']['output'];
  /** @deprecated Replaced by prerequisites */
  childOptions: Array<ReadyPlanOption>;
  globalOption: GlobalOption;
  type: GlobalOptionType;
  readyPlan: ReadyPlan;
  /**  V2 ReadyPlans have RPLs which drive the location of the RPOs. V1 ReadyPlans will not have a RPL, but may have a V1 location.  */
  readyPlanLocation?: Maybe<ReadyPlanLocation>;
  /**  For V2 ReadyPlans, the location of the RPO is driven by the RPL.location. For V1 ReadyPlans, the location could be a V1 location.  */
  location?: Maybe<Location>;
  description?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  /** Returns the assigned short name for an elevation option, if it exists */
  shortName?: Maybe<Scalars['String']['output']>;
  /** Returns the assigned short name for an elevation option, or the name field if there is no short name assigned */
  maybeShortName: Scalars['String']['output'];
  programData: ProgramData;
  optionGroup: ReadyPlanOptionGroup;
  userEvents: Array<UserEvent>;
  blueprintUrl: Url;
  programDataModifiedBy: Array<ReadyPlanOptionProgramDataModification>;
  modifiesProgramDataFor: Array<ReadyPlanOptionProgramDataModification>;
  optionPrereqChildren: Array<ReadyPlanOption>;
  optionPrerequisites: Array<ReadyPlanOption>;
  optionConflictChildren: Array<ReadyPlanOption>;
  optionConflicts: Array<ReadyPlanOption>;
  optionDefaultChildren: Array<ReadyPlanOption>;
  optionDefaultsIf: Array<ReadyPlanOption>;
  optionRequiredIf: Array<ReadyPlanRequiredOption>;
  personalizationTargetCombinations: Array<DesignPackageOptionCombination>;
  order: Scalars['Int']['output'];
  programDatas: Array<ReadyPlanProgramData>;
  assets: Array<ReadyPlanAsset>;
  bidOutPercentage: Scalars['Int']['output'];
  latestVersion?: Maybe<ReadyPlanOptionVersion>;
  draftVersion?: Maybe<ReadyPlanOptionVersion>;
  publishToUnderwriting: Scalars['Boolean']['output'];
  /**  Either plan-specific Assets or its global fallback Asset.  */
  optionImages: Array<Asset>;
  /**  Preferred single image to display from `optionImages` */
  optionImage?: Maybe<Asset>;
  /**  For product personalization options, the material this option represents, via the global option.  */
  materialVariant?: Maybe<MaterialVariant>;
  /**  For personalization options, the material this option represents, via the global option.  */
  materialVariants: Array<MaterialVariant>;
  /**  The desired margin in basis points for this Option before the cutoff date, either defined directly by a (non-market / non-community level) OptionPricingConfig or falling back to a default value. */
  preCutoffDesiredMarginInBasisPoints: Scalars['Int']['output'];
  /**  The desired margin in basis points for this Option after the cutoff date, either defined directly by a (non-market / non-community level) OptionPricingConfig or falling back to a default value. */
  postCutoffDesiredMarginInBasisPoints?: Maybe<Scalars['Int']['output']>;
  /**  The selection fee for this Option, either defined directly by a (non-market / non-community level) OptionPricingConfig or falling back to a default value. */
  selectionFeeInCents?: Maybe<Scalars['Int']['output']>;
  minimumPriceInCents: Scalars['Int']['output'];
  showInCheckout: Scalars['Boolean']['output'];
  canDelete: PotentialOperation2;
  packageOptionMaterial?: Maybe<MaterialVariant>;
  /**  Whether this is a newly-imported POF RPO.  */
  isNewFromUpstream: Scalars['Boolean']['output'];
  /**
   * Indicates if the POF RPO should be hidden behind the "Show Archived" toggle on the edit options screen.
   * This flag was initially used to tell if the copiedFrom/upstream RPO was inactive, but it now encompasses
   * more cases, like if the personalization RPO is no longer relevant.
   */
  isUpstreamInactive: Scalars['Boolean']['output'];
  checkoutOrder?: Maybe<Scalars['Int']['output']>;
};

export type ReadyPlanOptionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  readyPlan?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  We allow null IDs to represent querying for [1, null].  */
  location?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /**  All ReadyPlanOptions including all of the requested options  */
  tag?: InputMaybe<Array<Scalars['ID']['input']>>;
  isParentOption?: InputMaybe<Scalars['Boolean']['input']>;
  isElevation?: InputMaybe<Scalars['Boolean']['input']>;
  isExteriorPalette?: InputMaybe<Scalars['Boolean']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get all ReadyPlanOptions in the specified developments */
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateFilter2>;
  isInterior?: InputMaybe<Scalars['Boolean']['input']>;
  isFloorPlan?: InputMaybe<Scalars['Boolean']['input']>;
  isPlanPackage?: InputMaybe<Scalars['Boolean']['input']>;
  isAddOnV2?: InputMaybe<Scalars['Boolean']['input']>;
  isStructuralV2?: InputMaybe<Scalars['Boolean']['input']>;
  isCatalogV2?: InputMaybe<Scalars['Boolean']['input']>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveReadyPlanOptionsInput = {
  readyPlanOptions: Array<SaveReadyPlanOptionInput>;
};

export type SaveReadyPlanOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  homeownerChoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Replaced by optionPrerequisites */
  parentOptionId?: InputMaybe<Scalars['ID']['input']>;
  globalOptionId?: InputMaybe<Scalars['ID']['input']>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  /**  Used for V2 ReadyPlans  */
  readyPlanLocationId?: InputMaybe<Scalars['ID']['input']>;
  /**  Used for V1 ReadyPlans  */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   *  All existing childOptions are required when defining childOptions property in mutation
   * @deprecated Replaced by optionPrerequisites
   */
  childOptions?: InputMaybe<Array<SaveReadyPlanChildOptionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  Deprecated - use globalOptionId - Remove in SC-57703  */
  programData?: InputMaybe<SaveProgramDataInput>;
  programDatas?: InputMaybe<Array<SaveReadyPlanProgramDataInput>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  optionPrereqChildIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionPrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionConflictChildIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionConflictIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionDefaultsIfIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionGroupId?: InputMaybe<Scalars['ID']['input']>;
  assets?: InputMaybe<Array<SaveReadyPlanAssetInput>>;
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']['input']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requiredOptionId?: InputMaybe<Scalars['ID']['input']>;
  packageOptionMaterialId?: InputMaybe<Scalars['ID']['input']>;
  /**  POF RPOs only  */
  checkoutOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveReadyPlanChildOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  homeownerChoice?: InputMaybe<Scalars['Boolean']['input']>;
  globalOptionId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveReadyPlanOptionsResult = {
  __typename?: 'SaveReadyPlanOptionsResult';
  readyPlanOptions: Array<ReadyPlanOption>;
};

export type MergeReadyPlanOptionsInput = {
  targetId: Scalars['ID']['input'];
  sourceIds: Array<Scalars['ID']['input']>;
};

export type MergeReadyPlanOptionsResult = {
  __typename?: 'MergeReadyPlanOptionsResult';
  readyPlanOption: ReadyPlanOption;
};

export type ReadyPlanOptionGroup = {
  __typename?: 'ReadyPlanOptionGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  marketingDescription?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  group: GlobalOptionGroup;
  location?: Maybe<Location>;
  readyPlan: ReadyPlan;
  options: Array<ReadyPlanOption>;
  isSingleOptionGroup: Scalars['Boolean']['output'];
  isMultiOptionGroup: Scalars['Boolean']['output'];
  /** @deprecated No longer used */
  forDesignUpgrade: Scalars['Boolean']['output'];
  /** @deprecated use `forDesignInterior` instead */
  forDesignPackage: Scalars['Boolean']['output'];
  forDesignInterior: Scalars['Boolean']['output'];
  forDesignExterior: Scalars['Boolean']['output'];
  /**  helper for `forDesignInterior || forDesignExterior` so you don't have to do it by hand everywhere  */
  forDesignPackages: Scalars['Boolean']['output'];
  isPlanPackage: Scalars['Boolean']['output'];
  /**  Only applicable to Design Package-owned personalization RPOGs.  */
  personalizationType?: Maybe<ReadyPlanOptionGroupPersonalizationTypeDetail>;
  groupByFeature: Scalars['Boolean']['output'];
  /**  If this is a personalization RPOG, these are the placeholder slots that holds our defaults.  */
  personalizationPlaceholders: Array<TakeoffLineItem>;
  /**
   * If this is a product personalization RPOG, the material variants that are in our pool of options.
   *
   * These MVs all have their own backing RPOs, but this lets the FE directly get at the material variants.
   */
  personalizationMaterialVariants: Array<MaterialVariant>;
  groupPrerequisites: Array<ReadyPlanOptionGroup>;
  groupPrereqChildren: Array<ReadyPlanOptionGroup>;
  levels?: Maybe<Scalars['Int']['output']>;
  personalizationTargetGroups: Array<ReadyPlanOptionGroup>;
  readyPlanLocation?: Maybe<ReadyPlanLocation>;
  displayPackageOptionsAsSingleProduct?: Maybe<Scalars['Boolean']['output']>;
  checkoutOrder?: Maybe<Scalars['Int']['output']>;
  step?: Maybe<CheckoutConfigOptionGroupStepDetail>;
  substepNumber?: Maybe<Scalars['Int']['output']>;
  hasDynamicProducts: Scalars['Boolean']['output'];
  overrideStep?: Maybe<CheckoutConfigOptionGroupStepDetail>;
  overrideSubstepNumber?: Maybe<Scalars['Int']['output']>;
};


export type ReadyPlanOptionGroupOptionsArgs = {
  filter?: InputMaybe<OptionFilter>;
};

export type ReadyPlanOptionGroupsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  These will only be applied to RPOs on RPOGs that are in a ProductOffering. These filters are only used for the underwriting api. */
export type OptionFilter = {
  publishToUnderwriting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveReadyPlanOptionGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<Array<SaveReadyPlanOptionInput>>;
  marketingDescription?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Scalars['Int']['input']>;
  groupByFeature?: InputMaybe<Scalars['Boolean']['input']>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  checkoutOrder?: InputMaybe<Scalars['Int']['input']>;
  overrideStep?: InputMaybe<CheckoutConfigOptionGroupStep>;
  overrideSubstepNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveReadyPlanOptionGroupResult = {
  __typename?: 'SaveReadyPlanOptionGroupResult';
  optionGroup: ReadyPlanOptionGroup;
};

export type SaveReadyPlanOptionGroupsResult = {
  __typename?: 'SaveReadyPlanOptionGroupsResult';
  entities: Array<ReadyPlanOptionGroup>;
};

export type ReadyPlanOptionGroupVersion = {
  __typename?: 'ReadyPlanOptionGroupVersion';
  id: Scalars['ID']['output'];
  identity: ReadyPlanOptionGroup;
  first: ReadyPlanAggregateVersion;
  final?: Maybe<ReadyPlanAggregateVersion>;
  required: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  marketingDescription?: Maybe<Scalars['String']['output']>;
  levels?: Maybe<Scalars['Int']['output']>;
  personalizationTargetGroups: Array<ReadyPlanOptionGroup>;
  location?: Maybe<Location>;
  readyPlanLocation?: Maybe<ReadyPlanLocation>;
  displayPackageOptionsAsSingleProduct?: Maybe<Scalars['Boolean']['output']>;
  substepNumber?: Maybe<Scalars['Int']['output']>;
  step?: Maybe<CheckoutConfigOptionGroupStepDetail>;
  overrideStep?: Maybe<CheckoutConfigOptionGroupStepDetail>;
  overrideSubstepNumber?: Maybe<Scalars['Int']['output']>;
};

export type ReadyPlanOptionProgramDataModification = Named & {
  __typename?: 'ReadyPlanOptionProgramDataModification';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  programData: ProgramData;
  modifiedOption: ReadyPlanOption;
  matchesOption: ReadyPlanOption;
  userEvents: Array<UserEvent>;
  name: Scalars['String']['output'];
};

export type SaveReadyPlanOptionProgramDataModificationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  programData?: InputMaybe<SaveProgramDataInput>;
  modifiedOptionId?: InputMaybe<Scalars['ID']['input']>;
  matchesOptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveReadyPlanOptionProgramDataModificationsResult = {
  __typename?: 'SaveReadyPlanOptionProgramDataModificationsResult';
  entities: Array<ReadyPlanOptionProgramDataModification>;
};

export type DeleteReadyPlanOptionProgramDataModificationsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteReadyPlanOptionProgramDataModificationsResult = {
  __typename?: 'DeleteReadyPlanOptionProgramDataModificationsResult';
  id: Scalars['ID']['output'];
  modifiedOptionId: Scalars['ID']['output'];
};

export type ReadyPlanOptionVersion = {
  __typename?: 'ReadyPlanOptionVersion';
  id: Scalars['ID']['output'];
  identity: ReadyPlanOption;
  first: ReadyPlanAggregateVersion;
  final?: Maybe<ReadyPlanAggregateVersion>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  customName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use RPO.isNewFromUpstream */
  isNewFromUpstream: Scalars['Boolean']['output'];
  /**
   * Indicates if the POF RPO should be hidden behind the "Show Archived" toggle on the edit options screen.
   * This flag was initially used to tell if the copiedFrom/upstream RPO was inactive, but it now encompasses
   * more cases, like if the personalization RPO is no longer relevant.
   * @deprecated Use RPO.isUpstreamInactive
   */
  isUpstreamInactive: Scalars['Boolean']['output'];
  isOfferingInactive?: Maybe<Scalars['Boolean']['output']>;
  optionConflicts?: Maybe<Array<ReadyPlanOption>>;
  optionPrerequisites?: Maybe<Array<ReadyPlanOption>>;
  optionDefaultsIf?: Maybe<Array<ReadyPlanOption>>;
  publishToUnderwriting: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
  showInCheckout: Scalars['Boolean']['output'];
};

export type ReadyPlanProgramData = {
  __typename?: 'ReadyPlanProgramData';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  readyPlan: ReadyPlan;
  readyPlanOptions: Array<ReadyPlanOption>;
  programData: ProgramData;
  versions: Array<ReadyPlanProgramDataVersion>;
  active: Scalars['Boolean']['output'];
};

export type SaveReadyPlanProgramDataInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  readyPlanOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  programData?: InputMaybe<SaveProgramDataInput>;
  op: IncrementalCollectionOp;
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReadyPlanProgramDataVersion = {
  __typename?: 'ReadyPlanProgramDataVersion';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanProgramData;
  programData: ProgramData;
};

export type ReadyPlanRequiredOption = {
  __typename?: 'ReadyPlanRequiredOption';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  readyPlan: ReadyPlanLike;
  planAddOns: Array<ReadyPlanOption>;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
  active: Scalars['Boolean']['output'];
  usePersonalizationGroups: Scalars['Boolean']['output'];
};

export type SaveReadyPlanRequiredOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  designPackageId?: InputMaybe<Scalars['ID']['input']>;
  targetGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
  planAddOnIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  usePersonalizationGroups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveReadyPlanRequiredOptionsResult = {
  __typename?: 'SaveReadyPlanRequiredOptionsResult';
  readyPlanRequiredOptions: Array<ReadyPlanRequiredOption>;
};

export type ReadyPlanRequiredOptionVersion = {
  __typename?: 'ReadyPlanRequiredOptionVersion';
  id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: ReadyPlanRequiredOption;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
};

export type ReadyPlanVersion = {
  __typename?: 'ReadyPlanVersion';
  id: Scalars['ID']['output'];
  identity: ReadyPlan;
  name: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  type: ReadyPlanTypeDetail;
  lotTypes: Array<LotType>;
  contingencyMarkupPercentage?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  markets: Array<Market>;
  owner?: Maybe<InternalUser>;
};

export type Referencable = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  blueprintUrl: Url;
  references: Array<Referencable>;
  referencedBy: Array<Referencable>;
};

export type SaveReferencesInput = {
  references: Array<ReferenceInput>;
};

export type ReferenceInput = {
  source: Scalars['ID']['input'];
  target: Scalars['ID']['input'];
};

export type SaveReferencesResult = {
  __typename?: 'SaveReferencesResult';
  references: Array<Reference>;
};

export type Reference = {
  __typename?: 'Reference';
  source: Referencable;
  target: Referencable;
};

export type DeleteReferencesInput = {
  references: Array<ReferenceInput>;
};

export type SaveRegionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']['input']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']['input']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']['input']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']['input']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  builderId?: InputMaybe<Scalars['ID']['input']>;
  legalDescription?: InputMaybe<Scalars['String']['input']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  communityType?: InputMaybe<CommunityType>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveRegionResult = {
  __typename?: 'SaveRegionResult';
  region: Region;
};

export type RequiredTaskDocument = {
  __typename?: 'RequiredTaskDocument';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  watchers: Array<ProjectRole>;
  documentType: DocumentTypeDetail;
  sampleAsset?: Maybe<Asset>;
  task: Task;
  document?: Maybe<Document>;
  globalRequiredTaskDocument?: Maybe<GlobalRequiredTaskDocument>;
};

export type SaveRequiredTaskDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  watchers?: InputMaybe<Array<ProjectRole>>;
  /** @deprecated Will be removed in favor of documentType */
  documentCategory?: InputMaybe<DocumentCategory>;
  documentType?: InputMaybe<DocumentType>;
  sampleAsset?: InputMaybe<AssetInput>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  globalRequiredTaskDocumentId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveRequiredTaskDocumentResult = {
  __typename?: 'SaveRequiredTaskDocumentResult';
  requiredTaskDocument: RequiredTaskDocument;
};

export type DeleteRequiredTaskDocumentResult = {
  __typename?: 'DeleteRequiredTaskDocumentResult';
  task: Task;
};

export type DeleteRequireTaskDocumentInput = {
  id: Scalars['ID']['input'];
};

export type RoomType = {
  __typename?: 'RoomType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  locations: Array<Location>;
  canDesignPackageRemap?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveRoomTypeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  canDesignPackageRemap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveRoomTypeResult = {
  __typename?: 'SaveRoomTypeResult';
  roomType: RoomType;
};

export type TestMutationInput = {
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
};

export type TestMutationResult = {
  __typename?: 'TestMutationResult';
  datetime: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
};

export type HasUserErrors = {
  userErrors?: Maybe<Array<UserError>>;
};

export type UserError = {
  __typename?: 'UserError';
  message: Scalars['String']['output'];
};

/**  A standard result for when we're not returning any user errors, and instead will just fail the request.  */
export type EmptyResult = {
  __typename?: 'EmptyResult';
  emptyResult?: Maybe<Scalars['String']['output']>;
  /** @deprecated clients should prefer `emptyResult` in queries */
  dummyString?: Maybe<Scalars['String']['output']>;
};

/** Generic bulk delete input type */
export type DeleteEntitiesInput = {
  id: Array<Scalars['ID']['input']>;
};

/** Generic simple delete input type */
export type DeleteEntityInput = {
  id: Scalars['ID']['input'];
  /** An 'admin' flag, i.e. for eng/tech coordinators to do deletions that typically aren't allowed. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Named = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type HasDisplayName = {
  id: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
};

export type HasDisplayVersion = {
  id: Scalars['ID']['output'];
  displayVersion: Scalars['String']['output'];
};

export type Url = {
  __typename?: 'Url';
  /** Absolute path of the url, e.g. `/projects/p:1/` */
  path: Scalars['String']['output'];
  /** Fully qualified http url, e.g. `https://blueprint.homebound.com/projects/p:1/` */
  url: Scalars['String']['output'];
};

/**  Represents both whether an operation is performable, and if not the reasons.  */
export type PotentialOperation = {
  __typename?: 'PotentialOperation';
  shown: Scalars['Boolean']['output'];
  hiddenReasons: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  disabledReasons: Array<Scalars['String']['output']>;
};

/**
 * Represents both whether an operation is performable, and if not the reasons.
 * When the reason relates to a specific entity, we return it for convenient UI navigation.
 */
export type PotentialOperation2 = {
  __typename?: 'PotentialOperation2';
  allowed: Scalars['Boolean']['output'];
  disabledReasons: Array<Reason>;
};

export type Reason = {
  __typename?: 'Reason';
  message: Scalars['String']['output'];
  entity?: Maybe<HasBlueprintUrl>;
};

export type HasBlueprintUrl = {
  id: Scalars['ID']['output'];
  blueprintUrl: Url;
};

export type HasCheckoutUrl = {
  id: Scalars['ID']['output'];
  checkoutUrl: Url;
};

export type HasHopUrl = {
  id: Scalars['ID']['output'];
  hopUrl: Scalars['String']['output'];
};

export type MaybeHasPropcoUrl = {
  id: Scalars['ID']['output'];
  propcoUrl?: Maybe<Scalars['String']['output']>;
};

export type MaybeHasProject = {
  project?: Maybe<Project>;
};

/**  Represents the valid joist 'op' options for updating a nested collection. */
export enum IncrementalCollectionOp {
  Include = 'include',
  Delete = 'delete',
  Remove = 'remove',
  Incremental = 'incremental'
}

export type SyncSalesforceEntityInput = {
  entityType: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  operation: SalesforceEntityOperation;
  modifiedBy: SalesforceEntityModifiedByInput;
};

export enum SalesforceEntityOperation {
  Insert = 'INSERT',
  Update = 'UPDATE',
  Delete = 'DELETE',
  Undelete = 'UNDELETE'
}

export type SalesforceEntityModifiedByInput = {
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Schedule = ScheduleEntity & Named & MaybeHasInterval & MaybeHasBaselineInterval & {
  __typename?: 'Schedule';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  interval?: Maybe<CalendarInterval>;
  baselineInterval?: Maybe<CalendarInterval>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: ScheduleStatus;
  statusDetail: ScheduleStatusDetail;
  stage: Stage;
  stageDetail: StageDetail;
  parent: ScheduleParent;
  scheduleSetting?: Maybe<ScheduleSetting>;
  canPublishSchedule: PotentialOperation2;
  canCompleteSchedule: PotentialOperation2;
  duration?: Maybe<Scalars['Int']['output']>;
  baselineDuration?: Maybe<Scalars['Int']['output']>;
  phases: Array<SchedulePhase>;
  isLocked: Scalars['Boolean']['output'];
  flagCount: Scalars['Int']['output'];
  templateSchedule?: Maybe<Schedule>;
  enableReviewReminders: Scalars['Boolean']['output'];
  reviewReminderDays: Array<DayOfWeek>;
  market?: Maybe<Market>;
};

export type SchedulesFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  parent?: InputMaybe<Array<Scalars['ID']['input']>>;
  stage?: InputMaybe<Array<Stage>>;
  status?: InputMaybe<Array<ScheduleStatus>>;
};

export type SchedulesResult = {
  __typename?: 'SchedulesResult';
  schedules: Array<Schedule>;
};

export type SaveScheduleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<Stage>;
  status?: InputMaybe<ScheduleStatus>;
  /** Confirms that an unusual status change transition is intentionally being performed */
  confirmStatusException?: InputMaybe<Scalars['Boolean']['input']>;
  reviewReminderDays?: InputMaybe<Array<DayOfWeek>>;
};

export type SaveScheduleResult = {
  __typename?: 'SaveScheduleResult';
  schedule: Schedule;
};

export type ScheduleParent = StandaloneProject | Region | Development | Market | Community | Subdivision | Lot | Structure | Unit | ScheduleTemplate;

export type HasScheduleImpact = {
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
};

export type HasSchedules = {
  id: Scalars['ID']['output'];
  schedules: Array<Schedule>;
};

export type ScheduleCorrectScheduleBaselines = {
  scheduleIds: Array<Scalars['ID']['input']>;
  dryRun: Scalars['Boolean']['input'];
};

export type ResetScheduleBaselinesInput = {
  projectIds: Array<Scalars['ID']['input']>;
};

export type ResetScheduleBaselinesResult = {
  __typename?: 'ResetScheduleBaselinesResult';
  projectIds: Array<Scalars['ID']['output']>;
};

export type AddJobsForSchedulesInput = {
  jobName: Scalars['String']['input'];
  /**  These optional args will be merged with `scheduleId` before being passed to the job `payload`  */
  args?: InputMaybe<Scalars['JSONObject']['input']>;
  scheduleFilter: SchedulesFilter;
};

export type ScheduleEntity = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  interval?: Maybe<CalendarInterval>;
  baselineInterval?: Maybe<CalendarInterval>;
  parent: ScheduleParent;
};

export type MaybeHasInterval = {
  id: Scalars['ID']['output'];
  interval?: Maybe<CalendarInterval>;
};

export type MaybeHasBaselineInterval = {
  id: Scalars['ID']['output'];
  baselineInterval?: Maybe<CalendarInterval>;
};

export type ScheduleFlag = Entity & {
  __typename?: 'ScheduleFlag';
  id: Scalars['ID']['output'];
  durationInDays?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  reason?: Maybe<ScheduleFlagReason>;
  scheduleTask?: Maybe<ScheduleTask>;
  task: Task;
  attachments: Array<Attachment>;
};

export type SaveScheduleFlagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated use taskId instead */
  scheduleTaskId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated use oldTaskStartDate instead */
  oldTaskStart?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated use newTaskStartDate instead */
  newTaskStart?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated use oldTaskEndDate instead */
  oldTaskEnd?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated use newTaskEndDate instead */
  newTaskEnd?: InputMaybe<Scalars['Date']['input']>;
  oldTaskStartDate?: InputMaybe<Scalars['Date']['input']>;
  newTaskStartDate?: InputMaybe<Scalars['Date']['input']>;
  oldTaskEndDate?: InputMaybe<Scalars['Date']['input']>;
  newTaskEndDate?: InputMaybe<Scalars['Date']['input']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type SaveScheduleFlagResult = {
  __typename?: 'SaveScheduleFlagResult';
  scheduleFlag: ScheduleFlag;
};

export type DeleteScheduleFlagInput = {
  id: Scalars['ID']['input'];
};

export type DeleteScheduleFlagResult = {
  __typename?: 'DeleteScheduleFlagResult';
  /** @deprecated use task instead */
  scheduleTask?: Maybe<ScheduleTask>;
  task: Task;
};

export type ScheduleFlagFilter = {
  scheduleParent?: InputMaybe<Array<Scalars['ID']['input']>>;
  internalUser?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduleIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  taskStatus?: InputMaybe<Array<TaskStatus>>;
  /** @deprecated use task instead */
  scheduleTask?: InputMaybe<Array<Scalars['ID']['input']>>;
  task?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ScheduleFlagImpact = {
  __typename?: 'ScheduleFlagImpact';
  id: Scalars['ID']['output'];
  oldStartDate?: Maybe<Scalars['Date']['output']>;
  newStartDate: Scalars['Date']['output'];
  oldEndDate?: Maybe<Scalars['Date']['output']>;
  newEndDate: Scalars['Date']['output'];
  oldDurationInDays?: Maybe<Scalars['Int']['output']>;
  newDurationInDays: Scalars['Int']['output'];
  oldSlackInDays?: Maybe<Scalars['Int']['output']>;
  newSlackInDays?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  scheduleFlag: ScheduleFlag;
  impacted?: Maybe<ScheduleFlagImpactImpacted>;
};

export type ScheduleFlagImpactImpacted = PlanMilestone | Task;

export type ScheduleFlagReason = Entity & {
  __typename?: 'ScheduleFlagReason';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  scheduleFlagReasonType: ScheduleFlagReasonTypeDetail;
  stages: Array<Stage>;
  scheduleFlags: Array<ScheduleFlag>;
  title: Scalars['String']['output'];
  attachmentIsRequired: Scalars['Boolean']['output'];
  descriptionIsRequired: Scalars['Boolean']['output'];
};

export type ScheduleFlagReasonsFilter = {
  stage?: InputMaybe<Array<Stage>>;
};

export type SaveScheduleFlagReasonsInput = {
  scheduleFlagReasons: Array<SaveScheduleFlagReasonInput>;
};

export type SaveScheduleFlagReasonsResult = {
  __typename?: 'SaveScheduleFlagReasonsResult';
  scheduleFlagReasons: Array<ScheduleFlagReason>;
};

export type SaveScheduleFlagReasonInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  scheduleFlagReasonType?: InputMaybe<ScheduleFlagReasonType>;
  stages?: InputMaybe<Array<Stage>>;
  title?: InputMaybe<Scalars['String']['input']>;
  attachmentIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchedulePhaseProgress = {
  __typename?: 'SchedulePhaseProgress';
  scheduleSubPhaseProgress: ProgressSummary;
  taskProgress: ProgressSummary;
};

export type SchedulePhasesFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Obtain a list of SchedulePhases used on the specified parent(s)  */
  parent?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Obtain a list of SchedulePhases used on the specified schedule(s)  */
  schedule?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveSchedulePhasesResult = {
  __typename?: 'SaveSchedulePhasesResult';
  schedulePhases: Array<SchedulePhase>;
};

export type DeleteSchedulePhasesResult = HasScheduleImpact & {
  __typename?: 'DeleteSchedulePhasesResult';
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
};

export type SaveSchedulePhasesInput = {
  schedulePhases: Array<SaveSchedulePhaseInput>;
};

export type SaveSchedulePhaseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  schedule?: InputMaybe<Scalars['ID']['input']>;
  globalPhase?: InputMaybe<Scalars['ID']['input']>;
  globalPhaseId?: InputMaybe<Scalars['ID']['input']>;
};

export type ScheduleSetting = {
  __typename?: 'ScheduleSetting';
  id: Scalars['ID']['output'];
  workingDays: Array<DayOfWeek>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  schedule: Schedule;
  exceptions?: Maybe<Scalars['JSONObject']['output']>;
};

export type SaveScheduleSettingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  workingDays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveScheduleSettingsInput = {
  scheduleSettings: Array<SaveScheduleSettingInput>;
};

export type SaveScheduleSettingsResult = {
  __typename?: 'SaveScheduleSettingsResult';
  scheduleSettings: Array<ScheduleSetting>;
};

export type ScheduleSubPhaseProgress = {
  __typename?: 'ScheduleSubPhaseProgress';
  taskProgress: ProgressSummary;
};

export type SaveScheduleSubPhasesInput = {
  scheduleSubPhases: Array<SaveScheduleSubPhaseInput>;
};

export type SaveScheduleSubPhaseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Can specify either a SubPhase tagged ID or the name of an existing/new SubPhase */
  globalSubPhaseId?: InputMaybe<Scalars['ID']['input']>;
  schedulePhaseId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveScheduleSubPhasesResult = {
  __typename?: 'SaveScheduleSubPhasesResult';
  scheduleSubPhases: Array<ScheduleSubPhase>;
};

export type ScheduleSubPhasesFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Obtain a list of ScheduleSubPhases used on the specified parent(s)  */
  parent?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Obtain a list of ScheduleSubPhases used on the specified schedule(s)  */
  schedule?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteScheduleSubPhasesResult = HasScheduleImpact & {
  __typename?: 'DeleteScheduleSubPhasesResult';
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
};

export type MoveScheduleSubPhasesInput = {
  schedule: Scalars['ID']['input'];
  moves: Array<MoveScheduleSubPhasesMovesInput>;
};

export type MoveScheduleSubPhasesMovesInput = {
  scheduleSubPhase: Scalars['ID']['input'];
  targetGlobalPhase: Scalars['ID']['input'];
};

export type MoveScheduleSubPhasesResult = HasScheduleImpact & {
  __typename?: 'MoveScheduleSubPhasesResult';
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
};

export type SaveScheduleTasksInput = {
  tasks: Array<SaveScheduleTaskInput>;
};

export type SaveScheduleTaskInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TaskStatus>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  internalUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Incremental predecessors updates, i.e. either delete or append instead of an exhaustive set. */
  predecessorDependencies?: InputMaybe<Array<TaskDependencyInput>>;
  /** Incremental successor updates, i.e. either delete or append instead of an exhaustive set. */
  successorDependencies?: InputMaybe<Array<TaskDependencyInput>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  homeownerDescription?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Note: allowMilestoneDelete must also include delete as true, will currently only work when the tasks schedule stage is DEVELOPMENT */
  allowMilestoneDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Note: if this task has predecessors, setting `startDate` will updated predecessor dependency lag to derive the desired start date.
   * Therefore `startDate` shouldn't be combined with `predecessorDependencies` as it will override any `predecessorDependencies` values.
   */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  salesforceId?: InputMaybe<Scalars['String']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Must be specified when creating a new task without specifying an activityId,
   * in which case it is expected that one or both of phase/subPhase will be specified
   */
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Sets the phase of the task appropriately based on what is specified:
   *
   * `null` - disassociates from any `Phase` or `SubPhase`
   * (in the backend this is equivalent to associating with the default
   * `Phase` and `SubPhase`)
   * `[Tagged Phase ID]` - finds or creates an associated `SchedulePhase` for the
   * specified `Phase` and assigns the task appropriately.
   *
   * NOTE: When setting only this field, subPhase will be cleared
   * (aka set to the default `SubPhase`/`ScheduleSubPhase` for the selected phase)
   */
  schedulePhase?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Sets the subPhase (and sometimes phase) appropriately based on what is specified:
   *
   * `null` - disassociates from any `SubPhase`
   * (in the backend this is equivalent to associating with the default `SubPhase`
   * for the currently selected `Phase`)
   * `[Tagged SubPhase ID]` - finds or creates an associated `ScheduleSubPhase` for the
   * specified `SubPhase` and assigns the task appropriately.
   * NOTE: This may also result in changing the Phase/SchedulePhase associated with the task
   * `[NEW SubCategoryName]` - Attempts to find/create a new global `SubPhase` with the provided value as it's name.
   * It will then proceed as though the tagged ID of the new global `SubPhase` had been specified.
   * NOTE: This will be used as the way the schedule UI creates new `SubPhases`/`ScheduleSubPhases`, and
   * only works if a non-default `Phase` is associated with the task.
   */
  scheduleSubPhase?: InputMaybe<Scalars['ID']['input']>;
  projectItems?: InputMaybe<Array<Scalars['ID']['input']>>;
  deadlineType?: InputMaybe<TaskDeadlineType>;
  templateProjectRole?: InputMaybe<ProjectRole>;
  documents?: InputMaybe<Array<Scalars['ID']['input']>>;
  globalTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleTaskChecklistItems?: InputMaybe<Array<SaveScheduleTaskChecklistItemInput>>;
  tradePartnerStatus?: InputMaybe<TradePartnerTaskStatus>;
  workDays?: InputMaybe<Array<TaskWorkDayIncrementalInput>>;
};

export type SaveScheduleTasksResult = HasScheduleImpact & {
  __typename?: 'SaveScheduleTasksResult';
  scheduleTasks: Array<ScheduleTask>;
  impactedScheduleTasks: Array<ScheduleTask>;
  impactedScheduleSubPhases: Array<ScheduleSubPhase>;
  impactedSchedulePhases: Array<SchedulePhase>;
  impactedSchedules: Array<Schedule>;
  impacted: Array<ScheduleEntity>;
  resultingDelays: Array<ResultingDelay>;
  generatedInvoices: Array<Invoice>;
  generatedDepositBills: Array<Bill>;
};

export type ResultingDelay = {
  __typename?: 'ResultingDelay';
  scheduleTask: ScheduleTask;
  durationInDays: Scalars['Int']['output'];
  oldTaskStart: Scalars['Date']['output'];
  oldTaskEnd: Scalars['Date']['output'];
};

export type ScheduleTaskFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  internalUser?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Only tasks assigned to the currently-logged-in user.  */
  myTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Only return tasks whose activity / stage / project are all active; Candidate to drop from this filter?  */
  effectivelyActive?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<TaskStatus>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Candidate to drop from this filter?  */
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Note: Flipped the names on these interval filters so we can deprecate interval2 in the future  */
  interval?: InputMaybe<IntervalFilter2>;
  interval2?: InputMaybe<IntervalFilter>;
  slackInDays?: InputMaybe<IntFilter>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  stage?: InputMaybe<Array<Stage>>;
  tradePartner?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduleSubPhase?: InputMaybe<Array<Scalars['ID']['input']>>;
  schedulePhase?: InputMaybe<Array<Scalars['ID']['input']>>;
  deadlineType?: InputMaybe<Array<TaskDeadlineType>>;
  schedule?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduleParent?: InputMaybe<Array<Scalars['ID']['input']>>;
  isCriticalPath?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobalMilestoneTask?: InputMaybe<Scalars['Boolean']['input']>;
  startDateRange?: InputMaybe<DateFilter2>;
  endDateRange?: InputMaybe<DateFilter2>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Filter for tasks through the `parent: Project -> Development` relationship (vs `parent: Development`)  */
  projectTasksForDevelopment?: InputMaybe<Scalars['ID']['input']>;
  scheduleIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  hasChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  hasScheduleFlags?: InputMaybe<Scalars['Boolean']['input']>;
  systemTask?: InputMaybe<Array<SystemTask>>;
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  tradePartnerStatus?: InputMaybe<Array<TradePartnerTaskStatus>>;
};

/**
 * Supported ordering for tasks.
 *
 * Currently we don't support ordering by:
 *
 * - name, b/c we'd to do `COALESCE(task_def.name, task.name) - though we are likely to address that soon
 * - status, b/c it's a combination of stale & overdue that is calc'd in TS
 */
export type ScheduleTaskOrder = {
  id?: InputMaybe<Order>;
  project?: InputMaybe<Order>;
  internalUser?: InputMaybe<Order>;
  endDate?: InputMaybe<Order>;
  /**  Sorts by the ~deprecated? sort order.  */
  sortOrder?: InputMaybe<Order>;
};

export type MilestoneTasksForTemplatesInput = {
  templates: Array<Scalars['ID']['input']>;
};

export type ScheduleTaskChecklistItem = Entity & {
  __typename?: 'ScheduleTaskChecklistItem';
  id: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  completedBy?: Maybe<InternalUser>;
  isCompleted: Scalars['Boolean']['output'];
  task: ScheduleTask;
  templateChecklistItem?: Maybe<ScheduleTaskChecklistItem>;
  scheduleTaskChecklistItems: Array<ScheduleTaskChecklistItem>;
  canDelete: PotentialOperation2;
};

export type SaveScheduleTaskChecklistItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveScheduleTaskChecklistItemResult = {
  __typename?: 'SaveScheduleTaskChecklistItemResult';
  scheduleTaskChecklistItem: ScheduleTaskChecklistItem;
};

export type DeleteScheduleTaskChecklistItemInput = {
  id: Scalars['ID']['input'];
};

export type ApplyTemplateChecklistItems = {
  scheduleParentIds: Array<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<Stage>>;
};

export type ScheduleTaskDependency = {
  __typename?: 'ScheduleTaskDependency';
  type: TaskDependencyType;
  lagInDays: Scalars['Int']['output'];
  predecessor: ScheduleTask;
  successor: ScheduleTask;
  /** ID of the dependency record (not the dependency task) - only used for keeping the apollo cache up to date */
  id: Scalars['ID']['output'];
};

export type TaskDependencyInput = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<TaskDependencyType>;
  lagInDays?: InputMaybe<Scalars['Int']['input']>;
  predecessorId?: InputMaybe<Scalars['ID']['input']>;
  successorId?: InputMaybe<Scalars['ID']['input']>;
};

export type ScheduleTemplate = Named & HasSchedules & MaybeHasMarket & {
  __typename?: 'ScheduleTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: ScheduleTemplateStatus;
  statusDetail: ScheduleTemplateStatusDetail;
  stage: Stage;
  stageDetail: StageDetail;
  market?: Maybe<Market>;
  schedules: Array<Schedule>;
  /**  For a project-level schedule template, the developments that the schedule template might be used in.  */
  developments: Array<Development>;
  itemMappings: Array<ScheduleTemplateItemMapping>;
};

export type ScheduleTemplatesFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ScheduleTemplateStatus>>;
  stage?: InputMaybe<Array<Stage>>;
};

export type SaveScheduleTemplateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ScheduleTemplateStatus>;
  stage?: InputMaybe<Stage>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  developmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveScheduleTemplatesInput = {
  scheduleTemplates: Array<SaveScheduleTemplateInput>;
};

export type DuplicateScheduleTemplateInput = {
  scheduleTemplateId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  market?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveScheduleTemplatesResult = {
  __typename?: 'SaveScheduleTemplatesResult';
  scheduleTemplates: Array<ScheduleTemplate>;
  userErrors?: Maybe<Array<UserError>>;
};

export type DuplicateScheduleTemplateResult = {
  __typename?: 'DuplicateScheduleTemplateResult';
  scheduleTemplate?: Maybe<ScheduleTemplate>;
  userErrors?: Maybe<Array<UserError>>;
};

export type ApplyScheduleTemplateInput = {
  scheduleTemplateId: Scalars['ID']['input'];
  scheduleParentId: Scalars['ID']['input'];
  stage: Stage;
  replaceExisting?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ApplyScheduleTemplatesInput = {
  scheduleTemplates: Array<ApplyScheduleTemplateInput>;
};

export type ApplyScheduleTemplatesResult = {
  __typename?: 'ApplyScheduleTemplatesResult';
  /**  ScheduleParents updated by the operation  */
  scheduleParents: Array<ScheduleParent>;
  /**  Schedules updated by the operation  */
  schedules: Array<Schedule>;
};

export type ScheduleTemplateItemMapping = {
  __typename?: 'ScheduleTemplateItemMapping';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costType: CostTypeDetail;
  item: Item;
  location: Location;
  scheduleTemplate: ScheduleTemplate;
  task: Task;
};

export type SaveScheduleTemplateItemMappingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  costType?: InputMaybe<CostType>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  scheduleTemplateId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveScheduleTemplateItemMappingsInput = {
  scheduleTemplateItemMappings: Array<SaveScheduleTemplateItemMappingInput>;
};

export type SaveScheduleTemplateItemMappingsResult = {
  __typename?: 'SaveScheduleTemplateItemMappingsResult';
  scheduleTemplateItemMappings: Array<ScheduleTemplateItemMapping>;
};

export type SchedulingExclusionDate = {
  __typename?: 'SchedulingExclusionDate';
  id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  parent: SchedulingExclusionDateParent;
};

export type SchedulingExclusionDateFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveSchedulingExclusionDateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  op: IncrementalCollectionOp;
};

export type SchedulingExclusionDateParent = StandaloneProject | Region | Development | Market | Community | Subdivision | Lot | Structure | Unit;

export type ScopeChangeReason = {
  __typename?: 'ScopeChangeReason';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SaveScopeChangeReasonInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaveScopeChangeReasonResult = {
  __typename?: 'SaveScopeChangeReasonResult';
  scopeChangeReason: ScopeChangeReason;
};

export type SetupDataInput = {
  factoryScript: Scalars['String']['input'];
};

export type SiteSpecificInfo = {
  __typename?: 'SiteSpecificInfo';
  id: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SaveSiteSpecificInfoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type SaveSiteSpecificInfoResult = {
  __typename?: 'SaveSiteSpecificInfoResult';
  siteSpecificInfo: SiteSpecificInfo;
};

export type SaveStructureInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']['input']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']['input']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']['input']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']['input']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  builderId?: InputMaybe<Scalars['ID']['input']>;
  legalDescription?: InputMaybe<Scalars['String']['input']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  grossSalesPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  closingCostsForDirectMarginInCents?: InputMaybe<Scalars['Int']['input']>;
  purchaseCostInCents?: InputMaybe<Scalars['Int']['input']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  primaryProjectId?: InputMaybe<Scalars['ID']['input']>;
  suburbanAssetCategory?: InputMaybe<SuburbanAssetCategory>;
  modelHomeHardCostsInCents?: InputMaybe<Scalars['Int']['input']>;
  modelHomeSoftCostsInCents?: InputMaybe<Scalars['Int']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  lotSalesStatus?: InputMaybe<LotSalesStatus>;
  /**  Saves to the Structure's projectReadyPlanConfig.  */
  includedPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  includedOptions?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveStructureResult = {
  __typename?: 'SaveStructureResult';
  structure: Structure;
};

export type StructuresPageResult = {
  __typename?: 'StructuresPageResult';
  entities: Array<Structure>;
  pageInfo: PageInfo;
};

export type SaveSubdivisionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']['input']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']['input']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']['input']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']['input']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  builderId?: InputMaybe<Scalars['ID']['input']>;
  legalDescription?: InputMaybe<Scalars['String']['input']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  salesforceBusinessDevelopmentOpportunityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']['input']>;
  salesforceTakedownId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveSubdivisionResult = {
  __typename?: 'SaveSubdivisionResult';
  subdivision: Subdivision;
};

export type Submarket = Named & {
  __typename?: 'Submarket';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  market: Market;
};

export type SaveSubmarketInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveSubmarketResult = {
  __typename?: 'SaveSubmarketResult';
  submarket: Submarket;
};

export type CopyTakeoffLineItemsInput = {
  targetReadyPlanId: Scalars['ID']['input'];
  sourceReadyPlanId?: InputMaybe<Scalars['ID']['input']>;
  sourceItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CopyTakeoffLineItemsResult = {
  __typename?: 'CopyTakeoffLineItemsResult';
  targetReadyPlan: ReadyPlan;
  sourceReadyPlans: Array<ReadyPlan>;
  /** The sourceItems which were cloned, when sourceItemIds was specified and contained TLI IDs, otherwise [] */
  sourceItems: Array<TakeoffLineItem>;
  /** The new TLIs that were copied during the operation */
  copiedItems: Array<TakeoffLineItem>;
};

export type TliGroupTotalsInput = {
  filter?: InputMaybe<TakeoffLineItemFilter>;
  order?: InputMaybe<Array<TakeoffLineItemOrder>>;
};

export type TakeoffLineItemFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  readyPlan?: InputMaybe<Array<Scalars['ID']['input']>>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Return any TLI which includes the specified location IDs in its location path.  */
  locationInPath?: InputMaybe<Array<Scalars['ID']['input']>>;
  item?: InputMaybe<Array<Scalars['ID']['input']>>;
  unitOfMeasure?: InputMaybe<Array<Scalars['ID']['input']>>;
  costType?: InputMaybe<Array<CostType>>;
  costCode?: InputMaybe<Array<Scalars['ID']['input']>>;
  costDivision?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialVariant?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Include 'null' in the list of IDs to return items having no options assigned.
   * This means they are applicable to the plan generally, regardless of options chosen.
   * Unlike the option/specOption/elevation filters, this is applied to all assigned options regardless of type.
   */
  options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /**
   * Filter based on underlying Global Option. Useful for loading similar options across multiple
   * templates. More general than `options` filter and IGNORED if `option` is non-empty.
   */
  globalOption?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Filter based on text search using SQL LIKE.  */
  search?: InputMaybe<Scalars['String']['input']>;
  /**  Filter based on whether the item have anomalies or not. Currently only true or undefined is supported.  */
  hasAnomalies?: InputMaybe<Scalars['Boolean']['input']>;
  materialType?: InputMaybe<Array<MaterialType>>;
  globalPlanTask?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Filter to only TLIs with or without plan lines.  Implicitly sets materialType to [PLACEHOLDER] if not present.  */
  hasPlanLines?: InputMaybe<Scalars['Boolean']['input']>;
  designPackageType?: InputMaybe<Array<TakeoffLineItemDesignPackageType>>;
  isMissingPreferredBid?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedInCurrentVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /**  When true, includes TLIs that were removed in this version. Useful for highlighting changes. */
  includeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TakeoffLineItemsPage = {
  __typename?: 'TakeoffLineItemsPage';
  items: Array<TakeoffLineItem>;
  pageInfo: PageInfo;
  groupTotals: Array<TakeoffLineItemGroupTotal>;
};

export type TakeoffLineItemGroupTotal = {
  __typename?: 'TakeoffLineItemGroupTotal';
  groupId: Scalars['String']['output'];
  totalCostInCents: Scalars['Int']['output'];
  tlisInGroup: Scalars['Int']['output'];
  tliIdsInGroup: Array<Scalars['ID']['output']>;
  activeTliIdsInGroup: Array<Scalars['ID']['output']>;
  displayName: Scalars['String']['output'];
  /**  The number of TLIs with costType = MATERIAL in the group.  */
  materialsInGroup: Scalars['Int']['output'];
  /**  The number of TLIs with costType = LABOR in the group.  */
  tasksInGroup: Scalars['Int']['output'];
};

/**
 * The FE will specify at most one of the following order fields, and optionally a groupBy value (defaults to None).
 * The BE will then order first by the groupBy value, and then by the specified order field, and then by whatever other fields
 * it deems appropriate to keep related items close to each other an in a convenient/consistent order.
 */
export type TakeoffLineItemOrder = {
  field: ItivOrderField;
  direction: Order;
};

export type RegroupTliPlanLinesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  planLines: Array<Scalars['ID']['input']>;
  customPlaceholderName?: InputMaybe<Scalars['String']['input']>;
};

export type TestGroupDependenciesLineItemsInput = {
  addonOptionId: Scalars['ID']['input'];
  personalizationOptionGroupId: Scalars['ID']['input'];
};

/**  TODO: Inspect this type to ensure only desired fields are included  */
export type TakeoffLineItem = Named & HasDisplayName & HasBlueprintUrl & BaseItemLike & {
  __typename?: 'TakeoffLineItem';
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  parent: ReadyPlanLike;
  readyPlan: ReadyPlanLike;
  first: ReadyPlanAggregateVersion;
  customPlaceholderName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  totalCostInCents: Scalars['Int']['output'];
  unitCostInCents: Scalars['Int']['output'];
  isDisabledMaterialVariant: Scalars['Boolean']['output'];
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  specifications?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  costStatus: ItemTemplateItemCostStatusDetail;
  placeholder?: Maybe<TakeoffLineItem>;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  /**
   *  Only for BaseItemLike compatibility, always returns null.
   * @deprecated Only for BaseItemLike compatibility, always returns null.
   */
  bidItemTemplateItem?: Maybe<TakeoffLineItem>;
  /**
   *  Only for BaseItemLike compatibility, always returns null.
   * @deprecated Only for BaseItemLike compatibility, always returns null.
   */
  baseProduct?: Maybe<Product>;
  development?: Maybe<Development>;
  drop?: Maybe<Drop>;
  item: Item;
  slot: ItemSlot;
  location: Location;
  materialVariant?: Maybe<MaterialVariant>;
  /**  Optional b/c this being required was making FE Apollo factories fill it in, which many tests don't have mocks for.  */
  task?: Maybe<GlobalPlanTask>;
  unitOfMeasure: UnitOfMeasure;
  products: Array<TakeoffLineItem>;
  options: Array<ReadyPlanOption>;
  /** @deprecated renamed to assemblyRootItem */
  rootAssemblyItem?: Maybe<TakeoffLineItem>;
  assemblyRootItem?: Maybe<TakeoffLineItem>;
  childItems: Array<TakeoffLineItem>;
  /**  Added by Tyler for FE compatibility (PP).  */
  canEdit: PotentialOperation2;
  canEditLocation: PotentialOperation2;
  canEditOptions: PotentialOperation2;
  canEditQuantity: PotentialOperation2;
  canEditMaterial: PotentialOperation2;
  canDuplicate: PotentialOperation2;
  /**  Added by Tyler for FE compatibility (DP).  */
  canDeleteFromDesignPackage: PotentialOperation2;
  dpSignature: Scalars['String']['output'];
  /**  Added by Chris for idk.  */
  blueprintUrl: Url;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  elevationIds: Array<Scalars['ID']['output']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  specOptionIds: Array<Scalars['ID']['output']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  otherOptionIds: Array<Scalars['ID']['output']>;
  laborLine?: Maybe<TakeoffLineItem>;
  costEstimate: CostEstimate;
  isPlaceholderMaterial: Scalars['Boolean']['output'];
  isProductMaterial: Scalars['Boolean']['output'];
  changeType: Scalars['String']['output'];
  previous?: Maybe<TakeoffLineItemVersion>;
  planLines: Array<TakeoffLineItem>;
  personalizationOptionGroup?: Maybe<ReadyPlanOptionGroup>;
  personalizationPlaceholderControlledSlots: Array<TakeoffLineItem>;
  /**  For a regular placeholder, returns it's controlling IDP-based placeholder (if it's personalized). */
  personalizationShadowPlaceholder?: Maybe<TakeoffLineItem>;
  /**  For a RPO-based personalization placeholder, returns its IDP-based pair.  */
  personalizationIdpShadowPlaceholder?: Maybe<TakeoffLineItem>;
  /**  For a IDP-based personalization placeholder, returns its RPO-based pair.  */
  personalizationRpoShadowPlaceholder?: Maybe<TakeoffLineItem>;
  designPackageType?: Maybe<TakeoffLineItemDesignPackageTypeDetail>;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
  missingCombinations: Array<DesignPackageOptionCombination>;
  designNotes: Array<ReadyPlanDesignNote>;
  packageDesignNotes?: Maybe<Scalars['String']['output']>;
  targetPlan?: Maybe<PlanPackage>;
  personalizationSlotOrder?: Maybe<Scalars['Int']['output']>;
  isTaxExempt: Scalars['Boolean']['output'];
  taxableCostInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  planPackageIncomingSlots: Array<PlanPackageIncomingSlot>;
};

export type SaveTakeoffLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  customPlaceholderName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated replaced by isTaxExempt/taxableCostInCents */
  totalCostInCents?: InputMaybe<Scalars['Int']['input']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  taxableCostInCents?: InputMaybe<Scalars['Int']['input']>;
  isDisabledMaterialVariant?: InputMaybe<Scalars['Boolean']['input']>;
  tradePartnerNote?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Will be inferred from material/task */
  costType?: InputMaybe<CostType>;
  costStatus?: InputMaybe<ItemTemplateItemCostStatus>;
  placeholderId?: InputMaybe<Scalars['ID']['input']>;
  preferredBidContractLineItemId?: InputMaybe<Scalars['ID']['input']>;
  bidItemId?: InputMaybe<Scalars['ID']['input']>;
  /**  Only required for placeholders defining a new variant, otherwise inferred for tasks & construction materials.  */
  itemId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  materialVariantId?: InputMaybe<Scalars['ID']['input']>;
  readyPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Added (but not implemented) for type-parity with TLIVFilter. Use readyPlanId instead */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  /**  Allows creating new placeholders, i.e. a Fridge that is 52in wide, from the takeoff UI.  */
  placeholderMaterialAttributeValues?: InputMaybe<Array<SaveMaterialAttributeValueInput>>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']['input']>;
  /**  Added by Tyler for FE compatibility.  */
  remove?: InputMaybe<Scalars['Boolean']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   *  Added by Tyler for FE compatibility with CSV Import.
   * @deprecated Will be inferred from material/task
   */
  costTypeName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Will be inferred from material */
  itemCode?: InputMaybe<Scalars['String']['input']>;
  locationPath?: InputMaybe<Scalars['String']['input']>;
  materialVariantCode?: InputMaybe<Scalars['String']['input']>;
  optionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureName?: InputMaybe<Scalars['String']['input']>;
  targetGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetCombinations?: InputMaybe<Array<SaveTargetCombinationInput>>;
  targetPlanId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveTakeoffLineItemResult = {
  __typename?: 'SaveTakeoffLineItemResult';
  /**  The latest RPAV, which might be a new draft created by the save.  */
  version: ReadyPlanAggregateVersion;
  /**  The impacted TLIs that were just created/updated.  */
  takeoffLineItems: Array<TakeoffLineItem>;
  /**  Any TLIVs which were auto-added to the template due to the addition of a new material which requires labor.  */
  autoAddedLaborLines: Array<TakeoffLineItem>;
  /**  Any TLIVs that were removed from the template, but could not be deleted because they are used on a different version of the template.  */
  removed: Array<TakeoffLineItem>;
  /**  Any TLIVs that were deleted from the template.  */
  deleted: Array<Scalars['ID']['output']>;
  /**  Only calculated if groupTotalsInput is provided.  */
  groupTotals: Array<TakeoffLineItemGroupTotal>;
};

export type TakeoffLineItemVersion = Named & HasDisplayName & HasBlueprintUrl & BaseItemLike & {
  __typename?: 'TakeoffLineItemVersion';
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  specifications?: Maybe<Scalars['String']['output']>;
  totalCostInCents: Scalars['Int']['output'];
  unitCostInCents: Scalars['Int']['output'];
  tradePartnerNote?: Maybe<Scalars['String']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  parent: ReadyPlanLike;
  readyPlan: ReadyPlanLike;
  isDisabledMaterialVariant: Scalars['Boolean']['output'];
  placeholder?: Maybe<TakeoffLineItem>;
  customPlaceholderName?: Maybe<Scalars['String']['output']>;
  costType: CostType;
  costTypeDetail: CostTypeDetail;
  type: TakeoffLineItemTypeDetail;
  preferredBidContractLineItem?: Maybe<BidContractLineItem>;
  bidItem?: Maybe<BidItem>;
  bidItemTemplateItem?: Maybe<TakeoffLineItemVersion>;
  /**
   *  Only for BaseItemLike compatibility, always returns null.
   * @deprecated Only for BaseItemLike compatibility, always returns null.
   */
  baseProduct?: Maybe<Product>;
  item: Item;
  slot: ItemSlot;
  location: Location;
  unitOfMeasure: UnitOfMeasure;
  dpSignature: Scalars['String']['output'];
  canDeleteFromDesignPackage: PotentialOperation2;
  options: Array<ReadyPlanOption>;
  costStatus?: Maybe<ItemTemplateItemCostStatusDetail>;
  development?: Maybe<Development>;
  drop?: Maybe<Drop>;
  task?: Maybe<GlobalPlanTask>;
  materialVariant?: Maybe<MaterialVariant>;
  final?: Maybe<ReadyPlanAggregateVersion>;
  first: ReadyPlanAggregateVersion;
  identity: TakeoffLineItem;
  active: Scalars['Boolean']['output'];
  blueprintUrl: Url;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  elevationIds: Array<Scalars['ID']['output']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  specOptionIds: Array<Scalars['ID']['output']>;
  /**
   *  Helper for the FE multi-select dropdown
   * @deprecated Use options instead
   */
  otherOptionIds: Array<Scalars['ID']['output']>;
  laborLine?: Maybe<TakeoffLineItem>;
  costEstimate: CostEstimate;
  changeType: Scalars['String']['output'];
  planLines: Array<TakeoffLineItem>;
  targetGroups: Array<ReadyPlanOptionGroup>;
  targetCombinations: Array<DesignPackageOptionCombination>;
  missingCombinations: Array<DesignPackageOptionCombination>;
  packageDesignNotes?: Maybe<Scalars['String']['output']>;
  isTaxExempt: Scalars['Boolean']['output'];
  taxableCostInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
};

export enum TaskSchedulingStatus {
  Stale = 'STALE',
  OverBaseline = 'OVER_BASELINE',
  OnSchedule = 'ON_SCHEDULE'
}

export type DeleteTaskInput = {
  id: Scalars['ID']['input'];
};

export type TaskPage = {
  __typename?: 'TaskPage';
  tasks: Array<Task>;
  pageInfo: PageInfo;
};

export type TaskFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  internalUser?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**  Only tasks assigned to the currently-logged-in user.  */
  myTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *  Only return tasks whose activity / stage / project are all active.
   * @deprecated Legacy attribute, will only return ScheduleTasks.
   */
  effectivelyActive?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<TaskStatus>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  isMilestone?: InputMaybe<Scalars['Boolean']['input']>;
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<IntervalFilter>;
  interval2?: InputMaybe<IntervalFilter2>;
  slackInDays?: InputMaybe<IntFilter>;
  /**  Todo: Rename this to marketId.  */
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Use scheduleParent instead */
  projectId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  stage?: InputMaybe<Array<Stage>>;
  tradePartner?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  scheduleSubPhase?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  deadlineType?: InputMaybe<Array<TaskDeadlineType>>;
  schedule?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduleParent?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  schedulePhase?: InputMaybe<Array<Scalars['ID']['input']>>;
  isCriticalPath?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  isGlobalMilestoneTask?: InputMaybe<Scalars['Boolean']['input']>;
  startDateRange?: InputMaybe<DateFilter2>;
  endDateRange?: InputMaybe<DateFilter2>;
  /** @deprecated Use tradePartnerStatus instead */
  tradePartnerIsScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Filter for tasks through the `parent: Project -> Development` relationship (vs `parent: Development`)  */
  projectTasksForDevelopment?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  scheduleIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  hasChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  hasScheduleFlags?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Legacy attribute, will only return ScheduleTasks. */
  systemTask?: InputMaybe<Array<SystemTask>>;
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  tradePartnerStatus?: InputMaybe<Array<TradePartnerTaskStatus>>;
};

/**
 * Supported ordering for tasks.
 *
 * Currently we don't support ordering by:
 *
 * - name, b/c we'd to do `COALESCE(task_def.name, task.name)
 * - status, b/c it's a combination of stale & overdue that is calc'd in TS
 */
export type TaskOrder = {
  id?: InputMaybe<Order>;
  project?: InputMaybe<Order>;
  internalUser?: InputMaybe<Order>;
  endDate?: InputMaybe<Order>;
  /**  Sorts by the ~deprecated? sort order.  */
  sortOrder?: InputMaybe<Order>;
};

export type ScheduleLike = Schedule | PlanSchedule;

export type TaskDependency = {
  __typename?: 'TaskDependency';
  type: TaskDependencyType;
  typeDetail: TaskDependencyTypeDetail;
  lagInDays: Scalars['Int']['output'];
  predecessor: Task;
  successor: Task;
};

export type TaskSnapshot = {
  __typename?: 'TaskSnapshot';
  id: Scalars['ID']['output'];
  range: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
  endDate: Scalars['Date']['output'];
  durationInDays: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  task: Task;
};

export type TaskWorkDay = Entity & {
  __typename?: 'TaskWorkDay';
  id: Scalars['ID']['output'];
  workDay: Scalars['Date']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  task: Task;
};

export type SaveTaskWorkDayInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  workDay?: InputMaybe<Scalars['Date']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveTaskWorkDayResult = {
  __typename?: 'SaveTaskWorkDayResult';
  taskWorkDay: TaskWorkDay;
};

export type TaskWorkDayIncrementalInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  workDay?: InputMaybe<Scalars['Date']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveToDosInput = {
  toDos: Array<SaveToDoInput>;
};

export type SaveToDosResult = {
  __typename?: 'SaveToDosResult';
  toDos: Array<ToDo>;
};

export type SaveToDoAttachmentInput = {
  asset: AssetInput;
  /** `create` to add, `delete` to remove */
  op: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveTodoChecklistItem = {
  id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  op: IncrementalCollectionOp;
};

export type SaveToDoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ToDoStatus>;
  type?: InputMaybe<ToDoType>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  moveAfterId?: InputMaybe<Scalars['ID']['input']>;
  moveBeforeId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use assigneeIds instead */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<SaveToDoAttachmentInput>>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  checklistItems?: InputMaybe<Array<SaveTodoChecklistItem>>;
};

export type ToDoFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ToDoStatus>>;
  type?: InputMaybe<Array<ToDoType>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  cohort?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignee?: InputMaybe<Array<Scalars['ID']['input']>>;
  market?: InputMaybe<Array<Scalars['ID']['input']>>;
  dueDate?: InputMaybe<DateFilter2>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  watching?: InputMaybe<Scalars['Boolean']['input']>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteToDoInput = {
  id: Scalars['ID']['input'];
};

export type ToDoParent = StandaloneProject | Region | Cohort | Development | Market | Community | Subdivision | Lot | Structure | Unit;

export type ToDoChecklistProgress = {
  __typename?: 'ToDoChecklistProgress';
  total: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
};

export type ToDoChecklistItem = {
  __typename?: 'ToDoChecklistItem';
  id: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  toDo: ToDo;
  isComplete: Scalars['Boolean']['output'];
};

export type SaveToDoChecklistItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  toDoId?: InputMaybe<Scalars['ID']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveToDoChecklistItemResult = {
  __typename?: 'SaveToDoChecklistItemResult';
  toDoChecklistItem: ToDoChecklistItem;
};

export type TrackedJobFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<TrackedJobStatus>>;
};

export type TrackedJob = {
  __typename?: 'TrackedJob';
  id: Scalars['ID']['output'];
  pollIntervalInMs: Scalars['Int']['output'];
  progressCurrent?: Maybe<Scalars['Int']['output']>;
  progressTotal?: Maybe<Scalars['Int']['output']>;
  progressMessage?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: TrackedJobStatusDetail;
  user: User;
  result?: Maybe<TrackedJobResult>;
};

export type TrackedJobResult = Asset | BillOcr;

export type TradeCategory = Named & HasDisplayName & {
  __typename?: 'TradeCategory';
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**  The number + name combined.  */
  displayName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  items: Array<Item>;
  tradePartners: Array<TradePartner>;
  developmentCommitments: Array<DevelopmentCommitment>;
  leadTimes: Array<TradeCategoryLeadTime>;
};

export type SaveTradeCategoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type SaveTradeCategoryResult = {
  __typename?: 'SaveTradeCategoryResult';
  tradeCategory: TradeCategory;
};

export type TradeCategoryLeadTimeLike = {
  leadTimeInDays: Scalars['Int']['output'];
  market: Market;
  tradeCategory: TradeCategory;
  leadTimeFrequency: TimeFrequencyDetail;
};

export type TradeCategoryLeadTimeDefault = TradeCategoryLeadTimeLike & {
  __typename?: 'TradeCategoryLeadTimeDefault';
  leadTimeInDays: Scalars['Int']['output'];
  market: Market;
  tradeCategory: TradeCategory;
  leadTimeFrequency: TimeFrequencyDetail;
};

export type TradeCategoryLeadTime = TradeCategoryLeadTimeLike & {
  __typename?: 'TradeCategoryLeadTime';
  id: Scalars['ID']['output'];
  leadTimeInDays: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  leadTimeFrequency: TimeFrequencyDetail;
  market: Market;
  tradeCategory: TradeCategory;
};

export type SaveTradeCategoryLeadTimesInput = {
  tradeCategoryLeadTimes: Array<SaveTradeCategoryLeadTimeInput>;
};

export type SaveTradeCategoryLeadTimeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  leadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  leadTimeFrequency?: InputMaybe<TimeFrequency>;
  marketId: Scalars['ID']['input'];
  tradeCategoryId: Scalars['ID']['input'];
};

export type SaveTradeCategoryLeadTimesResult = {
  __typename?: 'SaveTradeCategoryLeadTimesResult';
  tradeCategoryLeadTimes: Array<TradeCategoryLeadTime>;
};

export type TradeCategoryLeadTimeFilter = {
  market: Scalars['ID']['input'];
  tradeCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveTradePartnerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  quickbooksId?: InputMaybe<Scalars['String']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contacts?: InputMaybe<Array<SaveTradePartnerContactChildInput>>;
  agreements?: InputMaybe<Array<SaveTradePartnerAgreementChildInput>>;
  doesMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  doesLabor?: InputMaybe<Scalars['Boolean']['input']>;
  isSweetheart?: InputMaybe<Scalars['Boolean']['input']>;
  sourceNote?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  doNotUse?: InputMaybe<Scalars['Boolean']['input']>;
  intacctId?: InputMaybe<Scalars['String']['input']>;
  costCodeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradeCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  homeboundAccountNumber?: InputMaybe<Scalars['String']['input']>;
  onboardingStatus?: InputMaybe<TradePartnerOnboardingStatus>;
  paymentTermId?: InputMaybe<Scalars['ID']['input']>;
  enableClickToPay?: InputMaybe<Scalars['Boolean']['input']>;
  isLienWaiverReceiver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveTradePartnersInput = {
  tradePartners: Array<SaveTradePartnerInput>;
};

export type SaveTradePartnerResult = {
  __typename?: 'SaveTradePartnerResult';
  tradePartner: TradePartner;
};

export type SaveTradePartnersResult = {
  __typename?: 'SaveTradePartnersResult';
  tradePartners: Array<TradePartner>;
};

export type DeleteTradePartnerInput = {
  id: Scalars['ID']['input'];
};

export type TradePartnerFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  markets?: InputMaybe<Array<Scalars['ID']['input']>>;
  developmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  cohortIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  doNotUse?: InputMaybe<Scalars['Boolean']['input']>;
  isSweetheart?: InputMaybe<Scalars['Boolean']['input']>;
  averageScore?: InputMaybe<IntFilter>;
  costCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradeCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  workingOn?: InputMaybe<Array<Scalars['ID']['input']>>;
  onboardingStatus?: InputMaybe<Array<InputMaybe<TradePartnerOnboardingStatus>>>;
  canLoginToPortal?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SaveTradePartnerContactChildInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mailingListIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  address?: InputMaybe<AddressInput>;
};

export type SaveTradePartnerAgreementChildInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  costDivisionId?: InputMaybe<Scalars['ID']['input']>;
  isNationalAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TradePartnersPage = {
  __typename?: 'TradePartnersPage';
  entities: Array<TradePartner>;
  pageInfo: PageInfo;
};

export type TradePartnerAgreement = {
  __typename?: 'TradePartnerAgreement';
  id: Scalars['ID']['output'];
  isNationalAgreement: Scalars['Boolean']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  costDivision: CostDivision;
  tradePartner: TradePartner;
};

export type SaveTradePartnerAgreementInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isNationalAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  costDivisionId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveTradePartnerAgreementResult = {
  __typename?: 'SaveTradePartnerAgreementResult';
  tradePartnerAgreement: TradePartnerAgreement;
};

export type DeleteTradePartnerAgreementInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTradePartnerAgreementResult = {
  __typename?: 'DeleteTradePartnerAgreementResult';
  tradePartner: TradePartner;
};

export type SaveTradePartnerAvailabilityRequestInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  emails?: InputMaybe<Array<SaveTradePartnerEmailInput>>;
  internalUserId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradePartnerConfirmationDate?: InputMaybe<Scalars['Date']['input']>;
  rescheduleDates?: InputMaybe<Array<Scalars['Date']['input']>>;
  status?: InputMaybe<TradePartnerAvailabilityRequestStatus>;
  rescheduleReasonNote?: InputMaybe<Scalars['String']['input']>;
};

export type SaveTradePartnerAvailabilityRequestResult = {
  __typename?: 'SaveTradePartnerAvailabilityRequestResult';
  tradePartnerAvailabilityRequest: TradePartnerAvailabilityRequest;
};

export type SaveTradePartnerAvailabilityRequestsResult = {
  __typename?: 'SaveTradePartnerAvailabilityRequestsResult';
  tradePartnerAvailabilityRequests: Array<TradePartnerAvailabilityRequest>;
};

export type SaveTradePartnerEmailInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type UpdateTradePartnerAvailabilityRequestStatusInput = {
  ids: Array<Scalars['ID']['input']>;
  status: TradePartnerAvailabilityRequestStatus;
};

export type TradePartnerAvailabilityRequestEmail = {
  __typename?: 'TradePartnerAvailabilityRequestEmail';
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
  message: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  tradePartnerAvailabilityRequest: TradePartnerAvailabilityRequest;
  attachments: Array<Attachment>;
};

export type TradePartnerAvailabilityRequestTextMessage = {
  __typename?: 'TradePartnerAvailabilityRequestTextMessage';
  id: Scalars['ID']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  tradePartnerAvailabilityRequest: TradePartnerAvailabilityRequest;
};

export type TradePartnerContact = Entity & Named & {
  __typename?: 'TradePartnerContact';
  id: Scalars['ID']['output'];
  /** @deprecated Use tradePartnerMarketContacts instead */
  isPrimary: Scalars['Boolean']['output'];
  /** @deprecated Use tradePartnerMarketContacts instead */
  isBillingSignatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  officePhone?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  canDelete: PotentialOperation2;
  canDeactivate: PotentialOperation2;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  tradePartner: TradePartner;
  title?: Maybe<Scalars['String']['output']>;
  maybeBillingSignatory: Scalars['Boolean']['output'];
  address?: Maybe<Address>;
  markets: Array<Market>;
  /** @deprecated Use mailingLists */
  tradePartnerMailingLists: Array<TradePartnerMailingList>;
  mailingLists: Array<TradePartnerMailingList>;
  tradePartnerUser?: Maybe<TradePartnerUser>;
  tradePartnerMarketContacts: Array<TradePartnerMarketContact>;
  canLoginToPortal: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type SaveTradePartnerContactInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  maybeBillingSignatory?: InputMaybe<Scalars['Boolean']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mailingListIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradePartnerUserId?: InputMaybe<Scalars['ID']['input']>;
  canLoginToPortal?: InputMaybe<Scalars['Boolean']['input']>;
  reactivate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveTradePartnerContactResult = {
  __typename?: 'SaveTradePartnerContactResult';
  tradePartnerContact: TradePartnerContact;
};

export type DeleteTradePartnerContactInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTradePartnerContactResult = {
  __typename?: 'DeleteTradePartnerContactResult';
  tradePartner: TradePartner;
  tradePartnerContact?: Maybe<TradePartnerContact>;
};

export type MarketContactWithRoles = {
  __typename?: 'MarketContactWithRoles';
  contact: TradePartnerContact;
  roles: Array<TradePartnerMarketRole>;
};

export type TradePartnerMailingList = Named & {
  __typename?: 'TradePartnerMailingList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  tradePartnerContacts: Array<TradePartnerContact>;
};

export type TradePartnerMarketContact = {
  __typename?: 'TradePartnerMarketContact';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  role: TradePartnerMarketRoleDetail;
  market: Market;
  tradePartner: TradePartner;
  contact: TradePartnerContact;
};

export type SaveTradePartnerMarketContactInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  role: TradePartnerMarketRole;
  marketId: Scalars['ID']['input'];
  tradePartnerId: Scalars['ID']['input'];
  contactId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveTradePartnerMarketContactResult = {
  __typename?: 'SaveTradePartnerMarketContactResult';
  tradePartnerMarketContact: TradePartnerMarketContact;
};

export type DeleteTradePartnerMarketContactInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTradePartnerMarketContactResult = {
  __typename?: 'DeleteTradePartnerMarketContactResult';
  tradePartner: TradePartner;
};

export type TradePartnerRequirement = {
  __typename?: 'TradePartnerRequirement';
  id: Scalars['ID']['output'];
  signedDate?: Maybe<Scalars['Date']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  coverageAmountInCents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  type: TradePartnerRequirementTypeDetail;
  tradePartner: TradePartner;
  status: TradePartnerRequirementStatusDetail;
  internalNote?: Maybe<Scalars['String']['output']>;
  attachments: Array<Attachment>;
};

export type SaveTradePartnerRequirementInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  signedDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  coverageAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TradePartnerRequirementType>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TradePartnerRequirementStatus>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
};

export type SaveTradePartnerRequirementResult = {
  __typename?: 'SaveTradePartnerRequirementResult';
  tradePartnerRequirement: TradePartnerRequirement;
};

export type TradePartnerRequirementFilter = {
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type TradePartnerReview = {
  __typename?: 'TradePartnerReview';
  id: Scalars['ID']['output'];
  recommended?: Maybe<Scalars['Boolean']['output']>;
  score: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  internalUser: InternalUser;
  tradePartner: TradePartner;
  project: Project;
  internalNote?: Maybe<Scalars['String']['output']>;
};

export type SaveTradePartnerReviewInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  internalUserId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
};

export type SaveTradePartnerReviewResult = {
  __typename?: 'SaveTradePartnerReviewResult';
  tradePartnerReview: TradePartnerReview;
};

export type TradePartnerUser = Entity & Named & {
  __typename?: 'TradePartnerUser';
  id: Scalars['ID']['output'];
  user: User;
  tradePartner: TradePartner;
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  commentStreams: Array<CommentStream>;
  tradePartnerContact?: Maybe<TradePartnerContact>;
  approvers: Array<Approver>;
  /** @deprecated renamed to lastActiveAt */
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SaveUnitInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAddress?: InputMaybe<AddressInput>;
  /**  Only used for creating the Project.  */
  client?: InputMaybe<ClientInput>;
  /**  Add's a new coverImage to a project.  */
  coverImage?: InputMaybe<AssetInput>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
  /**  Only used for creating the Project.  */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  planRoomLink?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  projectStatusChange?: InputMaybe<ProjectStatusChangeInput>;
  isDisaster?: InputMaybe<Scalars['Boolean']['input']>;
  intakeStyleNotes?: InputMaybe<Scalars['String']['input']>;
  lotType?: InputMaybe<LotType>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  projectRoles?: InputMaybe<Array<UpdateProjectRoleInput>>;
  salesforcePropertyId?: InputMaybe<Scalars['String']['input']>;
  scopeMode?: InputMaybe<ScopeMode>;
  lotPartitionId?: InputMaybe<Scalars['String']['input']>;
  warrantyStartDate?: InputMaybe<Scalars['Date']['input']>;
  checkoutCustomerConfigId?: InputMaybe<Scalars['String']['input']>;
  directCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  indirectCostMarkupOverrideBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerOwnerEntityId?: InputMaybe<Scalars['ID']['input']>;
  builderId?: InputMaybe<Scalars['ID']['input']>;
  legalDescription?: InputMaybe<Scalars['String']['input']>;
  salesTaxOverrideInBasisPoints?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentNetDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveUnitResult = {
  __typename?: 'SaveUnitResult';
  unit: Unit;
};

export type SaveUnitsOfMeasureInput = {
  unitsOfMeasure: Array<UnitOfMeasureInput>;
};

export type UnitOfMeasureInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /**  Can only be set when creating the unit of measure  */
  useQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  sageName?: InputMaybe<Scalars['String']['input']>;
  shouldMultiplySelectionFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveUnitsOfMeasureResult = {
  __typename?: 'SaveUnitsOfMeasureResult';
  unitsOfMeasure: Array<UnitOfMeasure>;
};

export type DeleteUnitOfMeasureInput = {
  id: Scalars['ID']['input'];
};

export type UnitOfMeasure = Named & {
  __typename?: 'UnitOfMeasure';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**  Indicates that this unit of measure is independent of quantity. For example: Lump Sum/Allowance  */
  useQuantity: Scalars['Boolean']['output'];
  /**  Sage analogue of our units  */
  sageName?: Maybe<Scalars['String']['output']>;
  abbreviation: Scalars['String']['output'];
  /**  Alias for abbreviation  */
  shortName: Scalars['String']['output'];
  shouldMultiplySelectionFee: Scalars['Boolean']['output'];
};

export type User = Named & {
  __typename?: 'User';
  /**
   * Either the InternalUser ID, the Homeowner ID, or the underlying user id (for trade/system/anonymous users).
   *
   * For PMs/engs that have a User w/both an InternalUser and a Homeowner, the Homeowner ID takes
   * precedence (for backwards compatibility).
   *
   * This exists for historical reasons from long ago where user types were entirely separated
   */
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  /** @deprecated replaced with just type */
  userType: UserType;
  name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  /** @deprecated renamed to just avatar for consistency with internal user */
  avatarUrl: Scalars['String']['output'];
  avatar: Scalars['String']['output'];
  /** only present when user type is internal */
  internalUser?: Maybe<InternalUser>;
  type: UserType;
  typeDetail: UserTypeDetail;
  isActive: Scalars['Boolean']['output'];
  /** @deprecated replaced by tradePartnerUsers */
  tradePartnerUser?: Maybe<TradePartnerUser>;
  tradePartnerUsers: Array<TradePartnerUser>;
  zendeskJwt: Scalars['String']['output'];
  userCommunicationPreference?: Maybe<UserCommunicationPreference>;
  isBeingImpersonated: Scalars['Boolean']['output'];
  /** True for all internal users, otherwise pulls down from homeowner */
  hasCheckoutAccess: Scalars['Boolean']['output'];
  pushNotificationTokens: Array<PushNotificationToken>;
};

export type SaveUserInput = {
  internalUserId?: InputMaybe<Scalars['ID']['input']>;
  userType?: InputMaybe<UserType>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserType>;
  gsuiteEmailAlias?: InputMaybe<Scalars['String']['input']>;
};

export type SaveUserResult = {
  __typename?: 'SaveUserResult';
  userErrors: Array<UserError>;
};

export type DeactivateUserInput = {
  email: Scalars['String']['input'];
};

export type DeactivateUserResult = {
  __typename?: 'DeactivateUserResult';
  userErrors: Array<UserError>;
};

export type ActivateUserInput = {
  email: Scalars['String']['input'];
};

export type ActivateUserResult = {
  __typename?: 'ActivateUserResult';
  userErrors: Array<UserError>;
};

export type DeactivateUsersInput = {
  id: Array<Scalars['ID']['input']>;
};

export type DeactivateUsersResult = {
  __typename?: 'DeactivateUsersResult';
  users: Array<User>;
};

export type ActivateUsersInput = {
  id: Array<Scalars['ID']['input']>;
};

export type ActivateUsersResult = {
  __typename?: 'ActivateUsersResult';
  users: Array<User>;
};

export type UserCommunicationPreference = {
  __typename?: 'UserCommunicationPreference';
  id: Scalars['ID']['output'];
  user: User;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  tpAvailabilityRequestPreference?: Maybe<Array<CommunicationChannel>>;
  commentPreference?: Maybe<Array<CommunicationChannel>>;
};

export type SaveUserCommunicationPreferenceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
  tpAvailabilityRequestPreference?: InputMaybe<Array<CommunicationChannel>>;
  commentPreference?: InputMaybe<Array<CommunicationChannel>>;
};

export type SaveUserCommunicationPreferenceResult = {
  __typename?: 'SaveUserCommunicationPreferenceResult';
  userCommunicationPreference: UserCommunicationPreference;
};

export type UserEventParent = Approval | Bill | ChangeEvent | Commitment | CommitmentChangeOrder | Document | Estimate | HomeownerContractChangeOrder | Invoice | ItemTemplate | JobLog | JobLogImage | JobLogNote | StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | ProjectItem | ProjectLotDetail | ProjectReadyPlanConfig | ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanOption | ToDo | ChangeRequestToDo | PunchlistItemTodo | Task | ScheduleTask | PlanTask | WarrantyTicket;

export type UserEvent = {
  __typename?: 'UserEvent';
  id: Scalars['ID']['output'];
  parent: UserEventParent;
  parentTypeName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdFor?: Maybe<User>;
  type: UserEventType;
  typeDetail: UserEventTypeDetail;
  development?: Maybe<Development>;
  cohort?: Maybe<Cohort>;
  project?: Maybe<Project>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  comment?: Maybe<Comment>;
  payload?: Maybe<Scalars['JSONObject']['output']>;
  attachment?: Maybe<Attachment>;
};

export type UserEventParentType = {
  __typename?: 'UserEventParentType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserEventFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateFilter2>;
  development?: InputMaybe<Array<Scalars['ID']['input']>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  cohort?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<UserEventType>>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdFor?: InputMaybe<Array<Scalars['ID']['input']>>;
  relevantTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentType?: InputMaybe<Array<Scalars['ID']['input']>>;
  parent?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserEventOrder = {
  createdAt?: InputMaybe<Order>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  featureFlagTargets: Array<FeatureFlagTarget>;
  users: Array<User>;
};

export type SaveUserGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveUserGroupResult = {
  __typename?: 'SaveUserGroupResult';
  userGroup: UserGroup;
};

export type UserGroupFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaveWarrantyTicketInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<WarrantyTicketType>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  availabilities?: InputMaybe<Array<SaveWarrantyTicketAvailabilityInput>>;
  items?: InputMaybe<Array<SaveWarrantyTicketItemInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WarrantyTicketFilter = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  itemStatuses?: InputMaybe<Array<WarrantyTicketItemStatus>>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemCreatedDateRange?: InputMaybe<DateFilter2>;
  statuses?: InputMaybe<Array<WarrantyTicketStatus>>;
  projectLotType?: InputMaybe<Array<LotType>>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteWarrantyTicketInput = {
  id: Scalars['ID']['input'];
};

export type SaveWarrantyTicketResult = {
  __typename?: 'SaveWarrantyTicketResult';
  warrantyTicket: WarrantyTicket;
};

export type WarrantyTicketsPage = {
  __typename?: 'WarrantyTicketsPage';
  entities: Array<WarrantyTicket>;
  pageInfo: PageInfo;
};

export type WarrantyTicketAvailability = {
  __typename?: 'WarrantyTicketAvailability';
  id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  dayOfWeek: DayOfWeekDetail;
  timeOfDay: TimeOfDayDetail;
  warrantyTicket: WarrantyTicket;
};

export type SaveWarrantyTicketAvailabilityInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  timeOfDay?: InputMaybe<TimeOfDay>;
  warrantyTicket?: InputMaybe<Scalars['ID']['input']>;
};

export type WarrantyTicketItem = {
  __typename?: 'WarrantyTicketItem';
  id: Scalars['ID']['output'];
  product?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  status: WarrantyTicketItemStatusDetail;
  warrantyTicket: WarrantyTicket;
  attachments: Array<Attachment>;
  type: WarrantyTicketItemTypeDetail;
  homeownerVisible: Scalars['Boolean']['output'];
  statusUpdatedAt: Scalars['DateTime']['output'];
};

export type SaveWarrantyTicketItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WarrantyTicketItemStatus>;
  warrantyTicketId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<WarrantyTicketItemType>;
  attachments?: InputMaybe<Array<SaveAttachmentInput>>;
  homeownerVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveWarrantyTicketItemResult = {
  __typename?: 'SaveWarrantyTicketItemResult';
  warrantyTicketItem: WarrantyTicketItem;
};

export type DeleteWarrantyTicketItemInput = {
  id: Scalars['ID']['input'];
};

export type SaveWarrantyTicketItemsInput = {
  warrantyTicketItems: Array<SaveWarrantyTicketItemInput>;
};

export type SaveWarrantyTicketItemsResult = {
  __typename?: 'SaveWarrantyTicketItemsResult';
  warrantyTicketItems: Array<WarrantyTicketItem>;
};

export type WorkAuthorization = {
  __typename?: 'WorkAuthorization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  projectStage: ProjectStage;
  documents: Array<Document>;
  projectItems: Array<ProjectItem>;
};

export type SaveWorkAuthorizationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectStageId?: InputMaybe<Scalars['ID']['input']>;
  projectItems?: InputMaybe<Array<Scalars['ID']['input']>>;
  documents?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveWorkAuthorizationResult = {
  __typename?: 'SaveWorkAuthorizationResult';
  workAuthorization: WorkAuthorization;
};

export type WorkAuthorizationFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  stage?: InputMaybe<Array<Stage>>;
};

export const possibleTypes = {
  CanCollaborate: [
    "ScheduleTask",
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "Product",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
  ],
  Commentable: [
    "ScheduleTask",
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "Product",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
  ],
  Referencable: [
    "ScheduleTask",
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "Product",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
  ],
  Followable: [
    "ScheduleTask",
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "Product",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
  ],
  Entity: [
    "ScheduleTask",
    "Asset",
    "TradePartner",
    "Bill",
    "PlanTask",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "Commitment",
    "Document",
    "JobLogNote",
    "PunchlistItemTodo",
    "Comment",
    "CommitmentDraw",
    "FeatureFlag",
    "JobLog",
    "JobLogImage",
    "Location",
    "MobileSyncUpdate",
    "ScheduleFlag",
    "ScheduleFlagReason",
    "ScheduleTaskChecklistItem",
    "TaskWorkDay",
    "TradePartnerContact",
    "TradePartnerUser",
  ],
  HasBlueprintUrl: [
    "ScheduleTask",
    "Approval",
    "BidContract",
    "BidContractRevision",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "BusinessFunction",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "Product",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
    "CommitmentChangeOrder",
    "DesignPackage",
    "Development",
    "ItemTemplateItem",
    "MaterialVariant",
    "ProductOffering",
    "ProjectReadyPlanConfig",
    "ProjectSiteCondition",
    "ReadyPlanOption",
    "TakeoffLineItem",
    "TakeoffLineItemVersion",
  ],
  ScheduleEntity: ["ScheduleTask", "SchedulePhase", "ScheduleSubPhase", "Schedule"],
  Named: [
    "ScheduleTask",
    "Approval",
    "BidContract",
    "BidContractLineItem",
    "BidItem",
    "BidPackage",
    "BidPackageRequest",
    "TradePartner",
    "Bill",
    "BusinessFunction",
    "ChangeEvent",
    "ChangeEventLineItem",
    "ChangeEventReason",
    "ChangeEventTemplateConfig",
    "ChangeRequest",
    "ChangeRequestAsset",
    "ChangeRequestToDo",
    "Client",
    "Cohort",
    "SchedulePhase",
    "ScheduleSubPhase",
    "Task",
    "PlanTask",
    "ToDo",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "DevelopmentCommitment",
    "Commitment",
    "Document",
    "Product",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "TradePartnerAvailabilityRequest",
    "PunchlistItemTodo",
    "WarrantyTicket",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "ReadyPlan",
    "PlanPackage",
    "GlobalOption",
    "ProjectCostCode",
    "CommitmentChangeOrder",
    "CostCode",
    "CostDivision",
    "Customer",
    "CustomerOwnerEntity",
    "DesignPackage",
    "Development",
    "GlobalOptionTag",
    "GlobalOptionType",
    "GlobalPlanConstraintItem",
    "GlobalPlanMilestone",
    "GlobalPlanTask",
    "GlobalTask",
    "HomeownerContractDraw",
    "HomeownerSelectionOption",
    "HomeownerSelectionProductOption",
    "InternalUser",
    "InvoiceScheduleTemplate",
    "Item",
    "ItemSlot",
    "ItemTemplate",
    "ItemTemplateItem",
    "Location",
    "MaterialVariantTag",
    "PandaDoc",
    "PandaDocRecipient",
    "PlanMilestone",
    "ProductOffering",
    "ProjectStageTemplateConfig",
    "ProjectStatusChangeReason",
    "ReadyPlanAggregateVersion",
    "ReadyPlanLocation",
    "ReadyPlanOption",
    "ReadyPlanOptionProgramDataModification",
    "Schedule",
    "ScheduleTemplate",
    "Submarket",
    "TakeoffLineItem",
    "TakeoffLineItemVersion",
    "TradeCategory",
    "TradePartnerContact",
    "TradePartnerMailingList",
    "TradePartnerUser",
    "UnitOfMeasure",
    "User",
  ],
  MaybeHasInterval: ["ScheduleTask", "SchedulePhase", "ScheduleSubPhase", "Task", "ProjectStage", "Schedule"],
  MaybeHasBaselineInterval: ["ScheduleTask", "SchedulePhase", "ScheduleSubPhase", "Schedule"],
  ApprovalSource: ["BidContractRevision", "ItemTemplate", "ReadyPlanAggregateVersion"],
  ApprovalSubject: ["Bill", "ChangeEvent", "ChangeRequest", "Invoice"],
  ApproverSource: ["DevelopmentTeamMember", "ProjectCollaborator", "ProjectTeamMember", "TradePartnerMarketContact"],
  ApproverSubjectData: ["ChangeRequestApproverSubjectData"],
  ApproverUser: ["Client", "InternalUser", "TradePartnerUser"],
  AttachmentParent: [
    "ChangeRequest",
    "Comment",
    "GlobalOption",
    "Product",
    "ProjectSiteCondition",
    "ScheduleFlag",
    "ToDo",
    "TradePartnerAvailabilityRequestEmail",
    "TradePartnerRequirement",
    "WarrantyTicket",
    "WarrantyTicketItem",
  ],
  HasPandaDoc: ["BidContractRevision", "DevelopmentCommitment", "Commitment", "CommitmentChangeOrder"],
  HasDisplayName: [
    "BidItem",
    "ChangeEventLineItem",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Commitment",
    "Document",
    "ItemTemplateItemVersion",
    "ReadyPlan",
    "PlanPackage",
    "CommitmentChangeOrder",
    "CostCode",
    "CostDivision",
    "DesignPackage",
    "Item",
    "ItemTemplate",
    "ItemTemplateItem",
    "ProductOffering",
    "ReadyPlanAggregateVersion",
    "ReadyPlanOption",
    "TakeoffLineItem",
    "TakeoffLineItemVersion",
    "TradeCategory",
  ],
  MaybeHasProject: [
    "Bill",
    "ChangeEvent",
    "Task",
    "Invoice",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "Estimate",
    "Commitment",
    "HomeownerContract",
    "ProjectStage",
    "ProjectCollaborator",
    "ProjectUpdate",
  ],
  ErpAccountBillLineItemErpSource: ["CommitmentDraw", "CommitmentLineItem", "ProjectItem", "CostCode", "Commitment"],
  ChangeEventCreatedBy: ["Bill", "Expense"],
  ProjectStageTemplateConfigLike: ["ChangeEventTemplateConfig", "ProjectStageTemplateConfig"],
  ChangeRequestScopeTarget: [
    "StandaloneProject",
    "Region",
    "Development",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  HasCheckoutUrl: ["CheckoutConfig"],
  ReadyPlanConfigLike: ["CheckoutConfig", "ProductOfferingConfig", "ProjectReadyPlanConfig"],
  Project: ["StandaloneProject", "Region", "Market", "Community", "Subdivision", "Lot", "Structure", "Unit"],
  HasSchedules: [
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "Development",
    "ScheduleTemplate",
  ],
  HasHopUrl: ["StandaloneProject", "Region", "Market", "Community", "Subdivision", "Lot", "Structure", "Unit"],
  MaybeHasPropcoUrl: ["StandaloneProject", "Structure"],
  ProjectItemLike: ["ProjectItem", "ProtoProjectItem"],
  CommitmentLike: ["Commitment", "CommitmentChangeOrder"],
  BaseItemLike: ["ItemTemplateItemVersion", "ItemTemplateItem", "TakeoffLineItem", "TakeoffLineItemVersion"],
  HomeownerContractLike: ["HomeownerContract", "HomeownerContractChangeOrder"],
  ReadyPlanLike: ["ReadyPlan", "PlanPackage", "DesignPackage", "ProductOffering"],
  BaseItemParent: ["ReadyPlan", "PlanPackage", "DesignPackage", "ItemTemplate", "ProductOffering"],
  CollaborationParent: [
    "ScheduleSubPhase",
    "Approval",
    "BidContract",
    "BidItem",
    "BidPackageRequest",
    "Bill",
    "ChangeEvent",
    "ChangeRequest",
    "ChangeRequestToDo",
    "Commitment",
    "DevelopmentCommitment",
    "Document",
    "Estimate",
    "GlobalOption",
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "Invoice",
    "ItemTemplateItemVersion",
    "JobLogNote",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "Product",
    "ProjectCostCode",
    "ProjectItem",
    "PunchlistItemTodo",
    "ReadyPlan",
    "Task",
    "ToDo",
    "TradePartnerAvailabilityRequest",
    "SchedulePhase",
    "WarrantyTicket",
  ],
  HasMaterialLeadTimeConfigData: ["CostCode", "Item", "MaterialListing"],
  MaybeHasMarket: ["Development", "ScheduleTemplate"],
  DocumentParent: [
    "Development",
    "PlanPackage",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  DocumentOwner: [
    "HomeownerContract",
    "HomeownerContractChangeOrder",
    "Commitment",
    "CommitmentChangeOrder",
    "DevelopmentCommitment",
    "InvoiceDocument",
    "Development",
    "PlanPackage",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "BidContractRevision",
    "LienWaiver",
    "ChangeEvent",
  ],
  ErpAccrualLineItemSourceLine: [
    "BillLineItemAllocation",
    "CommitmentDraw",
    "CommitmentLineItem",
    "ExpenseAllocationAllocation",
    "ProjectItem",
    "CostCode",
  ],
  FeatureFlagTargetTarget: [
    "Development",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "User",
    "UserGroup",
  ],
  HasGlobalConstraintItem: ["GlobalPlanAllowance", "GlobalPlanConstraint"],
  GlobalPlanTaskScopeTarget: ["Community", "Market", "Region", "Subdivision"],
  GlobalSearchRecordParent: [
    "Bill",
    "Commitment",
    "CommitmentChangeOrder",
    "Community",
    "DesignPackage",
    "Lot",
    "Market",
    "PlanPackage",
    "ProductOffering",
    "Region",
    "StandaloneProject",
    "Structure",
    "Subdivision",
    "TradePartner",
  ],
  HomeownerSelectionOptionLike: ["HomeownerSelectionOption", "HomeownerSelectionProductOption"],
  InvoiceParent: ["PlanMilestone", "Task", "ScheduleTask", "PlanTask"],
  InvoiceScheduleItemParent: ["PlanMilestone", "ScheduleTask"],
  InvoiceScheduleItemGlobalParent: ["GlobalPlanMilestone", "GlobalTask"],
  HasDisplayVersion: ["ItemTemplate", "ReadyPlanAggregateVersion"],
  BaseItemParentVersion: ["ItemTemplate", "ReadyPlanAggregateVersion"],
  ItemTemplateAnomalyParent: ["ItemTemplate", "ItemTemplateItemVersion"],
  JobLogImageParent: ["JobLog", "JobLogNote"],
  LienWaiverParent: [
    "StandaloneProject",
    "Region",
    "Bill",
    "Invoice",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  LienWaiverClaimant: ["Builder", "TradePartner"],
  LienWaiverPayer: ["Builder", "Client"],
  LienWaiverSignatory: ["InternalUser", "TradePartnerContact"],
  LienWaiverOwner: ["Customer", "Client"],
  MaterialLeadTimeConfigParent: ["CostCode", "Item", "MaterialListing"],
  HasOptionPricingData: ["MaterialListing", "ReadyPlanOption"],
  MaterialCostSource: ["BidItemEstimate", "BidContractLineItem"],
  OptionPricingConfigParent: ["CostCode", "GlobalOption", "Item", "MaterialListing"],
  PandaDocOwner: [
    "BidContractRevision",
    "ChangeEvent",
    "Commitment",
    "CommitmentChangeOrder",
    "DevelopmentCommitment",
    "Invoice",
    "LienWaiver",
  ],
  PlanScheduleParent: ["StandaloneProject", "Region", "Market", "Community", "Subdivision", "Lot", "Structure", "Unit"],
  ProductOfferingIncomingUpdateSource: ["Drop", "ReadyPlanAggregateVersion"],
  ProgramDataLike: ["ProgramData", "NewProgramData"],
  HasUserErrors: ["SaveProjectItemsResult"],
  CostLineItemEntity: ["Bill", "Expense"],
  SendTradePartnerPunchlistEmailResult: [
    "SendTradePartnerPunchlistEmailSuccess",
    "SendTradePartnerPunchlistEmailFailure",
  ],
  SendPunchlistExportEmailResult: ["SendPunchlistExportEmailSuccess", "SendPunchlistExportEmailFailure"],
  ReadyPlanCostData: ["ComputeReadyPlanCostResult", "ReadyPlanOptionCostDelta"],
  ReadyPlanAssetParent: [
    "ReadyPlan",
    "ReadyPlanLocation",
    "ReadyPlanOption",
    "PlanPackage",
    "DesignPackage",
    "ProductOffering",
  ],
  ScheduleParent: [
    "StandaloneProject",
    "Region",
    "Development",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ScheduleTemplate",
  ],
  ScheduleFlagImpactImpacted: ["PlanMilestone", "Task"],
  HasScheduleImpact: [
    "DeleteSchedulePhasesResult",
    "DeleteScheduleSubPhasesResult",
    "MoveScheduleSubPhasesResult",
    "SaveScheduleTasksResult",
  ],
  SchedulingExclusionDateParent: [
    "StandaloneProject",
    "Region",
    "Development",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  ScheduleLike: ["Schedule", "PlanSchedule"],
  ToDoParent: [
    "StandaloneProject",
    "Region",
    "Cohort",
    "Development",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
  ],
  TrackedJobResult: ["Asset", "BillOcr"],
  TradeCategoryLeadTimeLike: ["TradeCategoryLeadTimeDefault", "TradeCategoryLeadTime"],
  UserEventParent: [
    "Approval",
    "Bill",
    "ChangeEvent",
    "Commitment",
    "CommitmentChangeOrder",
    "Document",
    "Estimate",
    "HomeownerContractChangeOrder",
    "Invoice",
    "ItemTemplate",
    "JobLog",
    "JobLogImage",
    "JobLogNote",
    "StandaloneProject",
    "Region",
    "Market",
    "Community",
    "Subdivision",
    "Lot",
    "Structure",
    "Unit",
    "ProjectItem",
    "ProjectLotDetail",
    "ProjectReadyPlanConfig",
    "ReadyPlan",
    "PlanPackage",
    "DesignPackage",
    "ProductOffering",
    "ReadyPlanOption",
    "ToDo",
    "ChangeRequestToDo",
    "PunchlistItemTodo",
    "Task",
    "ScheduleTask",
    "PlanTask",
    "WarrantyTicket",
  ],
};

export const enumTypePolicies = {
  ActivityPlanningStateDetail: { keyFields: ["code"] },

  ActivityResponsibilityDetail: { keyFields: ["code"] },

  ActivityTypeDetail: { keyFields: ["code"] },

  AggregateVersionStatusDetail: { keyFields: ["code"] },

  AllocationStrategyDetail: { keyFields: ["code"] },

  ApprovalStatusDetail: { keyFields: ["code"] },

  ApproverStatusDetail: { keyFields: ["code"] },

  BidContractRevisionStatusDetail: { keyFields: ["code"] },

  BidContractTypeDetail: { keyFields: ["code"] },

  BidPackageStatusDetail: { keyFields: ["code"] },

  BidScopeSourceDetail: { keyFields: ["code"] },

  BillGmailAttachmentResultDetail: { keyFields: ["code"] },

  BillGmailMessageResultDetail: { keyFields: ["code"] },

  BillReviewReasonDetail: { keyFields: ["code"] },

  BillSourceDetail: { keyFields: ["code"] },

  BillStatusDetail: { keyFields: ["code"] },

  BillTypeDetail: { keyFields: ["code"] },

  BusinessFunctionTypeDetail: { keyFields: ["code"] },

  BuyoutStatusDetail: { keyFields: ["code"] },

  ChangeEventBudgetPhaseDetail: { keyFields: ["code"] },

  ChangeEventLineItemTypeDetail: { keyFields: ["code"] },

  ChangeEventStatusDetail: { keyFields: ["code"] },

  ChangeEventTypeDetail: { keyFields: ["code"] },

  ChangeRequestAssetPlatformDetail: { keyFields: ["code"] },

  ChangeRequestAssetScopeDetail: { keyFields: ["code"] },

  ChangeRequestPriorityDetail: { keyFields: ["code"] },

  ChangeRequestSourceDetail: { keyFields: ["code"] },

  ChangeRequestStatusDetail: { keyFields: ["code"] },

  ChangeRequestToDoTypeDetail: { keyFields: ["code"] },

  ChangeTypeDetail: { keyFields: ["code"] },

  CheckoutConfigOptionGroupStepDetail: { keyFields: ["code"] },

  CheckoutConfigStatusDetail: { keyFields: ["code"] },

  ClientPlatformDetail: { keyFields: ["code"] },

  CommentStreamVisibilityDetail: { keyFields: ["code"] },

  CommitmentStatusDetail: { keyFields: ["code"] },

  CommitmentTypeDetail: { keyFields: ["code"] },

  CommunicationChannelDetail: { keyFields: ["code"] },

  CommunityTypeDetail: { keyFields: ["code"] },

  ConstructionTypeDetail: { keyFields: ["code"] },

  ContractTypeDetail: { keyFields: ["code"] },

  CostClassificationTypeDetail: { keyFields: ["code"] },

  CostCodeInvoiceCategoryDetail: { keyFields: ["code"] },

  CostConfidenceDetail: { keyFields: ["code"] },

  CostSubClassificationTypeDetail: { keyFields: ["code"] },

  CostTypeDetail: { keyFields: ["code"] },

  DayOfWeekDetail: { keyFields: ["code"] },

  DesignPackageLocationDetail: { keyFields: ["code"] },

  DevelopmentCommitmentTypeDetail: { keyFields: ["code"] },

  DocumentAttachmentPlaceDetail: { keyFields: ["code"] },

  DocumentCategoryDetail: { keyFields: ["code"] },

  DocumentTypeDetail: { keyFields: ["code"] },

  ErpAccrualTypeDetail: { keyFields: ["code"] },

  ErpRevenueLineItemSourceEventDetail: { keyFields: ["code"] },

  ErpTransactionGroupEventDetail: { keyFields: ["code"] },

  ErpTransactionGroupStatusDetail: { keyFields: ["code"] },

  ErpTransactionStatusDetail: { keyFields: ["code"] },

  EstimateStatusDetail: { keyFields: ["code"] },

  EstimateTypeDetail: { keyFields: ["code"] },

  FeatureFlagStatusDetail: { keyFields: ["code"] },

  FeatureFlagTypeDetail: { keyFields: ["code"] },

  FloodPlainDetail: { keyFields: ["code"] },

  FloodZoneDetail: { keyFields: ["code"] },

  FoundationTypeDetail: { keyFields: ["code"] },

  GlobalOptionStatusDetail: { keyFields: ["code"] },

  GlobalOptionTypeStatusDetail: { keyFields: ["code"] },

  HomeownerSelectionOptionPricingTypeDetail: { keyFields: ["code"] },

  HomeownerSelectionStatusDetail: { keyFields: ["code"] },

  InboxItemStatusDetail: { keyFields: ["code"] },

  InvoiceDocumentSourceDetail: { keyFields: ["code"] },

  InvoiceScheduleAmountTypeDetail: { keyFields: ["code"] },

  InvoiceScheduleItemFrequencyDetail: { keyFields: ["code"] },

  InvoiceScheduleTriggerTypeDetail: { keyFields: ["code"] },

  InvoiceSourceDetail: { keyFields: ["code"] },

  InvoiceStatusDetail: { keyFields: ["code"] },

  InvoiceTypeDetail: { keyFields: ["code"] },

  ItemStatusDetail: { keyFields: ["code"] },

  ItemTemplateItemCostStatusDetail: { keyFields: ["code"] },

  ItemTemplateStatusDetail: { keyFields: ["code"] },

  JobLogFlagDetail: { keyFields: ["code"] },

  JobLogNoteTypeDetail: { keyFields: ["code"] },

  LienWaiverConditionDetail: { keyFields: ["code"] },

  LienWaiverStatusDetail: { keyFields: ["code"] },

  LienWaiverTypeDetail: { keyFields: ["code"] },

  LocationTypeDetail: { keyFields: ["code"] },

  LotSalesStatusDetail: { keyFields: ["code"] },

  LotTypeDetail: { keyFields: ["code"] },

  MarkupApplicationMethodDetail: { keyFields: ["code"] },

  MaterialAttributeDimensionTypeDetail: { keyFields: ["code"] },

  MaterialAttributeValueTypeDetail: { keyFields: ["code"] },

  MaterialTypeDetail: { keyFields: ["code"] },

  MobileSyncUpdateTypeDetail: { keyFields: ["code"] },

  PandaDocRoleDetail: { keyFields: ["code"] },

  PandaDocStatusDetail: { keyFields: ["code"] },

  PandaDocWorkspaceDetail: { keyFields: ["code"] },

  PaymentTermDueFromDetail: { keyFields: ["code"] },

  PermitDetail: { keyFields: ["code"] },

  ProductAttributeTypeDetail: { keyFields: ["code"] },

  ProductDimensionTypeDetail: { keyFields: ["code"] },

  ProductStatusDetail: { keyFields: ["code"] },

  ProgramDataBasementConfigDetail: { keyFields: ["code"] },

  ProgramDataGarageConfigDetail: { keyFields: ["code"] },

  ProgramDataMatchStateDetail: { keyFields: ["code"] },

  ProgramDataPrimaryBedroomConfigDetail: { keyFields: ["code"] },

  ProgramDataWindowColorDetail: { keyFields: ["code"] },

  ProjectCollaboratorRoleDetail: { keyFields: ["code"] },

  ProjectFeatureDetail: { keyFields: ["code"] },

  ProjectReadyPlanConfigOrientationDetail: { keyFields: ["code"] },

  ProjectRoleDetail: { keyFields: ["code"] },

  ProjectStageStatusDetail: { keyFields: ["code"] },

  ProjectStatusDetail: { keyFields: ["code"] },

  ProjectUpdateActionTypeDetail: { keyFields: ["code"] },

  PromotionStatusDetail: { keyFields: ["code"] },

  PushNotificationEnvironmentDetail: { keyFields: ["code"] },

  PushNotificationPlatformDetail: { keyFields: ["code"] },

  ReadyPlanAssetTypeDetail: { keyFields: ["code"] },

  ReadyPlanOptionGroupPersonalizationTypeDetail: { keyFields: ["code"] },

  ReadyPlanStatusDetail: { keyFields: ["code"] },

  ReadyPlanTypeDetail: { keyFields: ["code"] },

  ScheduleFlagReasonTypeDetail: { keyFields: ["code"] },

  ScheduleStatusDetail: { keyFields: ["code"] },

  ScheduleTemplateStatusDetail: { keyFields: ["code"] },

  ScopeChangeTypeDetail: { keyFields: ["code"] },

  ScopeModeDetail: { keyFields: ["code"] },

  SelectionCutoffDetail: { keyFields: ["code"] },

  SelectionPricingModeDetail: { keyFields: ["code"] },

  StageDetail: { keyFields: ["code"] },

  SuburbanAssetCategoryDetail: { keyFields: ["code"] },

  SystemChangeRequestAssetDetail: { keyFields: ["code"] },

  SystemPlanMilestoneDetail: { keyFields: ["code"] },

  SystemTaskDetail: { keyFields: ["code"] },

  TakeoffLineItemDesignPackageTypeDetail: { keyFields: ["code"] },

  TakeoffLineItemTypeDetail: { keyFields: ["code"] },

  TaskDeadlineTypeDetail: { keyFields: ["code"] },

  TaskDependencyTypeDetail: { keyFields: ["code"] },

  TaskStatusDetail: { keyFields: ["code"] },

  TaskTypeDetail: { keyFields: ["code"] },

  TimeFrequencyDetail: { keyFields: ["code"] },

  TimeOfDayDetail: { keyFields: ["code"] },

  ToDoStatusDetail: { keyFields: ["code"] },

  ToDoTypeDetail: { keyFields: ["code"] },

  TrackedJobStatusDetail: { keyFields: ["code"] },

  TradePartnerAvailabilityRequestStatusDetail: { keyFields: ["code"] },

  TradePartnerMarketRoleDetail: { keyFields: ["code"] },

  TradePartnerOnboardingStatusDetail: { keyFields: ["code"] },

  TradePartnerRequirementStatusDetail: { keyFields: ["code"] },

  TradePartnerRequirementTypeDetail: { keyFields: ["code"] },

  TradePartnerTaskStatusDetail: { keyFields: ["code"] },

  UserEventTypeDetail: { keyFields: ["code"] },

  UserTypeDetail: { keyFields: ["code"] },

  WarrantyTicketItemStatusDetail: { keyFields: ["code"] },

  WarrantyTicketItemTypeDetail: { keyFields: ["code"] },

  WarrantyTicketStatusDetail: { keyFields: ["code"] },

  WarrantyTicketTypeDetail: { keyFields: ["code"] },

  WeatherTypeDetail: { keyFields: ["code"] },
};

import { dateTimeTypePolicy, dateTypePolicy } from "src/utils/dates";

export const scalarTypePolicies = {
  ScheduleTask: { fields: { completedAt: dateTypePolicy, startDate: dateTypePolicy } },
  Approval: {
    fields: {
      requestedAt: dateTimeTypePolicy,
      dueOn: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  Approver: {
    fields: { statusUpdatedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  CreateAssetMultipartUploadUrlResult: { fields: { expiresAt: dateTimeTypePolicy } },
  Asset: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Attachment: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidContract: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, archivedAt: dateTimeTypePolicy },
  },
  BidContractLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidContractRevision: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      startDate: dateTypePolicy,
      endDate: dateTypePolicy,
      signedOn: dateTypePolicy,
    },
  },
  BidContractRevisionDraw: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidContractTradeLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidItemEstimate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackage: {
    fields: {
      dueDate: dateTypePolicy,
      estimatedAwardDate: dateTypePolicy,
      estimatedConstructionDate: dateTypePolicy,
      sendReminderDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      archivedAt: dateTimeTypePolicy,
    },
  },
  BidPackageAward: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackageGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackageIncomingUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackageLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BidPackageRequest: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      sentDate: dateTypePolicy,
      archivedAt: dateTimeTypePolicy,
    },
  },
  BidPackageVersion: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      dueDate: dateTypePolicy,
      estimatedConstructionDate: dateTypePolicy,
    },
  },
  TradePartner: {
    fields: {
      meetsRequirementsExpiresAt: dateTypePolicy,
      meetsRequirementsExpiresOn: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      billDueDateFor: dateTypePolicy,
    },
  },
  Bill: {
    fields: {
      billDate: dateTypePolicy,
      dueDate: dateTypePolicy,
      paidDate: dateTypePolicy,
      postedDate: dateTypePolicy,
      approvedAt: dateTimeTypePolicy,
      sentDate: dateTypePolicy,
      updatedAt: dateTimeTypePolicy,
      syncedToIntacctAt: dateTimeTypePolicy,
    },
  },
  BillGmailAttachment: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BillGmailMessage: {
    fields: { receivedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  BillLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BillOcr: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      billDate: dateTypePolicy,
      dueDate: dateTypePolicy,
    },
  },
  BusinessFunction: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CalendarInterval: { fields: { startDate: dateTypePolicy, endDate: dateTypePolicy } },
  CalendarInterval2: { fields: { startDate: dateTypePolicy, endDate: dateTypePolicy } },
  ChangeEvent: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, acceptedAt: dateTimeTypePolicy },
  },
  ChangeEventLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeEventLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeEventOriginalOption: { fields: { createdAt: dateTimeTypePolicy } },
  ChangeEventProposedOption: { fields: { createdAt: dateTimeTypePolicy } },
  ChangeEventReason: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeEventTemplateConfig: { fields: { createdAt: dateTimeTypePolicy } },
  ChangeRequest: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeRequestAsset: {
    fields: { deletedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ChangeRequestGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ChangeRequestScope: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, deletedAt: dateTimeTypePolicy },
  },
  ChangeRequestToDo: {
    fields: {
      deletedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      dueDate: dateTypePolicy,
    },
  },
  CheckoutConfig: {
    fields: {
      reservedAt: dateTimeTypePolicy,
      expiresAt: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      archivedAt: dateTimeTypePolicy,
    },
  },
  CheckoutConfigOptionGroup: { fields: { cutoffDate: dateTypePolicy } },
  CheckoutConfigOption: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, reservedCutoffDate: dateTypePolicy },
  },
  Client: { fields: { lastActiveAt: dateTimeTypePolicy, lastActive: dateTimeTypePolicy } },
  Cohort: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Task: { fields: { completedAt: dateTypePolicy, startDate: dateTypePolicy } },
  PlanTask: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      startDate: dateTypePolicy,
      endDate: dateTypePolicy,
      completedAt: dateTimeTypePolicy,
      earliestStartDate: dateTypePolicy,
    },
  },
  ToDo: {
    fields: {
      deletedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      dueDate: dateTypePolicy,
    },
  },
  Invoice: {
    fields: {
      invoiceDate: dateTypePolicy,
      dueDate: dateTypePolicy,
      lineItemCutoffDate: dateTypePolicy,
      lineItemStartDate: dateTypePolicy,
      paidDate: dateTypePolicy,
      updatedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
    },
  },
  StandaloneProject: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Region: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Market: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Community: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Subdivision: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Lot: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Structure: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Unit: {
    fields: {
      startDate: dateTypePolicy,
      warrantyStartDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      homeownerDeliveryDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
      warrantyEndDate: dateTypePolicy,
    },
  },
  Estimate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DevelopmentCommitment: {
    fields: {
      executionDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      releasedDate: dateTypePolicy,
      releasedAt: dateTypePolicy,
    },
  },
  Commitment: {
    fields: {
      executionDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      sentDate: dateTypePolicy,
    },
  },
  Document: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, issuanceDate: dateTypePolicy } },
  Product: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      priceLastUpdatedAt: dateTimeTypePolicy,
      priceLastUpdated: dateTimeTypePolicy,
    },
  },
  ItemTemplateItemVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  JobLogNote: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerAvailabilityRequest: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      tradePartnerConfirmationDate: dateTypePolicy,
    },
  },
  PunchlistItemTodo: {
    fields: {
      deletedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      dueDate: dateTypePolicy,
    },
  },
  WarrantyTicket: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  HomeownerContract: { fields: { executionDate: dateTypePolicy } },
  HomeownerContractChangeOrder: { fields: { executionDate: dateTypePolicy } },
  ReadyPlan: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanPackage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalOption: {
    fields: {
      activeDate: dateTypePolicy,
      archivedDate: dateTypePolicy,
      lastUsedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  Comment: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CommentTag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectStage: { fields: { clientPresentationDate: dateTypePolicy } },
  CommitmentChangeOrder: {
    fields: {
      executionDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      sentDate: dateTypePolicy,
    },
  },
  CommitmentDraw: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CommitmentLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CostLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Customer: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CustomerItemConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CustomerOwnerEntity: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Cutoff: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackagePlanUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackageSource: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackageSourceVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DesignPackageVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Development: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DevelopmentOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  DevelopmentTeamMember: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Drop: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Expense: {
    fields: {
      expenseDate: dateTypePolicy,
      dueDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  ExpenseAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ExpenseAllocationAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  FeatureFlag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  FeatureFlagTarget: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalOptionGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanAllowance: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanConstraint: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanConstraintItem: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, deletedAt: dateTimeTypePolicy },
  },
  GlobalPlanMilestone: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanMilestoneGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanStage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanStageVariant: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanTag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanTask: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanTaskChecklistItem: {
    fields: { deletedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  GlobalPlanTaskScope: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalPlanTaskVariant: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalRequiredTaskDocument: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GlobalTask: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  History: { fields: { recordedAt: dateTimeTypePolicy } },
  HomeboundHoliday: { fields: { date: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Homeowner: { fields: { createdAt: dateTimeTypePolicy } },
  HomeownerContractLineItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  HomeownerNote: { fields: { createdAt: dateTimeTypePolicy } },
  HomeownerSelection: { fields: { publishedDate: dateTypePolicy, publishedAt: dateTypePolicy } },
  InsideMapsRoomRendering: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InvoiceAccruedLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InvoiceDocument: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InvoiceScheduleItem: { fields: { invoiceDate: dateTypePolicy } },
  InvoiceScheduleTemplate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InvoiceScheduleTemplateItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemPlanTaskMapping: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemSlot: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemTemplate: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      activatedAt: dateTimeTypePolicy,
      archivedAt: dateTimeTypePolicy,
      lastUsedAsUnderwritingTemplate: dateTypePolicy,
    },
  },
  ItemTemplateCollection: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemTemplateCostUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ItemTemplateItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  JobLog: { fields: { logDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  JobLogImage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  LienWaiver: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, throughDate: dateTypePolicy } },
  LotRating: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialAssemblyComponent: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialAttributeDimension: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialAttributeValue: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialBrand: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialLeadTimeConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialLeadTimeConfigVariant: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialListing: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialVariant: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, lastUsedAt: dateTimeTypePolicy },
  },
  MaterialVariantImage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MaterialVariantTag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  MobileSyncUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  OptionPricingConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  OptionPricingConfigVariant: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PaymentTerm: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanMilestone: {
    fields: {
      estStartDate: dateTypePolicy,
      estEndDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      completedAt: dateTimeTypePolicy,
    },
  },
  PlanMilestoneSnapshot: {
    fields: {
      estStartDate: dateTypePolicy,
      estEndDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  PlanPackageIncomingSlot: { fields: { createdAt: dateTimeTypePolicy } },
  PlanPackageVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanSchedule: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      recalculatedAt: dateTimeTypePolicy,
      targetStartDate: dateTypePolicy,
      targetEndDate: dateTypePolicy,
      currentBaselineDate: dateTypePolicy,
      verticalCompleteDate: dateTypePolicy,
      readyToStartDate: dateTypePolicy,
    },
  },
  PotentialDateBasisPoints: { fields: { date: dateTypePolicy } },
  PlanTaskChecklistItem: {
    fields: { completedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  PreconContractType: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProductOffering: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProductOfferingConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProductOfferingIncomingUpdate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProductType: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProgramData: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  NewProgramData: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  EarnedValueDataPoint: { fields: { date: dateTypePolicy } },
  OptionWithCutoffDate: { fields: { cutoffDate: dateTypePolicy } },
  ProjectDirectMarginGraphData: { fields: { date: dateTypePolicy } },
  ProjectAllocationRule: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectCollaborator: { fields: { inviteSent: dateTimeTypePolicy, inviteSentAt: dateTimeTypePolicy } },
  ProjectContact: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectCutoff: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, date: dateTypePolicy } },
  ProjectDocumentAssociation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectInvoiceSetting: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CostLineItem: { fields: { costDate: dateTypePolicy } },
  ProjectItemAllocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectLotDetail: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectReadyPlanConfig: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      constructionStartDate: dateTypePolicy,
      lastAppliedAt: dateTimeTypePolicy,
      deliveryDate: dateTypePolicy,
      configurationUpdatedAt: dateTimeTypePolicy,
    },
  },
  ProjectReadyPlanConfigOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectSalesforceOpportunity: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectSiteCondition: {
    fields: { expectedSlabPourDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ProjectSiteSpecificInfo: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectSnapshot: { fields: { startDate: dateTypePolicy, endDate: dateTypePolicy } },
  ProjectStageHomeownerFinancials: { fields: { financialsLastUpdate: dateTypePolicy } },
  ProjectStageTemplateConfig: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ProjectStatusChange: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, date: dateTypePolicy },
  },
  ProjectUpdate: { fields: { createdAt: dateTimeTypePolicy, eventTime: dateTimeTypePolicy } },
  PushNotificationToken: {
    fields: { lastSeenAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ReadyPlanAggregateVersion: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      publishedAt: dateTimeTypePolicy,
      promotedAt: dateTimeTypePolicy,
    },
  },
  ReadyPlanAsset: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanAssetVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanDesignNote: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanDesignNoteVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanDesignPackage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanDesignPackageVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanLocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanLocationVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanOptionGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanOptionProgramDataModification: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanOptionVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanProgramData: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanProgramDataVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanRequiredOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ReadyPlanRequiredOptionVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  RequiredTaskDocument: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  RoomType: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TestMutationResult: { fields: { datetime: dateTimeTypePolicy, date: dateTypePolicy } },
  Schedule: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ScheduleFlag: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ScheduleFlagImpact: {
    fields: {
      oldStartDate: dateTypePolicy,
      newStartDate: dateTypePolicy,
      oldEndDate: dateTypePolicy,
      newEndDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  ScheduleFlagReason: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ScheduleSetting: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ResultingDelay: { fields: { oldTaskStart: dateTypePolicy, oldTaskEnd: dateTypePolicy } },
  ScheduleTaskChecklistItem: {
    fields: { completedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ScheduleTemplate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ScheduleTemplateItemMapping: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  SchedulingExclusionDate: {
    fields: { date: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ScopeChangeReason: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  SiteSpecificInfo: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Submarket: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TakeoffLineItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TakeoffLineItemVersion: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TaskSnapshot: {
    fields: {
      startDate: dateTypePolicy,
      endDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  TaskWorkDay: { fields: { workDay: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ToDoChecklistItem: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TrackedJob: {
    fields: {
      startedAt: dateTimeTypePolicy,
      completedAt: dateTimeTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  TradeCategory: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradeCategoryLeadTime: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerAgreement: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerAvailabilityRequestEmail: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerAvailabilityRequestTextMessage: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  TradePartnerContact: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerMailingList: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerMarketContact: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  TradePartnerRequirement: {
    fields: {
      signedDate: dateTypePolicy,
      expirationDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
    },
  },
  TradePartnerReview: { fields: { createdAt: dateTimeTypePolicy } },
  TradePartnerUser: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      lastActive: dateTimeTypePolicy,
      lastActiveAt: dateTimeTypePolicy,
    },
  },
  UserCommunicationPreference: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  UserEvent: { fields: { createdAt: dateTimeTypePolicy, notifiedAt: dateTimeTypePolicy } },
  UserGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  WarrantyTicketAvailability: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  WarrantyTicketItem: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, statusUpdatedAt: dateTimeTypePolicy },
  },
  WorkAuthorization: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
};
